// AUTO-GENERATED from inline <script type="text/babel"> by extract-jsx-blocks.mjs
// Manually verify: 1) Recharts components imported, 2) PropTypes if used,
// 3) export default App at the bottom, 4) supabase usage compiles.
import PropTypes from 'prop-types';
import { supabase } from './lib/supabase';


import React, { useState, useMemo, useEffect, useRef, useCallback, useContext, createContext, Fragment } from 'react';
import { LineChart, Line, BarChart, Bar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, PieChart, Pie, Cell, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

/* ───────── ICONS (inline SVG) ───────── */
const Icon = ({ name, className = 'w-5 h-5', stroke = 1.8 }) => {
  const paths = {
    home: 'M3 11.5L12 4l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1v-8.5z',
    cycle: 'M20 12a8 8 0 1 1-3.2-6.4M20 4v5h-5',
    target: 'M12 12m-9 0a9 9 0 1 0 18 0 9 9 0 1 0-18 0M12 12m-5 0a5 5 0 1 0 10 0 5 5 0 1 0-10 0M12 12v.01',
    chart: 'M3 3v18h18M7 15l4-6 4 3 5-7',
    users: 'M16 14a4 4 0 1 0-8 0M20 14a3 3 0 1 0-3-4M4 14a3 3 0 1 1 3-4M3 21a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5',
    user:  'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 20a8 8 0 0 1 16 0',
    badge: 'M12 2l2.5 4.5L20 8l-4 4 1 6-5-3-5 3 1-6-4-4 5.5-1.5L12 2z',
    shield:'M12 2l8 3v7c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V5l8-3z',
    trend: 'M3 17l5-5 4 4 7-7M14 7h6v6',
    cal:   'M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6zM8 2v4M16 2v4M4 10h16',
    book:  'M4 5a2 2 0 0 1 2-2h14v16H6a2 2 0 0 0-2 2V5zM20 17H6',
    money: 'M12 3v18M8 7h6a3 3 0 0 1 0 6H9a3 3 0 0 0 0 6h7',
    zap:   'M13 2L3 14h7l-1 8 10-12h-7l1-8z',
    bell:  'M15 17h5l-1.4-1.4A7 7 0 0 1 17 11V9a5 5 0 0 0-10 0v2a7 7 0 0 1-1.6 4.6L4 17h5M9 17a3 3 0 0 0 6 0',
    search:'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.3-4.3',
    check: 'M5 12l5 5L20 7',
    close: 'M6 6l12 12M6 18L18 6',
    plus:  'M12 5v14M5 12h14',
    more:  'M12 12h.01M18 12h.01M6 12h.01',
    chev:  'M9 6l6 6-6 6',
    chevd: 'M6 9l6 6 6-6',
    filter:'M4 5h16M6 10h12M10 15h4M12 20v-5',
    export:'M12 3v12m0 0l-4-4m4 4l4-4M5 21h14',
    import:'M12 21V9m0 0l-4 4m4-4l4 4M5 3h14',
    edit:  'M12 20h9M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4L16.5 3.5z',
    ok:    'M22 11.1V12a10 10 0 1 1-5.9-9.1M22 4L12 14l-3-3',
    sparkle:'M12 2l2 6 6 2-6 2-2 6-2-6-6-2 6-2 2-6zM19 14l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3z',
    flag:  'M4 21V4h12l-2 4 2 4H4',
    warn:  'M12 9v4m0 4h.01M5 20h14a2 2 0 0 0 1.7-3L13 4a2 2 0 0 0-3.4 0L3.3 17A2 2 0 0 0 5 20z',
    hist:  'M3 12a9 9 0 1 0 3-6.7M3 4v5h5M12 8v4l3 2',
    lock:  'M5 12h14v9H5zM8 12V8a4 4 0 1 1 8 0v4',
    logout:'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
    settings:'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3h0a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8v0a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z',
    grid:  'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z',
    inbox: 'M22 12h-6l-2 3h-4l-2-3H2M5.5 5h13a2 2 0 0 1 1.8 1.2l3.2 5.8v6a2 2 0 0 1-2 2H2.5a2 2 0 0 1-2-2v-6l3.2-5.8A2 2 0 0 1 5.5 5z',
    calendar: 'M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
    play:  'M7 4v16l13-8z',
    eye:   'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    arrow: 'M5 12h14M13 5l7 7-7 7',
    'arrow-right': 'M5 12h14M13 5l7 7-7 7',
    'arrow-left':  'M19 12H5M11 5l-7 7 7 7',
    chat:  'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z',
    trash: 'M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2M6 6v14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6M10 11v6M14 11v6',
    save:  'M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2zM17 21v-8H7v8M7 3v5h8',
    copy:  'M9 3h9a2 2 0 0 1 2 2v12M5 7h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z',
    link:  'M10 13a5 5 0 0 0 7 0l3-3a5 5 0 1 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 1 0 7 7l1-1',
    doc:   'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M9 13h6M9 17h6',
    x:     'M6 6l12 12M6 18L18 6',
  };
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d={paths[name] || paths.more} />
    </svg>
  );
};

/* ───────── SEED DATA ───────── */
const COMPANY = {
  name: 'Freedom AI Labs',
  parent: 'Choco',
  motto: 'AI-native team, AI-native performance',
  quarter: 'H1 2026',
  period: 'H1 2026',
  hq: 'Алматы',
};

/* Freedom AI Labs values (apr 2026):
   1. Смелая команда   — наследие Choco; высказываемся, не молчим, берём риск
   2. Ownership        — проект end-to-end, без "это не моё"
   3. Скорость > полировка — ship → measure → iterate (поглощает "Непрерывное совершенствование")
   4. AI Native        — мы сами 10x с AI; не использовать AI = непрофессионально
   5. WOW              — наследие Choco; "вау", не "ну ок"
   6. Фокус на главном — наследие Choco; одна цель на спринт */
const CULTURE_VALUES = [
  { id: 'bold-team',  name: 'Смелая команда',        desc: 'Высказывается даже несогласному CEO; берёт риск и лидерство' },
  { id: 'ownership',  name: 'Ownership',             desc: 'Ведёт проект end-to-end — от идеи до прода до метрик' },
  { id: 'speed',      name: 'Скорость > полировка',  desc: 'Ship → measure → iterate. В AI неделя = эпоха' },
  { id: 'ai-native',  name: 'AI Native',             desc: 'Живёт в 10x AI-режиме; автоматизирует всё, что можно' },
  { id: 'wow',        name: 'WOW',                   desc: 'Продукт и сервис вызывают восхищение, а не "ну ок"' },
  { id: 'focus',      name: 'Фокус на главном',      desc: 'Одна цель на спринт; всё остальное — шум' },
];

const SENIORITY = ['Junior','Mid','Senior','Lead','Director','VP'];

/* Talent bar: минимум по dimension для каждого уровня (по новой Big Tech лестнице).
   COMMIT_5 (30 apr 2026): мигрировали с seniority-ключей на level-ключи.
   Источник правды теперь — emp.level (IC1-IC6 / M1-M4 / S1-S3).
   Старые ключи сохранены для обратной совместимости с историческими записями. */
const TALENT_BAR = {
  /* Big Tech ladder (новый источник правды) */
  IC1:'Basic',          IC2:'Basic',          IC3:'Intermediate',
  IC4:'Advanced',       IC5:'Advanced',       IC6:'Exceptional',
  M1:'Intermediate',    M2:'Advanced',        M3:'Advanced',        M4:'Exceptional',
  S1:'Basic',           S2:'Intermediate',    S3:'Advanced',
  /* Legacy seniority keys (для исторических placement'ов и старых mock-записей) */
  Junior: 'Basic', Mid: 'Basic', Senior: 'Intermediate',
  Lead: 'Advanced', Director: 'Advanced', VP: 'Advanced', Exec: 'Advanced',
};

/* Возвращает таланто-планку для сотрудника. Сначала пытается через emp.level
   (если он явно проставлен или деривится через guessLevel), потом fallback на
   старое поле emp.seniority. Используй ВЕЗДЕ вместо прямого TALENT_BAR[X.seniority]. */
const talentBarFor = (p) => {
  if (!p) return 'Intermediate';
  /* guessLevel/personLevel определены ниже в файле — поэтому защищаемся
     от temporal dead zone проверкой typeof. */
  let lvl = p.level;
  if (!lvl || !TALENT_BAR[lvl]) {
    if (typeof personLevel === 'function') {
      lvl = personLevel(p)?.level;
    } else if (typeof guessLevel === 'function') {
      lvl = guessLevel(p)?.level;
    }
  }
  if (lvl && TALENT_BAR[lvl]) return TALENT_BAR[lvl];
  /* COMMIT_5 audit P1 #3 fix (30 apr 2026): warn когда не нашли level — это
     значит человеку не выставили level и seniority тоже неизвестен. Без warn'а
     функция молча возвращала 'Intermediate' fallback и проблема скрывалась. */
  if (p.id && typeof console !== 'undefined' && !p.__talentBarFallbackWarned) {
    console.warn(`[talentBar] No level/seniority for ${p.id} (${p.role || p.name || 'unknown'}) — returning Intermediate fallback`);
    p.__talentBarFallbackWarned = true;
  }
  return TALENT_BAR[p.seniority] || 'Intermediate';
};

const MASTERY = ['Poor','Basic','Intermediate','Advanced','Exceptional'];
const MASTERY_SCORE = { Poor:1, Basic:2, Intermediate:3, Advanced:4, Exceptional:5 };

/* COMMIT_8 (audit may 2026, bug 4): русское склонение по числу.
   one — 1, 21, 31; few — 2-4, 22-24; many — 0, 5-20, 25-30. */
const ruPlural = (n, [one, few, many]) => {
  const abs = Math.abs(Number(n) || 0);
  const mod100 = abs % 100;
  const mod10 = abs % 10;
  if (mod100 >= 11 && mod100 <= 14) return many;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
};

/* COMMIT_8 (audit may 2026, bug 14): глоссарий + Term-обёртка.
   В UI много англоязычных терминов вперемешку с русским; добавили
   нативный <abbr title> тултип и пунктирное подчёркивание, чтобы
   сотрудники могли узнать значение без выхода в документацию. */
const GLOSSARY = {
  'Mastery':                    'Уровень владения навыком: Poor → Basic → Intermediate → Advanced → Exceptional. Это шкала оценки внутри одного измерения скоркарта.',
  'Observable behaviors':       'Конкретные наблюдаемые действия сотрудника, по которым можно подтвердить уровень. Пример: «Сдаёт задачи в срок и инициирует ретро» (а не «ответственный»).',
  'Talent Bar':                 'Минимально требуемый mastery-уровень по позиции для конкретного seniority. Калибруется HR + Performance Team каждый цикл.',
  'Hold Performance Conversation': '1:1-разговор менеджера с сотрудником после Calibration: финальный grade, сильные/слабые стороны, согласование Development Plan / BoT. Gate для закрытия цикла.',
  'BoT':                        'Back on Track — 6-недельный план для Underperformer. Чёткие цели и halfway-checkpoint, по итогу — final evaluation.',
  'Gate':                       'Обязательная точка контроля в цикле: без её прохождения следующий этап не открывается.',
  'Manager scorecards':         'Скоркарты, которые менеджер заполняет на своих direct reports (Skills × Deliverables × Culture).',
  'Self Assessment':            'Самооценка сотрудника на старте цикла: достижения, рефлексия по фидбеку, цели на следующий период.',
  'Manager Assessment':         'Этап, когда менеджер оценивает каждого direct report по trio Skills / Deliverables / Culture, опираясь на Self Assessment и 360-фидбек.',
  'Calibration':                'Сессия Performance Team + People Partner, где сверяют распределение grade по командам, ловят bias и согласуют финальные оценки до общения с сотрудниками.',
  'Development Plan':           'Плановый документ для A-player / Above bar: 2–3 SMART-цели роста на следующее полугодие.',
  '360 feedback':               'Сбор именного и/или анонимного фидбека от коллег, на которых работа сотрудника влияет (peers, downstream, stakeholders).',
  'A-player':                   'Сотрудник, чей результат стабильно ≥ Talent Bar + 0.8. Кандидат на промо при дополнительных условиях.',
  'Above bar':                  'Результат в коридоре Talent Bar … Talent Bar + 0.79. Solid contributor — основной костяк команды.',
  'Underperformer':             'Результат < Talent Bar − 0.8. Открывается BoT (PIP) на 6 недель.',
  'STAR':                       'Формат описания примера: Situation → Task → Action → Result. Помогает превращать «я молодец» в проверяемый кейс.',
};
const Term = ({ name, children, className = '' }) => (
  <abbr
    title={GLOSSARY[name] || name}
    className={`underline decoration-dotted decoration-ink-300 underline-offset-2 cursor-help ${className}`}
    style={{ textDecorationThickness: 1 }}
  >
    {children || name}
  </abbr>
);

const ROLES = {
  'ml_engineer': {
    label: 'ML Engineer',
    skills: ['Software Lifecycle','Data Architecture','Programming','Machine Learning'],
  },
  'data_scientist': {
    label: 'Data Scientist',
    skills: ['Python','Data Modeling','Machine Learning','Statistics'],
  },
  'pm': {
    label: 'Product Manager',
    skills: ['Problem Solving','Lifecycle Management','Product Sense'],
  },
  'designer': {
    label: 'Designer',
    skills: ['Craft','Systems Thinking','Collaboration'],
  },
  'ops': {
    label: 'AI Ops / Platform',
    skills: ['Software Lifecycle','Infra','Reliability','Programming'],
  },
  'research': {
    label: 'Research Scientist',
    skills: ['Research','Machine Learning','Publishing'],
  },
  'perf_ops': {
    label: 'Strategy / Ops',
    skills: ['Process Building','Data Analysis','Problem Solving'],
  },
  'head': { label: 'Leadership', skills: ['Strategy','Execution','Talent Development'] },
};

/* Scorecards: Deliverables (company-wide), Culture (company-wide), Skills per role */
const SCORECARD_DELIVERABLES = {
  title: 'Deliverables',
  owner: 'CEO',
  formula: '(Speed + Quality) × Complexity',
  dimensions: [
    {
      name: 'Speed',
      desc: 'Способность укладываться в сроки',
      levels: [
        { level: 'Poor', items: ['Обычно сдаёт задачи поздно', 'Пропускает важные дедлайны'] },
        { level: 'Basic', items: ['Обычно выполняет задачи в срок', 'Редко пропускает дедлайны'] },
        { level: 'Intermediate', items: ['Всегда укладывается в сроки, часто опережает на 10–20%'] },
        { level: 'Advanced', items: ['Сдаёт очень быстро, привычно опережает дедлайны на 20–40%'] },
        { level: 'Exceptional', items: ['Систематически закрывает задачи с опережением 40%+ и без потери качества, при этом помогает разгрузить смежников'] },
      ],
    },
    {
      name: 'Quality',
      desc: 'Количество итераций до завершения и плотность дефектов',
      levels: [
        { level: 'Poor', items: ['Качество недопустимо низкое: задача возвращается на 3+ итерации', 'Регулярные баги/инциденты после релиза'] },
        { level: 'Basic', items: ['Задачи на приемлемом уровне, обычно 2 итерации', 'Иногда уходят дефекты в прод'] },
        { level: 'Intermediate', items: ['Высокий стандарт, как правило 1 итерация', 'Дефекты — редкость и закрываются до релиза'] },
        { level: 'Advanced', items: ['Всегда высокое качество, без итераций', 'Решения признаются эталоном внутри команды'] },
        { level: 'Exceptional', items: ['Выдаёт продакшен-готовые решения с первой итерации; качество выше отраслевого стандарта и тиражируется в другие команды как образец'] },
      ],
    },
    {
      name: 'Complexity',
      desc: 'Степень прецедентности задачи и широта влияния решения',
      levels: [
        { level: 'Poor', items: ['Берёт в работу только задачи по чёткой инструкции; буксует, когда нет готового шаблона; не предлагает альтернативных подходов'] },
        { level: 'Basic', items: ['Справляется с задачами, у которых есть готовые прецеденты; нестандартные кейсы эскалирует менеджеру'] },
        { level: 'Intermediate', items: ['Самостоятельно ведёт нестандартные задачи с небольшим числом прецедентов; адаптирует существующие подходы'] },
        { level: 'Advanced', items: ['Берёт задачи без прецедентов в команде; декомпозирует их и доводит до результата'] },
        { level: 'Exceptional', items: ['Решает задачи, требующие изобретения радикально новых методов; результаты задают новый стандарт для индустрии или компании'] },
      ],
    },
  ],
};

const SCORECARD_CULTURE = {
  title: 'Culture',
  owner: 'CEO',
  formula: 'AVG по 6 ценностям Freedom AI Labs',
  dimensions: [
    {
      name: 'Смелая команда',
      desc: 'Высказывается, не молчит; берёт риск и лидерство',
      levels: [
        { level: 'Poor',         items: ['Молчит на встречах, даже видя проблему', 'Избегает конфликтов и неудобных разговоров'] },
        { level: 'Basic',        items: ['Высказывается в узком кругу', 'Задаёт уточняющие вопросы', 'Берёт небольшие риски в зоне ответственности'] },
        { level: 'Intermediate', items: ['Возражает тимлиду / PM, если несогласен — по делу и с фактами', 'Берёт разумный риск в проектах'] },
        { level: 'Advanced',     items: ['Бросает вызов директору / CEO, если видит ошибку', 'Инициирует непопулярные, но нужные изменения'] },
        { level: 'Exceptional',  items: ['Формирует культуру открытого диалога', 'Люди в команде тянутся говорить правду благодаря его/её примеру'] },
      ],
    },
    {
      name: 'Ownership',
      desc: 'Ведёт проект end-to-end — от идеи до прода до метрик',
      levels: [
        { level: 'Poor',         items: ['"Я сделал свою часть, дальше не моё"', 'Проекты зависают без видимого владельца'] },
        { level: 'Basic',        items: ['Доводит свой кусок до конца', 'Отвечает за качество внутри своей зоны'] },
        { level: 'Intermediate', items: ['Ведёт проект end-to-end, включая интеграцию с соседями', 'Сопровождает после релиза, не "выкатил и забыл"'] },
        { level: 'Advanced',     items: ['Берёт на себя критичные провисающие зоны без запроса', 'Не боится большого scope-а и неопределённости'] },
        { level: 'Exceptional',  items: ['Несёт ответственность за успех продукта / направления', 'В проблеме ищет решение, а не виноватого'] },
      ],
    },
    {
      name: 'Скорость > полировка',
      desc: 'Ship → measure → iterate. В AI неделя = эпоха',
      levels: [
        { level: 'Poor',         items: ['Три недели на то, что делается за день', 'Перфекционизм блокирует релизы'] },
        { level: 'Basic',        items: ['Релизит регулярно, укладывается в дедлайны', 'Не сидит на готовом коде неделями'] },
        { level: 'Intermediate', items: ['Ship-to-learn: выпускает v0.1 быстро и итерирует по фактическому фидбеку', 'Защищает скоупы, чтобы не разрастались'] },
        { level: 'Advanced',     items: ['Сокращает цикл team-а в разы', 'Внедряет инструменты и процессы ускорения для других'] },
        { level: 'Exceptional',  items: ['Задаёт новый стандарт скорости для функции', 'Лаборатория в целом начинает двигаться в его/её темпе'] },
      ],
    },
    {
      name: 'AI Native',
      desc: 'Живёт в 10x AI-режиме; автоматизирует всё, что можно',
      levels: [
        { level: 'Poor',         items: ['"AI глючит, я лучше сам"', 'Тратит часы на то, что AI делает за минуты', 'Не пробует AI-инструменты в работе'] },
        { level: 'Basic',        items: ['Использует AI для очевидных задач: драфт текста, код-подсказки', 'Знаком с базовыми инструментами (Cursor, Claude, Perplexity)'] },
        { level: 'Intermediate', items: ['AI встроен в ежедневный workflow: ресёрч, код, доки, рутины', 'Автоматизирует повторяющиеся задачи'] },
        { level: 'Advanced',     items: ['Строит AI-workflows для команды: агенты, custom prompts, инструменты', 'Учит коллег работать в 10x AI-режиме'] },
        { level: 'Exceptional',  items: ['Двигает лабораторию к 10x через AI', 'Создаёт AI-практики, которые становятся стандартом для всей компании'] },
      ],
    },
    {
      name: 'WOW',
      desc: 'Продукт и сервис вызывают восхищение, а не "ну ок"',
      levels: [
        { level: 'Poor',         items: ['Сдаёт "ну ок" качество', 'Не проверяет результат глазами пользователя'] },
        { level: 'Basic',        items: ['Держит хорошее качество в зоне ответственности', 'Замечает явные косяки и фиксит'] },
        { level: 'Intermediate', items: ['Добавляет detail-и, которые заметит пользователь', 'Фанат деталей — polish без потери скорости'] },
        { level: 'Advanced',     items: ['Регулярно делает "вау"-решения, которые обсуждает индустрия', 'Поднимает планку качества для команды'] },
        { level: 'Exceptional',  items: ['Продукты / процессы становятся эталоном на рынке', 'Конкуренты пытаются скопировать его/её работу'] },
      ],
    },
    {
      name: 'Фокус на главном',
      desc: 'Одна цель на спринт; всё остальное — шум',
      levels: [
        { level: 'Poor',         items: ['Распыляется на 5 проектов, ни один не доведён', 'Reactive, реагирует на каждый запрос вместо приоритизации'] },
        { level: 'Basic',        items: ['Закрывает 1–2 ключевых задачи за спринт', 'Не теряет фокус под давлением'] },
        { level: 'Intermediate', items: ['Отказывается от "nice-to-have" ради "must-have"', 'Чётко приоритизирует и объясняет почему'] },
        { level: 'Advanced',     items: ['Помогает команде держать фокус', 'Отсекает шум, защищает ресурс команды от низкоприоритетных запросов'] },
        { level: 'Exceptional',  items: ['Превращает фокус в культуру команды', 'One-target-at-a-time встроено в процесс работы'] },
      ],
    },
  ],
};

const SCORECARD_SKILLS_ML = {
  title: 'ML Engineer — Skills',
  owner: 'CTO / Head of AI',
  formula: 'AVG по навыкам',
  dimensions: [
    { name: 'Software Lifecycle', desc: 'SDLC, CI/CD, продакшн', levels: [
      { level:'Poor',    items:['Считает код «готовым» когда написан','Не использует базовые SDLC-инструменты']},
      { level:'Basic',   items:['Код «готов» когда смёржен','Использует PR, CI, release automation','Использует логирование']},
      { level:'Intermediate', items:['Код «готов» когда работает в продакшне','Определяет и отслеживает метрики приложения / пайплайна','Разбивает работу на задачи']},
      { level:'Advanced',items:['Собирает требования для крупных фич','Оценивает и планирует поставку через репозитории/проекты','Определяет SLA и метрики решения']},
      { level:'Exceptional', items:['Двигает организацию к отличным SDLC-практикам','Широко признан как эксперт']},
    ]},
    { name: 'Data Architecture', desc: 'Моделирование и распределённые системы', levels: [
      { level:'Poor',    items:['Нет знаний о моделировании данных','Не может спроектировать решение на уровне приложения']},
      { level:'Basic',   items:['Знаком с базовыми техниками моделирования','Понимает разницу distributed vs single-node','Работает с архитектурой на уровне приложения']},
      { level:'Intermediate', items:['Проектирует сложные модели данных','Практически понимает гарантии распределённых систем','Подстраивает архитектуру под специфику системы']},
      { level:'Advanced',items:['Разрабатывает оптимизированные масштабируемые модели','Распределённые системы: латентность, throughput, multi-cloud','Определяет архитектуру на уровне организации']},
      { level:'Exceptional', items:['Рутинно избегает проблем через опыт','Автор публикаций по distributed systems']},
    ]},
    { name: 'Programming', desc: 'Качество кода и инженерная культура', levels: [
      { level:'Poor',    items:['Решает только тривиальные задачи','Код баговый']},
      { level:'Basic',   items:['Пишет чистый, структурированный код','Пишет юнит-тесты','Следует конвенциям']},
      { level:'Intermediate', items:['Навигирует средние кодбазы','Практикует TDD','Уделяет внимание перформансу']},
      { level:'Advanced',items:['Эффективно работает со множеством стеков','Безупречное знание кодбазы','Продвинутые алгоритмы и структуры данных']},
      { level:'Exceptional', items:['Жёсткое self-education','Переносит опыт между доменами']},
    ]},
    { name: 'Machine Learning', desc: 'ML/DL, статистика, research', levels: [
      { level:'Poor',    items:['Низкий уровень математики','Трудности с абстракцией']},
      { level:'Basic',   items:['Применяет mainstream ML-библиотеки','Понимает метрики и валидацию','Понимает frequentist statistics']},
      { level:'Intermediate', items:['Частотная и байесовская статистика','Track record деплоя ML-моделей','Refines approaches под specific edge cases']},
      { level:'Advanced',items:['Глубокое понимание classical ML и SOTA','Читает свежие статьи и имплементирует','Осведомлён о state-of-the-art']},
      { level:'Exceptional', items:['Track record industry-leading результатов','SOTA-модели, публикации']},
    ]},
  ],
};

const SCORECARD_SKILLS_PM = {
  title: 'Product Manager — Skills',
  owner: 'Head of Product',
  formula: 'AVG',
  dimensions: [
    { name:'Problem Solving', desc:'', levels: [
      { level:'Poor', items:['Неструктурированный подход','Не выявляет первопричины']},
      { level:'Basic', items:['Разбивает простые проблемы','Использует данные']},
      { level:'Intermediate', items:['Находит ошибки в кажущихся верными предпосылках','Погружается до глубокого понимания']},
      { level:'Advanced', items:['Синтез решения из несвязанных фактов','Инновационный подход']},
      { level:'Exceptional', items:['Абстрактное мышление','Применяет передовые научные методы']},
    ]},
    { name:'Lifecycle Management', desc:'', levels: [
      { level:'Poor', items:['Ограниченное понимание жизненного цикла продукта']},
      { level:'Basic', items:['Знает стадии жизненного цикла','Следует процессу','Коллаборация с командами']},
      { level:'Intermediate', items:['Переводит потребности пользователей в фичи','Использует Agile/Lean','QA высокого качества']},
      { level:'Advanced', items:['Ведёт product strategy и roadmap','Мастер UX/UI принципов','Запускает новые продукты и GTM']},
      { level:'Exceptional', items:['Стратегическое планирование на долгий срок','Иннование в lifecycle']},
    ]},
    { name:'Product Sense', desc:'', levels: [
      { level:'Poor', items:['Недостаёт market awareness','Не умеет приоритизировать']},
      { level:'Basic', items:['Пишет user stories','Рыночный анализ','Мониторит perf-метрики']},
      { level:'Intermediate', items:['Определяет новые продукты end-to-end','Систематический market research','Приоритизирует по business impact']},
      { level:'Advanced', items:['Высокое качество через фреймворки','Позиционирует продукты в конкурентном поле','Управляет competing objectives']},
      { level:'Exceptional', items:['Platform-level design','Инженерное понимание решения','Устанавливает стандарты индустрии']},
    ]},
  ],
};

const SCORECARD_SKILLS_DS = {
  title: 'Data Scientist — Skills',
  owner: 'Head of Data',
  formula: 'AVG по навыкам',
  dimensions: [
    { name:'Python', desc:'Уровень владения Python для анализа данных', levels: [
      { level:'Poor',    items:['Не владеет Python или пишет только скриптовые однострочники','Не использует pandas / numpy']},
      { level:'Basic',   items:['Пишет читаемые скрипты с функциями','Использует pandas для основных операций','Работает в Jupyter / VSCode']},
      { level:'Intermediate', items:['Пишет reusable-модули и пакеты','Владеет векторизацией и оптимизацией pandas','Использует typing, logging, конфиги']},
      { level:'Advanced',items:['Пишет production-код с тестами (pytest)','Знает memory profiling и распараллеливание','Создаёт библиотеки для команды']},
      { level:'Exceptional', items:['Ведёт open-source или internal core-tooling','Экспертное понимание CPython / PEP / performance']},
    ]},
    { name:'Data Modeling', desc:'Моделирование данных, SQL, warehouse', levels: [
      { level:'Poor',    items:['Не отличает star schema от snowflake','Пишет SQL только с ChatGPT']},
      { level:'Basic',   items:['Пишет корректные JOIN / GROUP BY','Понимает OLTP vs OLAP','Может прочитать модель данных']},
      { level:'Intermediate', items:['Проектирует fact/dim таблицы','Владеет window functions и CTE','Работает с dbt / Airflow']},
      { level:'Advanced',items:['Проектирует slowly changing dimensions','Знает query optimization и партиционирование','Владеет Spark / BigQuery / Snowflake']},
      { level:'Exceptional', items:['Архитектор data platform','Внедряет data contracts и lineage','Реферируется другими командами']},
    ]},
    { name:'Machine Learning', desc:'Применение ML от постановки до продакшна', levels: [
      { level:'Poor',    items:['Путает classification / regression','Не может интерпретировать confusion matrix']},
      { level:'Basic',   items:['Применяет mainstream библиотеки (scikit-learn, XGBoost)','Знает базовый feature engineering','Использует cross-validation']},
      { level:'Intermediate', items:['Строит end-to-end пайплайны','Понимает leakage, drift, calibration','Деплоит модели в продакшн']},
      { level:'Advanced',items:['Работает с DL (PyTorch / TF)','Знает MLOps best practices: monitoring, retraining','Читает свежие статьи и имплементирует']},
      { level:'Exceptional', items:['Публикуется на ведущих конференциях','SOTA-результаты в своём домене','Наставник для всей ML-функции']},
    ]},
    { name:'Statistics', desc:'Статистика, эксперименты, causal inference', levels: [
      { level:'Poor',    items:['Путает correlation и causation','Не знает что такое p-value']},
      { level:'Basic',   items:['Применяет t-test и χ²','Понимает базовое распределение выборок','Считает confidence intervals']},
      { level:'Intermediate', items:['Проектирует A/B-тесты','Понимает power, MDE, sample size','Применяет bayesian методы для базовых задач']},
      { level:'Advanced',items:['Владеет causal inference (IV, DiD, Synthetic Control)','Строит сложные experiment frameworks','Корректирует для множественного сравнения']},
      { level:'Exceptional', items:['Research-level работа по causality','Строит platform для экспериментов всей компании','Регулярно публикует и выступает']},
    ]},
  ],
};

const SCORECARDS = {
  deliverables: SCORECARD_DELIVERABLES,
  culture: SCORECARD_CULTURE,
  skills_ml: SCORECARD_SKILLS_ML,
  skills_pm: SCORECARD_SKILLS_PM,
  skills_ds: SCORECARD_SKILLS_DS,
};

/* ════════════════════════════════════════════════════════════════════════
   COMMIT_3 · SCORECARDS CRUD · client-side block
   29 apr 2026 · Айканыш

   Что это за файл:
   Один монолитный JSX-блок, который надо вставить в index.html
   ВМЕСТО старого ScorecardLibrary (строки 4929-5006) и ВМЕСТЕ с
   новым контекстом для live-загрузки из Supabase.

   Зависимости:
     • supabase (есть с 0001+)
     • permissions объект (perms.isHR, perms.isDirector) — определены в App
     • Card / CardHead / Icon / masteryChip — существующие компоненты
     • SCORECARD_DELIVERABLES, SCORECARD_CULTURE, ... — оставляем как FALLBACK
       на случай, если Supabase ещё не ответил на первом рендере.

   Структура блока:
     1. ScorecardsContext + ScorecardsProvider + useScorecards()
     2. <ScorecardEditor/> — модалка create/edit
     3. <ScorecardLibrary/> — обновлённый список с Edit/Add/Archive
     4. Fallback bridge — заполняет window.SCORECARDS_LIVE для других компонент

   См. README_APPLY.md, шаги 3-5.
   ════════════════════════════════════════════════════════════════════════ */

/* ──────────────────────────────────────────────────────────────────────
   1. CONTEXT + HOOK
   ────────────────────────────────────────────────────────────────────── */

const ScorecardsContext = React.createContext(null);

const FALLBACK_SCORECARDS_LIST = [
  { key:'deliverables', ...SCORECARD_DELIVERABLES, scope:'company', role_key:null,         tag:'Company-wide',         color:'amber',   id:null, current_version:0 },
  { key:'culture',      ...SCORECARD_CULTURE,      scope:'company', role_key:null,         tag:'Company-wide',         color:'emerald', id:null, current_version:0 },
  { key:'skills_ml',    ...SCORECARD_SKILLS_ML,    scope:'role',    role_key:'ml_engineer', tag:'Role: ML Engineer',    color:'brand',   id:null, current_version:0 },
  { key:'skills_pm',    ...SCORECARD_SKILLS_PM,    scope:'role',    role_key:'pm',          tag:'Role: PM',             color:'violet',  id:null, current_version:0 },
  { key:'skills_ds',    ...SCORECARD_SKILLS_DS,    scope:'role',    role_key:'data_scientist', tag:'Role: Data Scientist', color:'emerald', id:null, current_version:0 },
];

const ScorecardsProvider = ({ children }) => {
  const [list, setList]   = useState(FALLBACK_SCORECARDS_LIST);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);
  const [hydrated, setHydrated] = useState(false);

  const reload = useCallback(async () => {
    if (!supabase) { setLoading(false); return; }
    setLoading(true);
    setError(null);
    try {
      const { data, error } = await supabase
        .from('scorecards_view')
        .select('id, key, scope, role_key, is_active, current_version_id, current_version, title, owner, formula, tag, color, dimensions, current_published_at')
        .eq('is_active', true)
        .order('scope', { ascending: true })
        .order('title', { ascending: true });
      if (error) throw error;
      if (data && data.length) {
        const mapped = data.map(r => ({
          id: r.id, key: r.key, scope: r.scope, role_key: r.role_key,
          tag: r.tag || (r.scope==='company' ? 'Company-wide' : `Role: ${r.role_key||''}`),
          color: r.color || 'brand',
          title: r.title, owner: r.owner, formula: r.formula,
          dimensions: r.dimensions || [],
          current_version: r.current_version || 1,
          current_version_id: r.current_version_id,
        }));
        setList(mapped);
        // Bridge для legacy-кода, который читает SCORECARD_* напрямую
        window.SCORECARDS_LIVE = Object.fromEntries(mapped.map(s => [s.key, s]));
        setHydrated(true);
      }
    } catch (e) {
      console.warn('[scorecards] hydrate failed, using fallback constants:', e);
      setError(e.message || String(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const value = useMemo(() => ({ list, loading, error, hydrated, reload }), [list, loading, error, hydrated, reload]);
  return <ScorecardsContext.Provider value={value}>{children}</ScorecardsContext.Provider>;
};

const useScorecards = () => {
  const ctx = useContext(ScorecardsContext);
  if (!ctx) throw new Error('useScorecards must be used inside <ScorecardsProvider>');
  return ctx;
};

/* ──────────────────────────────────────────────────────────────────────
   2. EDITOR — модалка create / edit
   ────────────────────────────────────────────────────────────────────── */

const LEVEL_ORDER = ['Poor','Basic','Intermediate','Advanced','Exceptional'];
const COLOR_OPTIONS = ['amber','emerald','brand','violet','rose','sky'];

const emptyDimension = () => ({
  name: '',
  desc: '',
  levels: LEVEL_ORDER.map(l => ({ level: l, items: [''] })),
});

const ScorecardEditor = ({ initial, onClose, onSaved }) => {
  // initial = null → create mode; иначе edit (publish new version)
  const isEdit = !!(initial && initial.id);

  const [key, setKey]           = useState(initial?.key || '');
  const [scope, setScope]       = useState(initial?.scope || 'company');
  const [roleKey, setRoleKey]   = useState(initial?.role_key || '');
  const [title, setTitle]       = useState(initial?.title || '');
  const [owner, setOwner]       = useState(initial?.owner || '');
  const [formula, setFormula]   = useState(initial?.formula || '');
  const [tag, setTag]           = useState(initial?.tag || '');
  const [color, setColor]       = useState(initial?.color || 'brand');
  const [dimensions, setDimensions] = useState(
    initial?.dimensions?.length ? JSON.parse(JSON.stringify(initial.dimensions)) : [emptyDimension()]
  );
  const [changeNote, setChangeNote] = useState('');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  const updateDim = (i, patch) =>
    setDimensions(d => d.map((x,idx) => idx===i ? {...x, ...patch} : x));
  const addDim = () => setDimensions(d => [...d, emptyDimension()]);
  const removeDim = (i) => setDimensions(d => d.filter((_,idx)=>idx!==i));
  const moveDim = (i, dir) => setDimensions(d => {
    const j = i + dir;
    if (j<0 || j>=d.length) return d;
    const next = d.slice(); [next[i], next[j]] = [next[j], next[i]];
    return next;
  });

  const updateLevelItem = (di, li, ii, value) =>
    setDimensions(d => d.map((x,idx) => idx!==di ? x : {
      ...x,
      levels: x.levels.map((lv,lidx) => lidx!==li ? lv : {
        ...lv,
        items: lv.items.map((it,iidx) => iidx===ii ? value : it),
      }),
    }));
  const addLevelItem = (di, li) =>
    setDimensions(d => d.map((x,idx) => idx!==di ? x : {
      ...x,
      levels: x.levels.map((lv,lidx) => lidx!==li ? lv : { ...lv, items: [...lv.items, ''] }),
    }));
  const removeLevelItem = (di, li, ii) =>
    setDimensions(d => d.map((x,idx) => idx!==di ? x : {
      ...x,
      levels: x.levels.map((lv,lidx) => lidx!==li ? lv : {
        ...lv,
        items: lv.items.length===1 ? [''] : lv.items.filter((_,iidx)=>iidx!==ii),
      }),
    }));

  const validate = () => {
    if (!isEdit && !key.trim())               return 'Введи machine key (например, skills_design)';
    if (!isEdit && !/^[a-z0-9_]+$/.test(key)) return 'Key — латиница, цифры, _';
    if (!title.trim())                        return 'Введи название (title)';
    if (!owner.trim())                        return 'Укажи owner-а';
    if (!formula.trim())                      return 'Опиши формулу';
    if (scope==='role' && !roleKey.trim())    return 'Для role-scoped scorecard нужен role_key';
    if (!dimensions.length)                   return 'Нужно как минимум одно измерение';
    for (let i=0;i<dimensions.length;i++) {
      if (!dimensions[i].name.trim()) return `Измерение #${i+1}: введи name`;
      const cleanLevels = dimensions[i].levels
        .map(lv => ({...lv, items: lv.items.map(s=>s.trim()).filter(Boolean)}));
      if (cleanLevels.every(lv => lv.items.length===0))
        return `Измерение «${dimensions[i].name}»: хотя бы один уровень должен иметь items`;
    }
    return null;
  };

  const handleSave = async () => {
    const v = validate();
    if (v) { setErr(v); return; }
    setErr(null);
    setSaving(true);
    try {
      const cleanDims = dimensions.map(d => ({
        name: d.name.trim(),
        desc: (d.desc||'').trim(),
        levels: d.levels.map(lv => ({
          level: lv.level,
          items: (lv.items||[]).map(s=>s.trim()).filter(Boolean),
        })),
      }));

      let result;
      if (isEdit) {
        result = await supabase.rpc('publish_scorecard_version', {
          p_scorecard_id: initial.id,
          p_title: title.trim(),
          p_owner: owner.trim(),
          p_formula: formula.trim(),
          p_tag: tag.trim() || null,
          p_color: color,
          p_dimensions: cleanDims,
          p_change_note: changeNote.trim() || null,
        });
      } else {
        result = await supabase.rpc('create_scorecard', {
          p_key: key.trim(),
          p_scope: scope,
          p_role_key: scope==='role' ? roleKey.trim() : null,
          p_title: title.trim(),
          p_owner: owner.trim(),
          p_formula: formula.trim(),
          p_tag: tag.trim() || null,
          p_color: color,
          p_dimensions: cleanDims,
          p_change_note: changeNote.trim() || 'initial version',
        });
      }
      if (result.error) throw result.error;
      onSaved?.();
      onClose?.();
    } catch (e) {
      console.error('[scorecard editor] save failed:', e);
      setErr(e.message || String(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 grid place-items-center p-4 fade-in" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-lift max-w-4xl w-full max-h-[92vh] overflow-y-auto scrollbar"
           onClick={e=>e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-ink-100 px-6 py-4 flex items-center justify-between z-10">
          <div>
            <div className="text-lg font-bold">{isEdit ? `Редактировать: ${initial.title}` : 'Новый scorecard'}</div>
            <div className="text-xs text-ink-500">
              {isEdit ? `Сохранение создаст версию v${(initial.current_version||1)+1}. Старые reviews останутся на v${initial.current_version||1}.`
                      : 'Заполни все поля. Можно править после создания.'}
            </div>
          </div>
          <button onClick={onClose} className="text-ink-500 hover:text-ink-900 p-1">
            <Icon name="close" className="w-5 h-5"/>
          </button>
        </div>

        <div className="p-6 space-y-5">
          {/* Meta */}
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-semibold text-ink-600">Machine key {isEdit && <span className="text-ink-400">(нельзя менять)</span>}</label>
              <input value={key} disabled={isEdit}
                     onChange={e=>setKey(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g,''))}
                     placeholder="skills_design"
                     className="mt-1 w-full rounded-xl border border-ink-200 px-3 py-2 text-sm font-mono disabled:bg-ink-50 disabled:text-ink-500"/>
            </div>
            <div>
              <label className="text-xs font-semibold text-ink-600">Scope</label>
              <select value={scope} disabled={isEdit} onChange={e=>setScope(e.target.value)}
                      className="mt-1 w-full rounded-xl border border-ink-200 px-3 py-2 text-sm disabled:bg-ink-50">
                <option value="company">Company-wide</option>
                <option value="role">Role-specific</option>
              </select>
            </div>
            <div>
              <label className="text-xs font-semibold text-ink-600">Title</label>
              <input value={title} onChange={e=>setTitle(e.target.value)} placeholder="Designer — Skills"
                     className="mt-1 w-full rounded-xl border border-ink-200 px-3 py-2 text-sm"/>
            </div>
            <div>
              <label className="text-xs font-semibold text-ink-600">Owner</label>
              <input value={owner} onChange={e=>setOwner(e.target.value)} placeholder="Head of Design"
                     className="mt-1 w-full rounded-xl border border-ink-200 px-3 py-2 text-sm"/>
            </div>
            <div className="md:col-span-2">
              <label className="text-xs font-semibold text-ink-600">Formula (как считается итог)</label>
              <input value={formula} onChange={e=>setFormula(e.target.value)} placeholder="AVG по навыкам"
                     className="mt-1 w-full rounded-xl border border-ink-200 px-3 py-2 text-sm font-mono"/>
            </div>
            {scope==='role' && (
              <div>
                <label className="text-xs font-semibold text-ink-600">Role key</label>
                <input value={roleKey} disabled={isEdit}
                       onChange={e=>setRoleKey(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g,''))}
                       placeholder="designer"
                       className="mt-1 w-full rounded-xl border border-ink-200 px-3 py-2 text-sm font-mono disabled:bg-ink-50"/>
              </div>
            )}
            <div>
              <label className="text-xs font-semibold text-ink-600">Tag (бейдж в карточке)</label>
              <input value={tag} onChange={e=>setTag(e.target.value)} placeholder="Role: Designer"
                     className="mt-1 w-full rounded-xl border border-ink-200 px-3 py-2 text-sm"/>
            </div>
            <div>
              <label className="text-xs font-semibold text-ink-600">Color</label>
              <div className="mt-1 flex gap-2">
                {COLOR_OPTIONS.map(c => (
                  <button key={c} type="button" onClick={()=>setColor(c)}
                          className={`w-8 h-8 rounded-lg bg-${c}-200 border-2 transition ${color===c ? `border-${c}-600 ring-2 ring-${c}-300` : 'border-transparent'}`}
                          title={c}/>
                ))}
              </div>
            </div>
          </div>

          {/* Dimensions */}
          <div>
            <div className="flex items-center justify-between mb-2">
              <div className="font-bold">Измерения · {dimensions.length}</div>
              <button type="button" onClick={addDim}
                      className="text-xs px-3 py-1.5 rounded-lg bg-brand-600 text-white hover:bg-brand-700">
                + Добавить измерение
              </button>
            </div>
            <div className="space-y-4">
              {dimensions.map((d, di) => (
                <div key={di} className="border border-ink-200 rounded-2xl p-4 bg-ink-50/30">
                  <div className="flex items-start gap-2 mb-3">
                    <div className="flex-1 grid md:grid-cols-2 gap-2">
                      <input value={d.name} onChange={e=>updateDim(di, {name: e.target.value})}
                             placeholder="Название измерения (Speed, Ownership, …)"
                             className="rounded-xl border border-ink-200 px-3 py-2 text-sm font-semibold bg-white"/>
                      <input value={d.desc} onChange={e=>updateDim(di, {desc: e.target.value})}
                             placeholder="Короткое описание"
                             className="rounded-xl border border-ink-200 px-3 py-2 text-sm bg-white"/>
                    </div>
                    <div className="flex flex-col gap-1">
                      <button type="button" onClick={()=>moveDim(di, -1)} disabled={di===0}
                              className="text-xs px-2 py-1 rounded-md bg-white border border-ink-200 hover:bg-ink-100 disabled:opacity-30">↑</button>
                      <button type="button" onClick={()=>moveDim(di, 1)} disabled={di===dimensions.length-1}
                              className="text-xs px-2 py-1 rounded-md bg-white border border-ink-200 hover:bg-ink-100 disabled:opacity-30">↓</button>
                      <button type="button" onClick={()=>removeDim(di)} disabled={dimensions.length===1}
                              className="text-xs px-2 py-1 rounded-md bg-white border border-rose-200 text-rose-600 hover:bg-rose-50 disabled:opacity-30">✕</button>
                    </div>
                  </div>

                  {d.levels.map((lv, li) => (
                    <div key={li} className="mt-2">
                      <div className="text-[11px] font-semibold uppercase tracking-wider text-ink-500 mb-1">
                        {lv.level}
                      </div>
                      <div className="space-y-1.5">
                        {lv.items.map((item, ii) => (
                          <div key={ii} className="flex gap-2">
                            <input value={item}
                                   onChange={e=>updateLevelItem(di, li, ii, e.target.value)}
                                   placeholder="Observable behavior…"
                                   className="flex-1 rounded-lg border border-ink-200 px-3 py-1.5 text-[13px] bg-white"/>
                            <button type="button" onClick={()=>removeLevelItem(di, li, ii)}
                                    className="text-xs px-2 py-1 rounded-md bg-white border border-ink-200 hover:bg-rose-50 hover:border-rose-200 hover:text-rose-600">✕</button>
                          </div>
                        ))}
                        <button type="button" onClick={()=>addLevelItem(di, li)}
                                className="text-xs text-brand-600 hover:text-brand-800">+ Добавить пункт</button>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* Change note */}
          <div>
            <label className="text-xs font-semibold text-ink-600">Что изменилось (change note для аудита)</label>
            <textarea value={changeNote} onChange={e=>setChangeNote(e.target.value)} rows={2}
                      placeholder="например: добавили dimension Stakeholder Mgmt, переписали Advanced для Problem Solving"
                      className="mt-1 w-full rounded-xl border border-ink-200 px-3 py-2 text-sm"/>
          </div>

          {err && (
            <div className="bg-rose-50 border border-rose-200 text-rose-700 rounded-xl p-3 text-sm">{err}</div>
          )}
        </div>

        <div className="sticky bottom-0 bg-white border-t border-ink-100 px-6 py-3 flex items-center justify-end gap-2">
          <button onClick={onClose} disabled={saving}
                  className="px-4 py-2 text-sm rounded-xl border border-ink-200 hover:bg-ink-50">Отмена</button>
          <button onClick={handleSave} disabled={saving}
                  className="px-4 py-2 text-sm rounded-xl bg-brand-600 text-white hover:bg-brand-700 disabled:opacity-60">
            {saving ? 'Сохраняю…' : (isEdit ? `Опубликовать v${(initial.current_version||1)+1}` : 'Создать scorecard')}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ──────────────────────────────────────────────────────────────────────
   3. LIBRARY — обновлённый компонент (заменяет старый ScorecardLibrary)
   ────────────────────────────────────────────────────────────────────── */

const ScorecardLibrary = ({ onOpen, canEdit = false }) => {
  // canEdit передаётся из App как (perms.isHR || perms.isDirector).
  // perms — closure-переменная внутри App, поэтому пробрасываем через prop.
  const { list, loading, error, reload, hydrated } = useScorecards();
  const [active, setActive]   = useState(null);
  const [editing, setEditing] = useState(null);      // { } = open editor; null = closed
  const [busy, setBusy]       = useState(false);

  const items = list.map(s => ({
    k: s.key, id: s.id, title: s.title, owner: s.owner, formula: s.formula,
    dims: (s.dimensions||[]).length, tag: s.tag, color: s.color,
    raw: s,
  }));
  const sc = active ? list.find(s => s.key === active) : null;

  const handleArchive = async (sc) => {
    if (!sc?.id) return;
    if (!confirm(`Архивировать «${sc.title}»? Скрывается из библиотеки, но не удаляется.`)) return;
    setBusy(true);
    try {
      const { error } = await supabase.rpc('archive_scorecard', { p_scorecard_id: sc.id });
      if (error) throw error;
      await reload();
      setActive(null);
    } catch (e) {
      alert(`Ошибка архивации: ${e.message || e}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="p-8 space-y-5 fade-in">
      <Card>
        <CardHead title="Scorecard Library"
                  subtitle="Единые стандарты оценки. Менеджер отвечает Да/Нет — уровень определяется первым «Нет»."
                  right={canEdit && (
                    <button onClick={()=>setEditing({})}
                            className="text-xs px-3 py-1.5 rounded-lg bg-brand-600 text-white hover:bg-brand-700 flex items-center gap-1">
                      <Icon name="plus" className="w-3.5 h-3.5"/> Новый scorecard
                    </button>
                  )}/>

        {loading && !hydrated && (
          <div className="px-5 pb-3 text-xs text-ink-500">Загружаю scorecards из Supabase…</div>
        )}
        {error && (
          <div className="px-5 pb-3 text-xs text-rose-600">
            Не удалось загрузить из БД ({error}). Показываю встроенные fallback-ы.
          </div>
        )}

        <div className="p-5 grid md:grid-cols-2 gap-4">
          {items.map(it => (
            <div key={it.k}
                 className={`relative text-left rounded-2xl border ${active===it.k ? 'border-brand-400 ring-2 ring-brand-100' : 'border-ink-100 hover:border-brand-300'} hover:shadow-lift transition p-5 bg-white cursor-pointer`}
                 onClick={()=>setActive(active===it.k ? null : it.k)}>
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded-xl grid place-items-center bg-${it.color}-100 text-${it.color}-700`}>
                  <Icon name={it.k.startsWith('skills')?'book':it.k==='culture'?'sparkle':'target'} className="w-5 h-5"/>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-bold truncate">{it.title}</div>
                  <div className="text-xs text-ink-500 mt-0.5">Owner: {it.owner} · {it.dims} {ruPlural(it.dims,['измерение','измерения','измерений'])}</div>
                </div>
                <span className="text-[10px] uppercase tracking-wider bg-ink-100 text-ink-600 px-1.5 py-0.5 rounded shrink-0">{it.tag}</span>
              </div>
              <div className="mt-3 font-mono text-xs text-ink-500 bg-ink-50 rounded-lg p-2 truncate">{it.formula}</div>

              {canEdit && it.id && (
                <div className="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition" style={{opacity: active===it.k ? 1 : undefined}}>
                  <button onClick={(e)=>{e.stopPropagation(); setEditing(it.raw);}}
                          className="text-[11px] px-2 py-1 rounded-md bg-white border border-ink-200 hover:bg-brand-50 hover:border-brand-300 hover:text-brand-700">
                    Редактировать
                  </button>
                  <button onClick={(e)=>{e.stopPropagation(); handleArchive(it.raw);}}
                          disabled={busy}
                          className="text-[11px] px-2 py-1 rounded-md bg-white border border-ink-200 hover:bg-rose-50 hover:border-rose-300 hover:text-rose-700">
                    Архивировать
                  </button>
                </div>
              )}
            </div>
          ))}

          {canEdit && (
            <button onClick={()=>setEditing({})}
                    className="rounded-2xl border-2 border-dashed border-ink-200 p-5 hover:border-brand-400 hover:bg-brand-50/40 transition text-ink-500 hover:text-brand-700 flex flex-col items-center justify-center gap-2">
              <Icon name="plus" className="w-6 h-6"/>
              <div className="font-semibold">Создать scorecard</div>
              <div className="text-xs">Для новой роли (Designer, SRE, Research…)</div>
            </button>
          )}
        </div>
      </Card>

      {sc && (
        <Card className="slide-up">
          <CardHead title={sc.title}
                    subtitle={`Owner: ${sc.owner} · ${sc.formula}${sc.current_version ? ` · v${sc.current_version}` : ''}`}
                    right={<button onClick={()=>setActive(null)} className="text-xs text-ink-500 hover:text-ink-900 flex items-center gap-1">Закрыть <Icon name="close" className="w-3.5 h-3.5"/></button>}/>
          <div className="p-5 space-y-5">
            {(sc.dimensions||[]).map((d,i)=>(
              <div key={i}>
                <div className="flex items-center gap-2 mb-2">
                  <div className="font-bold">{d.name}</div>
                  <div className="text-xs text-ink-500">{d.desc}</div>
                </div>
                <div className="overflow-x-auto scrollbar">
                  <table className="w-full text-sm border border-ink-100 rounded-xl overflow-hidden">
                    <thead className="bg-ink-900 text-white text-xs">
                      <tr>
                        <th className="text-left px-3 py-2 font-semibold w-[130px]"><Term name="Mastery"/></th>
                        <th className="text-left px-3 py-2 font-semibold"><Term name="Observable behaviors"/></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-ink-100">
                      {(d.levels||[]).map(lv=>(
                        <tr key={lv.level} className="bg-white">
                          <td className="px-3 py-2 align-top">
                            <span className={typeof masteryChip==='function' ? masteryChip(lv.level) : 'text-xs font-semibold'}>{lv.level}</span>
                          </td>
                          <td className="px-3 py-2">
                            <ul className="space-y-1">
                              {(lv.items||[]).map((it,idx)=>(
                                <li key={idx} className="flex gap-2 text-[13px]">
                                  <div className="w-1 h-1 rounded-full bg-ink-400 mt-2 shrink-0"></div>
                                  <span>{it}</span>
                                </li>
                              ))}
                            </ul>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </Card>
      )}

      {editing !== null && (
        <ScorecardEditor
          initial={editing && editing.id ? editing : null}
          onClose={()=>setEditing(null)}
          onSaved={async ()=>{ await reload(); }}
        />
      )}
    </div>
  );
};


/* ───── People: Freedom AI Labs, 29 сотрудников (Notion snapshot, apr 2026) ─────
 * SECURITY NOTE (20 apr 2026, обновлено 22 apr 2026):
 *   PII fields — phone, telegram, birthday, start_date, tenure — ПЕРЕНЕСЕНЫ
 *   в Supabase и hydrate-ятся через public.employee_pii (self+manager+HR+exec).
 *   В этом файле они пустые: публичный HTML больше НЕ содержит PII.
 *   Загружаются в useEffect `hydrateEmployeesFromSupabase` после Supabase auth.
 *
 *   Compensation (base salary, equity grant) — УДАЛЕНО из системы 22 apr 2026.
 *   Не хранится во фронтенде, не экспортируется, не загружается из Supabase.
 *   Позиции r[10] и r[11] в массиве RAW_PEOPLE остались = 0 для сохранения
 *   индексов остальных полей, но mapper их игнорирует.
 *
 * Иерархия: u1 Рамиль Мухоряпов (CEO) → u2 Айканыш Сапаралиева (Executive Director) →
 * u3 Куаныш Беккулов (CTO), u4 Хасан Исламов (CPO), u5 Сергей Зубарев (CRDO),
 * u6 Адмет Жакупов (Head of AI Assistant). Engineering line через u7 (Head of SE),
 * u8 (Head of QA), u9 (Head of AI). PMs → CPO / Head of AI Assistant. Back Office → Exec Director.
 * Поля (23): id, name, role, roleKey, seniority, team, managerId, avatar, color,
 *            tenure, base, equity, currentGrade, subteam,
 *            nameEn, email, phone, telegram, department, workFormat, lifecycleStage, birthDate, startDate */
/* SEC-03 fix 17 May 2026 — PII (ФИО кириллицей, латиницей, emails) ВЫРЕЗАНЫ
 * из публичного bundle. Раньше RAW_PEOPLE содержал 31 email + ФИО, что давало
 * атакующему стартовый набор для энумерации (см. audit_16may2026.docx).
 *
 * Что осталось в seed: id, role, roleKey, seniority, team, managerId, avatar-инициалы,
 * color, department, workFormat, lifecycleStage — это структурный скелет без PII.
 *
 * Реальные ФИО + email + phone + telegram + birthday приходят из Supabase после
 * auth: hydrateEmployeesFromSupabase() → app.employees + public.employee_pii.
 * Поле hasName: false → UI показывает placeholder вида "— <Role>" пока данные
 * не пришли (миллисекунды после login). При невалидной auth-сессии страницу
 * редиректит на AuthScreen без отображения людей. */
const RAW_PEOPLE = [
  /* ───── Top Management ───── */
  ['u1','','CEO','head','Director','Top Management',null,'CEO','brand',0,0,0,null,'Executive','','','','','Top Management','Offline','onboarding','',''],
  ['u2','','Executive Director','head','Director','Top Management','u1','ED','brand',0,0,0,null,'Executive','','','','','Top Management','Offline','active','',''],
  ['u3','','CTO','head','Director','Top Management','u2','CTO','brand',0,0,0,null,'CTO','','','','','Top Management','Offline','active','',''],
  ['u4','','CPO','head','Director','Top Management','u2','CPO','brand',0,0,0,null,'CPO','','','','','Top Management','Offline','active','',''],
  ['u5','','CRDO','head','Director','Top Management','u2','CRDO','violet',0,0,0,null,'CRDO','','','','','Top Management','Offline','active','',''],
  ['u6','','Head of AI Assistant','head','Director','Top Management','u2','HAA','accent',0,0,0,null,'AI Assistant Stream','','','','','Top Management','Offline','onboarding','',''],

  /* ───── Engineering line (Heads → CTO) ───── */
  ['u7','','Head of Software Engineering','head','Lead','Software Engineering','u3','HSE','brand',0,0,0,null,'Engineering','','','','','Software Engineering','Offline','active','',''],
  ['u8','','Head of Quality Assurance','head','Lead','Quality Assurance','u3','HQA','violet',0,0,0,null,'QA','','','','','Quality Assurance','Offline','preboarding','',''],
  ['u9','','Head of Artificial Intelligence','head','Lead','Freedom Speech','u3','HAI','violet',0,0,0,null,'Freedom Speech','','','','','Freedom Speech','Offline','active','',''],

  /* ───── Product Managers ───── */
  ['u10','','Project Manager','pm','Senior','AI Platform Stream','u4','PM','accent',0,0,0,null,'Freedom AI Assistant','','','','','AI Platform Stream','Offline','onboarding','',''],
  ['u11','','Product Manager','pm','Senior','AI Platform Stream','u4','PM','accent',0,0,0,null,'Freedom Speech','','','','','AI Platform Stream','Offline','active','',''],
  ['u12','','Product Manager','pm','Senior','AI Assistant Stream','u6','PM','accent',0,0,0,null,'Freedom AI Assistant Ecosystem','','','','','AI Assistant Stream','Offline','onboarding','',''],
  ['u13','','Product Manager','pm','Senior','AI Assistant Stream','u6','PM','accent',0,0,0,null,'Contact Center AI Assistant','','','','','AI Assistant Stream','Hybrid','onboarding','',''],

  /* ───── Backend / Frontend Engineers (line → Head of SE) ───── */
  ['u14','','Backend Engineer','ops','Mid','Software Engineering','u7','BE','brand',0,0,0,null,'Freedom AI Assistant','','','','','Software Engineering','Offline','active','',''],
  ['u15','','Backend Engineer','ops','Mid','Software Engineering','u7','BE','brand',0,0,0,null,'Freedom AI Assistant','','','','','Software Engineering','Remote','active','',''],
  ['u16','','Backend Engineer','ops','Mid','Software Engineering','u7','BE','brand',0,0,0,null,'Freedom AI Assistant','','','','','Software Engineering','Offline','onboarding','',''],
  ['u17','','Frontend Engineer','ops','Mid','Software Engineering','u7','FE','brand',0,0,0,null,'Freedom AI Assistant Ecosystem','','','','','Software Engineering','Offline','active','',''],
  ['u18','','Backend Engineer','ops','Mid','Software Engineering','u7','BE','brand',0,0,0,null,'Freedom AI Assistant Ecosystem','','','','','Software Engineering','Offline','onboarding','',''],
  ['u19','','Backend Engineer','ops','Mid','Software Engineering','u7','BE','brand',0,0,0,null,'Contact Center AI Assistant','','','','','Software Engineering','Offline','onboarding','',''],
  ['u20','','Backend Engineer','ops','Mid','Software Engineering','u7','BE','brand',0,0,0,null,'Viral Scenarios','','','','','Software Engineering','Offline','onboarding','',''],
  ['u21','','Backend Engineer','ops','Mid','Software Engineering','u7','BE','brand',0,0,0,null,'Freedom Speech','','','','','Software Engineering','','preboarding','',''],

  /* ───── QA ───── */
  ['u22','','QA Engineer','ops','Mid','Quality Assurance','u8','QA','violet',0,0,0,null,'Freedom AI Assistant','','','','','Quality Assurance','Offline','active','',''],

  /* ───── ML Engineers (line → Head of AI) ───── */
  ['u23','','ML Engineer','ml_engineer','Mid','Freedom Speech','u9','ML','violet',0,0,0,null,'Freedom Speech','','','','','Freedom Speech','Remote','active','',''],
  ['u24','','ML Engineer','ml_engineer','Mid','Freedom Speech','u9','ML','violet',0,0,0,null,'Freedom Speech','','','','','Freedom Speech','Offline','active','',''],
  ['u25','','ML Engineer','ml_engineer','Mid','Freedom Speech','u9','ML','violet',0,0,0,null,'Freedom Speech','','','','','Freedom Speech','Remote','active','',''],
  ['u26','','ML Engineer','ml_engineer','Mid','Freedom Speech','u9','ML','violet',0,0,0,null,'Freedom Speech','','','','','Freedom Speech','Offline','onboarding','',''],
  ['u27','','ML Engineer','ml_engineer','Mid','Freedom Speech','u9','ML','violet',0,0,0,null,'Freedom Speech','','','','','Freedom Speech','Offline','onboarding','',''],

  /* ───── Back Office ───── */
  ['u28','','Business Assistant','ops','Mid','Back Office','u2','BA','accent',0,0,0,null,'Business Office','','','','','Back Office','Offline','onboarding','',''],
  ['u29','','Chief Accountant','ops','Senior','Back Office','u2','CA','accent',0,0,0,null,'Finance','','','','','Back Office','Offline','onboarding','',''],
  /* ───── Top Management · добавлено 29 apr 2026 ───── */
  ['u30','','Chief Operating Officer','head','Director','Top Management','u2','COO','brand',0,0,0,null,'Executive','','','','','Top Management','Offline','active','',''],
];

/* Инициалы роли для аватара, когда имя не указано (fallback на случай импорта CSV без аватара) */
const roleInitials = (role) => {
  const map = {
    'CEO':'CEO','Executive Director':'ED',
    'CTO':'CTO','CPO':'CPO','CRDO':'CRDO',
    'Head of AI Assistant':'HAA',
    'Head of Software Engineering':'HSE',
    'Head of Quality Assurance':'HQA',
    'Head of Artificial Intelligence':'HAI',
    'Project Manager':'PM','Product Manager':'PM',
    'Backend Engineer':'BE','Frontend Engineer':'FE',
    'ML Engineer':'ML','QA Engineer':'QA',
    'Business Assistant':'BA','Chief Accountant':'CA',
  };
  return map[role] || role.split(/\s+/).map(w=>w[0]).join('').slice(0,3).toUpperCase();
};

/* Системная роль доступа.
   COMMIT_5 follow-up (30 apr 2026): уточнили деривацию.
   - HR-функции (write на HR Admin / Forms / Settings / People / Calibration)
     закреплены за Executive Director (Айканыш) и за прочими HR-titled позициями.
     После COMMIT_2 RBAC tightening fullHRAccess = sysRole==='hr', и без этого
     override Айканыш-как-Director теряла доступ к Settings и к управлению людьми.
   - Остальные C-level (CEO/CTO/CPO/CRDO/COO/Chief*) получают 'director' = exec read-only org-wide.
   - Heads с подчинёнными — 'manager', остальные — 'employee'.
*/
/* COMMIT_5 audit P1 #4 fix (30 apr 2026): word-boundary вместо `[\s,]+`, чтобы
   не ловить false-positive из «VP of Engineering, People Ops» (после запятой
   старый регекс матчил «people» как HR). Теперь требуется буквальное
   "VP People" / "VP of People" с `\s+(of\s+)?people\b`. */
const HR_ADMIN_TITLES = /\b(executive director|chro|chief people officer|chief human resources officer|head of (?:hr|people)|vp\s+(?:of\s+)?people|people ops lead)\b/i;
const HR_ADMIN_EMAILS = new Set([
  'saparalieva.a@choco.kz',  // Айканыш — Executive Director, HR-владелец H1 2026
  'jamaldinov.t@choco.kz',   // Тимур Джамалдинов — COO, backup HR-admin
]);

const deriveSysRole = (raw) => {
  const id    = raw[0];
  const role  = (raw[2] || '').trim();
  const sen   = raw[4];
  const email = (raw[15] || '').toLowerCase().trim();

  // 1. HR-admin: явный email-override или HR-titled позиция
  if (email && HR_ADMIN_EMAILS.has(email)) return 'hr';
  if (HR_ADMIN_TITLES.test(role))          return 'hr';

  // 2. Прочие C-level / Director-tier → 'director' (exec read-only)
  if (sen === 'Director' || sen === 'Exec') return 'director';
  if (/^(CEO|CPO|CRDO|CTO|CFO|COO|CMO|CIO|CSO|CHRO|CDO|CRO|CCO)$/i.test(role)) return 'director';
  if (/^Chief\s/i.test(role)) return 'director';

  // 3. Менеджеры — у кого есть подчинённые
  const hasDirects = RAW_PEOPLE.some(o => o[6] === id);
  if (hasDirects) return 'manager';
  return 'employee';
};

const PEOPLE = RAW_PEOPLE.map(r => ({
  id:r[0],
  name: r[1] || `— ${r[2]}`,                    // отображаемое имя
  hasName: !!r[1],                               // реальное имя указано?
  placeholder: !r[1],                            // TBD, требует ввода
  role:r[2], roleKey:r[3], seniority:r[4], team:r[5],
  managerId:r[6],
  avatar: r[7] || roleInitials(r[2]),
  color:r[8], tenure:r[9],
  /* позиции r[10]=base и r[11]=equity игнорируются (22 apr 2026) */
  /* currentGrade = null: первый Performance Review (H1 2026) ещё не прошёл.
     Grade появится после завершения Calibration · Talent Bar review. */
  currentGrade: null, subteam:r[13],
  sysRole: deriveSysRole(r),                     // director | hr | manager | employee
  /* Новые поля из Notion */
  nameEn:        r[14] || '',
  email:         r[15] || null,
  phone:         r[16] || '',
  telegram:      r[17] || '',
  department:    r[18] || '',
  workFormat:    r[19] || '',                    // Offline | Remote | Hybrid
  lifecycleStage: r[20] || 'active',             // active | onboarding | preboarding
  birthDate:     r[21] || '',
  startDate:     r[22] || '',
}));

/* ───── Vacancies: открытые позиции (Hiring в оргсхеме) ─────
   Сид пуст: после миграции на боевую команду из Notion (apr 2026) HR
   заводит вакансии вручную через HiringPage. Все managerId должны
   ссылаться на актуальных u-id из новой PEOPLE. */
/* Поля: id, role, roleKey, seniority, team, subteam, managerId, status, openedDate, priority, candidate */
const RAW_VACANCIES = [];
const VACANCIES = RAW_VACANCIES.map(r => ({
  id:r[0], role:r[1], roleKey:r[2], seniority:r[3], team:r[4], subteam:r[5],
  managerId:r[6], status:r[7], openedDate:r[8], priority:r[9], candidate:r[10],
}));

const teamOf = (id) => PEOPLE.find(p=>p.id===id)?.team;
const peopleBy = (fn) => PEOPLE.filter(fn);
const directs = (mgrId) => PEOPLE.filter(p=>p.managerId===mgrId);
/* Live people registry (apr 2026): store.people прокидывается сюда при каждом ре-рендере,
   чтобы byId() возвращал актуальные HR-правки (photoUrl, email, level, и т.д.).
   Без этого byId() смотрел только seed PEOPLE — фотки, загруженные через HR Admin,
   не подтягивались на Hiring page, AuthScreen, в 360-feedback и т.д. */
let _LIVE_PEOPLE = null;
const _setLivePeople = (p) => { if (Array.isArray(p)) _LIVE_PEOPLE = p; };
const byId = (id) => {
  if (_LIVE_PEOPLE) {
    const hit = _LIVE_PEOPLE.find(p => p.id === id);
    if (hit) return hit;
  }
  return PEOPLE.find(p => p.id === id);
};

/* ───────── ROLE-BASED ACCESS CONTROL ───────── */
/* Матрица прав: director = hr = полный доступ, manager = своя команда, employee = только свой профиль */
const ROLE_LABELS = {
  director: 'Директор',
  hr:       'HR / Performance Team',
  manager:  'Менеджер',
  employee: 'Сотрудник',
};
const ROLE_TONE = {
  director: 'bg-brand-50 text-brand-700 border-brand-200',
  hr:       'bg-violet-50 text-violet-700 border-violet-200',
  manager:  'bg-amber-50 text-amber-700 border-amber-200',
  employee: 'bg-ink-50 text-ink-600 border-ink-200',
};

/* Основной permission helper — возвращает все флаги доступа для текущего пользователя.
   Архитектура (фикс 29 apr 2026, см. project_rbac_exec_hr_split_apr2026):
   - hr_admin   → fullHRAccess: write на HR Admin / Forms / Settings / Calibration / People
   - exec       → execReadOnly: read-only org-wide (Calibration / Promotions / PIP / Hiring / Analytics)
                  но НЕ HR Admin / Forms / Settings (там HR-only write)
   - manager    → видит и пишет по своей команде
   - employee   → только свой профиль и self/dev_plan
   До фикса fullAccess = (director || hr) — exec получал HR-панель. */
const permissions = (user, peopleList) => {
  const people  = peopleList || PEOPLE;
  const sysRole = user?.sysRole || 'employee';
  const hasDirects = people.some(p => p.managerId === user?.id && p.active !== false);
  const fullHRAccess = (sysRole === 'hr');                       // только hr_admin
  const execReadOnly = (sysRole === 'director');                 // exec — read-only org-wide
  const canSeeOrgWide = fullHRAccess || execReadOnly;            // оба видят org-wide read
  const fullAccess   = fullHRAccess;                             // legacy alias = HR-only write
  const isMgr        = fullHRAccess || sysRole === 'manager' || hasDirects;
  /* 18 may 2026: Promotions сузили до HR-admin + CEO (по запросу пользователя).
     Раньше exec read-only видел список org-wide → утечка sensitive data о
     promotion-кандидатах non-HR C-level (Куаныш и др.). Теперь только Айканыш,
     Тимур и Рамиль видят полный список. RLS-side фикс в mig 0059. */
  const isCeo = (user?.role === 'CEO');
  return {
    sysRole,
    roleLabel: ROLE_LABELS[sysRole] || 'Сотрудник',
    // Флаги уровня доступа
    isDirector: sysRole === 'director',
    isHR:       sysRole === 'hr',
    isManager:  isMgr && !fullHRAccess && !execReadOnly,
    isEmployee: !isMgr && !fullHRAccess && !execReadOnly,
    hasDirects,
    fullAccess,                         // legacy: HR-only (= fullHRAccess)
    fullHRAccess,                       // новый: hr_admin write
    execReadOnly,                       // новый: exec read-only
    canSeeOrgWide,                      // новый: HR или exec — оба видят org-wide
    canManageTeam: isMgr,
    // Разделы Sidebar / Dashboard — exec видит read, но не может писать
    canSeeCalibration:  canSeeOrgWide,
    canSeePromotions:   fullHRAccess || isCeo, // 18 may 2026: HR + CEO only — exec read-only снят
    canSeePIP:          canSeeOrgWide,
    canSeePerfTeam:     fullHRAccess,                            // Performance Team mandate — HR-only
    canSeeHiring:       canSeeOrgWide,
    canSeeAnalytics:    canSeeOrgWide,
    canSeeHRAdmin:      fullHRAccess,                            // HR-only — управление сотрудниками
    canSeeForms:        fullHRAccess,                            // HR-only — конструктор форм
    canSeeSettings:     fullHRAccess,                            // HR-only — настройки
    // Контент-уровень
    canViewAllPeople:   canSeeOrgWide,
    canReviewDirects:   isMgr,
    canEditPeople:      fullHRAccess,                            // только HR пишет в employees
    canRunCalibration:  fullHRAccess,                            // запуск калибровки — HR
  };
};

/* Исторические оценки по 4 полугодия */
const QUARTERS = ['H1 2024','H2 2024','H1 2025','H2 2025','H1 2026'];
const PERIODS  = QUARTERS;
const rndSeeded = (seed)=>{let s=seed;return ()=>{s=(s*9301+49297)%233280;return s/233280;};};
const gradeLvl = (overall, bump=0) => {
  const base = {'A-player':3.8,'Above bar':3.0,'Underperformer':2.0}[overall] ?? 3;
  const score = Math.max(1, Math.min(5, Math.round(base + bump)));
  return MASTERY[score-1];
};
const historyFor = (personId) => {
  const p = byId(personId);
  /* Если у сотрудника ещё нет performance grade — история отсутствует (первый цикл).
     После завершения первой Calibration · Talent Bar review HISTORY будет пополняться. */
  if (!p || !p.currentGrade) return [];
  const r = rndSeeded(parseInt(personId.slice(1))*17+3);
  return QUARTERS.slice(0,4).map((q,i) => {
    const drift = (r()-0.5)*0.8;
    const lvl = (dim,base) => {
      const s = Math.max(1, Math.min(5, Math.round(base + drift + (r()-0.5)*0.6)));
      return MASTERY[s-1];
    };
    const base = {'A-player':4.2,'Above bar':3.1,'Underperformer':1.8}[p.currentGrade];
    const skills = lvl('skills',base);
    const deliverables = lvl('deliverables',base);
    const culture = lvl('culture',base+0.2);
    // overall:
    const avg = (MASTERY_SCORE[skills]+MASTERY_SCORE[deliverables]+MASTERY_SCORE[culture])/3;
    const bar = MASTERY_SCORE[talentBarFor(p)];
    let overall = 'Above bar';
    if (avg < bar - 0.5) overall = 'Underperformer';
    else if (avg > bar + 0.8) overall = 'A-player';
    return { cycle:q, skills, deliverables, culture, overall };
  });
};
const HISTORY = Object.fromEntries(PEOPLE.map(p=>[p.id, historyFor(p.id)]));

/* Активный цикл — полугодовой, 6 фаз, Freedom AI Labs пилот H1 2026 */
const ACTIVE_CYCLE = {
  id: 'h1-2026', name: 'Performance Review — H1 2026', quarter: 'H1 2026', period: 'H1 2026',
  kind: 'semi-annual',
  stage: 'Feedback & Self-Assessment',
  stages: [
    { key:'feedback',    label:'Feedback & Self-Assessment', owner:'Employees',         duration:'2 нед',  start:'2026-06-01', end:'2026-06-14', status:'active',  icon:'chat',
      desc:'Сотрудники запрашивают 360-фидбек (до 5 stakeholders), заполняют Self Assessment (5 секций: собранные фидбеки, WHAT, HOW, Outcome, Review). Direct reports дают открытый upward feedback менеджеру.'},
    { key:'manager',     label:'Manager Assessment',         owner:'Managers',          duration:'2 нед',  start:'2026-06-15', end:'2026-06-28', status:'pending', icon:'badge',
      desc:'Менеджер заполняет scorecard (Skills × Deliverables × Culture) с опорой на Self Assessment и 360-фидбек. Может приложить supporting documents. Итог: mastery-уровни + grade.'},
    { key:'calibration', label:'Calibration · Talent Bar review', owner:'Performance Team + People Partner', duration:'1 нед', start:'2026-06-29', end:'2026-07-05', status:'pending', icon:'grid',
      desc:'Перф-команда ведёт калибровку по Talent Bar: grid (Skills × Deliverables × Culture) с проверкой минимального уровня для seniority, A-player cap (15–25%), manager-bias report. Финал: одобрение CEO.'},
    { key:'promo',       label:'Promo Recommendations',      owner:'Managers + Performance Team', duration:'3 дн',  start:'2026-07-06', end:'2026-07-08', status:'pending', icon:'trend',
      desc:'Auto-eligible кандидаты с grade A-player/Above bar. Менеджер готовит STAR-кейс, CEO approves. Промо вступает в силу с началом H2.'},
    { key:'conversation',label:'Hold Performance Conversation', owner:'Managers',       duration:'1 нед',  start:'2026-07-09', end:'2026-07-15', status:'pending', icon:'chat',
      desc:'Обязательный 1:1 debrief: менеджер доносит финальный grade, обсуждает сильные/слабые стороны, согласует Development Plan (для performers) или BoT (для underperformers). Gate для закрытия цикла.'},
    { key:'development', label:'Development Plan / BoT',     owner:'Managers + Employee', duration:'ongoing', start:'2026-07-16', end:'2026-12-31', status:'pending', icon:'target',
      desc:'Development Plan для A-player / Above bar: 2–3 SMART-цели на H2. BoT (Back on Track, 6-нед PIP) для Underperformer: halfway checkpoint + end-date final evaluation.'},
  ],
  submittedPct: 0,
  totalReviews: PEOPLE.length,
  submitted: 0,
  selfSubmitted: 0,
  upwardCollected: 0,
  /* Ключевые артефакты периода */
  keyDates: {
    cycleOpen:     '2026-06-01',
    selfDue:       '2026-06-14',
    managerDue:    '2026-06-28',
    calibrationAt: '2026-06-29',
    ceoApproval:   '2026-07-05',
    promoAnnounce: '2026-07-08',
    conversationBy:'2026-07-15',
    planActive:    '2026-07-16',
  },
};

/* Компания-новости / уведомления.
   COMMIT_8 (audit may 2026, bug 5): даты были захардкожены в будущем
   и подавались как уже произошедшие. Теперь генерируем относительно
   сегодняшнего дня: для будущих — «через N дн», для прошлых — «N дн назад». */
const RU_MONTHS_SHORT = ['янв','фев','мар','апр','май','июн','июл','авг','сен','окт','ноя','дек'];
const fmtRelDate = (iso) => {
  const target = new Date(iso + 'T00:00:00');
  const today  = new Date();
  today.setHours(0,0,0,0);
  const diffDays = Math.round((target - today) / 86400000);
  if (diffDays === 0) return 'сегодня';
  if (diffDays === 1) return 'завтра';
  if (diffDays === -1) return 'вчера';
  const abs = Math.abs(diffDays);
  const wordDays = ruPlural(abs, ['день','дня','дней']);
  if (diffDays > 0 && diffDays <= 14) return `через ${abs} ${wordDays}`;
  if (diffDays < 0 && abs <= 14)      return `${abs} ${wordDays} назад`;
  return `${target.getDate()} ${RU_MONTHS_SHORT[target.getMonth()]}`;
};

const NOTIFS = [
  { id:1, icon:'cal',     t:'Цикл H1 2026 — старт', dateIso: ACTIVE_CYCLE.keyDates.cycleOpen,     body:'Сотрудникам: Self Assessment + запрос 360-фидбека до 14 июня. Менеджерам: дедлайн Manager Assessment — 28 июня'},
  { id:2, icon:'chat',    t:'Upward Feedback — старт сбора', dateIso: ACTIVE_CYCLE.keyDates.cycleOpen, body:'Direct reports приглашены дать именной upward feedback своему менеджеру. Дедлайн — до конца фазы Feedback & Self-Assessment'},
  { id:3, icon:'warn',    t:'Talent Bar калибровка', dateIso: ACTIVE_CYCLE.keyDates.calibrationAt, body:'Product, Platform, Speech — calibration session. People Partner ведёт сессию'},
  { id:4, icon:'sparkle', t:'Auto-eligible: 2 кандидата на promotion', dateIso: ACTIVE_CYCLE.keyDates.promoAnnounce, body:'Grade A-player/Above bar ≥ 2 полугодия подряд. Менеджеру — подготовить STAR-кейс'},
  { id:5, icon:'flag',    t:'Hold Performance Conversation', dateIso: ACTIVE_CYCLE.keyDates.conversationBy, body:'Gate перед Development Plan / BoT. Без 1:1 цикл не закрывается'},
].map(n => ({ ...n, time: fmtRelDate(n.dateIso) }));

/* ───────── UTILS ───────── */
const masteryChip = (level) => {
  const m = {
    Poor:        'bg-poor-bg text-poor-ink',
    Basic:       'bg-basic-bg text-basic-ink',
    Intermediate:'bg-intermediate-bg text-intermediate-ink',
    Advanced:    'bg-advanced-bg text-advanced-ink',
    Exceptional: 'bg-exceptional-bg text-exceptional-ink',
  }[level] || 'bg-ink-100 text-ink-700';
  return `inline-flex items-center px-2 py-0.5 rounded-md text-xs font-semibold ${m}`;
};
const gradeChip = (grade) => {
  const m = {
    'A-player':       'bg-aplayer-bg text-aplayer-ink',
    'Above bar':      'bg-abovebar-bg text-abovebar-ink',
    'Underperformer': 'bg-under-bg text-under-ink',
  }[grade] || 'bg-ink-100 text-ink-700';
  return `inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${m}`;
};

/* Avatar: локальные инициалы на цветной плашке.
   Security (20 apr 2026): раньше использовался api.dicebear.com — это leak'ало имена
   сотрудников на сторонний CDN. Заменили на локальный рендер инициалов. Если HR
   загрузит реальное фото, оно подтягивается из Supabase Storage (p.photoUrl). */
const Avatar = ({ p, size=32 }) => {
  const c = { brand:'bg-brand-600', violet:'bg-violet-500', accent:'bg-amber-500' }[p.color] || 'bg-ink-600';
  const status = personStatus(p);
  if (status === 'vacant' || p.placeholder) {
    /* Вакансия / TBD — пунктирная рамка с инициалами роли */
    return <div className="border-2 border-dashed border-ink-300 text-ink-400 font-semibold flex items-center justify-center rounded-full shrink-0 bg-white" style={{width:size,height:size,fontSize:Math.max(9,size/3)}} title={`Вакантно / TBD — ${p.role}`}>{p.avatar || '??'}</div>;
  }
  /* Если HR загрузил настоящее фото — показываем его */
  if (p.photoUrl) {
    return <img src={p.photoUrl} alt={p.name} className="rounded-full shrink-0 object-cover bg-ink-100" style={{width:size,height:size}}/>;
  }
  /* Иначе — инициалы на цветной плашке. Никаких запросов на сторонние CDN. */
  return (
    <div className={`shrink-0 rounded-full ${c} text-white font-semibold flex items-center justify-center`} style={{width:size,height:size,fontSize:size/2.6}} title={p.name}>
      <span aria-hidden="true">{p.avatar}</span>
    </div>
  );
};

const PersonName = ({ p, className='' }) => (
  p.placeholder
    ? <span className={`italic text-ink-400 ${className}`} title="Имя не заполнено — позиция TBD">{p.role}</span>
    : <span className={className}>{p.name}</span>
);

/* ───────── AUTH / ROLE PICKER ───────── */
/* 4 preset'а — по одному на каждый уровень доступа, чтобы быстро переключаться для демо.
   Пресеты ссылаются на реальных сотрудников из Notion-импорта. */
const ROLE_PRESETS = [
  { id:'u1',  role:'CEO',                      desc:'Полный доступ: calibration, promotions, все данные компании', tag:'Director' },
  { id:'u2',  role:'Executive Director',       desc:'HR-функции: циклы, формы, администрирование, настройки',       tag:'Director · HR' },
  { id:'u7',  role:'Head of Software Engineering', desc:'Своя команда, scorecards, calibration input, dev plans',   tag:'Manager' },
  { id:'u14', role:'Backend Engineer',         desc:'Свой профиль, 360 feedback, self-assessment, история',         tag:'Employee' },
];

/* ─────────────────────────────────────────────────────────────────────
   AuthScreen (apr 2026, Phase 1 Supabase integration)
   — показывает кнопку "Войти через Google" (SSO домен @choco.kz через hd-hint);
   — слушает Supabase auth state; при наличии session резолвит employee по email
     (через RLS-защищённый SELECT на app.employees);
   — fallback: если Supabase недоступен или DEV_AUTH_BYPASS=1, показывает прежний
     role-picker (только для локальной разработки).
   ───────────────────────────────────────────────────────────────────── */
const DEV_AUTH_BYPASS = false; /* установить в true только для локальной dev-работы без Supabase */

const AuthScreen = ({ onPick, livePeople }) => {
  const [sbReady, setSbReady]   = useState(!!supabase);
  const [session, setSession]   = useState(null);
  const [resolving, setResolv]  = useState(false);
  const [authError, setErr]     = useState(null);
  const [signingIn, setSignIn]  = useState(false);

  /* 1. Ждём, пока Supabase ES module догрузится */
  useEffect(() => {
    if (supabase) { setSbReady(true); return; }
    const h = () => setSbReady(true);
    window.addEventListener('supabase-ready', h);
    return () => window.removeEventListener('supabase-ready', h);
  }, []);

  /* 2. Подписываемся на Supabase auth state */
  useEffect(() => {
    if (!sbReady) return;
    const sb = supabase;
    let unsub = null;

    sb.auth.getSession().then(({ data }) => setSession(data.session || null));

    const { data: sub } = sb.auth.onAuthStateChange((_event, s) => {
      setSession(s || null);
    });
    unsub = sub.subscription;
    return () => { if (unsub) unsub.unsubscribe(); };
  }, [sbReady]);

  /* 3. Есть session → резолвим employee по email и пробрасываем onPick */
  useEffect(() => {
    if (!session) return;
    const email = session.user?.email?.toLowerCase();
    if (!email) return;

    setResolv(true);
    (async () => {
      try {
        /* Сначала пробуем по auth_user_id (auto-link trigger должен был связать).
           Берём расширенный набор полей — нужен для synthetic fallback (если seed устарел). */
        const SELECT_FIELDS = 'id,email,full_name,role,team_id,active,title,level,metadata,photo_url,manager_id';
        let { data, error } = await supabase
          .from('employees')
          .select(SELECT_FIELDS)
          .eq('auth_user_id', session.user.id)
          .eq('active', true)
          .maybeSingle();

        /* Fallback: если trigger ещё не сработал — по email */
        if (!data && !error) {
          const r2 = await supabase
            .from('employees')
            .select(SELECT_FIELDS)
            .ilike('email', email)
            .eq('active', true)
            .maybeSingle();
          data = r2.data;
          error = r2.error;
        }

        if (error) { setErr(error.message || String(error)); return; }
        if (!data) {
          setErr(`Аккаунт ${email} не найден в реестре сотрудников. Обратись к HR (Аиканыш).`);
          return;
        }

        /* Мэпим DB employees.id → локальный "u*" id (по metadata.legacy_id в livePeople).
           Для Phase 1 вся UI-логика ещё завязана на u-id'ы. Email — стабильный ключ.
           Synthetic fallback (29 apr 2026): если в seed человека нет (свежий Notion-sync,
           manual INSERT и т.п.) — собираем минимальный профиль из DB-row на лету и
           прокидываем его в _LIVE_PEOPLE. Это убирает блокирующее «не совпадает с seed». */
        let localPerson = (livePeople || []).find(p => (p.email || '').toLowerCase() === email);
        if (!localPerson) {
          /* legacy_id из БД, иначе синтезируем стабильный u-id из uuid-префикса.
             COMMIT_5 audit P1 #7 fix (30 apr 2026): расширили префикс с 8 до 12
             символов — снижает вероятность коллизии при дубликатах первых 8
             символов UUID (теоретически возможно, на практике редко). */
          const legacyId = data.metadata?.legacy_id || ('u_' + (data.id || '').replace(/-/g, '').slice(0,12));
          /* manager legacy_id — отдельный запрос (только если manager_id есть) */
          let managerLegacyId = null;
          if (data.manager_id) {
            const mgr = await supabase
              .from('employees').select('metadata').eq('id', data.manager_id).maybeSingle();
            managerLegacyId = mgr?.data?.metadata?.legacy_id || null;
          }
          const SYS_FROM_DB = { hr_admin:'hr', exec:'director', manager:'manager', employee:'employee' };
          /* COMMIT_5 follow-up (30 apr 2026): override sysRole=hr для Executive Director
             и явных HR-emails, чтобы Айканыш и другие HR-titled позиции получали HR-доступ
             даже если DB-роль ещё не выставлена в hr_admin. */
          const isHrByTitle = HR_ADMIN_TITLES.test(data.title || '');
          const isHrByEmail = HR_ADMIN_EMAILS.has((data.email || '').toLowerCase().trim());
          const dbSysRole   = SYS_FROM_DB[data.role] || 'employee';
          const finalSysRole = (isHrByTitle || isHrByEmail) ? 'hr' : dbSysRole;
          const synthetic = {
            id: legacyId,
            name: data.full_name || email,
            hasName: !!data.full_name,
            placeholder: false,
            role: data.title || 'Сотрудник',
            roleKey: 'ops',
            seniority: data.level || 'Mid',
            team: data.metadata?.team_name || 'Top Management',
            managerId: managerLegacyId,
            avatar: data.photo_url || (data.full_name ? data.full_name.split(' ').map(w=>w[0]).join('').slice(0,2) : '??'),
            color: 'brand',
            tenure: 0,
            currentGrade: null,
            subteam: data.metadata?.subteam || '',
            sysRole: finalSysRole,
            nameEn: data.metadata?.name_en || '',
            email: data.email,
            phone: '', telegram: '', department: data.metadata?.team_name || '',
            workFormat: data.metadata?.work_format || 'Offline',
            lifecycleStage: data.metadata?.lifecycle || 'active',
            birthDate: '', startDate: '',
            active: true,
            photoUrl: data.photo_url || null,
            _synthetic: true,
          };
          /* _LIVE_PEOPLE будет затёрт useStore'ом на следующем рендере, поэтому
             отдаём synthetic в App — пусть он зальёт его через store.addPerson. */
          localPerson = synthetic;
          onPick(synthetic.id, data.role || null, synthetic);
          return;
        }
        /* Передаём DB-роль (employee/manager/hr_admin/exec) — это source of truth для permissions.
           App мэпит её в UI sysRole (employee/manager/hr/director). */
        onPick(localPerson.id, data.role || null);
      } catch (e) {
        setErr(e.message || String(e));
      } finally {
        setResolv(false);
      }
    })();
  }, [session, livePeople, onPick]);

  /* 4. Google SSO click handler */
  const signInWithGoogle = async () => {
    if (!supabase) { setErr('Supabase client ещё не загружен, подожди секунду'); return; }
    setSignIn(true); setErr(null);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin,
        queryParams: {
          hd: 'choco.kz',              /* hint Google: показывать только @choco.kz */
          prompt: 'select_account',
          access_type: 'offline',
        },
      },
    });
    if (error) { setErr(error.message || String(error)); setSignIn(false); }
  };

  const signOut = async () => {
    await supabase.auth.signOut();
    setSession(null); setErr(null);
  };

  /* ─── UI ─── */
  return (
    <div className="min-h-screen bg-ink-50 flex items-center justify-center p-6">
      <div className="w-full max-w-[440px] bg-white rounded-lg border border-ink-100 p-8">
        <div className="flex items-center gap-2.5 mb-6">
          <div className="w-8 h-8 rounded-md bg-brand-600 flex items-center justify-center">
            <Icon name="zap" className="w-4 h-4 text-white" stroke={2.2}/>
          </div>
          <div>
            <div className="font-semibold text-[15px] text-ink-900 leading-none">Freedom AI Labs</div>
            <div className="text-[10px] text-ink-400 mt-0.5">Performance Review Cycle</div>
          </div>
        </div>

        <h2 className="text-[20px] font-semibold tracking-tight text-ink-900 mb-1">Войдите в систему</h2>
        <div className="text-[12px] text-ink-500 mb-5">Используйте корпоративный Google-аккаунт <span className="font-medium text-ink-700">@choco.kz</span>.</div>

        {resolving && (
          <div className="text-[12px] text-ink-500 flex items-center gap-2 mb-4">
            <div className="w-3 h-3 border-2 border-brand-600 border-t-transparent rounded-full animate-spin"></div>
            Проверяем твой профиль в реестре…
          </div>
        )}

        {authError && (
          <div className="mb-4 p-3 rounded-md border border-poor-ring bg-poor-bg text-[12px] text-poor-ink">
            {authError}
          </div>
        )}

        {session ? (
          <div className="space-y-2">
            <div className="text-[12px] text-ink-600">Залогинен как <span className="font-medium text-ink-900">{session.user?.email}</span></div>
            <button onClick={signOut} className="w-full border border-ink-100 rounded-md py-2 text-[13px] text-ink-700 hover:bg-ink-50">
              Выйти и войти под другим аккаунтом
            </button>
          </div>
        ) : (
          <button
            onClick={signInWithGoogle}
            disabled={!sbReady || signingIn}
            className="w-full flex items-center justify-center gap-2.5 border border-ink-200 rounded-md py-2.5 text-[13px] font-medium text-ink-800 hover:border-brand-300 hover:bg-brand-50/40 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
              <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
              <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
              <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
              <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
            </svg>
            {signingIn ? 'Перенаправляем в Google…' : 'Войти через Google'}
          </button>
        )}

        {/* DEV fallback: старый role-picker для локальной разработки, когда SSO ещё не настроен */}
        {DEV_AUTH_BYPASS && (
          <div className="mt-6 pt-4 border-t border-dashed border-ink-200">
            <div className="text-[10px] uppercase tracking-wide text-ink-400 mb-2">DEV · bypass SSO</div>
            <div className="space-y-1.5">
              {ROLE_PRESETS.map(r => {
                const p = (livePeople && livePeople.find(x => x.id === r.id)) || byId(r.id);
                const sys = p?.sysRole || 'employee';
                return (
                  <button key={r.id} onClick={()=>onPick(r.id)} className="group w-full flex items-center gap-2 text-left border border-ink-100 rounded-md p-2 hover:border-brand-300 hover:bg-brand-50/40 transition">
                    <Avatar p={p} size={28}/>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2 flex-wrap">
                        <div className={`text-[12px] font-medium truncate ${p.placeholder ? 'italic text-ink-400' : 'text-ink-900'}`}>{p.placeholder ? r.role : p.name}</div>
                        <span className={`text-[9px] px-1 py-0.5 rounded border ${ROLE_TONE[sys]}`}>{ROLE_LABELS[sys]}</span>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        )}

        <div className="mt-5 pt-4 border-t border-ink-100 text-[11px] text-ink-400">
          Freedom AI Labs · Supabase auth · RLS · v1.0
        </div>
      </div>
    </div>
  );
};

/* ───────── LAYOUT ───────── */
const AppContext = createContext(null);
const useApp = () => useContext(AppContext);

/* ───────── STORE (peopleState + feedback + forms + settings + audit log) ───────── */
/* Простой in-memory store с персистом в localStorage. Seed-данные — PEOPLE/VACANCIES. */
const STORAGE_KEY = 'freedomos_store_v1';

/* Версия цикла-стейта. Бампается при релизах, когда надо сбросить данные
   performance cycle (assessments, placements, conversations и т.д.).
   v2 (apr 2026) = зачистка демо-сидов из прошлых версий app.
   v3 (apr 2026) = импорт боевой команды Freedom AI Labs из Notion (29 человек).
                   На v3 миграции state.people пересеивается из новой PEOPLE-сидя,
                   так как старые u-id (u30-u40) были placeholder и не пересекаются
                   с новой иерархией. HR-правки vacancies/forms/settings сохраняются.
   v4 (apr 2026) = форс-резеед людей: между релизами были корректировки seniority
                   (CTO/CPO/CRDO/Head of AI Assistant ← Director, не Lead) и subteam
                   у нескольких членов команды. Кому досталась v3 со старыми значениями,
                   получают свежий PEOPLE-snapshot; vacancies/forms/settings сохраняются.
                   ВНИМАНИЕ: v4 написана как полный резеед `people: peopleFresh`, что
                   ОЧИЩАЕТ HR-правки (photoUrl, email, phone, telegram). Это баг — см. v5.
   v5 (apr 2026) = безопасный резеед: для savedVersion>=3 используем mergePeople, который
                   сохраняет HR-правки. Дополнительно форс-обновляем seniority='Director'
                   для u3/u4/u5/u6 (CTO/CPO/CRDO/Head of AI Assistant) — это была причина
                   v4-миграции, теперь делается точечно без wipe HR-правок.
   v6 (apr 2026) = чистим "stuck" track/level: PersonForm в v3-v5 стартовала с EMPTY_PERSON
                   дефолтами (track='IC', level='IC3'), и при любом сохранении HR-профиля
                   эти дефолты перезаписывали умный guessLevel(). Для Director'ов (CEO, CTO,
                   CPO, CRDO, Head of AI Assistant) и Heads это давало IC3 вместо M4/M3.
                   Эта миграция обнуляет track/level у всех, кто сохранил seniority-несовместимый
                   уровень — после неё guessLevel() корректно вернёт M4 для CEO/Director и т.д.
   v7 (30 apr 2026) = COMMIT_5: HR-admin override для Айканыш (Executive Director).
                      После COMMIT_2 fullHRAccess стал sysRole==='hr', а deriveSysRole для
                      Executive Director возвращал 'director' → она теряла HR Admin / Settings.
                      Forced sysRole='hr' для emails из HR_ADMIN_EMAILS и titles из HR_ADMIN_TITLES.
                      Также фикс mergePeople (append fresh-only seed людей, типа Тимура u30). */
const CYCLE_DATA_VERSION = 7;
const FORCE_SENIORITY_DIRECTOR = ['u3','u4','u5','u6']; // CTO/CPO/CRDO/Head of AI Assistant
/* Сотрудники с seniority='Director' должны быть на Manager/M4. Если их level/track
   был ошибочно сохранён как IC3/IC (из-за бага PersonForm до v6) — сбрасываем.

   COMMIT_5 audit P1 #8 (30 apr 2026): это INTENTIONAL force-conversion для
   C-level / Director-tier — даже если человек hands-on пишет код, его карьерный
   уровень = M4 (Director-tier), а не IC. Talent Bar для них = Exceptional.
   На малых организациях (FreedomAILabs ~30 чел.) C-level всегда player-coaches,
   но conceptually на Manager-track. */
const cleanStuckLevel = (p) => {
  if (!p) return p;
  const isDirectorRole = p.seniority === 'Director' || /ceo|founder|chief/i.test(p.role) || p.sysRole === 'director';
  if (isDirectorRole && p.track === 'IC' && (p.level === 'IC3' || p.level === 'IC1' || p.level === 'IC2')) {
    const { track, level } = { track: 'Manager', level: 'M4' };
    return { ...p, track, level };
  }
  return p;
};

const DEFAULT_SETTINGS = {
  cycleName: 'H1 2026',
  cycleKind: 'semi-annual',
  cycleStart: '2026-06-01',
  cycleEnd:   '2026-07-15',
  selfAssessmentDue:  '2026-06-14',
  scorecardDeadline:  '2026-06-28',
  calibrationDate:    '2026-06-29',
  ceoApprovalDate:    '2026-07-05',
  conversationDue:    '2026-07-15',
  ratingScale: ['Poor','Basic','Intermediate','Advanced','Exceptional'],
  grades: ['A-player','Above bar','Underperformer'],
  valuesAlignment: ['Role Model','Lives Values','Does not live values'],
  aPlayerCapPct: 25,
  requestFeedbackMax: 5,
  botDurationWeeks: 6,
  developmentPlanEnabled: true,
  holdConversationRequired: true,
  promoCadence: 'semi-annual',
  notifyOnCycleOpen: true,
  notifyOnSelfAssessmentOpen: true,
  notifyOnScorecardOpen: true,
  notifyOnCalibration: true,
  notifyOnFeedbackRequest: true,
  notifyOnUpwardFeedbackReady: true,
  reminderDaysBefore: 3,
  notifyEmailTemplate: 'Привет, {name}. Напоминание: дедлайн по {artifact} — {deadline}.',
};

const DEFAULT_FORMS = [
  {
    id:'form-peer-1',
    name:'Peer-to-peer (стандарт)',
    type:'peer',
    createdAt:'2026-03-20',
    questions:[
      { id:'q1', type:'rating', text:'Какой уровень Skills ты видишь у этого человека?', required:true, scale:5 },
      { id:'q2', type:'rating', text:'Насколько регулярно он/она делает Deliverables в срок?', required:true, scale:5 },
      { id:'q3', type:'likert', text:'Culture fit (соответствие ценностям Freedom AI Labs)', required:true },
      { id:'q4', type:'text', text:'Что этот человек делает лучше всего?', required:true },
      { id:'q5', type:'text', text:'Что могло бы стать следующим шагом роста?', required:false },
    ],
  },
  {
    id:'form-upward-1',
    name:'Upward feedback (на менеджера)',
    type:'upward',
    createdAt:'2026-03-20',
    questions:[
      { id:'q1', type:'rating', text:'Качество фидбека и развития от менеджера', required:true, scale:5 },
      { id:'q2', type:'rating', text:'Clarity целей и ожиданий', required:true, scale:5 },
      { id:'q3', type:'rating', text:'Поддержка в сложных ситуациях', required:true, scale:5 },
      { id:'q4', type:'text', text:'Что менеджер мог бы делать больше / меньше?', required:true },
    ],
  },
  {
    id:'form-selfassess-1',
    name:'Self-assessment (самооценка)',
    type:'self',
    createdAt:'2026-03-20',
    questions:[
      { id:'q1', type:'text', text:'Три главных достижения полугодия', required:true },
      { id:'q2', type:'text', text:'Где я столкнулся с трудностями и чему научился', required:true },
      { id:'q3', type:'rating', text:'Моя самооценка по шкале', required:true, scale:5 },
      { id:'q4', type:'text', text:'Цели на следующее полугодие', required:true },
    ],
  },
];

/* Демо-данные удалены: фидбек-запросы создаются пользователями в цикле. */
const DEFAULT_FEEDBACK_REQUESTS = [];

/* Демо-данные удалены: журнал аудита наполняется реальными действиями пользователей. */
const DEFAULT_AUDIT_LOG = [];

/* Self Assessments — пустая коллекция, сотрудники создают свои в цикле.
   Демо-данные удалены: первый Performance Review (H1 2026) ещё не проводился. */
const DEFAULT_SELF_ASSESSMENTS = [];

/* Talent Bar Calibration Placements — фиксируем финальный grade по итогам Talent Bar review */
const DEFAULT_TALENT_BAR_PLACEMENTS = PEOPLE
  .filter(p => p.currentGrade)
  .map(p => ({
    employeeId: p.id,
    cycleId: 'h1-2026',
    grade: p.currentGrade,                 /* 'A-player' | 'Above bar' | 'Underperformer' */
    placedBy: 'system',
    placedAt: '2026-06-20 10:00',
  }));

/* Manager Assessments — заполняет manager по своим direct reports.
   Пустой seed: H1 2026 ещё в фазе Feedback & Self-Assessment, оценок менеджеров пока нет. */
const DEFAULT_MANAGER_ASSESSMENTS = [];

/* Development Plan — для A-player / Above bar; 2–3 SMART-цели на H2.
   Разблокируется после acknowledged Performance Conversation с nextStep='development'.
   Пустой seed: нет завершённых ревью → нет активных планов. */
const DEFAULT_DEV_PLANS = [];

/* Back on Track (BoT) — для Underperformer, 6-недельный PIP с halfway checkpoint и final review.
   Разблокируется после acknowledged Performance Conversation с nextStep='bot'.
   Пустой seed: нет Underperformer пока Calibration не прошла. */
const DEFAULT_BOT_CASES = [];

/* Hold Performance Conversation — gate между Calibration и Development Plan / BoT.
   Жизненный цикл: pending → scheduled → held (manager signs) → acknowledged (employee signs).
   Без acknowledged невозможно открыть Development Plan или запустить BoT. */
const DEFAULT_CONVERSATIONS = PEOPLE.filter(p=>p.currentGrade && p.manager).map(p => {
  const seed = (p.id.charCodeAt(1) || 0) + (p.id.length || 0);
  /* детерминированное распределение чтобы экран был «живой»: одна часть done, часть scheduled, часть pending */
  const bucket = seed % 10;
  const placement = DEFAULT_TALENT_BAR_PLACEMENTS.find(x=>x.employeeId===p.id);
  const nextStep = placement?.grade==='Underperformer' ? 'bot' : 'development';
  let status = 'pending', scheduledAt=null, heldAt=null, notes='', acknowledgedAt=null, acknowledgedNote='';
  if (bucket <= 2) {
    status = 'acknowledged';
    scheduledAt = '2026-07-09 10:00';
    heldAt = '2026-07-10 15:30';
    notes = 'Обсудили финальный grade, сильные стороны (delivery, ownership), зоны роста (cross-team влияние). Договорились о SMART-целях на H2.';
    acknowledgedAt = '2026-07-11 09:15';
    acknowledgedNote = 'Согласен с оценкой, цели понятны.';
  } else if (bucket <= 5) {
    status = 'held';
    scheduledAt = '2026-07-13 14:00';
    heldAt = '2026-07-14 14:22';
    notes = 'Debrief прошёл, employee просит сутки на обдумать acknowledgement.';
  } else if (bucket <= 7) {
    status = 'scheduled';
    scheduledAt = '2026-07-15 11:00';
  }
  return {
    id: 'conv-'+p.id+'-h1-2026',
    employeeId: p.id,
    managerId: p.manager,
    cycleId: 'h1-2026',
    period: 'H1 2026',
    status, /* pending | scheduled | held | acknowledged */
    scheduledAt,
    heldAt,
    heldBy: heldAt ? p.manager : null,
    notes,
    acknowledgedAt,
    acknowledgedBy: acknowledgedAt ? p.id : null,
    acknowledgedNote,
    finalGrade: p.currentGrade,
    nextStep, /* development | bot */
  };
});

const loadStore = () => {
  try {
    if (typeof localStorage === 'undefined') return null;
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) { return null; }
};
const saveStore = (data) => {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (e) {}
};

/* =====================================================================
   REVIEW_SYNC — модуль двустороннего sync review-цикла с Supabase.

   Зачем: до этого self/360/manager/dev/BoT/talent-bar жили ТОЛЬКО в
   localStorage. Значит, когда Манарбек открывал мой профиль, он видел
   свой локальный stub, а не мой реальный self-assessment. 360 cross-user
   просто не работал.

   Теперь каждый setter state'а делает fire-and-forget upsert в Supabase,
   а при загрузке гидратируем store из DB. RLS фильтрует, кто что видит.

   Модели:
     selfAssessments          ↔ public.self_assessments      (onConflict: cycle_id,employee_id)
     feedbackRequests.fromIds ↔ public.feedback_requests     (1 row на assignee; onConflict: cycle_id,about_id,assigned_to,feedback_type)
     feedbackRequests.responses ↔ public.feedback_responses  (onConflict: request_id; anon → author_id=NULL + nonce)
     managerAssessments       ↔ public.manager_assessments   (jsonb answers хранит scores/comments/derivedGrade)
     talentBarPlacements      ↔ public.ratings               (talent_box + derived rating_grade)
     devPlans                 ↔ public.dev_plans             (jsonb goals = {theme, goals:[]})
     botCases                 ↔ public.bot_cases             (jsonb checkins = smartGoals/halfway/final/severance)

   Идентификаторы: локальные u-ids (u1..u29) маппятся на DB uuids по email.
   cycle-коды маппятся по app.cycles.code (с нормализацией h1_2026 ↔ h1-2026). */
const REVIEW_SYNC = (() => {
  let bootstrapped = false;
  const empByLegacy  = new Map(); // 'u1' -> uuid
  const empByUuid    = new Map(); // uuid -> 'u1'
  const empByEmail   = new Map(); // email -> uuid
  const cycleByLegacy = new Map(); // 'h1-2026' -> uuid
  const cycleByUuid   = new Map(); // uuid -> 'h1-2026'

  const sb = () => (typeof window !== 'undefined' ? supabase : null) || null;
  const isReady = () => bootstrapped;

  /* Enum mappers */
  const saStatusLocalToDb = { draft: 'in_progress', submitted: 'submitted' };
  const saStatusDbToLocal = { not_started: 'draft', in_progress: 'draft', submitted: 'submitted', under_review: 'submitted', finalized: 'submitted', locked: 'submitted' };

  const maStatusLocalToDb = { draft: 'in_progress', submitted: 'submitted', locked: 'locked', reopened: 'under_review' };
  const maStatusDbToLocal = { not_started: 'draft', in_progress: 'draft', submitted: 'submitted', under_review: 'reopened', finalized: 'submitted', locked: 'locked' };

  const dpStatusLocalToDb = { active: 'in_progress', completed: 'finalized' };
  const dpStatusDbToLocal = { not_started: 'active', in_progress: 'active', submitted: 'active', under_review: 'active', finalized: 'completed', locked: 'completed' };

  const tbLocalToDb = { 'A-player': 'a_player', 'Above bar': 'solid_contributor', 'Underperformer': 'needs_support' };
  const tbDbToLocal = { 'a_player': 'A-player', 'solid_contributor': 'Above bar', 'new_or_developing': 'Above bar', 'needs_support': 'Underperformer', 'misaligned': 'Underperformer' };
  /* rating_grade derived from talent_box (ratings.rating_grade is NOT NULL) */
  const tbToRatingGrade = { 'a_player': 'above_expectations', 'solid_contributor': 'solid_performer', 'new_or_developing': 'solid_performer', 'needs_support': 'below_expectations', 'misaligned': 'below_expectations' };

  const botStatusLocalToDb = {
    'active': 'active', 'halfway-done': 'improving',
    'completed-continue': 'succeeded', 'completed-exit': 'terminated',
  };
  const botStatusDbToLocal = {
    'draft': 'active', 'active': 'active', 'improving': 'halfway-done',
    'escalated': 'active', 'succeeded': 'completed-continue', 'terminated': 'completed-exit',
  };

  /* feedback_type inference. Subject=кто получает, assignee=кто даёт. */
  const inferFeedbackType = (subjectId, assigneeId, people) => {
    if (subjectId === assigneeId) return 'self';
    if (!Array.isArray(people)) return 'peer';
    const subj = people.find(p => p.id === subjectId);
    const asg  = people.find(p => p.id === assigneeId);
    if (!subj || !asg) return 'peer';
    if (asg.manager === subjectId) return 'upward';    /* ревьюер подчиняется subject — upward на менеджера */
    if (subj.manager === assigneeId) return 'downward';/* subject подчиняется ревьюеру — downward */
    return 'peer';
  };

  /* Freedom AI Labs policy (apr 2026): 360 feedback всегда identified.
     В БД это защищено CHECK-constraint'ами fb_req_no_anonymous / fb_resp_no_anonymous (migration 0025). */
  const enforceMode = (_type, _requestedAnonymous) => 'identified';

  const toIso = (s) => {
    if (!s) return null;
    try {
      if (/^\d{4}-\d{2}-\d{2}(\s|T)?(\d{2}:\d{2})?/.test(s)) {
        return new Date(s.replace(' ', 'T') + (s.length <= 10 ? 'T00:00:00Z' : (s.length === 16 ? ':00Z' : 'Z'))).toISOString();
      }
      const d = new Date(s); if (!isNaN(d.getTime())) return d.toISOString();
    } catch (_) {}
    return null;
  };

  async function bootstrap(livePeople) {
    const c = sb(); if (!c || bootstrapped) return bootstrapped;
    try {
      const cyc = await c.from('cycles').select('id,code').limit(100);
      if (!cyc.error && Array.isArray(cyc.data)) {
        for (const row of cyc.data) {
          const legacy = (row.code || '').replace(/_/g, '-').toLowerCase();
          if (!legacy) continue;
          cycleByLegacy.set(legacy, row.id);
          cycleByUuid.set(row.id, legacy);
        }
      }
      const emp = await c.from('employees').select('id,email').limit(500);
      if (!emp.error && Array.isArray(emp.data)) {
        for (const row of emp.data) {
          const e = (row.email || '').toLowerCase();
          if (e) empByEmail.set(e, row.id);
        }
      }
      for (const p of (livePeople || [])) {
        const e = (p.email || '').toLowerCase();
        if (!e) continue;
        const uuid = empByEmail.get(e);
        if (uuid) { empByLegacy.set(p.id, uuid); empByUuid.set(uuid, p.id); }
      }
      bootstrapped = true;
    } catch (_) {}
    return bootstrapped;
  }

  const lu = (lid) => empByLegacy.get(lid) || null;     /* legacy u-id → uuid */
  const ul = (uid) => empByUuid.get(uid) || null;       /* uuid → u-id */
  const lc = (lid) => cycleByLegacy.get((lid || '').toLowerCase()) || null;
  const uc = (uid) => cycleByUuid.get(uid) || null;

  /* ============ Self Assessments ============ */
  async function upsertSelfAssessment(sa) {
    const c = sb(); if (!c || !bootstrapped || !sa) return;
    const eid = lu(sa.employeeId); const cid = lc(sa.cycleId);
    if (!eid || !cid) return;
    const row = {
      cycle_id: cid, employee_id: eid,
      status: saStatusLocalToDb[sa.status] || 'in_progress',
      accomplishments: sa.sections?.performance?.achievements || null,
      challenges: sa.sections?.performance?.challenges || null,
      dev_goals: sa.sections?.outcome?.goalsNextPeriod || null,
      culture_notes: sa.sections?.leadership?.values || null,
      answers: sa.sections || {},
      submitted_at: toIso(sa.submittedAt),
    };
    try { await c.from('self_assessments').upsert(row, { onConflict: 'cycle_id,employee_id' }); } catch (_) {}
  }

  async function fetchSelfAssessments() {
    const c = sb(); if (!c || !bootstrapped) return [];
    const r = await c.from('self_assessments').select('*');
    if (r.error || !Array.isArray(r.data)) return [];
    return r.data.map(row => {
      const e = ul(row.employee_id); const cy = uc(row.cycle_id);
      if (!e || !cy) return null;
      return {
        id: 'sa-'+e+'-'+cy, employeeId: e, cycleId: cy, period: cy.toUpperCase(),
        status: saStatusDbToLocal[row.status] || 'draft',
        lastSavedAt: row.updated_at ? row.updated_at.slice(0,16).replace('T',' ') : null,
        submittedAt: row.submitted_at ? row.submitted_at.slice(0,16).replace('T',' ') : null,
        sections: row.answers || {},
      };
    }).filter(Boolean);
  }

  /* ============ 360 Feedback ============ */
  async function upsertFeedbackRequestSet(req, people) {
    const c = sb(); if (!c || !bootstrapped || !req) return;
    const cid = lc(req.cycleId || 'h1-2026');
    const aboutUid = lu(req.subjectId);
    const reqUid = lu(req.requesterId) || aboutUid;
    if (!cid || !aboutUid || !reqUid) return;
    const due = req.dueDate ? toIso(req.dueDate) : null;
    const rows = [];
    for (const asgLeg of (req.fromIds || [])) {
      const asgUid = lu(asgLeg); if (!asgUid) continue;
      const type = inferFeedbackType(req.subjectId, asgLeg, people);
      const mode = enforceMode(type, !!req.anonymous);
      rows.push({
        cycle_id: cid, about_id: aboutUid, requested_by: reqUid, assigned_to: asgUid,
        feedback_type: type, delivery_mode: mode,
        status: req.status === 'done' ? 'submitted' : 'in_progress',
        due_at: due,
      });
    }
    if (!rows.length) return;
    try { await c.from('feedback_requests').upsert(rows, { onConflict: 'cycle_id,about_id,assigned_to,feedback_type' }); } catch (_) {}
  }

  async function upsertFeedbackResponse(req, resp, people) {
    const c = sb(); if (!c || !bootstrapped || !req || !resp) return;
    const cid = lc(req.cycleId || 'h1-2026');
    const aboutUid = lu(req.subjectId);
    const authorUid = resp.fromId ? lu(resp.fromId) : null;
    if (!cid || !aboutUid) return;
    const type = inferFeedbackType(req.subjectId, resp.fromId, people);
    const mode = enforceMode(type, !!req.anonymous);
    const reqUid = lu(req.requesterId) || aboutUid;
    /* 1) Upsert соответствующий feedback_request */
    if (authorUid) {
      try {
        await c.from('feedback_requests').upsert([{
          cycle_id: cid, about_id: aboutUid, requested_by: reqUid, assigned_to: authorUid,
          feedback_type: type, delivery_mode: mode,
          status: 'submitted', due_at: req.dueDate ? toIso(req.dueDate) : null,
          completed_at: toIso(resp.submittedAt) || new Date().toISOString(),
        }], { onConflict: 'cycle_id,about_id,assigned_to,feedback_type' });
      } catch (_) {}
    }
    /* 2) Найти request_id для response (unique constraint — нужен точный row) */
    let requestRowId = null;
    if (authorUid) {
      try {
        const q = await c.from('feedback_requests').select('id')
          .eq('cycle_id', cid).eq('about_id', aboutUid)
          .eq('assigned_to', authorUid).eq('feedback_type', type)
          .limit(1);
        if (!q.error && Array.isArray(q.data) && q.data.length) requestRowId = q.data[0].id;
      } catch (_) {}
    }
    if (!requestRowId) return; /* без request_id response не создать (NOT NULL) */
    const a = resp.answers || {};
    const row = {
      request_id: requestRowId, cycle_id: cid, about_id: aboutUid,
      feedback_type: type, delivery_mode: mode,
      author_id: mode === 'anonymous' ? null : authorUid,
      author_nonce: mode === 'anonymous' ? ('fr-'+(resp.fromId || 'anon')+'-'+Math.random().toString(36).slice(2,10)) : null,
      strengths: typeof a.strengths === 'string' ? a.strengths : (a.strengths != null ? String(a.strengths) : null),
      growth_areas: typeof a.growth === 'string' ? a.growth : (typeof a.areas === 'string' ? a.areas : null),
      examples: typeof a.examples === 'string' ? a.examples : null,
      ratings: (a.ratings && typeof a.ratings === 'object') ? a.ratings : {},
      submitted_at: toIso(resp.submittedAt) || new Date().toISOString(),
    };
    try { await c.from('feedback_responses').upsert(row, { onConflict: 'request_id' }); } catch (_) {}
  }

  async function fetchFeedback(people) {
    const c = sb(); if (!c || !bootstrapped) return [];
    const [reqs, resps] = await Promise.all([
      c.from('feedback_requests').select('*'),
      c.from('feedback_responses').select('*'),
    ]);
    if (reqs.error || !Array.isArray(reqs.data)) return [];
    const respsByReq = new Map();
    if (!resps.error && Array.isArray(resps.data)) {
      for (const r of resps.data) {
        if (!r.request_id) continue;
        if (!respsByReq.has(r.request_id)) respsByReq.set(r.request_id, []);
        respsByReq.get(r.request_id).push(r);
      }
    }
    /* Кластеризуем requests по (cycle, about, requested_by, delivery_mode, due) → локальный fr */
    const clusters = new Map();
    for (const row of reqs.data) {
      const subj = ul(row.about_id); const requester = ul(row.requested_by);
      const cy = uc(row.cycle_id); const asg = ul(row.assigned_to);
      if (!subj) continue;
      const due = row.due_at ? row.due_at.slice(0,10) : '';
      const key = `${cy || ''}|${subj}|${requester || ''}|${row.delivery_mode}|${due}`;
      if (!clusters.has(key)) {
        clusters.set(key, {
          id: 'fr-' + (row.id || '').slice(0,12),
          cycleId: cy || 'h1-2026', subjectId: subj, requesterId: requester || subj,
          fromIds: [], dbRequestIds: [],
          formId: row.delivery_mode === 'anonymous' ? 'form-anon' : 'form-named',
          anonymous: row.delivery_mode === 'anonymous',
          sentAt: row.created_at ? row.created_at.slice(0,10) : null,
          dueDate: due || null,
          status: 'in_progress', responses: [],
        });
      }
      const cl = clusters.get(key);
      if (asg && !cl.fromIds.includes(asg)) cl.fromIds.push(asg);
      cl.dbRequestIds.push(row.id);
      const rr = respsByReq.get(row.id) || [];
      for (const resp of rr) {
        const authLeg = resp.author_id ? ul(resp.author_id) : null;
        cl.responses.push({
          id: 'resp-' + (resp.id || '').slice(0,12),
          fromId: resp.delivery_mode === 'anonymous' ? null : (authLeg || asg),
          answers: {
            strengths: resp.strengths || '',
            growth: resp.growth_areas || '',
            examples: resp.examples || '',
            ratings: (resp.ratings && typeof resp.ratings === 'object') ? resp.ratings : {},
          },
          submittedAt: resp.submitted_at ? resp.submitted_at.slice(0,10) : null,
        });
      }
    }
    const out = [];
    for (const cl of clusters.values()) {
      if (cl.fromIds.length > 0 && cl.responses.length >= cl.fromIds.length) cl.status = 'done';
      delete cl.dbRequestIds;
      out.push(cl);
    }
    return out;
  }

  /* ============ Manager Assessments ============ */
  async function upsertManagerAssessment(ma) {
    const c = sb(); if (!c || !bootstrapped || !ma) return;
    const eid = lu(ma.employeeId); const cid = lc(ma.cycleId);
    const mid = ma.managerId ? lu(ma.managerId) : null;
    if (!eid || !cid || !mid) return;
    const row = {
      cycle_id: cid, employee_id: eid, manager_id: mid,
      status: maStatusLocalToDb[ma.status] || 'in_progress',
      impact_summary: ma.comments?.overall || null,
      strengths: ma.comments?.skills || null,
      growth_areas: ma.comments?.deliverables || null,
      leadership_notes: null,
      values_notes: ma.comments?.culture || null,
      proposed_rating: null, talent_box: null, promo_recommended: false, calibration_notes: null,
      answers: {
        scores: ma.scores || {},
        comments: ma.comments || {},
        derivedGrade: ma.derivedGrade || null,
        supportingDocs: ma.supportingDocs || [],
        lockedAt: ma.lockedAt || null, reopenedAt: ma.reopenedAt || null,
      },
      submitted_at: toIso(ma.submittedAt),
    };
    try { await c.from('manager_assessments').upsert(row, { onConflict: 'cycle_id,employee_id' }); } catch (_) {}
  }

  async function fetchManagerAssessments() {
    const c = sb(); if (!c || !bootstrapped) return [];
    const r = await c.from('manager_assessments').select('*');
    if (r.error || !Array.isArray(r.data)) return [];
    return r.data.map(row => {
      const e = ul(row.employee_id); const cy = uc(row.cycle_id);
      const m = row.manager_id ? ul(row.manager_id) : null;
      if (!e || !cy) return null;
      const a = row.answers || {};
      return {
        id: 'ma-'+e+'-'+cy, employeeId: e, managerId: m, cycleId: cy, period: cy.toUpperCase(),
        status: maStatusDbToLocal[row.status] || 'draft',
        lastSavedAt: row.updated_at ? row.updated_at.slice(0,16).replace('T',' ') : null,
        submittedAt: row.submitted_at ? row.submitted_at.slice(0,16).replace('T',' ') : null,
        lockedAt: a.lockedAt || null, reopenedAt: a.reopenedAt || null,
        scores: (a.scores && typeof a.scores === 'object') ? a.scores : {skills:{},deliverables:{},culture:{}},
        comments: (a.comments && typeof a.comments === 'object') ? a.comments : {skills:'',deliverables:'',culture:'',overall:''},
        supportingDocs: Array.isArray(a.supportingDocs) ? a.supportingDocs : [],
        derivedGrade: a.derivedGrade || null,
      };
    }).filter(Boolean);
  }

  /* ============ Dev Plans ============ */
  async function upsertDevPlan(dp) {
    const c = sb(); if (!c || !bootstrapped || !dp) return;
    const eid = lu(dp.employeeId); const cid = lc(dp.cycleId);
    const mid = dp.managerId ? lu(dp.managerId) : null;
    if (!eid || !cid) return;
    const row = {
      cycle_id: cid, employee_id: eid, manager_id: mid,
      status: dpStatusLocalToDb[dp.status] || 'in_progress',
      goals: { theme: dp.theme || '', goals: Array.isArray(dp.goals) ? dp.goals : [] },
    };
    try { await c.from('dev_plans').upsert(row, { onConflict: 'cycle_id,employee_id' }); } catch (_) {}
  }

  async function fetchDevPlans() {
    const c = sb(); if (!c || !bootstrapped) return [];
    const r = await c.from('dev_plans').select('*');
    if (r.error || !Array.isArray(r.data)) return [];
    return r.data.map(row => {
      const e = ul(row.employee_id); const cy = uc(row.cycle_id);
      const m = row.manager_id ? ul(row.manager_id) : null;
      if (!e || !cy) return null;
      const g = (row.goals && typeof row.goals === 'object') ? row.goals : {};
      return {
        id: 'dp-'+e+'-'+cy, employeeId: e, managerId: m, cycleId: cy, period: cy.toUpperCase(),
        status: dpStatusDbToLocal[row.status] || 'active',
        createdAt: row.created_at ? row.created_at.slice(0,10) : null,
        lastUpdated: row.updated_at ? row.updated_at.slice(0,10) : null,
        theme: g.theme || '',
        goals: Array.isArray(g.goals) ? g.goals : (Array.isArray(g) ? g : []),
      };
    }).filter(Boolean);
  }

  /* ============ BoT Cases ============ */
  async function upsertBotCase(bc) {
    const c = sb(); if (!c || !bootstrapped || !bc) return;
    const eid = lu(bc.employeeId); const cid = lc(bc.cycleId);
    const mid = bc.managerId ? lu(bc.managerId) : null;
    if (!eid || !mid) return; /* bot_cases.manager_id is NOT NULL */
    const row = {
      employee_id: eid, manager_id: mid, hr_partner_id: null,
      opened_at: bc.startDate || new Date().toISOString().slice(0,10),
      closes_at: bc.finalDate || null,
      status: botStatusLocalToDb[bc.status] || 'active',
      trigger_cycle: cid,
      concerns: bc.reason || null,
      success_criteria: (Array.isArray(bc.smartGoals) ? bc.smartGoals.map(g => g.text || g.title || '').filter(Boolean).join('; ') : null) || null,
      checkins: {
        smartGoals: Array.isArray(bc.smartGoals) ? bc.smartGoals : [],
        halfwayResult: bc.halfwayResult || null,
        finalResult: bc.finalResult || null,
        severanceChosen: !!bc.severanceChosen,
        halfwayDate: bc.halfwayDate || null,
        finalDate: bc.finalDate || null,
      },
      outcome: bc.finalResult?.decision || null,
      legal_reviewed: false,
    };
    /* Нет composite-unique на (employee_id, trigger_cycle) — ручная upsert логика */
    try {
      const existing = await c.from('bot_cases').select('id')
        .eq('employee_id', eid).eq('trigger_cycle', cid).limit(1);
      if (!existing.error && Array.isArray(existing.data) && existing.data.length) {
        await c.from('bot_cases').update(row).eq('id', existing.data[0].id);
      } else {
        await c.from('bot_cases').insert(row);
      }
    } catch (_) {}
  }

  async function fetchBotCases() {
    const c = sb(); if (!c || !bootstrapped) return [];
    const r = await c.from('bot_cases').select('*');
    if (r.error || !Array.isArray(r.data)) return [];
    return r.data.map(row => {
      const e = ul(row.employee_id);
      const m = row.manager_id ? ul(row.manager_id) : null;
      const cy = row.trigger_cycle ? uc(row.trigger_cycle) : null;
      if (!e || !cy) return null;
      const chk = (row.checkins && typeof row.checkins === 'object' && !Array.isArray(row.checkins)) ? row.checkins : {};
      return {
        id: 'bot-'+e+'-'+cy, employeeId: e, managerId: m, cycleId: cy, period: cy.toUpperCase(),
        status: botStatusDbToLocal[row.status] || 'active',
        startDate: row.opened_at ? String(row.opened_at).slice(0,10) : null,
        halfwayDate: chk.halfwayDate || null,
        finalDate: chk.finalDate || (row.closes_at ? String(row.closes_at).slice(0,10) : null),
        reason: row.concerns || '',
        severanceChosen: !!chk.severanceChosen,
        smartGoals: Array.isArray(chk.smartGoals) ? chk.smartGoals : [],
        halfwayResult: chk.halfwayResult || null,
        finalResult: chk.finalResult || null,
      };
    }).filter(Boolean);
  }

  /* ============ Talent Bar → Ratings ============ */
  async function upsertRatingFromPlacement(placement) {
    const c = sb(); if (!c || !bootstrapped || !placement) return;
    const eid = lu(placement.employeeId); const cid = lc(placement.cycleId);
    if (!eid || !cid) return;
    const tb = tbLocalToDb[placement.grade] || null;
    if (!tb) return;
    const row = {
      cycle_id: cid, employee_id: eid, calibration_id: null,
      rating_grade: tbToRatingGrade[tb], talent_box: tb,
      rationale: null,
      finalized_at: toIso(placement.placedAt) || new Date().toISOString(),
      finalized_by: null, locked: false,
    };
    try { await c.from('ratings').upsert(row, { onConflict: 'cycle_id,employee_id' }); } catch (_) {}
  }

  async function fetchRatings() {
    const c = sb(); if (!c || !bootstrapped) return [];
    const r = await c.from('ratings').select('*');
    if (r.error || !Array.isArray(r.data)) return [];
    return r.data.map(row => {
      const e = ul(row.employee_id); const cy = uc(row.cycle_id);
      if (!e || !cy || !row.talent_box) return null;
      const grade = tbDbToLocal[row.talent_box];
      if (!grade) return null;
      return {
        employeeId: e, cycleId: cy, grade,
        placedBy: 'Calibration',
        placedAt: row.finalized_at ? row.finalized_at.slice(0,16).replace('T',' ') : null,
      };
    }).filter(Boolean);
  }

  return {
    bootstrap, isReady,
    upsertSelfAssessment, fetchSelfAssessments,
    upsertFeedbackRequestSet, upsertFeedbackResponse, fetchFeedback,
    upsertManagerAssessment, fetchManagerAssessments,
    upsertDevPlan, fetchDevPlans,
    upsertBotCase, fetchBotCases,
    upsertRatingFromPlacement, fetchRatings,
    /* ID-мапперы для AI_COACH и других внешних модулей */
    employeeUuid: (legacyId) => lu(legacyId),
    cycleUuid: (legacyId) => lc(legacyId),
    employeeLegacy: (uuid) => ul(uuid),
    cycleLegacy: (uuid) => uc(uuid),
  };
})();
/* expose для дебага в DevTools */
if (typeof window !== 'undefined') window.__reviewSync = REVIEW_SYNC;

/* ─────────────────────────────────────────────────────────────────────
   useCurrentCyclePhase — small hook to surface real DB cycle.phase to the UI.
   Used by employee-facing banners to explain when manager assessment / rating
   becomes visible. Read-only; HR controls phase via SettingsPage.
   ───────────────────────────────────────────────────────────────────── */
const useCurrentCyclePhase = () => {
  const [state, setState] = useState({ loading:true, cycle:null, err:null });
  useEffect(() => {
    let cancelled = false;
    const sb = (typeof window !== 'undefined') ? supabase : null;
    if (!sb) { setState({ loading:false, cycle:null, err:'no-supabase' }); return; }
    (async () => {
      try {
        const { data, error } = await sb.from('cycles').select('id,code,name,phase,calibration_at,delivery_at,closed_at').eq('is_current', true).maybeSingle();
        if (cancelled) return;
        if (error) setState({ loading:false, cycle:null, err:error.message });
        else setState({ loading:false, cycle:data, err:null });
      } catch (e) {
        if (!cancelled) setState({ loading:false, cycle:null, err:String(e) });
      }
    })();
    return () => { cancelled = true; };
  }, []);
  return state;
};

/* ─────────────────────────────────────────────────────────────────────
   ReviewVisibilityBanner — informational card for employees.
   Tells them: your manager assessment / 360 feedback / final rating
   will become visible only after HR advances the cycle phase.
   Hidden in phases where results are already visible (delivery/closed).
   ───────────────────────────────────────────────────────────────────── */
const ReviewVisibilityBanner = () => {
  const { cycle, loading } = useCurrentCyclePhase();
  if (loading || !cycle) return null;
  /* В delivery/closed нет смысла показывать — результаты уже видны. */
  if (cycle.phase === 'delivery' || cycle.phase === 'closed') return null;

  const phaseLabel = {
    planning:            'Планирование',
    self_assessment:     'Self Assessment',
    feedback_collection: 'Сбор 360 фидбека',
    manager_assessment:  'Manager Assessment',
    calibration:         'Calibration',
  }[cycle.phase] || cycle.phase;

  const whatsNext = {
    planning:            'Цикл ещё не открыт для подачи. Дождись уведомления о старте Self Assessment.',
    self_assessment:     'Сейчас время для твоей Self Assessment. Менеджер оценит позже — результаты ты увидишь после Calibration и Delivery.',
    feedback_collection: 'Собираются 360 отзывы. Субъект видит их после фазы Delivery (все отзывы — именные по политике Freedom AI Labs).',
    manager_assessment:  'Менеджер заполняет scorecard. Итог покажем тебе после Calibration и перевода цикла в фазу Delivery.',
    calibration:         'Performance Team проводит калибровку. Как только CEO утвердит grades и цикл переведут в Delivery — ты увидишь свой Manager Assessment, 360-отзывы и финальный rating (после locked).',
  }[cycle.phase] || '';

  const eta = cycle.delivery_at ? formatDate(cycle.delivery_at.slice(0,10)) : null;

  return (
    <Card>
      <div className="p-5 flex items-start gap-4">
        <div className="w-10 h-10 rounded-xl bg-amber-50 text-amber-700 grid place-items-center shrink-0">
          <Icon name="shield" className="w-5 h-5"/>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-[.18em] text-ink-400 font-bold">Когда будут видны результаты ревью</div>
          <div className="text-sm font-semibold text-ink-900 mt-0.5">Текущая фаза: {phaseLabel}</div>
          <div className="text-xs text-ink-600 mt-2">{whatsNext}</div>
          {eta && (
            <div className="text-[11px] text-ink-500 mt-2">Ориентировочная дата Delivery: <b className="text-ink-800">{eta}</b></div>
          )}
        </div>
      </div>
    </Card>
  );
};

/* ============================================================================
   AI_COACH — клиентский модуль поверх edge-функции ai-coach (Supabase).
   ----------------------------------------------------------------------------
   Задачи, поддерживаемые edge-функцией:
     quality_check     — оценка черновика фидбека (Haiku, ~0.5–2 сек)
     theme_cluster     — кластеринг 360 (Sonnet, hr_admin/manager-only)
     calibration_pack  — калибровочный пакет (Sonnet, hr_admin/manager-only)
     dev_plan_suggest  — черновик dev-плана (Sonnet, manager+)
     evidence_tag      — массовая разметка evidence (Haiku, hr_admin/exec)
   Все вызовы логируются в app.ai_invocations с cost/tokens/latency/status.
   Вызов всегда требует валидный JWT (verify_jwt=true на edge-функции).
============================================================================ */
const AI_COACH = (() => {
  const sb = () => (typeof window !== 'undefined' ? supabase : null) || null;

  /* Тянем access_token из активной сессии. Если его нет — пользователь не залогинен
     (или сессия истекла), и любой вызов ai-coach вернёт 401. Лучше упасть рано
     с осмысленным сообщением, чем ловить непонятный non-2xx. */
  async function getAccessToken(c) {
    const { data, error } = await c.auth.getSession();
    if (error) throw new Error('Не удалось получить сессию: ' + (error.message || 'unknown'));
    const token = data?.session?.access_token;
    if (!token) throw new Error('Нет активной сессии — войдите через Google SSO заново');
    /* Проверим exp: если токен просрочен — попробуем refresh */
    try {
      const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g,'+').replace(/_/g,'/')));
      const now = Math.floor(Date.now() / 1000);
      if (payload.exp && payload.exp < now + 30) {
        const refreshed = await c.auth.refreshSession();
        if (refreshed.error || !refreshed.data?.session?.access_token) {
          throw new Error('Сессия истекла, не удалось обновить — войдите заново');
        }
        return refreshed.data.session.access_token;
      }
    } catch (_) { /* не критично — пойдём с тем, что есть */ }
    return token;
  }

  async function invoke(task_type, payload) {
    const c = sb(); if (!c) throw new Error('Supabase not ready');
    const accessToken = await getAccessToken(c);
    const { data, error } = await c.functions.invoke('ai-coach', {
      body: { task_type, ...payload },
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (error) {
      /* supabase-js оборачивает non-2xx в FunctionsHttpError; достанем тело */
      let detail = null;
      try { detail = error.context?.body ? await error.context.body.text() : null; } catch (_) {}
      const e = new Error(error.message || 'ai-coach call failed');
      e.detail = detail;
      throw e;
    }
    if (data && data.error) {
      const e = new Error(data.error);
      e.detail = data.detail || null;
      throw e;
    }
    return data;
  }

  return {
    qualityCheck: (draft_text, opts = {}) => invoke('quality_check', {
      input: { draft_text, feedback_type: opts.feedback_type, competency: opts.competency },
      subject_employee_id: opts.subject_employee_id || null,
      cycle_id: opts.cycle_id || null,
    }),
    themeCluster: (subject_employee_id, cycle_id, feedback_responses) => invoke('theme_cluster', {
      subject_employee_id, cycle_id,
      input: { feedback_responses },
    }),
    calibrationPack: (subject_employee_id, cycle_id) => invoke('calibration_pack', {
      subject_employee_id, cycle_id,
    }),
    devPlanSuggest: (subject_employee_id, cycle_id) => invoke('dev_plan_suggest', {
      subject_employee_id, cycle_id,
    }),
    evidenceTag: (evidence_ids) => invoke('evidence_tag', { evidence_ids }),
  };
})();
if (typeof window !== 'undefined') window.__aiCoach = AI_COACH;

/* Вспомогательный React-компонент: Feedback Quality Coach.
   Встраиваем прямо под textarea/input — даёт оценку черновика, список issues,
   suggestions (quoted snippet → rewrite) и strengths. Полностью read-only:
   НЕ переписывает текст автора, только предлагает правки. Автор решает сам. */
const QualityCoachBox = ({ getDraft, feedbackType, competency, subjectEmployeeId, cycleId, disabled, label = 'Проверить качество фидбека (AI-коуч)' }) => {
  const [loading, setLoading] = useState(false);
  const [result, setResult]   = useState(null);
  const [error, setError]     = useState(null);
  const run = async () => {
    setError(null); setResult(null);
    const draft = (typeof getDraft === 'function' ? getDraft() : '') || '';
    if (draft.trim().length < 20) {
      setError('Нужно минимум 20 символов черновика, чтобы дать полезную обратную связь.');
      return;
    }
    setLoading(true);
    try {
      const out = await AI_COACH.qualityCheck(draft.trim(), {
        feedback_type: feedbackType,
        competency,
        subject_employee_id: subjectEmployeeId,
        cycle_id: cycleId,
      });
      setResult(out?.result || null);
    } catch (e) {
      setError(e?.detail || e?.message || 'Ошибка AI-коуча');
    } finally {
      setLoading(false);
    }
  };
  const scoreColor = (lbl) => {
    if (lbl === 'excellent') return 'bg-emerald-100 text-emerald-800 border-emerald-300';
    if (lbl === 'good')      return 'bg-brand-100 text-brand-800 border-brand-300';
    if (lbl === 'ok')        return 'bg-amber-100 text-amber-800 border-amber-300';
    return 'bg-rose-100 text-rose-800 border-rose-300';
  };
  return (
    <div className="mt-2 rounded-xl border border-ink-100 bg-ink-50/40">
      <div className="flex items-center justify-between px-3 py-2 border-b border-ink-100">
        <div className="flex items-center gap-2 text-xs font-semibold text-ink-600 uppercase tracking-wider">
          <Icon name="sparkle" className="w-3.5 h-3.5 text-brand-600"/>
          {label}
        </div>
        <button type="button" onClick={run} disabled={disabled || loading}
          className="h-7 px-3 rounded-md bg-brand-600 text-white text-xs font-semibold hover:bg-brand-700 disabled:bg-ink-200 disabled:cursor-not-allowed">
          {loading ? 'Анализирую…' : (result ? 'Перепроверить' : 'Проверить')}
        </button>
      </div>
      {error && (
        <div className="p-3 text-xs text-rose-700 bg-rose-50 border-t border-rose-100">{error}</div>
      )}
      {result && (
        <div className="p-3 space-y-3">
          <div className="flex items-center gap-2">
            <span className={`text-[11px] uppercase tracking-wider font-bold px-2 py-1 rounded border ${scoreColor(result.score_label)}`}>
              {result.score}/10 · {result.score_label}
            </span>
            {Array.isArray(result.strengths) && result.strengths.length > 0 && (
              <span className="text-[11px] text-ink-500">+ {result.strengths.length} сильных сторон</span>
            )}
          </div>
          {Array.isArray(result.issues) && result.issues.length > 0 && (
            <div>
              <div className="text-[11px] uppercase tracking-wider text-ink-500 font-semibold mb-1">Найденные проблемы</div>
              <ul className="space-y-1.5">
                {result.issues.map((is, i) => (
                  <li key={i} className="text-xs bg-white border border-ink-100 rounded-lg p-2">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-[10px] uppercase tracking-wider bg-rose-100 text-rose-800 px-1.5 py-0.5 rounded font-bold">{is.kind}</span>
                      {is.where && <span className="italic text-ink-500 truncate">«{String(is.where).slice(0, 120)}»</span>}
                    </div>
                    <div className="text-ink-700">{is.why}</div>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {Array.isArray(result.suggestions) && result.suggestions.length > 0 && (
            <div>
              <div className="text-[11px] uppercase tracking-wider text-ink-500 font-semibold mb-1">Предложения</div>
              <ul className="space-y-1.5">
                {result.suggestions.map((s, i) => (
                  <li key={i} className="text-xs bg-white border border-brand-100 rounded-lg p-2">
                    {s.target && <div className="text-ink-400 line-through mb-1">«{String(s.target).slice(0, 160)}»</div>}
                    <div className="text-ink-900 font-medium">→ {s.rewrite}</div>
                    {s.reason && <div className="text-[11px] text-ink-500 mt-1">{s.reason}</div>}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {Array.isArray(result.strengths) && result.strengths.length > 0 && (
            <div>
              <div className="text-[11px] uppercase tracking-wider text-ink-500 font-semibold mb-1">Что уже хорошо</div>
              <ul className="space-y-1">
                {result.strengths.map((s, i) => (
                  <li key={i} className="text-xs text-emerald-700 flex gap-2"><span>✓</span><span>{s}</span></li>
                ))}
              </ul>
            </div>
          )}
          <div className="text-[10px] text-ink-400 italic">AI-коуч только подсказывает — правки принимает автор. Вызов залогирован в app.ai_invocations.</div>
        </div>
      )}
      {!result && !error && !loading && (
        <div className="p-3 text-xs text-ink-500">Нажмите «Проверить», чтобы AI-коуч оценил черновик: укажет расплывчатые места, предубеждения и предложит конкретные правки.</div>
      )}
    </div>
  );
};

const useStore = () => {
  const initial = useMemo(() => {
    const saved = loadStore();
    const peopleFresh = PEOPLE.map(p => ({ ...p, active: true }));
    const freshById = Object.fromEntries(peopleFresh.map(p => [p.id, p]));
    /* Миграция: для известных u-id сливаем fresh-дефолты с сохранёнными значениями.
       Правило: HR-редактирования всегда побеждают (spread saved после fresh).
       Fresh поля заполняют ТОЛЬКО то, что отсутствует в saved (новые поля вроде
       sysRole/photoUrl после апгрейда схемы). Это ломало сохранение правок HR.

       MIGRATION (apr 2026): grade теперь только из Calibration · Talent Bar.
       currentGrade ВСЕГДА выводится из talentBarPlacements — никаких кэшей в person.
       Это лечит старые saved-стейты, где HR-форма позволяла выставлять grade вручную
       или где прошлые демо-версии сохраняли currentGrade при сохранении профиля. */
    const mergePeople = (savedList, savedPlacements) => {
      if (!Array.isArray(savedList)) return peopleFresh;
      const placementByEmployee = {};
      (Array.isArray(savedPlacements) ? savedPlacements : []).forEach(x => { placementByEmployee[x.employeeId] = x; });

      /* COMMIT_5 fix v3 (30 apr 2026): дедуп savedList по email перед обработкой.
         Раньше после первого деплоя у Айканыш появилось ДВА Тимура в state.people:
         один с синтетическим id (u_c0f8cae2 — запомненный auth-синтезом), второй с
         seed-id u30 (добавленный append-fresh). При orgchart рендере оба показывались.
         Логика: если в savedList несколько записей с одним email, оставляем ту, чей id
         есть в freshById (=совпадает с seed) — он стабильный и manager_id корректный.
         Если ни один не совпадает с seed, оставляем первую запись. */
      const byEmail = {};
      const orphans = [];
      savedList.forEach(sp => {
        const e = (sp.email || '').toLowerCase().trim();
        if (!e) { orphans.push(sp); return; }
        const existing = byEmail[e];
        if (!existing) { byEmail[e] = sp; return; }
        // Prefer the entry whose id matches seed
        const existingMatchesSeed = !!freshById[existing.id];
        const newMatchesSeed = !!freshById[sp.id];
        const winner = (newMatchesSeed && !existingMatchesSeed) ? sp : existing;
        const loser  = (winner === sp) ? existing : sp;
        byEmail[e] = winner;
        /* COMMIT_5 audit P1 #5 fix (30 apr 2026): warn если потеряли запись —
           это значит у пользователя в localStorage был дубликат и мы выбрали
           seed-id. Помогает диагностировать silently-dropped HR-правки. */
        if (loser.id !== winner.id) {
          console.warn(
            `[mergePeople] Dropped duplicate for email=${e}: kept id=${winner.id}, discarded id=${loser.id}`,
            { winner, loser }
          );
        }
      });
      const dedupedSavedList = [...Object.values(byEmail), ...orphans];
      const savedIds = new Set(dedupedSavedList.map(sp => sp.id));

      /* COMMIT_5 fix v4 (30 apr 2026): HR-admin override должен применяться на КАЖДОЙ
         загрузке, а не только при миграции версии. Раньше force sysRole='hr' для
         HR_ADMIN_EMAILS / HR_ADMIN_TITLES жил только в migration-branch (savedVersion <
         CYCLE_DATA_VERSION). Когда пользователь уже на текущей версии, mergePeople
         принимал saved.sysRole='director' без коррекции, и Айканыш теряла HR-доступ.
         Теперь idempotent override живёт прямо в map — fresh.sysRole перебивает saved
         для HR-titled людей. Безопасно для повторных загрузок (одинаковый результат). */
      const applyHrOverride = (p) => {
        if (!p) return p;
        const email = (p.email || '').toLowerCase().trim();
        const isHrByEmail = HR_ADMIN_EMAILS.has(email);
        const isHrByTitle = HR_ADMIN_TITLES.test(p.role || '');
        if ((isHrByEmail || isHrByTitle) && p.sysRole !== 'hr') {
          return { ...p, sysRole: 'hr' };
        }
        return p;
      };

      const merged = dedupedSavedList.map(sp => {
        const placement = placementByEmployee[sp.id];
        /* currentGrade — строго из placement; если placement нет, grade null */
        const cleanSp = { ...sp, currentGrade: placement ? placement.grade : null };
        const fresh = freshById[sp.id];
        let base = fresh ? { ...fresh, ...cleanSp } : cleanSp;
        /* COMMIT_8 normalize (16 may 2026): uppercase level и Capitalize track.
           Supabase sync / старая PersonForm иногда сохраняли lowercase ('m3',
           'manager'). Это ломало LEVELS[level] lookup в personLevel (S3 Lead
           вместо M3 у Тимура), И ломало isDirectorTier check ниже (base.level
           === 'M3' возвращал false для 'm3'), из-за чего roleKey='head' не
           восстанавливался. Idempotent: на uppercase данных ничего не меняет. */
        if (typeof base.level === 'string' && base.level !== base.level.toUpperCase()) {
          base = { ...base, level: base.level.toUpperCase() };
        }
        if (typeof base.track === 'string') {
          const t = base.track.toLowerCase();
          const trackNorm = t === 'manager' ? 'Manager' : t === 'ic' ? 'IC' : t === 'support' ? 'Support' : null;
          if (trackNorm && trackNorm !== base.track) base = { ...base, track: trackNorm };
        }
        /* COMMIT_5 fix v7 (30 apr 2026): auto-restore roleKey='head' ТОЛЬКО для
           Director-tier (Manager M3/M4). Раньше восстанавливал у всех с
           seed.roleKey='head' — это ломало IC track людей типа Сергея Зубарева,
           которого HR явно перевела с CRDO на R&D IC4. Теперь IC track сохраняет
           HR-выбор, а C-level/Heads на Manager track форсятся обратно в head,
           если их roleKey случайно перезаписался старым багнутым дропдауном. */
        const isDirectorTier =
          base.level === 'M3' || base.level === 'M4' || base.track === 'Manager';
        if (fresh && fresh.roleKey === 'head'
            && cleanSp.roleKey && cleanSp.roleKey !== 'head'
            && isDirectorTier) {
          base = { ...base, roleKey: 'head' };
        }
        return applyHrOverride(base);
      });
      /* COMMIT_5 fix (30 apr 2026): добавляем тех, кто появился в свежем seed
         после того, как у пользователя сохранилась его versия localStorage.
         Раньше mergePeople просто возвращал savedList.map(...) и ЛЮБОЙ новый
         seed-сотрудник (например u30 Тимур, добавленный 29 apr 2026) не
         подгружался — пользователь видел старый список без него.
         FIX v2: дедуп не только по id, но и по email — иначе синтетический
         профиль (например 'u_c0f8cae2' для Тимура) и seed-id ('u30') считались
         разными людьми и создавали дубликат карточки. */
      const savedEmails = new Set(
        savedList.map(sp => (sp.email || '').toLowerCase().trim()).filter(Boolean)
      );
      const appendedFromFresh = peopleFresh.filter(fp => {
        if (savedIds.has(fp.id)) return false;
        const email = (fp.email || '').toLowerCase().trim();
        if (email && savedEmails.has(email)) return false;
        return true;
      }).map(applyHrOverride);
      return [...merged, ...appendedFromFresh];
    };

    /* Отбрасываем talentBarPlacements, у которых нет соответствующего submitted/locked
       Manager Assessment. Это старые демо-placements из предыдущих версий приложения
       (до apr 2026), которые «протекали» через localStorage. Real Calibration всегда
       идёт после Manager Assessment, поэтому placement без MA — всегда stale. */
    const cleanPlacements = (savedPlacements, savedAssessments) => {
      if (!Array.isArray(savedPlacements)) return [];
      const validMA = new Set(
        (Array.isArray(savedAssessments) ? savedAssessments : [])
          .filter(m => m.status === 'submitted' || m.status === 'locked')
          .map(m => `${m.employeeId}|${m.cycleId}`)
      );
      return savedPlacements.filter(p => validMA.has(`${p.employeeId}|${p.cycleId}`));
    };

    /* Отбрасываем стейл-conversations (те, что ссылаются на несуществующих людей
       или на cycleId с нулём submitted MA). DEFAULT_CONVERSATIONS теперь пустой —
       нет PEOPLE с currentGrade, — но старый localStorage мог сохранить демо-беседы. */
    const cleanConversations = (savedConversations, savedAssessments) => {
      if (!Array.isArray(savedConversations)) return [];
      const validMA = new Set(
        (Array.isArray(savedAssessments) ? savedAssessments : [])
          .filter(m => m.status === 'submitted' || m.status === 'locked')
          .map(m => `${m.employeeId}|${m.cycleId}`)
      );
      return savedConversations.filter(c => validMA.has(`${c.employeeId}|${c.cycleId}`));
    };
    const base = {
      people: peopleFresh,
      vacancies: VACANCIES,
      feedbackRequests: DEFAULT_FEEDBACK_REQUESTS,
      forms: DEFAULT_FORMS,
      settings: DEFAULT_SETTINGS,
      auditLog: DEFAULT_AUDIT_LOG,
      selfAssessments: DEFAULT_SELF_ASSESSMENTS,
      managerAssessments: DEFAULT_MANAGER_ASSESSMENTS,
      talentBarPlacements: DEFAULT_TALENT_BAR_PLACEMENTS,
      conversations: DEFAULT_CONVERSATIONS,
      devPlans: DEFAULT_DEV_PLANS,
      botCases: DEFAULT_BOT_CASES,
    };
    if (saved) {
      /* Миграция v2 (apr 2026): при первой загрузке на новой версии полностью
         сбрасываем данные performance cycle, оставляя HR-правки. Это нужно, чтобы
         убрать стейл-демо из старых сборок app (assessments, placements, conversations,
         dev plans, BoT, feedback requests, audit log). После миграции сохраняем
         cycleDataVersion = CYCLE_DATA_VERSION, чтобы больше не сбрасывать. */
      const savedVersion = saved.cycleDataVersion || 0;
      /* Миграция v<3 (полный резеед): для очень старых сборок с u30-u40 placeholder-ами,
         где HR не вводил имён/email. Безопасно затираем people полностью. Cycle data wipe. */
      if (savedVersion < 3) {
        return {
          ...base,
          people: peopleFresh,
          vacancies: Array.isArray(saved.vacancies) ? saved.vacancies : VACANCIES,
          forms: saved.forms || DEFAULT_FORMS,
          settings: saved.settings || DEFAULT_SETTINGS,
          /* Cycle data — чистые дефолты (пустые) */
          feedbackRequests: DEFAULT_FEEDBACK_REQUESTS,
          auditLog: DEFAULT_AUDIT_LOG,
          selfAssessments: DEFAULT_SELF_ASSESSMENTS,
          managerAssessments: DEFAULT_MANAGER_ASSESSMENTS,
          talentBarPlacements: DEFAULT_TALENT_BAR_PLACEMENTS,
          conversations: DEFAULT_CONVERSATIONS,
          devPlans: DEFAULT_DEV_PLANS,
          botCases: DEFAULT_BOT_CASES,
          cycleDataVersion: CYCLE_DATA_VERSION,
        };
      }
      /* Миграция v3→v6 (точечная правка seniority БЕЗ потери HR-правок):
         Для savedVersion 3-5 — используем mergePeople, который сохраняет всё, что
         HR вводил руками (photoUrl, email, phone, telegram, и т.д.). Дополнительно
         форс-обновляем seniority='Director' у u3/u4/u5/u6 — это была причина v4.
         v6 чистит "stuck" track/level у Director'ов (баг PersonForm до v6 сохранял IC3).
         ВАЖНО: v4 ошибочно делала полный `people: peopleFresh` — те, кто успел
         загрузить v4, потеряли photoUrl. v5+ не вернёт потерянное, но защитит
         будущие правки. */
      if (savedVersion < CYCLE_DATA_VERSION) {
        const mergedPeople = mergePeople(saved.people, saved.talentBarPlacements)
          .map(p => FORCE_SENIORITY_DIRECTOR.includes(p.id) && p.seniority !== 'Director'
            ? { ...p, seniority: 'Director' }
            : p)
          .map(cleanStuckLevel) /* v6: сбрасываем неправильный IC3 у Director'ов */
          .map(p => { /* v7: force sysRole='hr' для HR-titled позиций и явных HR-admin emails */
            const email = (p.email || '').toLowerCase().trim();
            const isHrByEmail = HR_ADMIN_EMAILS.has(email);
            const isHrByTitle = HR_ADMIN_TITLES.test(p.role || '');
            return (isHrByEmail || isHrByTitle) && p.sysRole !== 'hr'
              ? { ...p, sysRole: 'hr' }
              : p;
          });
        /* talentBarPlacements может быть в saved напрямую, или мигрироваться из старого nineBoxPlacements */
        const rawPlacementsM = saved.talentBarPlacements || saved.nineBoxPlacements?.map(x => ({ employeeId:x.employeeId, cycleId:x.cycleId, grade: x.performance==='high'?'A-player':x.performance==='med'?'Above bar':'Underperformer', placedBy:x.placedBy, placedAt:x.placedAt })) || DEFAULT_TALENT_BAR_PLACEMENTS;
        const talentBarPlacementsM = cleanPlacements(rawPlacementsM, saved.managerAssessments);
        const conversationsM = cleanConversations(saved.conversations, saved.managerAssessments);
        return {
          ...base,
          people: mergedPeople,
          vacancies: Array.isArray(saved.vacancies) ? saved.vacancies : VACANCIES,
          forms: saved.forms || DEFAULT_FORMS,
          settings: saved.settings || DEFAULT_SETTINGS,
          feedbackRequests: saved.feedbackRequests || DEFAULT_FEEDBACK_REQUESTS,
          auditLog: saved.auditLog || DEFAULT_AUDIT_LOG,
          selfAssessments: saved.selfAssessments || DEFAULT_SELF_ASSESSMENTS,
          managerAssessments: saved.managerAssessments || DEFAULT_MANAGER_ASSESSMENTS,
          talentBarPlacements: talentBarPlacementsM,
          conversations: conversationsM,
          devPlans: saved.devPlans || DEFAULT_DEV_PLANS,
          botCases: saved.botCases || DEFAULT_BOT_CASES,
          cycleDataVersion: CYCLE_DATA_VERSION,
        };
      }
      /* talentBarPlacements может быть в saved напрямую, или мигрироваться из старого nineBoxPlacements */
      const rawPlacements = saved.talentBarPlacements || saved.nineBoxPlacements?.map(x => ({ employeeId:x.employeeId, cycleId:x.cycleId, grade: x.performance==='high'?'A-player':x.performance==='med'?'Above bar':'Underperformer', placedBy:x.placedBy, placedAt:x.placedAt })) || DEFAULT_TALENT_BAR_PLACEMENTS;
      const savedMA = saved.managerAssessments || DEFAULT_MANAGER_ASSESSMENTS;
      /* Чистим stale-placements/conversations от прошлых демо-версий */
      const placements = cleanPlacements(rawPlacements, savedMA);
      const conversations = cleanConversations(saved.conversations || DEFAULT_CONVERSATIONS, savedMA);
      return {
        ...base, ...saved,
        people: mergePeople(saved.people, placements),
        vacancies: Array.isArray(saved.vacancies) ? saved.vacancies : VACANCIES,
        selfAssessments: saved.selfAssessments || DEFAULT_SELF_ASSESSMENTS,
        managerAssessments: savedMA,
        talentBarPlacements: placements,
        conversations,
        devPlans: saved.devPlans || DEFAULT_DEV_PLANS,
        botCases: saved.botCases || DEFAULT_BOT_CASES,
        cycleDataVersion: CYCLE_DATA_VERSION,
      };
    }
    /* Fresh install — никаких saved, просто дефолты с установленной версией */
    return { ...base, cycleDataVersion: CYCLE_DATA_VERSION };
    return base;
  }, []);
  const [state, setState] = useState(initial);
  useEffect(() => { saveStore(state); }, [state]);
  /* Прокидываем live-people в глобальный реестр, чтобы все byId() во всём приложении
     возвращали актуальные HR-правки (фотки, email, level, и т.д.). См. _LIVE_PEOPLE. */
  _setLivePeople(state.people); /* sync (не useEffect — чтобы успеть до первого byId в рендере) */
  useEffect(() => { _setLivePeople(state.people); }, [state.people]);

  /* Phase 2 bridge: подтягиваем с Supabase то, что не живёт в публичном HTML:
       1) photo_url  (public.employees)
       2) phone, telegram, date_of_birth, start_date, tenure_years  (public.employee_pii — RLS)
     Матчим по email → employees.id. Заодно кешируем email → DB uuid в window.__empDbIdByEmail,
     чтобы PersonForm мог грузить фотки в Storage и дёргать RPC set_employee_photo.

     Security (20 apr 2026): до этой ре-факторинга PII были прямо в RAW_PEOPLE
     и отдавались любому, кто открыл index.html. Теперь они за авторизацией + RLS.

     Compensation (22 apr 2026): запросы к public.employee_compensation удалены.
     Salary/equity не нужны в системе ни в каком виде (решение Aikanysh). */
  useEffect(() => {
    if (!supabase) return;
    let cancelled = false;
    (async () => {
      try {
        // COMMIT_7 (16 may 2026, fix BUG 5b): расширили select чтобы синтезировать
        // seed-shaped записи для сотрудников из БД, которых нет в state.people
        // (RAW_PEOPLE seed + localStorage). Раньше map() только апдейтил
        // существующих → новые HR-добавленные сотрудники не появлялись у других
        // админов. Теперь БД — источник правды для списка людей.
        const base = await supabase
          .from('employees')
          .select('id,email,full_name,title,team_id,subteam,track,level,role,manager_id,active,placeholder,photo_url,metadata');
        if (base.error || !Array.isArray(base.data) || cancelled) return;

        const dbIdMap   = {};   // email -> uuid
        const byDbId    = {};   // uuid  -> base row
        const photoMap  = {};   // email -> photo url
        /* COMMIT_7.2 (16 may 2026): добавили dbByLegacyId — это маппинг metadata.legacy_id → DB row.
           Нужен потому что bootstrap match только по email ломался на email mismatch
           (Жәнібек: seed email != DB placeholder email; Кирилл: seed email пустой,
           DB email = реальный). Теперь legacy_id — primary key для seed↔DB sync. */
        const dbByLegacyId = {};
        for (const row of base.data) {
          const e = (row.email || '').toLowerCase();
          if (e) {
            dbIdMap[e] = row.id;
            if (row.photo_url) photoMap[e] = row.photo_url;
          }
          byDbId[row.id] = row;
          const legId = row.metadata && row.metadata.legacy_id;
          if (legId) dbByLegacyId[legId] = row;
        }
        window.__empDbIdByEmail = dbIdMap;

        // Подтянуть team names — нужны для synthesized seed-shape (team_id → name).
        const teamMapById = {};
        try {
          const teamsRes = await supabase.from('teams').select('id,name');
          if (!teamsRes.error && Array.isArray(teamsRes.data)) {
            for (const t of teamsRes.data) teamMapById[t.id] = t.name || '';
          }
        } catch (_) { /* offline или таблицы нет — синтез отработает с team='' */ }

        // PII — RLS filters: self + manager + HR + exec.
        // Для остальных rows вернутся с NULL-колонками (это нормально).
        const pii = await supabase
          .from('employee_pii')
          .select('employee_id,phone,telegram,date_of_birth,start_date,tenure_years');
        const piiById = {};
        if (!pii.error && Array.isArray(pii.data)) {
          for (const row of pii.data) piiById[row.employee_id] = row;
        }

        /* 22 apr 2026: запрос к public.employee_compensation удалён.
           Salary/equity больше не гидратируются во фронтенд вообще. */

        if (cancelled) return;
        setState(s => {
          let changed = false;

          /* COMMIT_7.1 (16 may 2026, fix BUG 6): построим uuid→legacy map ДО основного
             map'а, чтобы можно было резолвить managerId из БД (uuid) в legacy-id
             которым оперирует state.people. Раньше bootstrap не обновлял managerId
             из БД — поэтому когда HR Admin меняла manager в БД, org-chart всё равно
             отрисовывал старого manager'а из захардкоженного RAW_PEOPLE seed
             (например Райхан/Ясмина застряли под Айканыш вместо Тимура). */
          const dbUuidToLegacyId = {};
          for (const p of s.people) {
            const e = (p.email || '').toLowerCase().trim();
            const dbId = dbIdMap[e];
            if (dbId) dbUuidToLegacyId[dbId] = p.id;
          }

          /* A. Обновление существующих (как было раньше + managerId из БД + legacy_id fallback) */
          const next = s.people.map(p => {
            const e = (p.email || '').toLowerCase();
            /* COMMIT_7.2: matching сначала по email, fallback на legacy_id (p.id).
               Это покрывает случай когда seed email пустой/устарел, а в БД email
               настоящий — раньше bootstrap не находил match и создавал дубль через synth. */
            let dbRow = e ? byDbId[dbIdMap[e]] : null;
            if (!dbRow && p.id && dbByLegacyId[p.id]) {
              dbRow = dbByLegacyId[p.id];
            }
            const dbId   = dbRow ? dbRow.id : null;
            const piiRow = dbId ? piiById[dbId] : null;

            const merged = { ...p };
            let rowChanged = false;

            /* COMMIT_7.2 + 7.4: если matched по legacy_id или email, обновим из БД
               следующие поля (БД — источник правды):
                 - email (case Кирилл: seed=='', db='prokopev.k@choco.kz')
                 - photo_url
                 - level (case Тимур: seed без level → дерайв S1; БД=m3 → 7.4 fix)
                 - track (ic/manager/support) — нужен для scorecard lookup
                 - title (HR-правки в БД должны видеть все)
               НЕ обновляем: name, roleKey (нет в БД), seniority (auto-derives из level). */
            if (dbRow) {
              if (dbRow.email && dbRow.email !== merged.email
                  && !String(dbRow.email).endsWith('.placeholder@choco.kz')) {
                merged.email = dbRow.email;
                rowChanged = true;
              }
              if (dbRow.photo_url && merged.photoUrl !== dbRow.photo_url) {
                merged.photoUrl = dbRow.photo_url;
                rowChanged = true;
              }
              if (dbRow.level && merged.level !== dbRow.level) {
                merged.level = dbRow.level;
                rowChanged = true;
                /* COMMIT_7.6 BUG 9.1: при смене level авто-деривим seniority через LEVELS map.
                   Иначе seed-seniority ('Director' у Тимура из RAW_PEOPLE) остаётся и виден
                   в чипе HR Admin вместо актуального ('Lead' для M3). LEVELS keys uppercase
                   (M3), а БД хранит lowercase (m3) — нормализуем. */
                try {
                  const lvKey = String(dbRow.level).toUpperCase();
                  const hint = (typeof LEVELS === 'object') && LEVELS[lvKey] && LEVELS[lvKey].seniorityHint;
                  if (hint && merged.seniority !== hint) {
                    merged.seniority = hint;
                  }
                } catch (_) { /* LEVELS не в scope — игнор */ }
              }
              if (dbRow.track && merged.track !== dbRow.track) {
                merged.track = dbRow.track;
                rowChanged = true;
              }
              if (dbRow.title && merged.role !== dbRow.title) {
                merged.role = dbRow.title;
                rowChanged = true;
              }
              /* BUGFIX 24 jun 2026 (v2): реальный сотрудник из БД не должен показываться «вакансией».
                 personStatus() => 'vacant' при placeholder ИЛИ пустом name. Seed для топ-менеджмента
                 кладёт name='— CEO' (авто-фолбэк r[1]||`— ${role}`), placeholder=true, email=null —
                 поэтому они висели вакансиями. Матч с БД идёт по metadata.legacy_id (u1..uN).
                 Если у dbRow есть настоящее full_name и email не placeholder — подставляем имя
                 (в т.ч. поверх авто-«— role»), снимаем placeholder и vacant-статус.
                 Curated-имена (не начинающиеся с «—») не трогаем. */
              const seedAutoName = !String(merged.name || '').trim()
                                 || String(merged.name).trim().startsWith('—');
              if (dbRow.full_name && dbRow.full_name.trim() && seedAutoName
                  && !String(dbRow.email || '').endsWith('.placeholder@choco.kz')) {
                merged.name = dbRow.full_name;
                merged.hasName = true;
                merged.placeholder = false;
                if (merged.status === 'vacant') merged.status = 'active';
                rowChanged = true;
              }
            }
            // photo (старый путь — на случай если matching был по email и photoMap'у)
            const url = e ? photoMap[e] : null;
            if (url && merged.photoUrl !== url) { merged.photoUrl = url; rowChanged = true; }

            /* COMMIT_7.1 fix BUG 6: managerId из БД перебивает RAW_PEOPLE/localStorage.
               БД — источник правды для оргструктуры. */
            if (dbRow && dbRow.manager_id) {
              const dbManagerLegacy = dbUuidToLegacyId[dbRow.manager_id];
              if (dbManagerLegacy && merged.managerId !== dbManagerLegacy) {
                merged.managerId = dbManagerLegacy;
                rowChanged = true;
              }
            } else if (dbRow && dbRow.manager_id === null && merged.managerId) {
              /* В БД явно нет manager (CEO) — сбросим JS-stale managerId */
              merged.managerId = null;
              rowChanged = true;
            }

            // PII
            if (piiRow) {
              if (piiRow.phone != null && merged.phone !== piiRow.phone)
                { merged.phone = piiRow.phone; rowChanged = true; }
              if (piiRow.telegram != null && merged.telegram !== piiRow.telegram)
                { merged.telegram = piiRow.telegram; rowChanged = true; }
              if (piiRow.date_of_birth != null && merged.birthDate !== piiRow.date_of_birth)
                { merged.birthDate = piiRow.date_of_birth; rowChanged = true; }
              if (piiRow.start_date != null && merged.startDate !== piiRow.start_date)
                { merged.startDate = piiRow.start_date; rowChanged = true; }
              if (piiRow.tenure_years != null) {
                const t = Number(piiRow.tenure_years);
                if (!Number.isNaN(t) && merged.tenure !== t)
                  { merged.tenure = t; rowChanged = true; }
              }
            }

            /* Compensation: удалено 22 apr 2026. */

            if (rowChanged) { changed = true; return merged; }
            return p;
          });

          /* B. COMMIT_7 fix BUG 5b: синтезируем seed-shaped записи из БД для
             email-ов, которых нет в state.people. legacy_id берём из
             metadata.legacy_id (если есть) либо синтезируем 'u_<uuid12>'.
             manager_id мапим uuid→legacy через ту же логику. */
          const existingEmails = new Set(
            next.map(p => (p.email || '').toLowerCase().trim()).filter(Boolean)
          );
          /* COMMIT_7.2 fix BUG 7 (Кирилл/Жәнібек дубль): legacy_id-set для skip-on-collision.
             Защищает от случая когда email в seed пустой/устарел, а в БД email настоящий:
             part A уже спарилась через legacy_id fallback, но part B всё равно может
             синтезировать ту же запись если её email уникален. Skip по legacy_id —
             убирает этот edge case. */
          const existingLegacyIds = new Set(next.map(p => p.id));

          /* COMMIT_7.1 fix: переиспользуем dbUuidToLegacyId из верхнего блока
             (объявлен на строке 3006) — раньше тут было повторное объявление const,
             что давало SyntaxError "Identifier 'dbUuidToLegacyId' has already been declared".
             Map уже содержит ВСЕ существующие email→legacy_id связи. Дополним
             только если в next добавились новые между объявлением и сюда (защита). */
          for (const p of next) {
            const e = (p.email || '').toLowerCase().trim();
            const dbId = dbIdMap[e];
            if (dbId && !dbUuidToLegacyId[dbId]) dbUuidToLegacyId[dbId] = p.id;
          }

          const appended = [];
          for (const row of (base.data || [])) {
            const e = (row.email || '').toLowerCase().trim();
            if (!e || existingEmails.has(e)) continue;
            if (row.active === false) continue; /* деактивированные — не льём */

            const legacyId = (row.metadata && row.metadata.legacy_id)
              || ('u_' + String(row.id || '').replace(/-/g, '').slice(0, 12));

            /* COMMIT_7.2 fix BUG 7: коллизия legacy_id — этот сотрудник уже есть в state.people
               (через seed с другим/пустым email). Не синтезировать. */
            if (existingLegacyIds.has(legacyId)) continue;

            const managerLegacy = row.manager_id
              ? (dbUuidToLegacyId[row.manager_id] || null)
              : null;

            const piiRow = piiById[row.id] || null;
            const photoUrl = photoMap[e] || row.photo_url || '';
            const teamName = row.team_id ? (teamMapById[row.team_id] || '') : '';

            // Также добавим в uuid-map чтобы последующие synthesized могли резолвить manager_id
            dbUuidToLegacyId[row.id] = legacyId;

            appended.push({
              id: legacyId,
              name: row.full_name || '',
              email: row.email,
              role: row.title || '—',
              roleKey: 'ops', /* fallback — после COMMIT_8 (job_role в БД) станет точно */
              seniority: 'Mid',
              track: row.track || 'ic',
              level: row.level || null,
              team: teamName,
              subteam: row.subteam || '',
              managerId: managerLegacy,
              avatar: (row.full_name || row.email).split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase(),
              color: 'brand',
              photoUrl,
              phone: piiRow?.phone || '',
              telegram: piiRow?.telegram || '',
              birthDate: piiRow?.date_of_birth || '',
              startDate: piiRow?.start_date || '',
              tenure: piiRow?.tenure_years != null ? Number(piiRow.tenure_years) : 0,
              currentGrade: null,
              sysRole: 'employee', /* DB-role override применится через App() useState dbRole */
              active: true,
              hasName: !!row.full_name,
              placeholder: !row.full_name,
              __syntheticFromDb: true,
            });
            existingEmails.add(e); /* защита от дубля если row повторится */
          }

          if (appended.length > 0) {
            changed = true;
            return { ...s, people: [...next, ...appended] };
          }
          return changed ? { ...s, people: next } : s;
        });
      } catch (_) { /* оффлайн / не залогинен — ок, просто покажем без PII */ }
    })();
    return () => { cancelled = true; };
  }, []);

  /* Phase 3 bridge: гидратируем review-цикл (self/360/manager/dev/BoT/placements)
     из Supabase, чтобы 360-фидбек реально работал cross-user, а Манарбек/любой
     HR видел актуальные submitted-ассессменты Аиканыш, не свой локальный stub.

     Стратегия: только при наличии supabase И залогиненного пользователя.
     RLS-слой на стороне Supabase фильтрует, кто что видит (manager видит direct
     reports, HR — всех, employee — только свои submitted). Раннер:
       1) bootstrap(state.people) — мапим u-ids на uuids по email.
       2) Parallel fetch: selfAssessments, managerAssessments, feedback, devPlans,
          botCases, ratings(→talentBarPlacements).
       3) Мерджим в локальный state (server wins для cycle-данных — они authoritative).

     Если Supabase вернёт пусто (новый deploy, миграция ещё не прошла), state
     остаётся как был — ломать UX не будем. */
  const reviewHydratedRef = useRef(false);
  useEffect(() => {
    if (!supabase) return;
    if (reviewHydratedRef.current) return;
    if (!Array.isArray(state.people) || state.people.length === 0) return;
    let cancelled = false;
    (async () => {
      try {
        const ok = await REVIEW_SYNC.bootstrap(state.people);
        if (!ok || cancelled) return;
        const [saRows, maRows, fbRows, dpRows, botRows, ratingRows] = await Promise.all([
          REVIEW_SYNC.fetchSelfAssessments(),
          REVIEW_SYNC.fetchManagerAssessments(),
          REVIEW_SYNC.fetchFeedback(state.people),
          REVIEW_SYNC.fetchDevPlans(),
          REVIEW_SYNC.fetchBotCases(),
          REVIEW_SYNC.fetchRatings(),
        ]);
        if (cancelled) return;
        reviewHydratedRef.current = true;
        setState(s => {
          /* Merge policy: если DB вернула row, server wins. Локальные rows, которых
             нет в DB (например, офлайн-драфты пока ещё не sync), сохраняем. */
          const merge = (serverList, localList, keyFn) => {
            const serverKeys = new Set(serverList.map(keyFn));
            const localOnly = localList.filter(x => !serverKeys.has(keyFn(x)));
            return [...serverList, ...localOnly];
          };
          const saKey = x => `${x.employeeId}|${x.cycleId}`;
          const maKey = x => `${x.employeeId}|${x.cycleId}`;
          const dpKey = x => `${x.employeeId}|${x.cycleId}`;
          const botKey = x => `${x.employeeId}|${x.cycleId}`;
          const placeKey = x => `${x.employeeId}|${x.cycleId}`;
          /* 360: server wins полностью (более сложный кластеринг) */
          const mergedFb = fbRows.length ? fbRows : (s.feedbackRequests || []);
          return {
            ...s,
            selfAssessments:      merge(saRows,     s.selfAssessments      || [], saKey),
            managerAssessments:   merge(maRows,     s.managerAssessments   || [], maKey),
            feedbackRequests:     mergedFb,
            devPlans:             merge(dpRows,    s.devPlans              || [], dpKey),
            botCases:             merge(botRows,   s.botCases              || [], botKey),
            talentBarPlacements:  merge(ratingRows, s.talentBarPlacements  || [], placeKey),
          };
        });
      } catch (_) { /* молча: оффлайн, не залогинен, или RLS вернула пусто */ }
    })();
    return () => { cancelled = true; };
  }, [state.people]);

  const log = (who, action) => ({
    id:'a-'+Math.random().toString(36).slice(2,8),
    at: new Date().toISOString().slice(0,16).replace('T',' '),
    who, action,
  });

  const actions = useMemo(() => ({
    addPerson: (p, actorName='HR Admin') => setState(s => ({
      ...s,
      people: [...s.people, { ...p, active:true, placeholder: !p.name, hasName: !!p.name }],
      auditLog: [log(actorName, `Добавил сотрудника: ${p.name || p.role}`), ...s.auditLog],
    })),
    updatePerson: (id, patch, actorName='HR Admin') => setState(s => ({
      ...s,
      people: s.people.map(p => p.id === id ? { ...p, ...patch, placeholder: !((patch.name!==undefined?patch.name:p.name)), hasName: !!(patch.name!==undefined?patch.name:p.name) } : p),
      auditLog: [log(actorName, `Обновил профиль: ${id} — ${Object.keys(patch).join(', ')}`), ...s.auditLog],
    })),
    deactivatePerson: (id, actorName='HR Admin') => setState(s => ({
      ...s,
      people: s.people.map(p => p.id === id ? { ...p, active:false } : p),
      auditLog: [log(actorName, `Деактивировал сотрудника: ${id}`), ...s.auditLog],
    })),
    reactivatePerson: (id, actorName='HR Admin') => setState(s => ({
      ...s,
      people: s.people.map(p => p.id === id ? { ...p, active:true } : p),
      auditLog: [log(actorName, `Возобновил сотрудника: ${id}`), ...s.auditLog],
    })),
    bulkImportPeople: (rows, actorName='HR Admin') => setState(s => ({
      ...s,
      people: [...s.people, ...rows],
      auditLog: [log(actorName, `Импорт CSV: +${rows.length} сотрудников`), ...s.auditLog],
    })),

    /* Vacancies */
    addVacancy: (v, actorName='HR Admin') => setState(s => {
      const newV = {
        id: v.id || 'V-'+String((s.vacancies||[]).length + 1).padStart(2,'0'),
        role: v.role || 'Новая роль',
        roleKey: v.roleKey || 'role-'+Math.random().toString(36).slice(2,6),
        seniority: v.seniority || 'Mid',
        team: v.team || 'AI',
        subteam: v.subteam || '',
        managerId: v.managerId || '',
        status: v.status || 'sourcing',
        openedDate: v.openedDate || new Date().toISOString().slice(0,10),
        priority: v.priority || 'med',
        candidate: v.candidate || '',
      };
      return {
        ...s,
        vacancies: [...(s.vacancies || []), newV],
        auditLog: [log(actorName, `Открыл вакансию: ${newV.role} (${newV.id})`), ...s.auditLog],
      };
    }),
    updateVacancy: (id, patch, actorName='HR Admin') => setState(s => ({
      ...s,
      vacancies: (s.vacancies || []).map(v => v.id === id ? { ...v, ...patch } : v),
      auditLog: [log(actorName, `Обновил вакансию: ${id} — ${Object.keys(patch).join(', ')}`), ...s.auditLog],
    })),
    deleteVacancy: (id, actorName='HR Admin') => setState(s => {
      const v = (s.vacancies || []).find(x => x.id === id);
      return {
        ...s,
        vacancies: (s.vacancies || []).filter(x => x.id !== id),
        auditLog: [log(actorName, `Закрыл/удалил вакансию: ${v ? v.role : id} (${id})`), ...s.auditLog],
      };
    }),

    /* Forms */
    addForm: (form, actorName='HR Admin') => setState(s => ({
      ...s, forms: [...s.forms, { ...form, id: form.id || 'form-'+Math.random().toString(36).slice(2,8), createdAt: new Date().toISOString().slice(0,10) }],
      auditLog: [log(actorName, `Создал форму: ${form.name}`), ...s.auditLog],
    })),
    updateForm: (id, patch, actorName='HR Admin') => setState(s => ({
      ...s, forms: s.forms.map(f => f.id === id ? { ...f, ...patch } : f),
      auditLog: [log(actorName, `Изменил форму: ${id}`), ...s.auditLog],
    })),
    deleteForm: (id, actorName='HR Admin') => setState(s => ({
      ...s, forms: s.forms.filter(f => f.id !== id),
      auditLog: [log(actorName, `Удалил форму: ${id}`), ...s.auditLog],
    })),

    /* Feedback */
    createFeedbackRequest: (req, actorName='System') => setState(s => {
      const newReq = {
        id:'fr-'+Math.random().toString(36).slice(2,8),
        status:'in_progress',
        sentAt: new Date().toISOString().slice(0,10),
        responses:[],
        ...req,
      };
      /* fire-and-forget sync: flatten fromIds[] в N row'ов feedback_requests.
         RLS+upsert идемпотентны. */
      if (REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertFeedbackRequestSet(newReq, s.people));
      }
      return {
        ...s,
        feedbackRequests: [...s.feedbackRequests, newReq],
        auditLog: [log(actorName, `Создал запрос фидбека: → ${req.fromIds?.length || 1} reviewers`), ...s.auditLog],
      };
    }),
    submitFeedbackResponse: (requestId, response, actorName='Reviewer') => setState(s => {
      const newResp = { ...response, id:'resp-'+Math.random().toString(36).slice(2,8), submittedAt: new Date().toISOString().slice(0,10) };
      const parentReq = s.feedbackRequests.find(fr => fr.id === requestId) || null;
      const next = s.feedbackRequests.map(fr => fr.id === requestId
        ? { ...fr, responses: [...fr.responses, newResp] }
        : fr);
      /* Sync: upsert feedback_request(s) и feedback_response в Supabase.
         Для identified — author_id=uuid; для anonymous — author_id=NULL+nonce. */
      if (parentReq && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertFeedbackResponse(parentReq, newResp, s.people));
      }
      return {
        ...s,
        feedbackRequests: next,
        auditLog: [log(actorName, `Отправил фидбек по запросу: ${requestId}`), ...s.auditLog],
      };
    }),

    /* Settings */
    updateSettings: (patch, actorName='HR Admin') => setState(s => ({
      ...s, settings: { ...s.settings, ...patch },
      auditLog: [log(actorName, `Изменил настройки: ${Object.keys(patch).join(', ')}`), ...s.auditLog],
    })),

    /* Self Assessment */
    saveSelfAssessmentDraft: (employeeId, cycleId, sections, actorName='Employee') => setState(s => {
      const now = new Date().toISOString().slice(0,16).replace('T',' ');
      const existing = s.selfAssessments.find(sa => sa.employeeId===employeeId && sa.cycleId===cycleId);
      if (existing && existing.status==='submitted') return s; /* Locked after submit */
      const next = existing
        ? s.selfAssessments.map(sa => sa.id===existing.id ? { ...sa, sections:{...sa.sections, ...sections}, status:'draft', lastSavedAt:now } : sa)
        : [...s.selfAssessments, {
            id:'sa-'+employeeId+'-'+cycleId,
            employeeId, cycleId, period: ACTIVE_CYCLE.period,
            status:'draft', lastSavedAt:now, submittedAt:null,
            sections,
          }];
      const newRow = next.find(sa => sa.employeeId===employeeId && sa.cycleId===cycleId) || null;
      if (newRow && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertSelfAssessment(newRow));
      }
      return { ...s, selfAssessments: next,
        auditLog: [log(actorName, `Self Assessment: сохранил черновик (${employeeId} · ${cycleId})`), ...s.auditLog]};
    }),
    submitSelfAssessment: (employeeId, cycleId, sections, actorName='Employee') => setState(s => {
      const now = new Date().toISOString().slice(0,16).replace('T',' ');
      const existing = s.selfAssessments.find(sa => sa.employeeId===employeeId && sa.cycleId===cycleId);
      const next = existing
        ? s.selfAssessments.map(sa => sa.id===existing.id ? { ...sa, sections:{...sa.sections, ...sections}, status:'submitted', lastSavedAt:now, submittedAt:now } : sa)
        : [...s.selfAssessments, {
            id:'sa-'+employeeId+'-'+cycleId,
            employeeId, cycleId, period: ACTIVE_CYCLE.period,
            status:'submitted', lastSavedAt:now, submittedAt:now,
            sections,
          }];
      const newRow = next.find(sa => sa.employeeId===employeeId && sa.cycleId===cycleId) || null;
      if (newRow && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertSelfAssessment(newRow));
      }
      return { ...s, selfAssessments: next,
        auditLog: [log(actorName, `Self Assessment: отправил (${employeeId} · ${cycleId})`), ...s.auditLog]};
    }),

    /* Manager Assessment */
    saveManagerAssessmentDraft: (employeeId, managerId, cycleId, patch, actorName='Manager') => setState(s => {
      const now = new Date().toISOString().slice(0,16).replace('T',' ');
      const existing = s.managerAssessments.find(ma => ma.employeeId===employeeId && ma.cycleId===cycleId);
      if (existing && existing.status==='locked') return s;
      const next = existing
        ? s.managerAssessments.map(ma => ma.id===existing.id
            ? { ...ma,
                scores: {...ma.scores, ...(patch.scores||{})},
                comments: {...ma.comments, ...(patch.comments||{})},
                supportingDocs: patch.supportingDocs || ma.supportingDocs,
                derivedGrade: patch.derivedGrade ?? ma.derivedGrade,
                status: (ma.status==='submitted') ? 'draft' : 'draft',
                lastSavedAt: now,
              }
            : ma)
        : [...s.managerAssessments, {
            id:'ma-'+employeeId+'-'+cycleId,
            employeeId, managerId, cycleId, period: ACTIVE_CYCLE.period,
            status:'draft', lastSavedAt:now, submittedAt:null, lockedAt:null, reopenedAt:null,
            scores: patch.scores || {skills:{},deliverables:{},culture:{}},
            comments: patch.comments || {skills:'',deliverables:'',culture:'',overall:''},
            supportingDocs: patch.supportingDocs || [],
            derivedGrade: patch.derivedGrade || null,
          }];
      const newRow = next.find(ma => ma.employeeId===employeeId && ma.cycleId===cycleId) || null;
      if (newRow && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertManagerAssessment(newRow));
      }
      return { ...s, managerAssessments: next,
        auditLog: [log(actorName, `Manager Assessment: сохранил черновик (${employeeId} · ${cycleId})`), ...s.auditLog]};
    }),
    submitManagerAssessment: (employeeId, managerId, cycleId, patch, actorName='Manager') => setState(s => {
      const now = new Date().toISOString().slice(0,16).replace('T',' ');
      const existing = s.managerAssessments.find(ma => ma.employeeId===employeeId && ma.cycleId===cycleId);
      if (existing && existing.status==='locked') return s;
      const next = existing
        ? s.managerAssessments.map(ma => ma.id===existing.id
            ? { ...ma,
                scores: {...ma.scores, ...(patch.scores||{})},
                comments: {...ma.comments, ...(patch.comments||{})},
                supportingDocs: patch.supportingDocs || ma.supportingDocs,
                derivedGrade: patch.derivedGrade ?? ma.derivedGrade,
                status:'submitted',
                lastSavedAt:now,
                submittedAt:now,
              }
            : ma)
        : [...s.managerAssessments, {
            id:'ma-'+employeeId+'-'+cycleId,
            employeeId, managerId, cycleId, period: ACTIVE_CYCLE.period,
            status:'submitted', lastSavedAt:now, submittedAt:now, lockedAt:null, reopenedAt:null,
            scores: patch.scores || {skills:{},deliverables:{},culture:{}},
            comments: patch.comments || {skills:'',deliverables:'',culture:'',overall:''},
            supportingDocs: patch.supportingDocs || [],
            derivedGrade: patch.derivedGrade || null,
          }];
      const newRow = next.find(ma => ma.employeeId===employeeId && ma.cycleId===cycleId) || null;
      if (newRow && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertManagerAssessment(newRow));
      }
      return { ...s, managerAssessments: next,
        auditLog: [log(actorName, `Manager Assessment: отправил (${employeeId} · ${cycleId})`), ...s.auditLog]};
    }),
    lockManagerAssessment: (employeeId, cycleId, actorName='HR Admin') => setState(s => {
      const now = new Date().toISOString().slice(0,16).replace('T',' ');
      const next = s.managerAssessments.map(ma =>
        ma.employeeId===employeeId && ma.cycleId===cycleId
          ? { ...ma, status:'locked', lockedAt:now }
          : ma);
      const newRow = next.find(ma => ma.employeeId===employeeId && ma.cycleId===cycleId) || null;
      if (newRow && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertManagerAssessment(newRow));
      }
      return { ...s, managerAssessments: next,
        auditLog: [log(actorName, `Manager Assessment: залочил (${employeeId} · ${cycleId})`), ...s.auditLog]};
    }),
    /* Talent Bar Calibration — присваиваем финальный grade по итогам Talent Bar review */
    setTalentBarPlacement: (employeeId, cycleId, grade, actorName='Performance Team') => setState(s => {
      const now = new Date().toISOString().slice(0,16).replace('T',' ');
      const existing = s.talentBarPlacements.find(x => x.employeeId===employeeId && x.cycleId===cycleId);
      const next = existing
        ? s.talentBarPlacements.map(x => x.employeeId===employeeId && x.cycleId===cycleId
            ? { ...x, grade, placedBy:actorName, placedAt:now }
            : x)
        : [...s.talentBarPlacements, { employeeId, cycleId, grade, placedBy:actorName, placedAt:now }];
      const newPlacement = next.find(x => x.employeeId===employeeId && x.cycleId===cycleId) || null;
      /* Sync: placement → public.ratings (talent_box + derived rating_grade).
         Ratings — source of truth для final Calibration-grade; immutable после locked=true. */
      if (newPlacement && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertRatingFromPlacement(newPlacement));
      }
      return { ...s, talentBarPlacements: next,
        auditLog: [log(actorName, `Talent Bar: ${employeeId} → ${grade}`), ...s.auditLog]};
    }),
    reopenManagerAssessment: (employeeId, cycleId, actorName='HR Admin') => setState(s => {
      const now = new Date().toISOString().slice(0,16).replace('T',' ');
      const next = s.managerAssessments.map(ma =>
        ma.employeeId===employeeId && ma.cycleId===cycleId
          ? { ...ma, status:'reopened', reopenedAt:now, lockedAt:null }
          : ma);
      const newRow = next.find(ma => ma.employeeId===employeeId && ma.cycleId===cycleId) || null;
      if (newRow && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertManagerAssessment(newRow));
      }
      return { ...s, managerAssessments: next,
        auditLog: [log(actorName, `Manager Assessment: переоткрыл (${employeeId} · ${cycleId})`), ...s.auditLog]};
    }),

    /* Hold Performance Conversation */
    scheduleConversation: (employeeId, cycleId, scheduledAt, actorName='Manager') => setState(s => {
      const existing = s.conversations.find(c=>c.employeeId===employeeId && c.cycleId===cycleId);
      const person = s.people.find(p=>p.id===employeeId);
      const next = existing
        ? s.conversations.map(c => c.employeeId===employeeId && c.cycleId===cycleId
            ? { ...c, status: c.status==='acknowledged' ? c.status : 'scheduled', scheduledAt }
            : c)
        : [...s.conversations, {
            id:'conv-'+employeeId+'-'+cycleId,
            employeeId, managerId: person?.manager || null, cycleId, period: cycleId.toUpperCase(),
            status:'scheduled', scheduledAt, heldAt:null, heldBy:null, notes:'',
            acknowledgedAt:null, acknowledgedBy:null, acknowledgedNote:'',
            finalGrade: person?.currentGrade || null, nextStep: person?.currentGrade==='Underperformer' ? 'bot' : 'development',
          }];
      return { ...s, conversations: next,
        auditLog: [log(actorName, `Performance Conversation: запланирован 1:1 (${employeeId} · ${scheduledAt})`), ...s.auditLog]};
    }),
    holdConversation: (employeeId, cycleId, patch, actorName='Manager') => setState(s => {
      const now = new Date().toISOString().slice(0,16).replace('T',' ');
      const person = s.people.find(p=>p.id===employeeId);
      const existing = s.conversations.find(c=>c.employeeId===employeeId && c.cycleId===cycleId);
      const base = existing || {
        id:'conv-'+employeeId+'-'+cycleId,
        employeeId, managerId: person?.manager || null, cycleId, period: cycleId.toUpperCase(),
        status:'pending', scheduledAt:null, heldAt:null, heldBy:null, notes:'',
        acknowledgedAt:null, acknowledgedBy:null, acknowledgedNote:'',
        finalGrade: person?.currentGrade || null, nextStep: person?.currentGrade==='Underperformer' ? 'bot' : 'development',
      };
      const updated = { ...base, ...patch, status:'held', heldAt: now, heldBy: base.managerId };
      const next = existing
        ? s.conversations.map(c => c===existing ? updated : c)
        : [...s.conversations, updated];
      return { ...s, conversations: next,
        auditLog: [log(actorName, `Performance Conversation: проведён 1:1 (${employeeId})`), ...s.auditLog]};
    }),
    acknowledgeConversation: (employeeId, cycleId, patch, actorName='Employee') => setState(s => {
      const now = new Date().toISOString().slice(0,16).replace('T',' ');
      const next = s.conversations.map(c =>
        c.employeeId===employeeId && c.cycleId===cycleId
          ? { ...c, status:'acknowledged', acknowledgedAt: now, acknowledgedBy: employeeId, acknowledgedNote: patch?.note || '' }
          : c);
      return { ...s, conversations: next,
        auditLog: [log(actorName, `Performance Conversation: подтверждено сотрудником (${employeeId})`), ...s.auditLog]};
    }),

    /* Development Plan */
    upsertDevPlan: (employeeId, cycleId, patch, actorName='Manager') => setState(s => {
      const today = new Date().toISOString().slice(0,10);
      const existing = s.devPlans.find(p => p.employeeId===employeeId && p.cycleId===cycleId);
      let nextList;
      if (existing) {
        nextList = s.devPlans.map(p => p===existing ? { ...p, ...patch, lastUpdated: today } : p);
      } else {
        const person = s.people.find(p=>p.id===employeeId);
        const created = {
          id:'dp-'+employeeId+'-'+cycleId,
          employeeId, managerId: person?.manager || null,
          cycleId, period: cycleId.toUpperCase(),
          status:'active', createdAt: today, lastUpdated: today,
          theme:'', goals:[], ...patch,
        };
        nextList = [...s.devPlans, created];
      }
      const newRow = nextList.find(p => p.employeeId===employeeId && p.cycleId===cycleId) || null;
      if (newRow && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertDevPlan(newRow));
      }
      return { ...s, devPlans: nextList,
        auditLog: [log(actorName, existing ? `Development Plan: обновлён (${employeeId} · ${cycleId})` : `Development Plan: создан (${employeeId} · ${cycleId})`), ...s.auditLog]};
    }),
    updateDevPlanGoal: (employeeId, cycleId, goalId, goalPatch, actorName='Manager') => setState(s => {
      const today = new Date().toISOString().slice(0,10);
      const next = s.devPlans.map(p => {
        if (p.employeeId!==employeeId || p.cycleId!==cycleId) return p;
        return { ...p, lastUpdated: today,
          goals: p.goals.map(g => g.id===goalId ? { ...g, ...goalPatch } : g) };
      });
      const newRow = next.find(p => p.employeeId===employeeId && p.cycleId===cycleId) || null;
      if (newRow && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertDevPlan(newRow));
      }
      return { ...s, devPlans: next,
        auditLog: [log(actorName, `Dev Plan: цель «${goalId}» обновлена (${employeeId})`), ...s.auditLog]};
    }),

    /* BoT (Back on Track) — 6-week PIP с halfway + final */
    startBotCase: (employeeId, cycleId, patch, actorName='Manager') => setState(s => {
      const today = new Date().toISOString().slice(0,10);
      const existing = s.botCases.find(b => b.employeeId===employeeId && b.cycleId===cycleId);
      let nextList;
      if (existing) {
        nextList = s.botCases.map(b => b===existing ? { ...b, ...patch } : b);
      } else {
        const person = s.people.find(p=>p.id===employeeId);
        /* halfway = +3 нед, final = +6 нед */
        const add = (d, days) => { const x = new Date(d); x.setDate(x.getDate()+days); return x.toISOString().slice(0,10); };
        const created = {
          id:'bot-'+employeeId+'-'+cycleId,
          employeeId, managerId: person?.manager || null,
          cycleId, period: cycleId.toUpperCase(),
          status:'active', startDate: today, halfwayDate: add(today,21), finalDate: add(today,42),
          reason:'', severanceChosen:false, smartGoals:[], halfwayResult:null, finalResult:null,
          ...patch,
        };
        nextList = [...s.botCases, created];
      }
      const newRow = nextList.find(b => b.employeeId===employeeId && b.cycleId===cycleId) || null;
      if (newRow && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertBotCase(newRow));
      }
      return { ...s, botCases: nextList,
        auditLog: [log(actorName, existing ? `BoT: обновлён (${employeeId})` : `BoT: стартовал (${employeeId})`), ...s.auditLog]};
    }),
    recordBotHalfway: (employeeId, cycleId, result, actorName='Manager') => setState(s => {
      const today = new Date().toISOString().slice(0,10);
      const next = s.botCases.map(b =>
        b.employeeId===employeeId && b.cycleId===cycleId
          ? { ...b, status:'halfway-done', halfwayResult:{ date: today, ...result } }
          : b);
      const newRow = next.find(b => b.employeeId===employeeId && b.cycleId===cycleId) || null;
      if (newRow && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertBotCase(newRow));
      }
      return { ...s, botCases: next,
        auditLog: [log(actorName, `BoT: halfway checkpoint (${employeeId} · ${result.verdict})`), ...s.auditLog]};
    }),
    recordBotFinal: (employeeId, cycleId, result, actorName='Committee') => setState(s => {
      const today = new Date().toISOString().slice(0,10);
      const statusMap = { continue:'completed-continue', extend:'active', exit:'completed-exit' };
      const next = s.botCases.map(b =>
        b.employeeId===employeeId && b.cycleId===cycleId
          ? { ...b, status: statusMap[result.decision] || 'completed-continue', finalResult:{ date: today, ...result } }
          : b);
      const newRow = next.find(b => b.employeeId===employeeId && b.cycleId===cycleId) || null;
      if (newRow && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertBotCase(newRow));
      }
      return { ...s, botCases: next,
        auditLog: [log(actorName, `BoT: final decision — ${result.decision} (${employeeId})`), ...s.auditLog]};
    }),
    toggleBotGoal: (employeeId, cycleId, goalId, met, actorName='Manager') => setState(s => {
      const next = s.botCases.map(b => {
        if (b.employeeId!==employeeId || b.cycleId!==cycleId) return b;
        return { ...b, smartGoals: b.smartGoals.map(g => g.id===goalId ? { ...g, met } : g) };
      });
      const newRow = next.find(b => b.employeeId===employeeId && b.cycleId===cycleId) || null;
      if (newRow && REVIEW_SYNC.isReady()) {
        Promise.resolve().then(() => REVIEW_SYNC.upsertBotCase(newRow));
      }
      return { ...s, botCases: next,
        auditLog: [log(actorName, `BoT: цель ${goalId} → ${met?'met':'not met'} (${employeeId})`), ...s.auditLog]};
    }),

    /* Utilities */
    resetStore: () => { try { localStorage.removeItem(STORAGE_KEY); } catch(e){} window.location.reload(); },
  }), []);

  return { state, ...actions };
};

/* CSV helpers для import/export */
const parseCSV = (text) => {
  const lines = text.trim().split(/\r?\n/);
  if (lines.length < 2) return [];
  const headers = lines[0].split(',').map(h=>h.trim().replace(/^"|"$/g,''));
  return lines.slice(1).map(line => {
    const cells = [];
    let cur=''; let inQ=false;
    for (let i=0;i<line.length;i++) {
      const c=line[i];
      if (c==='"') { inQ=!inQ; continue; }
      if (c===',' && !inQ) { cells.push(cur); cur=''; continue; }
      cur+=c;
    }
    cells.push(cur);
    const row={}; headers.forEach((h,i)=>{ row[h]=cells[i]||''; }); return row;
  });
};
const toCSV = (rows, columns) => {
  const esc = v => {
    if (v==null) return '';
    const s = String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g,'""')}"` : s;
  };
  const header = columns.join(',');
  const body = rows.map(r => columns.map(c => esc(r[c])).join(',')).join('\n');
  return header+'\n'+body;
};
const downloadText = (filename, text) => {
  try {
    const blob = new Blob([text], {type:'text/plain;charset=utf-8'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename; document.body.appendChild(a); a.click();
    setTimeout(()=>{ URL.revokeObjectURL(url); a.remove(); }, 200);
  } catch(e) { alert('Не удалось скачать файл: '+e.message); }
};

const Sidebar = ({ current, onNav }) => {
  const { user, store } = useApp();
  const perms = permissions(user, store.state.people);
  const isMgr = perms.canManageTeam;
  /* Входящие запросы фидбека для текущего пользователя */
  const inboundFeedback = store.state.feedbackRequests.filter(fr =>
    fr.status==='in_progress' &&
    (fr.fromIds||[]).includes(user.id) &&
    !fr.responses.some(r=>r.fromId===user.id)
  ).length;
  /* Self Assessment pill: '✓' / 'draft' / 'new' */
  const saPill = (()=>{
    const sa = store.state.selfAssessments.find(x=>x.employeeId===user.id && x.cycleId===ACTIVE_CYCLE.id);
    return sa?.status==='submitted' ? '✓' : sa?.status==='draft' ? 'draft' : 'new';
  })();
  /* Мой 1:1 debrief — видим только если есть held/acknowledged */
  const myConv = store.state.conversations.find(c=>c.employeeId===user.id && c.cycleId===ACTIVE_CYCLE.id);
  const myConvItem = (perms.isEmployee && myConv && (myConv.status==='held' || myConv.status==='acknowledged'))
    ? { k:'conversations', icon:'chat', label:'Мой 1:1 Debrief', pill: myConv.status==='held' ? '!' : '✓' }
    : null;
  /* Performance Talks: счётчик pending по всему циклу */
  const talksPending = store.state.conversations.filter(c=>c.cycleId===ACTIVE_CYCLE.id && c.status!=='acknowledged').length;
  /* Калибровка: кол-во BoT-кейсов (раньше было захардкожено '3') */
  const calibrationPill = (store.state.botCases && store.state.botCases.length) ? String(store.state.botCases.length) : null;
  /* Development Plan team-счётчик для менеджеров/HR */
  const teamDpCount = store.state.devPlans.filter(p=>p.cycleId===ACTIVE_CYCLE.id).length;

  /* ─── Секции навигации ───
     Пустые секции скрываются вместе с заголовком, так что сотрудник
     не видит "Команда" / "Администрирование". */
  const sections = [
    /* Базовый блок, без заголовка */
    { items: [
      { k:'home',  icon:'home',  label:'Обзор' },
      { k:'cycle', icon:'cycle', label:'Активный цикл', pill: ACTIVE_CYCLE.stage },
    ]},
    /* Моё — всегда видно */
    { label:'Моё', items: [
      { k:'myprofile',      icon:'user',  label:'Мой профиль' },
      { k:'selfassessment', icon:'edit',  label:'Self Assessment', pill: saPill },
      { k:'reviews',        icon:'badge', label: isMgr ? 'Мои reviews' : 'Мой review' },
      { k:'feedback',       icon:'chat',  label:'360 Feedback', pill: inboundFeedback ? String(inboundFeedback) : null },
      myConvItem,
      perms.isEmployee && !isMgr && { k:'development', icon:'target', label:'Development Plan' },
      { k:'ladder', icon:'trend', label:'Career Ladder' },
      { k:'enps', icon:'chat', label:'eNPS · Пульс' },
    ]},
    /* Команда — org-структура, видна всем сотрудникам (18 may 2026 fix).
       Раньше пункт «Команда / Люди» был ТОЛЬКО внутри manager-блока
       и обычные сотрудники не могли попасть в org-chart из сайдбара. */
    { label:'Команда', items: [
      { k:'people', icon:'users', label:'Орг-структура' },
    ]},
    /* Управление командой — менеджер / HR / exec (exec org-wide read-only) */
    { label:'Управление командой', items: (perms.canSeeOrgWide || isMgr) ? [
      { k:'conversations', icon:'chat', label:'Performance Talks', pill: talksPending ? String(talksPending) : null },
      perms.canSeePromotions && { k:'promotions', icon:'trend', label:'Promotions' },
      { k:'development', icon:'target', label:'Development Plan', pill: teamDpCount ? String(teamDpCount) : null },
      perms.canSeePIP    && { k:'pip', icon:'warn', label:'BoT · PIP Tracker' },
      perms.canSeeHiring && { k:'hiring', icon:'users', label:'Hiring · Вакансии', pill: String(VACANCIES.length) },
    ] : [] },
    /* Performance цикл — процессы и общие справочники */
    { label:'Performance цикл', items: [
      { k:'scorecards', icon:'book', label:'Scorecard Library' },
      perms.canSeeCalibration && { k:'calibration', icon:'grid', label:'Калибровка', pill: calibrationPill },
      perms.canSeeAnalytics  && { k:'analytics', icon:'chart', label:'Аналитика команды' },
      perms.canSeeAnalytics  && { k:'enpsdash', icon:'chart', label:'eNPS · Аналитика' },
      { k:'history', icon:'hist', label:'История и тренды' },
      perms.canSeePerfTeam   && { k:'perfteam', icon:'shield', label:'Performance Team' },
    ]},
    /* Администрирование — только hr_admin (exec сюда не входит) */
    { label:'Администрирование', items: perms.fullHRAccess ? [
      perms.canSeeHRAdmin  && { k:'hradmin', icon:'users', label:'HR Admin · Сотрудники' },
      perms.canSeeForms    && { k:'forms', icon:'book', label:'Конструктор форм' },
      perms.canSeeSettings && { k:'settings', icon:'settings', label:'Настройки' },
    ] : [] },
  ];

  /* Разворачиваем секции в плоский список, пропуская пустые секции целиком */
  const items = [];
  sections.forEach((sec, i) => {
    const cleanItems = sec.items.filter(Boolean);
    if (cleanItems.length === 0) return;
    if (sec.label) items.push({ divider:true, label: sec.label, _dkey: 'sec-'+i });
    cleanItems.forEach(it => items.push(it));
  });
  return (
    <aside className="w-[232px] shrink-0 bg-white border-r border-ink-100 flex flex-col h-screen sticky top-0">
      <div className="px-5 pt-5 pb-4 flex items-center gap-2.5">
        <div className="w-7 h-7 rounded-md bg-brand-600 flex items-center justify-center">
          <Icon name="zap" className="w-3.5 h-3.5 text-white" stroke={2.2}/>
        </div>
        <div>
          <div className="font-semibold text-[14px] leading-none text-ink-900">Freedom AI Labs</div>
          <div className="text-[10px] text-ink-400 mt-0.5">Performance Review Cycle</div>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto scrollbar px-2 pt-2 space-y-0.5">
        {items.map((it,idx)=>{
          if (it.divider) return <div key={'div-'+idx} className="px-3 pt-4 pb-1.5 text-[10px] uppercase tracking-[.12em] text-ink-400 font-medium">{it.label}</div>;
          const active = current===it.k;
          return (
            <button key={it.k} onClick={()=>onNav(it.k)} className={`w-full flex items-center gap-2.5 px-3 py-1.5 rounded-md text-[13px] transition ${active?'bg-brand-50 text-brand-700 font-medium':'text-ink-700 hover:bg-ink-50'}`}>
              <Icon name={it.icon} className={`w-4 h-4 ${active?'text-brand-600':'text-ink-400'}`} stroke={1.6}/>
              <span className="flex-1 text-left truncate">{it.label}</span>
              {it.pill && <span className={`text-[10px] px-1.5 py-0.5 rounded-full ${active?'bg-brand-100 text-brand-700':'bg-ink-100 text-ink-500'}`}>{it.pill}</span>}
            </button>
          );
        })}
      </nav>
      <div className="p-3 mt-auto border-t border-ink-100">
        <div className="flex items-center gap-2.5 px-2 py-2">
          <Avatar p={user} size={30}/>
          <div className="min-w-0 flex-1">
            <div className="text-[12px] font-medium truncate text-ink-900">{user.name}</div>
            <div className="text-[10px] text-ink-400 truncate">{user.role}</div>
          </div>
          <span className={`text-[9px] px-1.5 py-0.5 rounded border ${ROLE_TONE[perms.sysRole]}`} title={`Уровень доступа: ${perms.roleLabel}`}>{perms.roleLabel}</span>
        </div>
      </div>
    </aside>
  );
};

const Topbar = ({ title, subtitle, right, onLogout }) => (
  <header className="sticky top-0 z-20 bg-white border-b border-ink-100">
    <div className="px-8 h-14 flex items-center gap-4">
      <div className="min-w-0 flex-1">
        <h1 className="text-[15px] font-semibold tracking-tight truncate text-ink-900">{title}</h1>
        {subtitle && <div className="text-[11px] text-ink-400 mt-0.5 truncate">{subtitle}</div>}
      </div>
      <div className="hidden md:flex items-center gap-2 px-3 h-8 rounded-md bg-ink-50 w-[280px]">
        <Icon name="search" className="w-3.5 h-3.5 text-ink-400" stroke={1.6}/>
        <input placeholder="Поиск…" className="bg-transparent text-[13px] flex-1 outline-none placeholder-ink-400" />
      </div>
      <button className="relative h-8 w-8 grid place-items-center rounded-md hover:bg-ink-50">
        <Icon name="bell" className="w-4 h-4 text-ink-500" stroke={1.6}/>
        <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-brand-600"></span>
      </button>
      {right}
      <button onClick={onLogout} className="h-8 px-2.5 rounded-md text-[12px] text-ink-500 hover:bg-ink-50 flex items-center gap-1.5">
        <Icon name="logout" className="w-3.5 h-3.5" stroke={1.6}/> Выйти
      </button>
    </div>
  </header>
);

const Card = ({ children, className = '' }) => (
  <div className={`bg-white rounded-lg border border-ink-100 ${className}`}>{children}</div>
);
const CardHead = ({ title, subtitle, right, divider=true }) => (
  <div className={`flex items-start gap-4 px-5 pt-4 pb-3 ${divider?'border-b border-ink-100':''}`}>
    <div className="min-w-0 flex-1">
      <div className="text-[14px] font-semibold tracking-tight text-ink-900">{title}</div>
      {subtitle && <div className="text-[11px] text-ink-500 mt-0.5">{subtitle}</div>}
    </div>
    {right}
  </div>
);

const Stat = ({ label, value, delta, hint, color='ink' }) => (
  <Card className="p-4">
    <div className="text-[11px] text-ink-500">{label}</div>
    <div className="flex items-baseline gap-2 mt-1.5">
      <div className="text-[22px] font-semibold tracking-tight text-ink-900">{value}</div>
      {delta && <div className={`text-[11px] font-medium ${delta.startsWith('+')?'text-emerald-700':'text-rose-700'}`}>{delta}</div>}
    </div>
    {hint && <div className="text-[11px] text-ink-400 mt-1">{hint}</div>}
  </Card>
);

/* ───────── TelegramConnectCard — привязка @freedomailabs_performance_bot ──
   Сгенерирует одноразовый токен через RPC tg_link_token_create (миграция
   20260513044125), откроет t.me/freedomailabs_performance_bot?start=<token>.
   После /start бот сжигает токен, сохраняет связку, и self-assessment
   можно проходить прямо в Telegram. */
const TG_BOT_USERNAME = "freedomailabs_performance_bot";
const TelegramConnectCard = ({ myEmployeeId }) => {
  const [loading, setLoading] = React.useState(false);
  const [linked, setLinked]   = React.useState(null);
  const [error, setError]     = React.useState(null);
  const [deepLink, setDeepLink] = React.useState(null);
  const [countdown, setCountdown] = React.useState(0);

  React.useEffect(() => {
    // COMMIT_7 (16 may 2026): fix BUG 4A.
    // Раньше .eq("employee_id", myEmployeeId) ломался с 22P02 потому что
    // myEmployeeId — JS-string ('u23'/'u_<hex12>'), а колонка uuid. Catch
    // проглатывал ошибку, карточка всем показывала "не привязан".
    // Теперь зовём public.tg_link_self() RPC — он сам резолвит
    // current_employee_id() через auth.uid() и возвращает строку tg_links.
    let alive = true;
    (async () => {
      try {
        const { data, error } = await supabase.rpc("tg_link_self");
        if (!alive) return;
        if (error) {
          console.warn("[tg-card] tg_link_self failed:", error.message);
          return;
        }
        // PostgREST для функции RETURNS TABLE возвращает массив строк.
        if (Array.isArray(data) && data.length > 0 && data[0].linked_at) {
          setLinked(data[0]);
        } else if (data && typeof data === 'object' && data.linked_at) {
          setLinked(data);
        }
        // иначе — не привязан, оставляем linked=null (правильное поведение).
      } catch (e) {
        console.warn("[tg-card] init", e);
      }
    })();
    return () => { alive = false; };
  }, []);

  const handleConnect = React.useCallback(async () => {
    setLoading(true); setError(null); setDeepLink(null);
    try {
      const { data, error } = await supabase.rpc("tg_link_token_create");
      if (error) throw error;
      const url = `https://t.me/${TG_BOT_USERNAME}?start=${encodeURIComponent(data)}`;
      setDeepLink(url);
      setCountdown(600);
      try { window.open(url, "_blank", "noopener,noreferrer"); } catch (_) {}
    } catch (e) {
      console.error("[tg-card] create token", e);
      setError(e.message || "Не получилось сгенерировать ссылку");
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    if (countdown <= 0) return;
    const t = setInterval(() => setCountdown(c => c > 0 ? c - 1 : 0), 1000);
    return () => clearInterval(t);
  }, [countdown]);

  return (
    <Card>
      <div className="p-5">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-50 text-brand-700 text-xl">🤖</div>
          <div className="min-w-0">
            <h3 className="text-base font-semibold text-ink-900">Telegram-бот</h3>
            <p className="text-xs text-ink-500">Заполняй self-assessment и читай гайды в Telegram</p>
          </div>
        </div>
        {linked ? (
          <div className="mt-4 rounded-xl bg-emerald-50 px-4 py-3 text-sm text-emerald-900 border border-emerald-200">
            ✅ Привязан как <b>@{linked.tg_username || "—"}</b>
            <span className="text-emerald-700/70"> · с {new Date(linked.linked_at).toLocaleDateString("ru-RU")}</span>
            <div className="mt-1">
              Открой бота: <a className="font-medium underline" href={`https://t.me/${TG_BOT_USERNAME}`} target="_blank" rel="noopener noreferrer">@{TG_BOT_USERNAME}</a> и набери <code>/menu</code>
            </div>
          </div>
        ) : (
          <div className="mt-4 space-y-3">
            <button type="button" onClick={handleConnect} disabled={loading}
              className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 disabled:opacity-50">
              {loading ? "Создаю ссылку…" : "Привязать Telegram"}
            </button>
            {deepLink && (
              <div className="rounded-lg border border-brand-200 bg-brand-50 px-4 py-3 text-sm text-ink-700">
                <p className="mb-2">Ссылка создана. Если бот не открылся — нажми:</p>
                <a href={deepLink} target="_blank" rel="noopener noreferrer" className="break-all font-medium text-brand-700 underline">{deepLink}</a>
                <p className="mt-2 text-xs text-ink-500">Одноразовая, действует {Math.floor(countdown/60)}:{String(countdown%60).padStart(2,"0")}.</p>
              </div>
            )}
            {error && <div className="rounded-lg bg-rose-50 px-4 py-2 text-sm text-rose-900 border border-rose-200">{error}</div>}
          </div>
        )}
      </div>
    </Card>
  );
};

/* ───────── MY PROFILE — личная сводка сотрудника ─────────
   Что включает:
   - Hero: имя, аватар, role/seniority/team, level chip, grade chip (или «ещё не оценён»)
   - Карточка «Текущий цикл»: статус Self Assessment / Manager Assessment / 1:1 Debrief
   - Карточка «Последний review»: либо запись из HISTORY, либо «Ещё нет ревью»
   - Карточка «Команда»: менеджер + directs (если есть)
*/
/* ═══════════════ eNPS · Пульс команды (анонимный опрос) ═══════════════
   DB: public.enps_current_survey() / enps_submit() — ответы анонимны,
   HR видит только агрегаты по командам (enps_overall/team_breakdown). */
const ENPS_CAT = (s) => s >= 9 ? 'prom' : s >= 7 ? 'pass' : 'det';
/* Full literal Tailwind classes (no interpolation — keeps JIT happy on the CDN). */
const ENPS_BTN_SEL = {
  prom: 'bg-emerald-600 text-white border-emerald-600',
  pass: 'bg-amber-600 text-white border-amber-600',
  det:  'bg-rose-600 text-white border-rose-600',
};
const ENPS_BTN_IDLE = {
  prom: 'bg-white text-ink-600 border-ink-200 hover:border-emerald-300 hover:bg-emerald-50',
  pass: 'bg-white text-ink-600 border-ink-200 hover:border-amber-300 hover:bg-amber-50',
  det:  'bg-white text-ink-600 border-ink-200 hover:border-rose-300 hover:bg-rose-50',
};

/* Каталог engagement-вопросов. Меняй формулировки здесь — БД хранит ответы по ключу, миграция не нужна. */
const ENPS_DRIVERS = [
  { cat:'Вовлечённость', items:[
    { key:'eng_pride',  text:'Я горжусь тем, что работаю в Freedom AI Labs' },
    { key:'eng_effort', text:'Я готов прилагать дополнительные усилия ради успеха компании' },
  ]},
  { cat:'Руководитель', items:[
    { key:'mgr_feedback', text:'Мой руководитель даёт мне понятную и полезную обратную связь' },
    { key:'mgr_care',     text:'Мой руководитель относится ко мне с уважением и заботой' },
  ]},
  { cat:'Рост и развитие', items:[
    { key:'grw_opportunities', text:'У меня есть реальные возможности учиться и расти' },
  ]},
  { cat:'Признание', items:[
    { key:'rec_valued', text:'За хорошую работу здесь благодарят и признают' },
  ]},
  { cat:'Нагрузка и благополучие', items:[
    { key:'wl_balance', text:'Мой объём работы позволяет работать стабильно, без выгорания' },
  ]},
  { cat:'Ясность и цели', items:[
    { key:'clr_goals', text:'Я понимаю, как моя работа связана с целями компании' },
  ]},
  { cat:'Культура и доверие', items:[
    { key:'cul_safety',    text:'Я могу открыто высказывать мнение, не опасаясь последствий' },
    { key:'cul_belonging', text:'Я чувствую, что принадлежу к команде' },
  ]},
  { cat:'Руководство компании', items:[
    { key:'lead_trust', text:'Я доверяю решениям руководства компании' },
  ]},
  { cat:'Ресурсы', items:[
    { key:'res_tools', text:'У меня есть инструменты и информация, чтобы хорошо делать свою работу' },
  ]},
  { cat:'Автономия', items:[
    { key:'aut_freedom', text:'У меня достаточно свободы решать, как выполнять свою работу' },
  ]},
  { cat:'Достижения', items:[
    { key:'acc_meaning', text:'Большинство дней я чувствую, что добиваюсь значимого результата' },
  ]},
  { cat:'Отношения с коллегами', items:[
    { key:'peer_support', text:'Я могу рассчитывать на помощь коллег, когда она нужна' },
  ]},
  { cat:'Вознаграждение', items:[
    { key:'rew_fair', text:'Я считаю, что моя оплата справедлива за мой вклад' },
  ]},
];
/* Outcome-вопросы (как у Peakon: вовлечённость = среднее advocacy + loyalty + satisfaction). Шкала 0–10. */
const ENPS_OUTCOME = [
  { key:'out_loyalty',      text:'Если бы мне предложили такую же работу в другой компании, я бы остался в Freedom AI Labs' },
  { key:'out_satisfaction', text:'В целом я доволен тем, что работаю в Freedom AI Labs' },
];
const ENPS_OPEN = [
  { key:'open_keep',    text:'Что вам особенно ценно в работе здесь?' },
  { key:'open_improve', text:'Что бы вы улучшили в первую очередь?' },
];
const ENPS_QLABEL = (() => { const m={}; ENPS_DRIVERS.forEach(g=>g.items.forEach(it=>{m[it.key]={text:it.text,cat:g.cat};})); return m; })();
const ENPS_CATS = ENPS_DRIVERS.map(g=>g.cat);

const EnpsSurveyPage = () => {
  const [survey, setSurvey]   = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [score, setScore]     = React.useState(null);
  const [comment, setComment] = React.useState('');
  const [done, setDone]       = React.useState(false);
  const [busy, setBusy]       = React.useState(false);
  const [err, setErr]         = React.useState(null);

  React.useEffect(() => {
    let alive = true;
    (async () => {
      try {
        if (!window.__supabase) { setLoading(false); return; }
        const { data, error } = await window.__supabase.rpc('enps_current_survey');
        if (!alive) return;
        if (error) { console.warn('[enps] current_survey', error.message); setLoading(false); return; }
        const row = Array.isArray(data) ? data[0] : data;
        if (row) { setSurvey(row); setDone(!!row.responded); }
      } catch (e) { console.warn('[enps] init', e); }
      finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, []);

  const [answers, setAnswers] = React.useState({});  // { key: 1..5 }
  const [openAns, setOpenAns] = React.useState({});   // { key: text }

  const submit = React.useCallback(async () => {
    if (score === null || !survey) return;
    setBusy(true); setErr(null);
    try {
      const p_answers = [
        ...Object.entries(answers).map(([key,value])=>({ key, value })),
        ...Object.entries(openAns).filter(([,t])=>t && t.trim()).map(([key,text])=>({ key, text })),
      ];
      const { data, error } = await window.__supabase.rpc('enps_submit', {
        p_survey_id: survey.id, p_score: score, p_comment: comment || null, p_answers,
      });
      if (error) throw error;
      if (data && data.ok) { setDone(true); }
      else if (data && data.error === 'already_responded') { setDone(true); }
      else if (data && data.error === 'survey_closed') { setErr('Опрос уже закрыт.'); }
      else { setErr('Не удалось отправить ответ. Попробуйте ещё раз.'); }
    } catch (e) { setErr(e.message || 'Ошибка отправки'); }
    finally { setBusy(false); }
  }, [score, comment, survey, answers, openAns]);

  if (loading) return <div className="p-8 text-sm text-ink-500">Загрузка…</div>;

  if (!survey) return (
    <div className="p-8 fade-in">
      <Card><div className="p-8 text-center">
        <div className="w-12 h-12 rounded-full bg-ink-50 flex items-center justify-center mx-auto mb-3">
          <Icon name="chat" className="w-6 h-6 text-ink-400"/>
        </div>
        <div className="text-[15px] font-semibold text-ink-900">Сейчас нет активного опроса eNPS</div>
        <div className="text-[13px] text-ink-500 mt-1">Когда HR откроет новую волну, она появится здесь.</div>
      </div></Card>
    </div>
  );

  if (done) return (
    <div className="p-8 fade-in">
      <Card><div className="p-8 text-center">
        <div className="w-12 h-12 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-3">
          <Icon name="check" className="w-6 h-6 text-emerald-600"/>
        </div>
        <div className="text-[15px] font-semibold text-ink-900">Спасибо! Ваш ответ записан анонимно.</div>
        <div className="text-[13px] text-ink-500 mt-1">{survey.title} · повторно отправить нельзя.</div>
      </div></Card>
    </div>
  );

  const tone = score === null ? null : ENPS_CAT(score);
  return (
    <div className="p-8 space-y-5 fade-in">
      <Card>
        <CardHead title={survey.title}
          subtitle="Анонимный опрос. HR видит только агрегаты по командам — ваш ответ нельзя связать с вами."
          right={<span className="text-[11px] px-2 py-0.5 rounded border font-semibold bg-brand-50 text-brand-700 border-brand-200">Анонимно</span>}/>
        <div className="p-6 space-y-6">
          <div className="text-[15px] font-medium text-ink-900">{survey.question}</div>

          <div>
            <div className="grid grid-cols-11 gap-1.5">
              {Array.from({length:11}, (_,i)=>i).map(n => {
                const sel = score === n;
                const cat = ENPS_CAT(n);
                return (
                  <button key={n} onClick={()=>setScore(n)}
                    className={`h-11 rounded-md border text-[14px] font-semibold transition ${sel ? ENPS_BTN_SEL[cat] : ENPS_BTN_IDLE[cat]}`}>
                    {n}
                  </button>
                );
              })}
            </div>
            <div className="flex justify-between text-[11px] text-ink-400 mt-1.5 px-0.5">
              <span>0 — точно не порекомендую</span>
              <span>10 — обязательно порекомендую</span>
            </div>
          </div>

          {/* Outcome-вопросы (loyalty, satisfaction) — 0..10, рядом с eNPS */}
          <div className="space-y-4 pt-2 border-t border-ink-100">
            {ENPS_OUTCOME.map(o => (
              <div key={o.key} className="space-y-1.5">
                <div className="text-[14px] font-medium text-ink-900">{o.text}</div>
                <div className="grid grid-cols-11 gap-1.5">
                  {Array.from({length:11}, (_,v)=>v).map(v => {
                    const sel = answers[o.key] === v;
                    return (
                      <button key={v} onClick={()=>setAnswers(a=>({ ...a, [o.key]: v }))}
                        className={`h-10 rounded-md border text-[13px] font-semibold transition ${sel ? 'bg-brand-600 text-white border-brand-600' : 'bg-white text-ink-500 border-ink-200 hover:border-brand-300 hover:bg-brand-50'}`}>
                        {v}
                      </button>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          {/* Драйверы вовлечённости — шкала 0..10 */}
          <div className="space-y-5 pt-2 border-t border-ink-100">
            <div className="text-[13px] font-semibold text-ink-700">Насколько вы согласны со следующими утверждениями?</div>
            <div className="flex justify-between text-[11px] text-ink-400 px-0.5">
              <span>0 — совсем не согласен</span><span>10 — полностью согласен</span>
            </div>
            {ENPS_DRIVERS.map(group => (
              <div key={group.cat} className="space-y-3">
                <div className="text-[11px] uppercase tracking-wide text-ink-400 font-semibold">{group.cat}</div>
                {group.items.map(it => (
                  <div key={it.key} className="space-y-1.5">
                    <div className="text-[13px] text-ink-800">{it.text}</div>
                    <div className="grid grid-cols-11 gap-1">
                      {Array.from({length:11}, (_,v)=>v).map(v => {
                        const sel = answers[it.key] === v;
                        return (
                          <button key={v}
                            onClick={()=>setAnswers(a=>({ ...a, [it.key]: v }))}
                            className={`h-9 rounded-md border text-[12px] font-semibold transition ${sel ? 'bg-brand-600 text-white border-brand-600' : 'bg-white text-ink-500 border-ink-200 hover:border-brand-300 hover:bg-brand-50'}`}>
                            {v}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* Открытые вопросы */}
          <div className="space-y-4 pt-2 border-t border-ink-100">
            {ENPS_OPEN.map(o => (
              <div key={o.key}>
                <label className="text-[12px] font-medium text-ink-600">{o.text}</label>
                <textarea value={openAns[o.key]||''} onChange={e=>setOpenAns(s=>({ ...s, [o.key]: e.target.value }))} rows={2}
                  className="mt-1.5 w-full rounded-md border border-ink-200 px-3 py-2 text-[14px] focus:outline-none focus:ring-2 focus:ring-brand-200 focus:border-brand-400"/>
              </div>
            ))}
          </div>

          <div>
            <label className="text-[12px] font-medium text-ink-600">Комментарий к оценке eNPS (необязательно)</label>
            <textarea value={comment} onChange={e=>setComment(e.target.value)} rows={2}
              placeholder="Что повлияло на вашу оценку?"
              className="mt-1.5 w-full rounded-md border border-ink-200 px-3 py-2 text-[14px] focus:outline-none focus:ring-2 focus:ring-brand-200 focus:border-brand-400"/>
          </div>

          {err && <div className="text-[13px] text-rose-600">{err}</div>}

          <div className="flex items-center gap-3">
            <button onClick={submit} disabled={score===null || busy}
              className={`px-5 py-2.5 rounded-md text-[14px] font-semibold text-white transition ${
                score===null || busy ? 'bg-ink-300 cursor-not-allowed' : 'bg-brand-600 hover:bg-brand-700'}`}>
              {busy ? 'Отправка…' : 'Отправить анонимно'}
            </button>
            {tone && <span className="text-[12px] text-ink-500">
              Ваша оценка: <b className="text-ink-800">{score}</b> · {tone==='prom'?'промоутер':tone==='pass'?'нейтрал':'критик'}
            </span>}
          </div>
        </div>
      </Card>
    </div>
  );
};

const EnpsBar = ({ prom, pass, det }) => {
  const total = (prom||0)+(pass||0)+(det||0) || 1;
  const seg = (v, cls) => v>0 ? <div className={cls} style={{width:`${(v/total)*100}%`}}/> : null;
  return (
    <div className="flex h-3 w-full rounded-full overflow-hidden bg-ink-100">
      {seg(prom,'bg-emerald-500')}{seg(pass,'bg-amber-400')}{seg(det,'bg-rose-500')}
    </div>
  );
};

const EnpsDashboardPage = () => {
  const [surveys, setSurveys]   = React.useState([]);
  const [sel, setSel]           = React.useState(null);
  const [overall, setOverall]   = React.useState(null);
  const [teams, setTeams]       = React.useState([]);
  const [comments, setComments] = React.useState([]);
  const [trend, setTrend]       = React.useState([]);
  const [drivers, setDrivers]   = React.useState([]);
  const [driverTeams, setDriverTeams] = React.useState([]);
  const [openAnswers, setOpenAnswers] = React.useState({});
  const [loading, setLoading]   = React.useState(true);
  const [err, setErr]           = React.useState(null);
  const [showNew, setShowNew]   = React.useState(false);
  const [newCode, setNewCode]   = React.useState('');
  const [newTitle, setNewTitle] = React.useState('');
  const [notifyMsg, setNotifyMsg] = React.useState(null);
  const [notifyBusy, setNotifyBusy] = React.useState(false);

  const loadSurveys = React.useCallback(async () => {
    const { data, error } = await window.__supabase.rpc('enps_list_surveys');
    if (error) { setErr(error.message); return []; }
    const list = data || [];
    setSurveys(list);
    return list;
  }, []);

  const loadDetail = React.useCallback(async (surveyId) => {
    if (!surveyId) return;
    const [o, t, c, tr, dv, dt] = await Promise.all([
      window.__supabase.rpc('enps_overall', { p_survey_id: surveyId }),
      window.__supabase.rpc('enps_team_breakdown', { p_survey_id: surveyId }),
      window.__supabase.rpc('enps_comments', { p_survey_id: surveyId }),
      window.__supabase.rpc('enps_trend'),
      window.__supabase.rpc('enps_driver_overall', { p_survey_id: surveyId }),
      window.__supabase.rpc('enps_driver_by_team', { p_survey_id: surveyId }),
    ]);
    if (!o.error) setOverall(o.data);
    if (!t.error) setTeams(t.data || []);
    if (!c.error) setComments(c.data || []);
    if (!tr.error) setTrend(tr.data || []);
    if (!dv.error) setDrivers(dv.data || []);
    if (!dt.error) setDriverTeams(dt.data || []);
    const openRes = await Promise.all(ENPS_OPEN.map(o2 =>
      window.__supabase.rpc('enps_open_answers', { p_survey_id: surveyId, p_key: o2.key })));
    const openMap = {};
    ENPS_OPEN.forEach((o2,i)=>{ openMap[o2.key] = openRes[i].error ? [] : (openRes[i].data || []); });
    setOpenAnswers(openMap);
  }, []);

  React.useEffect(() => {
    let alive = true;
    (async () => {
      try {
        if (!window.__supabase) { setLoading(false); return; }
        const list = await loadSurveys();
        if (!alive) return;
        const open = list.find(s=>s.is_open) || list[0];
        if (open) { setSel(open.id); await loadDetail(open.id); }
      } catch (e) { setErr(e.message); }
      finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, []);

  const onSelect = async (id) => { setSel(id); await loadDetail(id); };

  const toggleOpen = async (id, open) => {
    await window.__supabase.rpc('enps_set_open', { p_survey_id: id, p_open: open });
    await loadSurveys();
  };

  const createWave = async () => {
    if (!newCode.trim() || !newTitle.trim()) return;
    const { data, error } = await window.__supabase.rpc('enps_create_survey', {
      p_code: newCode.trim(), p_title: newTitle.trim(),
    });
    if (error) { setErr(error.message); return; }
    setShowNew(false); setNewCode(''); setNewTitle('');
    const list = await loadSurveys();
    const created = list.find(s=>s.id === (data && data.id)) || list.find(s=>s.is_open);
    if (created) { setSel(created.id); await loadDetail(created.id); }
  };

  /* Экспорт агрегатов в Excel (HTML-table → .xls, без зависимостей; только агрегаты, без персональных данных). */
  const exportXls = () => {
    if (!selSurvey) return;
    const esc = s => String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    const o = overall || {};
    const dByKey = {}; (drivers||[]).forEach(d=>{ dByKey[d.question_key]=d; });
    let h = '<html><head><meta charset="utf-8"></head><body>';
    h += `<h3>eNPS — ${esc(selSurvey.title)} (${esc(selSurvey.code)})</h3>`;
    h += '<table border="1"><tr><th>Метрика</th><th>Значение</th></tr>'
       + `<tr><td>eNPS</td><td>${esc(o.enps)}</td></tr>`
       + `<tr><td>Средняя оценка (0–10)</td><td>${esc(o.avg_score)}</td></tr>`
       + `<tr><td>Ответов</td><td>${esc(o.total)}</td></tr>`
       + `<tr><td>Участие, %</td><td>${esc(o.response_rate)}</td></tr>`
       + `<tr><td>Промоутеры</td><td>${esc(o.promoters)}</td></tr>`
       + `<tr><td>Нейтралы</td><td>${esc(o.passives)}</td></tr>`
       + `<tr><td>Критики</td><td>${esc(o.detractors)}</td></tr></table><br>`;
    h += '<h3>По командам</h3><table border="1"><tr><th>Команда</th><th>Ответов</th><th>eNPS</th><th>Промоутеры</th><th>Нейтралы</th><th>Критики</th></tr>';
    (teams||[]).forEach(t=>{ h += `<tr><td>${esc(t.team_name)}</td><td>${esc(t.n)}</td><td>${t.suppressed?'скрыто (<5)':esc(t.enps)}</td><td>${t.suppressed?'':esc(t.promoters)}</td><td>${t.suppressed?'':esc(t.passives)}</td><td>${t.suppressed?'':esc(t.detractors)}</td></tr>`; });
    h += '</table><br>';
    h += '<h3>Драйверы вовлечённости</h3><table border="1"><tr><th>Категория</th><th>Утверждение</th><th>Среднее (0–10)</th><th>% согласных (7–10)</th></tr>';
    ENPS_DRIVERS.forEach(g=>g.items.forEach(it=>{ const d=dByKey[it.key]; h += `<tr><td>${esc(g.cat)}</td><td>${esc(it.text)}</td><td>${d?esc(d.avg):''}</td><td>${d?esc(d.favorable_pct):''}</td></tr>`; }));
    ENPS_OUTCOME.forEach(oq=>{ const d=dByKey[oq.key]; if(d) h += `<tr><td>Outcome</td><td>${esc(oq.text)}</td><td>${esc(d.avg)}</td><td>${esc(d.favorable_pct)}</td></tr>`; });
    h += '</table><br>';
    h += '<h3>Открытые ответы (анонимно)</h3><table border="1"><tr><th>Вопрос</th><th>Ответ</th><th>Команда</th></tr>';
    ENPS_OPEN.forEach(oq=>{ (openAnswers[oq.key]||[]).forEach(a=>{ h += `<tr><td>${esc(oq.text)}</td><td>${esc(a.text_value)}</td><td>${esc(a.team_name)}</td></tr>`; }); });
    h += '</table></body></html>';
    const blob = new Blob(['﻿'+h], {type:'application/vnd.ms-excel'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href=url; a.download=`eNPS_${selSurvey.code}.xls`;
    document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
  };

  /* Telegram-оповещение о текущей открытой волне (только привязанным сотрудникам). */
  const notifyTelegram = async () => {
    const open = surveys.find(s=>s.is_open);
    if (!open) { setNotifyMsg('Нет открытой волны.'); return; }
    if (!window.confirm('Отправить напоминание в Telegram всем привязанным сотрудникам?')) return;
    setNotifyBusy(true); setNotifyMsg('Отправка…');
    try {
      const { data, error } = await window.__supabase.functions.invoke('enps-notify', { body: { title: open.title } });
      if (error) { setNotifyMsg('Ошибка: ' + error.message); }
      else if (data && data.ok) { setNotifyMsg(`Отправлено ${data.sent} из ${data.total}${data.failed?` · не доставлено ${data.failed}`:''}.`); }
      else { setNotifyMsg('Ошибка: ' + ((data && data.error) || 'не удалось отправить')); }
    } catch (e) { setNotifyMsg('Ошибка: ' + (e.message || e)); }
    finally { setNotifyBusy(false); }
  };

  if (loading) return <div className="p-8 text-sm text-ink-500">Загрузка…</div>;
  const selSurvey = surveys.find(s=>s.id===sel);
  const enpsColor = (v) => v===null||v===undefined ? 'text-ink-400' : v>=30 ? 'text-emerald-600' : v>=0 ? 'text-amber-600' : 'text-rose-600';
  const driverByKey = {}; (drivers||[]).forEach(d=>{ driverByKey[d.question_key]=d; });
  const likertCell = (a) => a==null ? 'bg-ink-100 text-ink-400'
    : a>=8 ? 'bg-emerald-500 text-white' : a>=7 ? 'bg-emerald-300 text-emerald-900'
    : a>=5 ? 'bg-amber-300 text-amber-900' : 'bg-rose-400 text-white';
  /* Тепловая карта: категория × команда (среднее по вопросам категории) */
  const heatTeams = [...new Set((driverTeams||[]).map(r=>r.team_name))];
  const heat = {}; ENPS_CATS.forEach(c=>{ heat[c]={}; });
  (driverTeams||[]).forEach(r=>{
    const meta = ENPS_QLABEL[r.question_key]; if(!meta || !heat[meta.cat]) return;
    const cell = heat[meta.cat][r.team_name] || (heat[meta.cat][r.team_name]={sum:0,cnt:0,suppressed:r.suppressed});
    if(r.avg!=null){ cell.sum+=Number(r.avg); cell.cnt++; }
    cell.suppressed = r.suppressed;
  });
  /* Индекс вовлечённости (как у Peakon): среднее из advocacy + loyalty + satisfaction */
  const outLoyalty = driverByKey['out_loyalty'];
  const outSat = driverByKey['out_satisfaction'];
  const engParts = [overall && overall.avg_score, outLoyalty && outLoyalty.avg, outSat && outSat.avg]
    .map(Number).filter(v=>!isNaN(v));
  const engIndex = engParts.length ? Math.round(engParts.reduce((a,b)=>a+b,0)/engParts.length*10)/10 : null;

  return (
    <div className="p-8 space-y-5 fade-in">
      <Card>
        <CardHead title="Волны eNPS" subtitle="Ежеквартальный пульс. Открыта может быть только одна волна."
          right={<div className="flex items-center gap-4">
            {selSurvey && overall && <button onClick={exportXls} className="text-[12px] font-semibold text-ink-600 hover:text-brand-600 hover:underline flex items-center gap-1"><Icon name="export" className="w-3.5 h-3.5"/>Экспорт в Excel</button>}
            <button onClick={()=>setShowNew(v=>!v)} className="text-[12px] font-semibold text-brand-600 hover:underline flex items-center gap-1"><Icon name="plus" className="w-3.5 h-3.5"/>Новая волна</button>
          </div>}/>
        <div className="p-4 space-y-2">
          {showNew && (
            <div className="flex flex-wrap items-end gap-2 p-3 rounded-md bg-ink-50 border border-ink-100">
              <div><label className="text-[11px] text-ink-500">Код</label>
                <input value={newCode} onChange={e=>setNewCode(e.target.value)} placeholder="2026-Q3"
                  className="block mt-0.5 rounded-md border border-ink-200 px-2.5 py-1.5 text-[13px] w-32"/></div>
              <div className="flex-1 min-w-[180px]"><label className="text-[11px] text-ink-500">Название</label>
                <input value={newTitle} onChange={e=>setNewTitle(e.target.value)} placeholder="eNPS · Q3 2026"
                  className="block mt-0.5 w-full rounded-md border border-ink-200 px-2.5 py-1.5 text-[13px]"/></div>
              <button onClick={createWave} className="px-3 py-1.5 rounded-md bg-brand-600 text-white text-[13px] font-semibold hover:bg-brand-700">Создать и открыть</button>
            </div>
          )}
          {surveys.length===0 && <div className="text-[13px] text-ink-500 px-1 py-2">Волн ещё нет.</div>}
          {surveys.map(s => (
            <div key={s.id} className={`flex items-center gap-3 px-3 py-2 rounded-md border cursor-pointer ${sel===s.id?'border-brand-300 bg-brand-50':'border-ink-100 hover:bg-ink-50'}`} onClick={()=>onSelect(s.id)}>
              <div className="flex-1 min-w-0">
                <div className="text-[13px] font-semibold text-ink-900 truncate">{s.title} <span className="text-ink-400 font-normal">· {s.code}</span></div>
                <div className="text-[11px] text-ink-500">{s.responded} ответов</div>
              </div>
              <span className={`text-[11px] px-2 py-0.5 rounded border font-semibold ${s.is_open?'bg-emerald-50 text-emerald-700 border-emerald-200':'bg-ink-50 text-ink-500 border-ink-200'}`}>{s.is_open?'Открыта':'Закрыта'}</span>
              <button onClick={(e)=>{e.stopPropagation(); toggleOpen(s.id, !s.is_open);}} className="text-[11px] font-semibold text-brand-600 hover:underline">{s.is_open?'Закрыть':'Открыть'}</button>
            </div>
          ))}
          {surveys.some(s=>s.is_open) && (
            <div className="flex flex-wrap items-center gap-3 pt-3 mt-1 border-t border-ink-100">
              <button onClick={notifyTelegram} disabled={notifyBusy}
                className={`text-[12px] font-semibold flex items-center gap-1 ${notifyBusy?'text-ink-400 cursor-wait':'text-brand-600 hover:underline'}`}>
                <Icon name="bell" className="w-3.5 h-3.5"/>{notifyBusy?'Отправка…':'Оповестить в Telegram о текущей волне'}
              </button>
              {notifyMsg && <span className="text-[11px] text-ink-500">{notifyMsg}</span>}
            </div>
          )}
        </div>
      </Card>

      {err && <div className="text-[13px] text-rose-600">{err}</div>}

      {selSurvey && overall && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Card><div className="p-5">
              <div className="text-[12px] text-ink-500 uppercase tracking-wide">eNPS</div>
              <div className={`text-4xl font-extrabold mt-1 ${enpsColor(overall.enps)}`}>{overall.enps===null?'—':overall.enps}</div>
              <div className="text-[11px] text-ink-400 mt-1">% промоутеров − % критиков</div>
            </div></Card>
            <Card><div className="p-5">
              <div className="text-[12px] text-ink-500 uppercase tracking-wide">Участие</div>
              <div className="text-4xl font-extrabold mt-1 text-ink-900">{overall.response_rate===null?'—':overall.response_rate+'%'}</div>
              <div className="text-[11px] text-ink-400 mt-1">{overall.responded} из {overall.eligible} сотрудников</div>
            </div></Card>
            <Card><div className="p-5">
              <div className="text-[12px] text-ink-500 uppercase tracking-wide">Распределение</div>
              <div className="text-[13px] font-semibold text-ink-900 mt-2 mb-2">{overall.total} ответов</div>
              <EnpsBar prom={overall.promoters} pass={overall.passives} det={overall.detractors}/>
              <div className="flex justify-between text-[11px] mt-1.5">
                <span className="text-emerald-600">Промоутеры {overall.promoters}</span>
                <span className="text-amber-600">Нейтралы {overall.passives}</span>
                <span className="text-rose-600">Критики {overall.detractors}</span>
              </div>
            </div></Card>
          </div>

          {(engIndex!=null || outLoyalty || outSat) && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Card><div className="p-5">
                <div className="text-[12px] text-ink-500 uppercase tracking-wide">Индекс вовлечённости</div>
                <div className="text-4xl font-extrabold mt-1 text-ink-900">{engIndex!=null?engIndex:'—'}<span className="text-lg text-ink-400">/10</span></div>
                <div className="text-[11px] text-ink-400 mt-1">Среднее: рекомендация + лояльность + удовлетворённость</div>
              </div></Card>
              <Card><div className="p-5">
                <div className="text-[12px] text-ink-500 uppercase tracking-wide">Лояльность</div>
                <div className="text-4xl font-extrabold mt-1 text-ink-900">{outLoyalty?outLoyalty.avg:'—'}<span className="text-lg text-ink-400">/10</span></div>
                <div className="text-[11px] text-ink-400 mt-1">«остался бы при таком же оффере»</div>
              </div></Card>
              <Card><div className="p-5">
                <div className="text-[12px] text-ink-500 uppercase tracking-wide">Удовлетворённость</div>
                <div className="text-4xl font-extrabold mt-1 text-ink-900">{outSat?outSat.avg:'—'}<span className="text-lg text-ink-400">/10</span></div>
                <div className="text-[11px] text-ink-400 mt-1">«в целом доволен работой»</div>
              </div></Card>
            </div>
          )}

          <Card>
            <CardHead title="По командам" subtitle="Команды с менее чем 5 ответами скрыты для защиты анонимности."/>
            <div className="p-4 space-y-2">
              {teams.length===0 && <div className="text-[13px] text-ink-500 px-1 py-2">Ответов пока нет.</div>}
              {teams.map((t,i) => (
                <div key={i} className="flex items-center gap-3 px-2 py-2 rounded-md hover:bg-ink-50">
                  <div className="w-40 shrink-0 text-[13px] font-medium text-ink-800 truncate">{t.team_name}</div>
                  {t.suppressed ? (
                    <div className="flex-1 text-[12px] text-ink-400 italic">Скрыто · {t.n} (&lt;5 ответов)</div>
                  ) : (
                    <>
                      <div className={`w-12 shrink-0 text-[15px] font-bold ${enpsColor(t.enps)}`}>{t.enps}</div>
                      <div className="flex-1"><EnpsBar prom={t.promoters} pass={t.passives} det={t.detractors}/></div>
                      <div className="w-16 shrink-0 text-right text-[11px] text-ink-400">{t.n} отв.</div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </Card>

          {trend.length > 1 && (
            <Card>
              <CardHead title="Тренд eNPS" subtitle="По волнам опроса"/>
              <div className="p-5 flex items-end gap-4 h-40">
                {trend.map((p,i)=>{
                  const v = p.enps;
                  const h = v===null ? 4 : Math.max(4, Math.abs(v)/100*120);
                  return (
                    <div key={i} className="flex-1 flex flex-col items-center justify-end h-full">
                      <div className={`text-[12px] font-bold mb-1 ${enpsColor(v)}`}>{v===null?'—':v}</div>
                      <div className={`w-full rounded-t ${v>=30?'bg-emerald-400':v>=0?'bg-amber-300':'bg-rose-400'}`} style={{height:`${h}px`}}/>
                      <div className="text-[10px] text-ink-400 mt-1.5 truncate w-full text-center">{p.code}</div>
                    </div>
                  );
                })}
              </div>
            </Card>
          )}

          <Card>
            <CardHead title="Комментарии" subtitle="Анонимно. Команда указана только если у неё ≥5 ответов."/>
            <div className="p-4 space-y-2">
              {comments.length===0 && <div className="text-[13px] text-ink-500 px-1 py-2">Комментариев нет.</div>}
              {comments.map((c,i)=>{
                const cat = ENPS_CAT(c.score);
                const dot = cat==='prom'?'bg-emerald-500':cat==='pass'?'bg-amber-400':'bg-rose-500';
                return (
                  <div key={i} className="flex gap-3 px-2 py-2 border-b border-ink-50 last:border-0">
                    <div className="flex flex-col items-center shrink-0 pt-0.5">
                      <span className={`w-2 h-2 rounded-full ${dot}`}/>
                      <span className="text-[11px] font-bold text-ink-500 mt-1">{c.score}</span>
                    </div>
                    <div className="min-w-0">
                      <div className="text-[13px] text-ink-800">{c.comment}</div>
                      {c.team_name && c.team_name!=='—' && <div className="text-[11px] text-ink-400 mt-0.5">{c.team_name}</div>}
                    </div>
                  </div>
                );
              })}
            </div>
          </Card>

          {/* Драйверы вовлечённости */}
          {drivers.length > 0 && (
            <Card>
              <CardHead title="Драйверы вовлечённости" subtitle="Средняя оценка (0–10) и % согласных (7–10) по каждому утверждению."/>
              <div className="p-4 space-y-4">
                {ENPS_DRIVERS.map(group => (
                  <div key={group.cat}>
                    <div className="text-[11px] uppercase tracking-wide text-ink-400 font-semibold mb-1.5">{group.cat}</div>
                    <div className="space-y-1.5">
                      {group.items.map(it => {
                        const d = driverByKey[it.key];
                        const fav = d ? Number(d.favorable_pct) : null;
                        return (
                          <div key={it.key} className="flex items-center gap-3">
                            <div className="flex-1 text-[13px] text-ink-800 truncate">{it.text}</div>
                            <div className="w-40 shrink-0 h-2.5 rounded-full bg-ink-100 overflow-hidden">
                              {fav!=null && <div className={`h-full ${fav>=70?'bg-emerald-500':fav>=40?'bg-amber-400':'bg-rose-500'}`} style={{width:`${fav}%`}}/>}
                            </div>
                            <div className="w-10 shrink-0 text-right text-[12px] font-semibold text-ink-700">{fav!=null?fav+'%':'—'}</div>
                            <div className="w-12 shrink-0 text-right text-[12px] text-ink-400">{d?`${d.avg}/10`:'—'}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </Card>
          )}

          {/* Тепловая карта по командам */}
          {heatTeams.length > 0 && (
            <Card>
              <CardHead title="Тепловая карта по командам" subtitle="Среднее по категории (0–10). Команды с <5 ответов скрыты."/>
              <div className="p-4 overflow-x-auto">
                <table className="text-[12px] border-separate" style={{borderSpacing:'3px'}}>
                  <thead>
                    <tr>
                      <th className="text-left font-semibold text-ink-500 px-2"></th>
                      {heatTeams.map(tn => <th key={tn} className="px-1 font-medium text-ink-500 text-[11px] align-bottom" style={{minWidth:'54px'}}><div className="truncate max-w-[80px]">{tn}</div></th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {ENPS_CATS.map(cat => (
                      <tr key={cat}>
                        <td className="text-[12px] text-ink-700 pr-2 whitespace-nowrap">{cat}</td>
                        {heatTeams.map(tn => {
                          const cell = heat[cat][tn];
                          const avg = cell && cell.cnt>0 ? cell.sum/cell.cnt : null;
                          const sup = cell && cell.suppressed;
                          return (
                            <td key={tn} className={`text-center rounded font-semibold ${sup?'bg-ink-50 text-ink-300':likertCell(avg)}`} style={{height:'30px'}}>
                              {sup ? '·' : (avg!=null ? avg.toFixed(1) : '')}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Card>
          )}

          {/* Открытые ответы */}
          {ENPS_OPEN.map(o => {
            const list = openAnswers[o.key] || [];
            return (
              <Card key={o.key}>
                <CardHead title={o.text} subtitle="Анонимно. Команда указана только если у неё ≥5 ответов."/>
                <div className="p-4 space-y-1.5">
                  {list.length===0 && <div className="text-[13px] text-ink-500 px-1 py-2">Ответов нет.</div>}
                  {list.map((a,i)=>(
                    <div key={i} className="flex gap-3 px-2 py-2 border-b border-ink-50 last:border-0">
                      <div className="text-[13px] text-ink-800 flex-1">{a.text_value}</div>
                      {a.team_name && a.team_name!=='—' && <div className="text-[11px] text-ink-400 shrink-0">{a.team_name}</div>}
                    </div>
                  ))}
                </div>
              </Card>
            );
          })}
        </>
      )}
    </div>
  );
};

const MyProfilePage = ({ onNav }) => {
  const { user, store, dottedRels = [] } = useApp();
  const people = store.state.people;
  const liveById = (id) => people.find(x=>x.id===id) || byId(id);
  const me = liveById(user.id);
  if (!me) return <div className="p-8 text-sm text-ink-500">Профиль не найден.</div>;

  const mgr = me.managerId ? liveById(me.managerId) : null;
  const myDirects = people.filter(p => p.managerId===me.id && p.active!==false && !p.placeholder && p.name && p.name !== '—');
  /* Matrix: dotted-кураторы (≤2). Source — bootstrap из app.employee_managers через AppContext. */
  const myEmail = (me.email || '').toLowerCase();
  const myDottedMgrs = dottedRels.filter(r =>
    r.relationship === 'dotted' && (r.employee_email || '').toLowerCase() === myEmail
  );
  /* Кого сам курирую через dotted (для блока «также курирую») */
  const myDottedDirects = dottedRels.filter(r =>
    r.relationship === 'dotted' && (r.manager_email || '').toLowerCase() === myEmail
  );

  /* Текущий цикл */
  const cycleId = ACTIVE_CYCLE.id;
  const sa = store.state.selfAssessments.find(x => x.employeeId===me.id && x.cycleId===cycleId);
  const ma = (store.state.managerAssessments || []).find(m => m.employeeId===me.id && m.cycleId===cycleId);
  const conv = store.state.conversations.find(c => c.employeeId===me.id && c.cycleId===cycleId);
  const placement = (store.state.talentBarPlacements || []).find(p => p.employeeId===me.id && p.cycleId===cycleId);

  const statusChip = (label, tone='ink') => {
    const tones = {
      ok:    'bg-emerald-50 text-emerald-700 border-emerald-200',
      warn:  'bg-amber-50 text-amber-700 border-amber-200',
      ink:   'bg-ink-50 text-ink-600 border-ink-200',
      brand: 'bg-brand-50 text-brand-700 border-brand-200',
    };
    return <span className={`text-[11px] px-2 py-0.5 rounded border font-semibold ${tones[tone]}`}>{label}</span>;
  };

  const saStatus = !sa ? { label:'Ещё не начат', tone:'ink' }
    : sa.status==='draft' ? { label:'Черновик', tone:'warn' }
    : sa.status==='submitted' ? { label:'Отправлен', tone:'ok' }
    : { label:sa.status, tone:'ink' };
  const maStatus = !ma ? { label:'Ещё не начат', tone:'ink' }
    : ma.status==='draft' ? { label:'Черновик', tone:'warn' }
    : ma.status==='submitted' ? { label:'Отправлен', tone:'ok' }
    : ma.status==='locked' ? { label:'Зафиксирован', tone:'ok' }
    : { label:ma.status, tone:'ink' };
  const convStatus = !conv ? { label:'Не назначен', tone:'ink' }
    : conv.status==='scheduled' ? { label:`Назначен · ${conv.scheduledFor || ''}`, tone:'brand' }
    : conv.status==='held' ? { label:'Проведён · ждёт ack', tone:'warn' }
    : conv.status==='acknowledged' ? { label:'Подтверждён', tone:'ok' }
    : { label:conv.status, tone:'ink' };

  /* Последний review из HISTORY (история до текущего цикла) */
  const hist = HISTORY[me.id] || [];
  const lastReview = hist.length ? hist[hist.length-1] : null;

  return (
    <div className="p-8 space-y-5 fade-in">
      {/* Telegram-бот — привязка для self-assessment */}
      <TelegramConnectCard myEmployeeId={me.id} />
      {/* Hero */}
      <Card>
        <div className="p-6 flex items-center gap-5">
          <Avatar p={me} size={72}/>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2 flex-wrap">
              <h2 className="text-2xl font-extrabold tracking-tight">{me.name}</h2>
              {(() => { const lv = personLevel(me).level; return (
                <span className={`text-[11px] px-2 py-0.5 rounded border font-semibold ${LEVEL_TONE(lv)}`} title={LEVELS[lv]?.label}>{lv}</span>
              ); })()}
              {me.currentGrade
                ? <span className={gradeChip(me.currentGrade)}>{me.currentGrade}</span>
                : <span className="text-[11px] px-2 py-0.5 rounded-full bg-ink-100 text-ink-500 italic" title="Grade появится после Calibration · Talent Bar review">ещё не оценён</span>}
            </div>
            <div className="text-sm text-ink-600 mt-1">{me.role} · {me.seniority} · {me.team}</div>
            <div className="text-xs text-ink-500 mt-1 flex items-center gap-3 flex-wrap">
              {me.email && <span>{me.email}</span>}
              {mgr && (
                <span>Менеджер: <span className="text-ink-900 font-semibold">{mgr.name}</span>
                  <span className="ml-1 text-[9px] px-1.5 py-0.5 rounded border bg-brand-50 text-brand-700 border-brand-200 uppercase tracking-wider font-semibold" title="Solid line: пишет финальный Manager Assessment">solid</span>
                </span>
              )}
              {myDottedMgrs.map((r,i) => (
                <span key={'dotted-'+i}>Куратор: <span className="text-ink-900 font-semibold">{r.manager_name}</span>
                  <span className="ml-1 text-[9px] px-1.5 py-0.5 rounded border bg-violet-50 text-violet-700 border-violet-200 uppercase tracking-wider font-semibold" title="Dotted line: продуктовый/проектный куратор. Попадает в 360 feedback">dotted</span>
                </span>
              ))}
              {typeof me.tenure === 'number' && <span>Стаж: {formatTenure(me.tenure)}</span>}
              <span>Bar {me.level || me.seniority}: <span className={masteryChip(talentBarFor(me))}>{talentBarFor(me)}</span></span>
              {me.levelSince && <span>Уровень с: <span className="text-ink-900 font-semibold">{me.levelSince}</span></span>}
            </div>
          </div>
        </div>
      </Card>

      {/* Visibility banner — объясняет, когда сотрудник увидит Manager Assessment,
          360-отзывы и финальный rating. Читает реальную фазу из app.cycles.phase. */}
      <ReviewVisibilityBanner/>

      <div className="grid lg:grid-cols-3 gap-5">
        {/* Текущий цикл */}
        <Card className="lg:col-span-2">
          <CardHead title={`Текущий цикл · ${ACTIVE_CYCLE.name}`} subtitle={`Стадия: ${ACTIVE_CYCLE.stage}`}/>
          <div className="p-5 space-y-3">
            <div className="flex items-center justify-between gap-3 py-2 border-b border-ink-100">
              <div>
                <div className="text-sm font-semibold text-ink-900">Self Assessment</div>
                <div className="text-xs text-ink-500 mt-0.5">Дедлайн: {formatDate(ACTIVE_CYCLE.keyDates.selfDue)}</div>
              </div>
              <div className="flex items-center gap-2">
                {statusChip(saStatus.label, saStatus.tone)}
                <button onClick={()=>onNav('selfassessment')} className="text-xs text-brand-600 hover:underline font-semibold">Открыть →</button>
              </div>
            </div>
            <div className="flex items-center justify-between gap-3 py-2 border-b border-ink-100">
              <div>
                <div className="text-sm font-semibold text-ink-900">Manager Assessment</div>
                <div className="text-xs text-ink-500 mt-0.5">{mgr ? `Заполняет: ${mgr.name}` : 'Менеджер не назначен'} · Дедлайн: {formatDate(ACTIVE_CYCLE.keyDates.managerDue)}</div>
              </div>
              <div className="flex items-center gap-2">
                {statusChip(maStatus.label, maStatus.tone)}
                {ma && (ma.status==='submitted' || ma.status==='locked') && (
                  <button onClick={()=>onNav('reviews')} className="text-xs text-brand-600 hover:underline font-semibold">Посмотреть →</button>
                )}
              </div>
            </div>
            <div className="flex items-center justify-between gap-3 py-2">
              <div>
                <div className="text-sm font-semibold text-ink-900">1:1 Performance Debrief</div>
                <div className="text-xs text-ink-500 mt-0.5">Происходит после Calibration · gate перед Dev Plan</div>
              </div>
              <div className="flex items-center gap-2">
                {statusChip(convStatus.label, convStatus.tone)}
                {conv && (conv.status==='held' || conv.status==='acknowledged') && (
                  <button onClick={()=>onNav('conversations')} className="text-xs text-brand-600 hover:underline font-semibold">Открыть →</button>
                )}
              </div>
            </div>
          </div>
        </Card>

        {/* Последний review */}
        <Card>
          <CardHead title="Последний performance review" subtitle={lastReview ? lastReview.cycle : 'Ещё нет завершённых ревью'}/>
          <div className="p-5">
            {lastReview ? (
              <div className="space-y-3">
                <div>
                  <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold">Итог</div>
                  <div className="mt-1">{lastReview.overall ? <span className={gradeChip(lastReview.overall)}>{lastReview.overall}</span> : <span className="text-ink-500 text-sm italic">—</span>}</div>
                </div>
                <div className="grid grid-cols-3 gap-2 text-xs">
                  <div>
                    <div className="text-ink-400">Skills</div>
                    <div className="mt-0.5"><span className={masteryChip(lastReview.skills)}>{lastReview.skills}</span></div>
                  </div>
                  <div>
                    <div className="text-ink-400">Deliverables</div>
                    <div className="mt-0.5"><span className={masteryChip(lastReview.deliverables)}>{lastReview.deliverables}</span></div>
                  </div>
                  <div>
                    <div className="text-ink-400">Culture</div>
                    <div className="mt-0.5"><span className={masteryChip(lastReview.culture)}>{lastReview.culture}</span></div>
                  </div>
                </div>
                <button onClick={()=>onNav('history')} className="w-full mt-2 text-xs text-brand-600 hover:underline font-semibold text-left">Вся история и тренды →</button>
              </div>
            ) : (
              <div className="text-sm text-ink-500">
                <div className="italic mb-2">У тебя пока нет завершённых полугодовых ревью.</div>
                <div className="text-xs text-ink-400">Первый итог появится после Calibration текущего цикла {ACTIVE_CYCLE.name}.</div>
              </div>
            )}
            {placement && (
              <div className="mt-3 pt-3 border-t border-ink-100">
                <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold">Текущий цикл · placement</div>
                <div className="mt-1"><span className={gradeChip(placement.grade)}>{placement.grade}</span></div>
              </div>
            )}
          </div>
        </Card>
      </div>

      {/* Команда — solid + dotted (COMMIT_7 fix BUG 1: matrix management) */}
      {(mgr || myDirects.length > 0 || myDottedMgrs.length > 0 || myDottedDirects.length > 0) && (
        <Card>
          <CardHead title="Команда" subtitle="Solid manager · Dotted curators · Direct reports"/>
          <div className="p-5 grid md:grid-cols-2 gap-5">
            {mgr ? (
              <div>
                <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold mb-2 flex items-center gap-1.5">
                  Мой менеджер
                  <span className="text-[9px] px-1.5 py-0.5 rounded border bg-brand-50 text-brand-700 border-brand-200 uppercase tracking-wider font-semibold" title="Solid line: пишет финальный Manager Assessment">solid</span>
                </div>
                <div className="flex items-center gap-3 p-3 rounded-lg border border-ink-100">
                  <Avatar p={mgr} size={40}/>
                  <div className="min-w-0 flex-1">
                    <div className="text-sm font-semibold text-ink-900 truncate">{mgr.name}</div>
                    <div className="text-xs text-ink-500 truncate">{mgr.role} · {mgr.team}</div>
                  </div>
                </div>
              </div>
            ) : <div><div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold mb-2">Мой менеджер</div><div className="text-xs text-ink-500 italic">Не назначен</div></div>}

            {myDottedMgrs.length > 0 && (
              <div>
                <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold mb-2 flex items-center gap-1.5">
                  Мои кураторы · {myDottedMgrs.length}
                  <span className="text-[9px] px-1.5 py-0.5 rounded border bg-violet-50 text-violet-700 border-violet-200 uppercase tracking-wider font-semibold" title="Dotted line: продуктовый/проектный куратор. Попадает в 360 feedback">dotted</span>
                </div>
                <div className="space-y-1.5">
                  {myDottedMgrs.map((r, i) => {
                    const curatorPerson = (r.manager_email || '').toLowerCase()
                      ? people.find(p => (p.email || '').toLowerCase() === (r.manager_email || '').toLowerCase())
                      : null;
                    return (
                      <div key={'dm-'+i} className="flex items-center gap-3 p-3 rounded-lg border border-violet-100 bg-violet-50/30">
                        {curatorPerson ? <Avatar p={curatorPerson} size={40}/> : <div className="h-10 w-10 rounded-full bg-violet-100 text-violet-700 font-bold text-sm flex items-center justify-center">{(r.manager_name || '?').split(/\s+/).map(w=>w[0]).slice(0,2).join('').toUpperCase()}</div>}
                        <div className="min-w-0 flex-1">
                          <div className="text-sm font-semibold text-ink-900 truncate">{r.manager_name || r.manager_email}</div>
                          <div className="text-xs text-ink-500 truncate">{r.manager_title || '—'}</div>
                          {r.context && <div className="text-[10px] text-violet-700 mt-0.5 italic">{r.context}</div>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {myDirects.length > 0 && (
              <div>
                <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold mb-2 flex items-center gap-1.5">
                  Direct reports · {myDirects.length}
                  <span className="text-[9px] px-1.5 py-0.5 rounded border bg-brand-50 text-brand-700 border-brand-200 uppercase tracking-wider font-semibold">solid</span>
                </div>
                <div className="space-y-1.5 max-h-[200px] overflow-y-auto scrollbar pr-1">
                  {myDirects.map(d => (
                    <div key={d.id} className="flex items-center gap-2.5 p-2 rounded border border-ink-100">
                      <Avatar p={d} size={28}/>
                      <div className="min-w-0 flex-1">
                        <div className="text-xs font-semibold text-ink-900 truncate">{d.name}</div>
                        <div className="text-[10px] text-ink-500 truncate">{d.role} · {d.seniority}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {myDottedDirects.length > 0 && (
              <div>
                <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold mb-2 flex items-center gap-1.5">
                  Также курирую · {myDottedDirects.length}
                  <span className="text-[9px] px-1.5 py-0.5 rounded border bg-violet-50 text-violet-700 border-violet-200 uppercase tracking-wider font-semibold" title="Dotted line: я их куратор по продукту/проекту">dotted</span>
                </div>
                <div className="space-y-1.5 max-h-[200px] overflow-y-auto scrollbar pr-1">
                  {myDottedDirects.map((r, i) => {
                    const reportPerson = (r.employee_email || '').toLowerCase()
                      ? people.find(p => (p.email || '').toLowerCase() === (r.employee_email || '').toLowerCase())
                      : null;
                    return (
                      <div key={'dd-'+i} className="flex items-center gap-2.5 p-2 rounded border border-violet-100 bg-violet-50/30">
                        {reportPerson ? <Avatar p={reportPerson} size={28}/> : <div className="h-7 w-7 rounded-full bg-violet-100 text-violet-700 font-bold text-[10px] flex items-center justify-center">{(r.employee_name || '?').split(/\s+/).map(w=>w[0]).slice(0,2).join('').toUpperCase()}</div>}
                        <div className="min-w-0 flex-1">
                          <div className="text-xs font-semibold text-ink-900 truncate">{r.employee_name || r.employee_email}</div>
                          <div className="text-[10px] text-violet-700 truncate italic">{r.context || 'dotted curator'}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </Card>
      )}
    </div>
  );
};

/* ───────── DASHBOARD (Workday-style worklet home) ───────── */
const Dashboard = ({ onNav }) => {
  const { user, store } = useApp();
  const perms = permissions(user, store.state.people);
  const myDirects = directs(user.id);
  const isPerf = perms.fullAccess;
  const myHist = HISTORY[user.id];
  const lastReview = myHist && myHist[myHist.length-1];

  /* Приветствие по времени */
  const hour = new Date().getHours();
  const greet = hour<5 ? 'Доброй ночи' : hour<12 ? 'Доброе утро' : hour<18 ? 'Добрый день' : 'Добрый вечер';
  const firstName = user.placeholder ? user.role.split(' ')[0] : user.name.split(' ')[0];

  /* COMMIT_8 (audit may 2026, bug 6): счётчики Dashboard теперь идут из store,
     а не из захардкоженных ACTIVE_CYCLE.submitted/totalReviews (которые
     застряли на старом seed=30). Источник истины — store.state.people минус
     placeholder/inactive × submitted manager scorecards активного цикла. */
  const liveCycleStats = useMemo(() => {
    const cycleId = ACTIVE_CYCLE.id;
    const active  = (store.state.people || []).filter(p => p.active !== false && !p.placeholder && p.name && p.name !== '—');
    const submittedMgr = (store.state.managerAssessments || [])
      .filter(ma => ma.cycleId === cycleId && (ma.status === 'submitted' || ma.status === 'locked'));
    const submitted = new Set(submittedMgr.map(ma => ma.employeeId).filter(id => active.some(p => p.id === id))).size;
    const total = active.length;
    const pct = total ? Math.round(submitted / total * 100) : 0;
    return { total, submitted, pct };
  }, [store.state.people, store.state.managerAssessments]);
  /* PIP count: реальные active BoT/PIP-плейсменты, а не хардкод */
  const pipCount = useMemo(() => {
    const placements = store.state.talentBarPlacements || [];
    return placements.filter(p => p.cycleId === ACTIVE_CYCLE.id && (p.grade === 'Underperformer' || p.onPip === true)).length;
  }, [store.state.talentBarPlacements]);
  const aPlayersCount = useMemo(() => {
    return (store.state.people || []).filter(p => p.active !== false && !p.placeholder && p.currentGrade === 'A-player').length;
  }, [store.state.people]);

  /* Awaiting Your Action — собирается из реальных данных */
  const inboundFeedback = store.state.feedbackRequests.filter(fr =>
    fr.status==='in_progress' &&
    (fr.fromIds||[]).includes(user.id) &&
    !fr.responses.some(r=>r.fromId===user.id)
  );
  const awaiting = [];
  if (myDirects.length) {
    awaiting.push({
      id:'sc', icon:'badge', title:`Заполнить ${myDirects.length} scorecards`,
      meta:`Дедлайн: 28 июня · ${myDirects.length} ${myDirects.length===1?'подчинённый':'подчинённых'}`,
      action:()=>onNav('reviews'), cta:'Начать',
    });
  }
  if (inboundFeedback.length) {
    awaiting.push({
      id:'fb', icon:'chat', title:`Запросы фидбека: ${inboundFeedback.length}`,
      meta:inboundFeedback.slice(0,2).map(f=>'про '+ (PEOPLE.find(p=>p.id===f.subjectId)?.name || '—')).join(' · '),
      action:()=>onNav('feedback'), cta:'Открыть',
    });
  }
  if (isPerf) {
    awaiting.push({
      id:'cal', icon:'grid', title:'Калибровка: 3 кейса требуют проверки',
      meta:'Выбросы в распределении A-players · Talent Bar до 29 июня',
      action:()=>onNav('calibration'), cta:'Проверить',
    });
  }
  if (!myDirects.length && !inboundFeedback.length && !isPerf) {
    awaiting.push({
      id:'self', icon:'user', title:'Self-review ещё не заполнен',
      meta:'Рекомендация: до начала менеджерской оценки',
      action:()=>onNav('reviews'), cta:'Заполнить',
    });
  }

  /* Announcements */
  const announcements = [
    { id:1, tag:'Performance Team', title:`Цикл ${ACTIVE_CYCLE.name} · стадия «${ACTIVE_CYCLE.stage}»`, body:'Self Assessment и запрос 360-фидбека открыты. Дедлайн — 14 июня. Затем Manager Assessment до 28 июня.', time:'сегодня' },
    { id:2, tag:'CEO', title:'CEO Approval — 5 июля', body:'Финальное утверждение Talent Bar распределения, кейсов promo и BoT.', time:'вчера' },
  ];

  /* Worklets — главные модули (как Workday «Applications») */
  const worklets = [
    { k:'cycle',      icon:'cycle',  label:'Активный цикл',    desc:ACTIVE_CYCLE.stage,        color:'brand' },
    { k:'reviews',    icon:'badge',  label:myDirects.length?'Мои reviews':'Мой review', desc:myDirects.length?`${myDirects.length} чел.`:lastReview?.overall||'—', color:'brand' },
    { k:'feedback',   icon:'chat',   label:'360 Feedback',     desc:inboundFeedback.length?`${inboundFeedback.length} входящих`:'без новых', color:'brand' },
    ...((perms.fullAccess || myDirects.length) ? [
      { k:'calibration', icon:'grid', label:'Talent Bar', desc:'Skills × Deliverables × Culture', color:'accent' },
    ] : []),
    { k:'people',     icon:'users',  label:'Люди',             desc:`${store.state.people.filter(p=>p.active!==false && !p.placeholder).length}/${store.state.people.filter(p=>p.active!==false).length}`, color:'ink' },
    { k:'history',    icon:'hist',   label:'История',          desc:'Тренды и compare',         color:'ink' },
    ...(isPerf?[
      { k:'calibration', icon:'grid',  label:'Калибровка',       desc:'3 выброса',                color:'accent' },
      { k:'hiring',      icon:'users', label:'Hiring',           desc:`${VACANCIES.length} вакансий`, color:'ink' },
      { k:'analytics',   icon:'chart', label:'Аналитика',        desc:'По командам',              color:'ink' },
      { k:'hradmin',     icon:'users', label:'Сотрудники',       desc:'Добавить / CSV',           color:'ink' },
    ]:[]),
  ];

  const workletTone = (c) => ({
    brand:'bg-brand-50 text-brand-600 border-brand-100',
    accent:'bg-amber-50 text-amber-600 border-amber-100',
    ink:'bg-ink-50 text-ink-500 border-ink-100',
  }[c]);

  return (
    <div className="p-8 max-w-[1280px] mx-auto space-y-6 fade-in">
      {/* Greeting */}
      <div className="pb-1">
        <div className="text-[11px] text-ink-500">{new Date().toLocaleDateString('ru-RU',{weekday:'long', day:'numeric', month:'long'})}</div>
        <h1 className="text-[26px] font-semibold text-ink-900 tracking-tight mt-0.5">{greet}, {firstName}</h1>
      </div>

      {/* Placeholder banner — без агрессивных цветов */}
      {store.state.people.some(p=>p.active!==false && p.placeholder) && (
        <div className="flex items-center gap-3 px-4 py-3 bg-ink-50 border border-ink-100 rounded-md text-[12px]">
          <Icon name="warn" className="w-4 h-4 text-ink-500 shrink-0" stroke={1.6}/>
          <div className="flex-1 text-ink-600">
            <span className="font-medium text-ink-900">{store.state.people.filter(p=>p.active!==false && p.placeholder).length} позиций — TBD.</span> Оргструктура заполнена; имена подставляются через HR Admin или CSV-импорт.
          </div>
          {isPerf && <button onClick={()=>onNav('hradmin')} className="text-[12px] font-medium text-brand-600 hover:underline shrink-0">Перейти к HR Admin →</button>}
        </div>
      )}

      <div className="grid lg:grid-cols-[1fr_320px] gap-6">
        <div className="space-y-6">
          {/* Awaiting Your Action */}
          {awaiting.length > 0 && (
            <Card>
              <CardHead title="Ожидают вашего действия" subtitle={`${awaiting.length} ${awaiting.length===1?'задача':'задачи'}`} />
              <div className="divide-y divide-ink-100">
                {awaiting.map(a=>(
                  <div key={a.id} className="px-5 py-4 flex items-center gap-4 hover:bg-ink-50/60">
                    <div className="w-9 h-9 rounded-md bg-brand-50 text-brand-600 grid place-items-center shrink-0">
                      <Icon name={a.icon} className="w-4 h-4" stroke={1.6}/>
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="text-[13px] font-medium text-ink-900 truncate">{a.title}</div>
                      <div className="text-[11px] text-ink-500 mt-0.5 truncate">{a.meta}</div>
                    </div>
                    <button onClick={a.action} className="h-8 px-3 rounded-md bg-brand-600 text-white text-[12px] font-medium hover:bg-brand-700 shrink-0">{a.cta}</button>
                  </div>
                ))}
              </div>
            </Card>
          )}

          {/* Applications / Worklets */}
          <Card>
            <CardHead title="Разделы"/>
            <div className="p-4 grid grid-cols-2 md:grid-cols-3 gap-3">
              {worklets.map(w=>(
                <button key={w.k} onClick={()=>onNav(w.k)} className="group text-left p-4 rounded-md border border-ink-100 hover:border-brand-300 hover:bg-brand-50/30 transition">
                  <div className={`w-9 h-9 rounded-md border ${workletTone(w.color)} grid place-items-center mb-3`}>
                    <Icon name={w.icon} className="w-4 h-4" stroke={1.6}/>
                  </div>
                  <div className="text-[13px] font-medium text-ink-900">{w.label}</div>
                  <div className="text-[11px] text-ink-500 mt-0.5">{w.desc}</div>
                </button>
              ))}
            </div>
          </Card>

          {/* Announcements */}
          <Card>
            <CardHead title="Объявления" />
            <div className="divide-y divide-ink-100">
              {announcements.map(a=>(
                <div key={a.id} className="px-5 py-4">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-[10px] font-medium text-brand-700 bg-brand-50 rounded px-1.5 py-0.5">{a.tag}</span>
                    <span className="text-[11px] text-ink-400">{a.time}</span>
                  </div>
                  <div className="text-[13px] font-medium text-ink-900">{a.title}</div>
                  <div className="text-[12px] text-ink-600 mt-0.5">{a.body}</div>
                </div>
              ))}
            </div>
          </Card>

          {/* Моя команда — простая список */}
          {myDirects.length > 0 && (
            <Card>
              <CardHead title="Моя команда" subtitle={`${myDirects.length} прямых подчинённых`} right={
                <button onClick={()=>onNav('reviews')} className="text-[12px] text-brand-600 font-medium hover:underline">Открыть все →</button>
              }/>
              <div className="divide-y divide-ink-100">
                {myDirects.slice(0,5).map(p=>{
                  const h = HISTORY[p.id];
                  const last = h && h[h.length-1];
                  return (
                    <div key={p.id} className="px-5 py-3 flex items-center gap-3 hover:bg-ink-50/60">
                      <Avatar p={p} size={32}/>
                      <div className="min-w-0 flex-1">
                        <div className="text-[13px] font-medium text-ink-900 truncate">{p.name}</div>
                        <div className="text-[11px] text-ink-500 truncate">{p.role}</div>
                      </div>
                      {last && <span className={gradeChip(last.overall)}>{last.overall}</span>}
                    </div>
                  );
                })}
              </div>
            </Card>
          )}
        </div>

        {/* Right rail — компактная */}
        <div className="space-y-6">
          {/* Мой review (если не менеджер) */}
          {!myDirects.length && lastReview && (
            <Card>
              <CardHead title="Мой последний review" subtitle={lastReview.cycle} divider={true}/>
              <div className="p-5 space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-[11px] text-ink-500">Итог</span>
                  <span className={gradeChip(lastReview.overall)}>{lastReview.overall}</span>
                </div>
                <div className="space-y-2">
                  {['skills','deliverables','culture'].map(dim=>(
                    <div key={dim} className="flex items-center justify-between text-[12px]">
                      <span className="text-ink-600 capitalize">{dim}</span>
                      <span className={masteryChip(lastReview[dim])}>{lastReview[dim]}</span>
                    </div>
                  ))}
                </div>
                <button onClick={()=>onNav('history')} className="w-full h-8 rounded-md border border-ink-200 text-[12px] font-medium text-ink-700 hover:bg-ink-50">Смотреть историю</button>
              </div>
            </Card>
          )}

          {/* Cycle status — минималистично */}
          <Card>
            <CardHead title={ACTIVE_CYCLE.name} subtitle="Прогресс цикла"/>
            <div className="p-5 space-y-3">
              <div className="flex items-baseline justify-between">
                <span className="text-[24px] font-semibold text-ink-900 tracking-tight">{liveCycleStats.pct}<span className="text-[14px] text-ink-400">%</span></span>
                <span className="text-[11px] text-ink-500">{liveCycleStats.submitted} / {liveCycleStats.total}</span>
              </div>
              <div className="h-1 bg-ink-100 rounded-full overflow-hidden">
                <div className="h-full bg-brand-600" style={{width:`${liveCycleStats.pct}%`}}></div>
              </div>
              <div className="pt-2 space-y-2">
                {ACTIVE_CYCLE.stages.map((s,i)=>(
                  <div key={s.key} className="flex items-center gap-2.5 text-[12px]">
                    <div className={`w-4 h-4 rounded-full grid place-items-center text-[9px] font-semibold ${s.status==='active'?'bg-brand-600 text-white':s.status==='done'?'bg-ink-200 text-ink-600':'bg-ink-50 text-ink-400 border border-ink-100'}`}>{i+1}</div>
                    <span className={`flex-1 ${s.status==='active'?'font-medium text-ink-900':'text-ink-500'}`}>{s.label}</span>
                    <span className="text-[10px] text-ink-400">{s.duration}</span>
                  </div>
                ))}
              </div>
              <button onClick={()=>onNav('cycle')} className="w-full h-8 rounded-md border border-ink-200 text-[12px] font-medium text-ink-700 hover:bg-ink-50">Подробнее</button>
            </div>
          </Card>

          {/* Notifications — компактно */}
          <Card>
            <CardHead title="Уведомления"/>
            <div className="divide-y divide-ink-100">
              {NOTIFS.slice(0,4).map(n=>(
                <div key={n.id} className="px-4 py-3 flex gap-3">
                  <div className="w-6 h-6 rounded-md bg-ink-50 text-ink-500 grid place-items-center shrink-0 mt-0.5">
                    <Icon name={n.icon} className="w-3 h-3" stroke={1.6}/>
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="text-[12px] font-medium text-ink-900 truncate">{n.t}</div>
                    <div className="text-[11px] text-ink-500 truncate mt-0.5">{n.body}</div>
                  </div>
                  <div className="text-[10px] text-ink-400 shrink-0">{n.time}</div>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>

      {/* KPI row внизу — сдержанно */}
      {isPerf && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <Stat label="Всего сотрудников" value={liveCycleStats.total}/>
          <Stat label="A-players" value={`${aPlayersCount}`} hint={`${liveCycleStats.total?Math.round(aPlayersCount/liveCycleStats.total*100):0}% команды`}/>
          <Stat label="Scorecards" value={`${liveCycleStats.submitted}/${liveCycleStats.total}`} hint={`${liveCycleStats.pct}% готово`}/>
          <Stat label="На PIP" value={String(pipCount)}/>
        </div>
      )}
    </div>
  );
};

/* ───────── CYCLE PAGE (6-phase semi-annual) ───────── */
const formatDate = (iso) => {
  if (!iso) return '';
  const months = ['янв','фев','мар','апр','май','июн','июл','авг','сен','окт','ноя','дек'];
  const d = new Date(iso);
  return `${d.getDate()} ${months[d.getMonth()]}`;
};
const dateRange = (start, end) => `${formatDate(start)} – ${formatDate(end)}`;

/* COMMIT_7.7 (16 may 2026): adaptive tenure display. Принимает число лет (как
   из public.employee_pii.tenure_years на бэке, computed из start_date) и
   возвращает human-readable формат: дни / мес / лет+мес. */
const formatTenure = (years) => {
  if (years == null || Number.isNaN(Number(years))) return '—';
  const y = Math.max(0, Number(years));
  const days = Math.round(y * 365.25);
  if (days < 31) return days + ' дн.';
  const totalMonths = Math.floor(days / 30.4375);
  if (totalMonths < 12) return totalMonths + ' мес.';
  const yy = Math.floor(totalMonths / 12);
  const mm = totalMonths % 12;
  return mm > 0 ? `${yy} лет ${mm} мес.` : `${yy} лет`;
};

const CyclePage = ({ onNav }) => {
  const store = useStore();
  const { user } = useApp();
  const perms = permissions(user, store.state.people);
  const showTeamProgress = perms.canManageTeam; // manager / HR / director
  /* Живой прогресс ревью: считаем от состава store.state.people × submitted manager scorecards
     текущего цикла. Плейсхолдеры/вакансии и неактивные — исключаем. */
  const cycleProgress = useMemo(()=>{
    const cycleId = ACTIVE_CYCLE.id;
    const reviewees = (store.state.people || [])
      .filter(p => p.active !== false && !p.placeholder && p.name && p.name !== '—');
    const submittedMgr = new Set(
      (store.state.managerAssessments || [])
        .filter(ma => ma.cycleId === cycleId && (ma.status === 'submitted' || ma.status === 'locked'))
        .map(ma => ma.employeeId)
    );
    const submittedSelf = new Set(
      (store.state.selfAssessments || [])
        .filter(sa => sa.cycleId === cycleId && sa.status === 'submitted')
        .map(sa => sa.employeeId)
    );
    const teams = {};
    reviewees.forEach(p => {
      const t = p.team || '—';
      if (!teams[t]) teams[t] = { t, total: 0, done: 0, selfDone: 0 };
      teams[t].total++;
      if (submittedMgr.has(p.id)) teams[t].done++;
      if (submittedSelf.has(p.id)) teams[t].selfDone++;
    });
    const byTeam = Object.values(teams).sort((a,b) => a.t.localeCompare(b.t, 'ru'));
    return {
      byTeam,
      total: reviewees.length,
      selfSubmitted: submittedSelf.size,
      managerSubmitted: submittedMgr.size,
    };
  }, [store.state.people, store.state.managerAssessments, store.state.selfAssessments]);
  const progressByTeam = cycleProgress.byTeam;
  /* Фазы таймлайна: из Настроек (редактируемые), иначе дефолт ACTIVE_CYCLE.stages.
     Активная фаза по-прежнему берётся из status (реальная фаза цикла, не по дате). */
  const cfgPhases = (Array.isArray(store.state.settings.cyclePhases) && store.state.settings.cyclePhases.length === 6)
    ? store.state.settings.cyclePhases : ACTIVE_CYCLE.stages;
  let activeIdx = cfgPhases.findIndex(s=>s.status==='active');
  if (activeIdx < 0) activeIdx = 0;
  return (
    <div className="p-8 space-y-6 fade-in">
      <Card>
        <div className="p-5 grid md:grid-cols-[1fr_auto] gap-4 items-center">
          <div>
            <div className="text-[11px] text-ink-500 uppercase tracking-wider">Активный цикл · Semi-annual</div>
            <h2 className="text-[20px] font-semibold tracking-tight text-ink-900 mt-0.5">{ACTIVE_CYCLE.name}</h2>
            <div className="text-[12px] text-ink-500 mt-1">
              Стадия: <span className="text-ink-900 font-medium">{ACTIVE_CYCLE.stage}</span>
              {' · '}Self Assessment до <span className="font-medium text-ink-900">{formatDate(ACTIVE_CYCLE.keyDates.selfDue)}</span>
              {' · '}Manager Assessment до <span className="font-medium text-ink-900">{formatDate(ACTIVE_CYCLE.keyDates.managerDue)}</span>
              {' · '}Calibration <span className="font-medium text-ink-900">{formatDate(ACTIVE_CYCLE.keyDates.calibrationAt)}</span>
            </div>
          </div>
          <div className="flex gap-2">
            <button className="h-8 px-3 rounded-md bg-brand-600 text-white text-[12px] font-medium hover:bg-brand-700 flex items-center gap-1.5">
              <Icon name="play" className="w-3.5 h-3.5" stroke={1.6}/> Напомнить
            </button>
            <button className="h-8 px-3 rounded-md border border-ink-200 text-[12px] font-medium text-ink-700 hover:bg-ink-50">Экспорт</button>
          </div>
        </div>
      </Card>

      {/* Timeline horizontal */}
      <Card>
        <CardHead title="Timeline H1 2026" subtitle="6-фазный процесс · пилот H1 2026"/>
        <div className="p-5">
          <div className="relative">
            <div className="absolute left-0 right-0 top-[22px] h-0.5 bg-ink-100"></div>
            <div className="absolute left-0 top-[22px] h-0.5 bg-brand-600" style={{width:`${((activeIdx+1)/cfgPhases.length)*100}%`}}></div>
            <div className="relative grid grid-cols-6 gap-2">
              {cfgPhases.map((s,i)=>{
                const isActive = s.status==='active';
                const isDone = i < activeIdx;
                return (
                  <div key={s.key} className="flex flex-col items-center text-center">
                    <div className={`w-11 h-11 rounded-full grid place-items-center border-2 z-10 ${isActive?'bg-brand-600 border-brand-600 text-white':isDone?'bg-brand-100 border-brand-600 text-brand-700':'bg-white border-ink-200 text-ink-400'}`}>
                      <Icon name={s.icon} className="w-4 h-4" stroke={2}/>
                    </div>
                    <div className={`text-[11px] font-semibold mt-2 ${isActive?'text-brand-700':'text-ink-700'}`}>{s.label.split(' (')[0]}</div>
                    <div className="text-[10px] text-ink-400 mt-0.5">{dateRange(s.start, s.end)}</div>
                    <div className="text-[10px] text-ink-400 mt-0.5">{s.owner}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Card>

      {showTeamProgress && (
        <div className="grid md:grid-cols-4 gap-4">
          <Stat label="Self Assessments" value={`${cycleProgress.selfSubmitted}/${cycleProgress.total}`} hint={`До ${formatDate(ACTIVE_CYCLE.keyDates.selfDue)}`}/>
          <Stat label="Upward Feedback" value={`${ACTIVE_CYCLE.upwardCollected}`} hint="Именной фидбек от direct reports"/>
          <Stat label="Manager scorecards" value={`${cycleProgress.managerSubmitted}/${cycleProgress.total}`} hint={`До ${formatDate(ACTIVE_CYCLE.keyDates.managerDue)}`}/>
          <Stat label="Calibration" value="Ожидает" hint={`${formatDate(ACTIVE_CYCLE.keyDates.calibrationAt)} · People Partner`}/>
        </div>
      )}

      {showTeamProgress && (
        <Card>
          <CardHead title="Прогресс по командам" subtitle={`Manager scorecards · ${ACTIVE_CYCLE.id}`}/>
          <div className="divide-y divide-ink-100">
            {progressByTeam.length === 0 ? (
              <div className="p-6 text-center text-[12px] text-ink-500">
                Нет активных сотрудников для текущего цикла. Добавьте людей в HR Admin.
              </div>
            ) : progressByTeam.map(t=>{
              const pct = t.total > 0 ? Math.round(t.done/t.total*100) : 0;
              return (
                <div key={t.t} className="p-4 flex items-center gap-4">
                  <div className="w-[180px] font-semibold text-sm">{t.t}</div>
                  <div className="flex-1">
                    <div className="h-2 bg-ink-100 rounded-full overflow-hidden">
                      <div className={`h-full rounded-full ${pct===100?'bg-emerald-500':pct>=70?'bg-brand-600':pct>0?'bg-amber-500':'bg-ink-200'}`} style={{width:`${pct}%`}}></div>
                    </div>
                  </div>
                  <div className="w-[90px] text-right text-sm font-mono">{t.done}/{t.total}</div>
                  <div className="w-[50px] text-right text-sm font-semibold">{pct}%</div>
                </div>
              );
            })}
          </div>
        </Card>
      )}

      <div className="grid md:grid-cols-2 gap-6">
        <Card>
          <CardHead title="Процесс полугодового review" subtitle="Playbook Performance Team · 6 фаз"/>
          <div className="p-5 space-y-4">
            {ACTIVE_CYCLE.stages.map((s,i)=>(
              <div key={s.key} className="flex gap-4">
                <div className={`w-8 h-8 shrink-0 rounded-full grid place-items-center text-xs font-bold ${s.status==='active'?'bg-brand-600 text-white':'bg-ink-100 text-ink-600'}`}>{i+1}</div>
                <div className="flex-1 pb-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <div className="font-semibold text-sm">{s.label}</div>
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-ink-100 text-ink-600">{s.owner}</span>
                    <span className="text-[10px] text-ink-400">{s.duration}</span>
                    <span className="text-[10px] text-ink-400">{dateRange(s.start, s.end)}</span>
                  </div>
                  <div className="text-xs text-ink-500 mt-1">{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </Card>

        <Card>
          <CardHead title="Ключевые даты H1 2026" subtitle="Deadline-ориентиры для менеджеров и сотрудников"/>
          <div className="p-5 space-y-3">
            {[
              ['Цикл открыт',                ACTIVE_CYCLE.keyDates.cycleOpen,     'CEO + Performance Team',  'Готово'],
              ['Self Assessment + Upward',   ACTIVE_CYCLE.keyDates.selfDue,      'Employees',               'Активно'],
              ['Manager Assessment · дедлайн', ACTIVE_CYCLE.keyDates.managerDue, 'Managers',                'Ждёт'],
              ['Calibration · Talent Bar сессии', ACTIVE_CYCLE.keyDates.calibrationAt,'People Partner + Perf Team','Ждёт'],
              ['CEO approval',               ACTIVE_CYCLE.keyDates.ceoApproval,  'CEO',                     'Ждёт'],
              ['Promo announcements',        ACTIVE_CYCLE.keyDates.promoAnnounce,'Performance Team',        'Ждёт'],
              ['Performance Conversations',  ACTIVE_CYCLE.keyDates.conversationBy,'Managers',               'Ждёт · обязательный gate'],
              ['Development Plan / BoT start', ACTIVE_CYCLE.keyDates.planActive, 'Managers + Employee',     'Ждёт'],
            ].map(([t, date, who, status])=>(
              <div key={t} className="flex items-center gap-3 p-3 rounded-xl bg-ink-50/50 border border-ink-100">
                <div className="w-6 h-6 rounded-full bg-white grid place-items-center shadow-card">
                  <Icon name={status==='Готово'?'check':status==='Активно'?'play':'cycle'} className={`w-3.5 h-3.5 ${status==='Готово'?'text-emerald-600':status==='Активно'?'text-brand-600':'text-ink-400'}`}/>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold">{t}</div>
                  <div className="text-xs text-ink-500">{who} · {formatDate(date)}</div>
                </div>
                <span className={`text-[11px] font-semibold ${status==='Готово'?'text-emerald-700':status==='Активно'?'text-brand-700':'text-ink-500'}`}>{status}</span>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
};

/* ───────── SCORECARD FILL (HERO FEATURE) ───────── */
const ScorecardFill = ({ employeeId, onBack }) => {
  const { store, user } = useApp();
  const emp = byId(employeeId);
  const cycleId = ACTIVE_CYCLE.id;
  const [tab, setTab] = useState('deliverables');
  /* COMMIT_4: live scorecards from Supabase (вместо захардкоженных констант).
     При отсутствии данных откатываемся на JS-константы как fallback. */
  const { list: scLiveList } = useScorecards();
  const scByKey = useMemo(() =>
    Object.fromEntries((scLiveList||[]).map(s => [s.key, s])), [scLiveList]);

  /* COMMIT_4 (30 apr 2026): динамический lookup role-scoped scorecard
     по emp.roleKey. Раньше был хардкод
       pm → skills_pm, data_scientist → skills_ds, иначе → skills_ml,
     из-за которого CTO/CPO/CRDO (roleKey='head') видели «ML Engineer — Skills».
     Теперь:
       • Ищем точный match по role_key в live-списке (включая skills_head из
         миграции 0046, плюс любые новые scorecards, созданные через UI:
         Designer, SRE, Research…)
       • Если для роли нет scorecard — отдаём stub с пустым dimensions=[].
         Downstream-код (Object.keys(scorecards).forEach, derived,
         scoresToAnswers) не падает — просто 0 итераций → skillsAvg=null →
         overall=null → submit естественно заблокирован, пока HR не создаст
         scorecard. UI отрисует empty-state с CTA. */
  const skillsScorecard = useMemo(() => {
    if (!emp.roleKey) return null;
    return (scLiveList || []).find(
      s => s.scope === 'role' && s.role_key === emp.roleKey
    ) || null;
  }, [scLiveList, emp.roleKey]);

  const SKILLS_EMPTY_STUB = useMemo(() => ({
    title: 'Skills',
    owner: '',
    formula: '',
    dimensions: [],
    __missing: true,
    __roleKey: emp.roleKey,
    __roleLabel: (typeof ROLES === 'object' && ROLES?.[emp.roleKey]?.label)
                  || emp.role || emp.roleKey || 'эта роль',
  }), [emp.roleKey, emp.role]);

  const scSkills       = skillsScorecard || SKILLS_EMPTY_STUB;
  const scDeliverables = scByKey['deliverables'] || SCORECARD_DELIVERABLES;
  const scCulture      = scByKey['culture']      || SCORECARD_CULTURE;
  const scorecards = { skills: scSkills, deliverables: scDeliverables, culture: scCulture };
  const sc = scorecards[tab];

  /* Existing Manager Assessment (draft/submitted/locked/reopened) */
  const existingMA = store.state.managerAssessments.find(ma => ma.employeeId===employeeId && ma.cycleId===cycleId);
  const maStatus = existingMA?.status || 'new';
  const isLocked = maStatus==='locked';
  const isSubmitted = maStatus==='submitted';
  const isReopened = maStatus==='reopened';
  const isDraft = maStatus==='draft';
  const canEdit = !isLocked && !isSubmitted;  /* submitted = read-only until reopen */

  /* Self Assessment by this employee */
  const selfAsm = store.state.selfAssessments.find(sa => sa.employeeId===employeeId && sa.cycleId===cycleId && sa.status==='submitted');

  /* 360 feedback received about this employee */
  const incoming360 = store.state.feedbackRequests
    .filter(fr => fr.subjectId===employeeId && fr.responses.length>0)
    .flatMap(fr => {
      const form = store.state.forms.find(f=>f.id===fr.formId);
      return fr.responses.map(r => ({ ...r, formType: form?.type||'360', formName: form?.name||'360', anonymous: fr.anonymous }));
    });

  /* Helper: convert stored {dimName: level} back to answers structure.
     Poor has INVERTED semantics (red flags should NOT occur):
       stored = 'Poor'  → Poor='yes' (red flags confirmed, locked at Poor)
       stored = 'Basic' → Poor='no' (no red flags), Basic='yes'
       stored = 'Intermediate' → Poor='no', Basic='yes', Intermediate='yes'
       …and so on.
     (fix 16 may 2026 — Talent Bar Poor inversion bug) */
  const scoresToAnswers = (storedScores) => {
    const init = {};
    Object.keys(scorecards).forEach(k=>{
      init[k] = {};
      scorecards[k].dimensions.forEach((d,i)=>{
        init[k][i] = {};
        const lvl = storedScores?.[k]?.[d.name];
        if (lvl) {
          const idx = MASTERY.indexOf(lvl);
          if (lvl === 'Poor') {
            init[k][i]['Poor'] = 'yes';
          } else if (idx > 0) {
            init[k][i]['Poor'] = 'no';
            MASTERY.slice(1, idx+1).forEach(l => { init[k][i][l] = 'yes'; });
          }
        }
      });
    });
    return init;
  };

  /* answers: { [tab]: { [dimensionIdx]: { [level]: 'yes'|'no'|null } } } */
  const [answers, setAnswers] = useState(()=>{
    if (existingMA?.scores) return scoresToAnswers(existingMA.scores);
    const init = {};
    Object.keys(scorecards).forEach(k=>{
      init[k] = {};
      scorecards[k].dimensions.forEach((_,i)=>{ init[k][i] = {}; });
    });
    return init;
  });
  const [comments, setComments] = useState(()=> existingMA?.comments || { skills:'', deliverables:'', culture:'', overall:'' });
  const [supportingDocs, setSupportingDocs] = useState(()=> existingMA?.supportingDocs || []);
  const [showDocModal, setShowDocModal] = useState(false);
  const [docDraft, setDocDraft] = useState({ type:'link', title:'', url:'' });

  /* AI: 360 Theme Clustering — локальное состояние для вызова AI_COACH.themeCluster */
  const [themeResult, setThemeResult] = useState(null);
  const [themeLoading, setThemeLoading] = useState(false);
  const [themeError, setThemeError] = useState(null);
  const runThemeCluster = async () => {
    setThemeError(null); setThemeResult(null);
    if (!REVIEW_SYNC.isReady()) { setThemeError('Supabase ещё не загрузился — откройте страницу чуть позже.'); return; }
    const empUuid = REVIEW_SYNC.employeeUuid(employeeId);
    const cycUuid = REVIEW_SYNC.cycleUuid(cycleId);
    if (!empUuid || !cycUuid) { setThemeError('Не удалось сопоставить сотрудника/цикл с Supabase.'); return; }
    if (!incoming360.length) { setThemeError('Нет 360-ответов для кластеринга.'); return; }
    const payload = incoming360.map((r, i) => {
      const parts = r.answers ? Object.values(r.answers).filter(v => typeof v === 'string' && v.trim().length > 0) : [];
      return {
        reviewer: r.anonymous ? `Аноним #${i + 1}` : (byId(r.reviewerId)?.name || 'Unknown'),
        type: r.formType || 'peer',
        text: parts.join('\n').slice(0, 4000),
      };
    }).filter(x => x.text.length > 0);
    if (!payload.length) { setThemeError('В 360-ответах нет текстовых комментариев для кластеринга.'); return; }
    setThemeLoading(true);
    try {
      const out = await AI_COACH.themeCluster(empUuid, cycUuid, payload);
      setThemeResult(out?.result || null);
    } catch (e) {
      setThemeError(e?.detail || e?.message || 'Ошибка AI-кластеринга');
    } finally {
      setThemeLoading(false);
    }
  };

  /* Derive level for dimension. Poor has INVERTED semantics — its items are red
     flags that should NOT occur. So:
       Poor === 'yes'  → red flags PRESENT → locked at Poor
       Poor === 'no'   → no red flags     → continue evaluating Basic..Exceptional
     For Basic..Exceptional (standard positive ladder): first 'no' stops; result
     is the last 'yes'. Unanswered levels are skipped, preserving the previous
     forgiving behaviour. (fix 16 may 2026 — Talent Bar Poor inversion bug) */
  const deriveLevel = (tabKey, dimIdx) => {
    const a = answers[tabKey][dimIdx];
    if (a['Poor'] === 'yes') return 'Poor';
    let result = null;
    for (const lvl of MASTERY.slice(1)) {
      const v = a[lvl];
      if (v === 'yes') result = lvl;
      else if (v === 'no') break;
    }
    return result;
  };

  const derived = useMemo(()=>{
    const r = {};
    Object.keys(scorecards).forEach(k=>{
      r[k] = scorecards[k].dimensions.map((d,i)=>({ name:d.name, level: deriveLevel(k, i) }));
    });
    return r;
  },[answers]);

  /* Compute overall using Talent Bar formula:
     Deliverables overall = (Speed+Quality)/2 * (Complexity/2.5) normalized back to 1-5
     Skills = avg, Culture = avg
     Overall grade: compare avg to TALENT_BAR
  */
  const scoreOf = lvl => lvl ? MASTERY_SCORE[lvl] : null;
  const avgScore = arr => {
    const s = arr.map(x=>scoreOf(x.level)).filter(x=>x!=null);
    return s.length? s.reduce((a,b)=>a+b,0)/s.length : null;
  };
  const delivScore = () => {
    const d = derived.deliverables;
    const speed = scoreOf(d[0].level), qual = scoreOf(d[1].level), comp = scoreOf(d[2].level);
    if (speed==null||qual==null||comp==null) return null;
    return Math.min(5, ((speed+qual)/2) * (comp/3) );  // normalized
  };
  const skillsAvg = avgScore(derived.skills);
  const cultureAvg = avgScore(derived.culture);
  const delAvg = delivScore();

  const overallAvg = [skillsAvg, delAvg, cultureAvg].filter(x=>x!=null);
  const overall = overallAvg.length===3
    ? (overallAvg.reduce((a,b)=>a+b,0)/3)
    : null;
  const bar = MASTERY_SCORE[talentBarFor(emp)];
  let grade = null;
  if (overall != null) {
    if (overall < bar - 0.4) grade = 'Underperformer';
    else if (overall >= bar + 0.8) grade = 'A-player';
    else grade = 'Above bar';
  }

  const setAnswer = (lvl, val) => {
    setAnswers(a => {
      const copy = JSON.parse(JSON.stringify(a));
      copy[tab][activeDim][lvl] = val;
      /* Early-stop rule. Poor is INVERTED (red flags should NOT occur):
           'yes' on Poor  → red flags confirmed → locked at Poor → clear higher
           'no'  on Poor  → no red flags        → keep evaluating Basic+ (do NOT clear)
         For Basic..Exceptional (standard positive ladder):
           'no'  → stop here, clear higher levels
           'yes' → keep going
         (fix 16 may 2026 — Talent Bar Poor inversion bug) */
      const idx = MASTERY.indexOf(lvl);
      const shouldClearHigher = lvl === 'Poor' ? (val === 'yes') : (val === 'no');
      if (shouldClearHigher) {
        MASTERY.slice(idx+1).forEach(l => { delete copy[tab][activeDim][l]; });
      }
      return copy;
    });
  };

  const [activeDim, setActiveDim] = useState(0);
  useEffect(()=>{ setActiveDim(0); }, [tab]);
  /* COMMIT_5 audit P1 #6 fix (30 apr 2026): защита от out-of-bounds activeDim
     если scorecard перезагрузился с меньшим числом измерений (например HR
     опубликовал новую версию с 2 dimensions, а пользователь был на dim #2).
     Без этого сRender падал бы на sc.dimensions[activeDim].name = undefined.name. */
  useEffect(() => {
    const dims = scorecards[tab]?.dimensions?.length || 0;
    if (activeDim >= dims) setActiveDim(0);
  }, [scorecards, tab, activeDim]);

  const completedDims = (tabKey) => scorecards[tabKey].dimensions.filter((_,i)=>deriveLevel(tabKey,i)).length;
  /* COMMIT_4: блокируем submit если skills.__missing — нельзя сабмитить
     review без оценки навыков. dimensions.length === 0 → completedDims === 0,
     что иначе считалось бы как «всё готово». */
  const allDone = !scSkills?.__missing
    && Object.keys(scorecards).every(k => completedDims(k) === scorecards[k].dimensions.length);

  return (
    <div className="p-8 space-y-5 fade-in">
      <div className="flex items-center gap-2 text-sm text-ink-500">
        <button onClick={onBack} className="hover:text-ink-900 flex items-center gap-1"><Icon name="chev" className="w-4 h-4 rotate-180"/> Назад</button>
        <span>/</span>
        <span>Reviews H1 2026</span>
        <span>/</span>
        <span className="text-ink-900 font-semibold">{emp.name}</span>
      </div>

      <div className="grid lg:grid-cols-[1fr_380px] gap-5">
        <div className="space-y-5">
          {/* Header */}
          <Card>
            <div className="p-5 flex items-center gap-4">
              <Avatar p={emp} size={54}/>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <div className="text-xl font-bold">{emp.name}</div>
                  <span className="text-[10px] uppercase tracking-wider bg-ink-100 px-1.5 py-0.5 rounded text-ink-600">{emp.seniority}</span>
                  <span className="text-[10px] uppercase tracking-wider bg-ink-100 px-1.5 py-0.5 rounded text-ink-600">{emp.team}</span>
                  {/* State badge */}
                  {maStatus==='new' && (
                    <span className="text-[10px] uppercase tracking-wider bg-ink-100 px-2 py-0.5 rounded font-bold text-ink-600">New</span>
                  )}
                  {isDraft && (
                    <span className="text-[10px] uppercase tracking-wider bg-amber-100 text-amber-800 px-2 py-0.5 rounded font-bold">Draft</span>
                  )}
                  {isSubmitted && (
                    <span className="text-[10px] uppercase tracking-wider bg-brand-100 text-brand-800 px-2 py-0.5 rounded font-bold">Submitted</span>
                  )}
                  {isLocked && (
                    <span className="text-[10px] uppercase tracking-wider bg-emerald-100 text-emerald-800 px-2 py-0.5 rounded font-bold">Locked</span>
                  )}
                  {isReopened && (
                    <span className="text-[10px] uppercase tracking-wider bg-violet-100 text-violet-800 px-2 py-0.5 rounded font-bold">Re-opened</span>
                  )}
                </div>
                <div className="text-sm text-ink-500">{emp.role}</div>
                <div className="text-xs text-ink-400 mt-1">
                  Талантовая планка для {emp.level || emp.seniority}: <span className={masteryChip(talentBarFor(emp))}>{talentBarFor(emp)}</span>
                  {existingMA?.lastSavedAt && <span className="ml-3">· последнее сохранение {existingMA.lastSavedAt}</span>}
                  {isSubmitted && existingMA?.submittedAt && <span className="ml-3">· отправлено {existingMA.submittedAt}</span>}
                </div>
              </div>
              <div className="hidden md:block">
                <div className="text-[10px] uppercase tracking-wider text-ink-400 text-right">Предыдущее полугодие</div>
                <div className="mt-1">{(() => {
                  const hist = Array.isArray(HISTORY[emp.id]) ? HISTORY[emp.id] : [];
                  const last = hist.length ? hist[hist.length-1] : null;
                  return last
                    ? <span className={gradeChip(last.overall)}>{last.overall}</span>
                    : <span className="text-xs text-ink-400 italic">нет истории</span>;
                })()}</div>
              </div>
            </div>
          </Card>

          {/* Supporting Inputs: Self Assessment + 360 */}
          <Card>
            <CardHead title="Supporting inputs" subtitle="Self Assessment и 360 feedback — входные данные для вашей оценки"/>
            <div className="grid md:grid-cols-2 divide-x divide-ink-100">
              {/* Self Assessment link */}
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="edit" className="w-4 h-4 text-brand-600"/>
                  <div className="text-xs uppercase tracking-wider text-ink-500 font-semibold">Self Assessment</div>
                  {selfAsm
                    ? <span className="text-[10px] uppercase tracking-wider bg-emerald-100 text-emerald-800 px-2 py-0.5 rounded font-bold">Submitted</span>
                    : <span className="text-[10px] uppercase tracking-wider bg-ink-100 text-ink-600 px-2 py-0.5 rounded font-bold">Не получено</span>
                  }
                </div>
                {selfAsm ? (
                  <div className="space-y-2">
                    <div className="text-xs text-ink-500">Отправлено {selfAsm.submittedAt}</div>
                    <div className="rounded-lg border border-ink-100 p-3 text-xs">
                      <div className="font-semibold text-ink-700 mb-1">Self-grade</div>
                      <div className="flex gap-2 flex-wrap">
                        <span className={gradeChip(selfAsm.sections?.outcome?.selfGrade)}>{selfAsm.sections?.outcome?.selfGrade || '—'}</span>
                        <span className={masteryChip(selfAsm.sections?.outcome?.selfSkills)}>S · {selfAsm.sections?.outcome?.selfSkills || '—'}</span>
                        <span className={masteryChip(selfAsm.sections?.outcome?.selfDeliverables)}>D · {selfAsm.sections?.outcome?.selfDeliverables || '—'}</span>
                        <span className={masteryChip(selfAsm.sections?.outcome?.selfCulture)}>C · {selfAsm.sections?.outcome?.selfCulture || '—'}</span>
                      </div>
                    </div>
                    {selfAsm.sections?.performance?.achievements && (
                      <div className="rounded-lg border border-ink-100 p-3 text-xs">
                        <div className="font-semibold text-ink-700 mb-1">Достижения H1</div>
                        <div className="text-ink-600 leading-relaxed line-clamp-4">{selfAsm.sections.performance.achievements}</div>
                      </div>
                    )}
                    {selfAsm.sections?.outcome?.goalsNextPeriod && (
                      <div className="rounded-lg border border-ink-100 p-3 text-xs">
                        <div className="font-semibold text-ink-700 mb-1">Цели на H2</div>
                        <div className="text-ink-600 leading-relaxed line-clamp-3">{selfAsm.sections.outcome.goalsNextPeriod}</div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="rounded-lg border border-dashed border-amber-300 bg-amber-50/30 p-4 text-xs text-amber-800">
                    <div className="font-semibold mb-1">Self Assessment ещё не отправлен</div>
                    Попросите сотрудника заполнить Self до подачи Manager Assessment. Это снижает риск blind-spots при калибровке.
                  </div>
                )}
              </div>

              {/* 360 Feedback summary */}
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <Icon name="users" className="w-4 h-4 text-brand-600"/>
                  <div className="text-xs uppercase tracking-wider text-ink-500 font-semibold">360 Feedback</div>
                  <span className="text-[10px] uppercase tracking-wider bg-brand-100 text-brand-800 px-2 py-0.5 rounded font-bold">{incoming360.length} ответов</span>
                  {incoming360.length > 0 && (
                    <button type="button" onClick={runThemeCluster} disabled={themeLoading}
                      className="ml-auto h-7 px-3 rounded-md bg-brand-600 text-white text-[11px] font-semibold hover:bg-brand-700 disabled:bg-ink-200 disabled:cursor-not-allowed flex items-center gap-1">
                      <Icon name="sparkle" className="w-3 h-3"/>
                      {themeLoading ? 'Кластеризую…' : (themeResult ? 'Перекластеризовать темы' : 'AI: кластеризовать темы')}
                    </button>
                  )}
                </div>
                {themeError && (
                  <div className="mb-2 p-2 rounded-lg bg-rose-50 border border-rose-200 text-[11px] text-rose-700">{themeError}</div>
                )}
                {themeResult && (
                  <div className="mb-3 rounded-lg border border-brand-200 bg-brand-50/40 p-3 space-y-2">
                    <div className="flex items-center justify-between">
                      <div className="text-[11px] uppercase tracking-wider text-brand-700 font-bold">AI Themes ({(themeResult.themes||[]).length})</div>
                      <div className="text-[10px] text-ink-500 italic">AI кластеризация — не окончательная истина. Проверьте кавычки.</div>
                    </div>
                    {Array.isArray(themeResult.themes) && themeResult.themes.map((t, i) => (
                      <div key={i} className="rounded-md bg-white border border-ink-100 p-2 text-xs">
                        <div className="flex items-center gap-2 mb-1">
                          <span className={`text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded font-bold ${t.sentiment==='positive'?'bg-emerald-100 text-emerald-800':t.sentiment==='negative'?'bg-rose-100 text-rose-800':'bg-ink-100 text-ink-700'}`}>
                            {t.sentiment||'neutral'}
                          </span>
                          <div className="font-semibold text-ink-800">{t.theme}</div>
                          {typeof t.mentions === 'number' && (
                            <span className="text-[10px] text-ink-500">· упомянули {t.mentions}×</span>
                          )}
                        </div>
                        {t.summary && <div className="text-ink-700 mb-1">{t.summary}</div>}
                        {Array.isArray(t.quotes) && t.quotes.length > 0 && (
                          <ul className="space-y-0.5 mt-1">
                            {t.quotes.slice(0, 3).map((q, j) => (
                              <li key={j} className="text-[11px] text-ink-600 italic border-l-2 border-brand-200 pl-2">
                                «{String(q).slice(0, 240)}»
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                    {themeResult.conflicts && Array.isArray(themeResult.conflicts) && themeResult.conflicts.length > 0 && (
                      <div className="rounded-md bg-amber-50 border border-amber-200 p-2 text-xs">
                        <div className="font-semibold text-amber-900 mb-1">Противоречия в фидбеке</div>
                        <ul className="space-y-0.5">
                          {themeResult.conflicts.map((c, i) => (
                            <li key={i} className="text-amber-900">• {typeof c === 'string' ? c : c.description || JSON.stringify(c)}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {themeResult.summary && (
                      <div className="text-[11px] text-ink-600 italic border-t border-ink-100 pt-2">
                        <span className="font-semibold text-ink-700 not-italic">Итого: </span>{themeResult.summary}
                      </div>
                    )}
                  </div>
                )}
                {incoming360.length>0 ? (
                  <div className="space-y-2 max-h-[280px] overflow-y-auto">
                    {incoming360.slice(0,8).map((r,i)=>{
                      const reviewer = r.anonymous ? {name:`Аноним #${i+1}`, team:'—'} : (byId(r.reviewerId) || {name:'Unknown', team:'—'});
                      return (
                        <div key={r.id||i} className="rounded-lg border border-ink-100 p-3 text-xs">
                          <div className="flex items-center justify-between mb-1.5">
                            <div className="font-semibold text-ink-700">{reviewer.name}</div>
                            <span className="text-[10px] text-ink-400">{r.formType} · {r.submittedAt||''}</span>
                          </div>
                          {r.answers && Object.entries(r.answers).slice(0,2).map(([qid,val])=>(
                            <div key={qid} className="text-ink-600 mt-1 line-clamp-2">
                              <span className="text-ink-400 text-[10px]">Q: </span>{typeof val==='string'? val : String(val)}
                            </div>
                          ))}
                        </div>
                      );
                    })}
                    {incoming360.length>8 && (
                      <div className="text-center text-[11px] text-ink-500 pt-1">+{incoming360.length-8} ещё ответов · откройте вкладку Feedback для полного просмотра</div>
                    )}
                  </div>
                ) : (
                  <div className="rounded-lg border border-dashed border-ink-200 bg-ink-50/30 p-4 text-xs text-ink-500">
                    <div className="font-semibold text-ink-700 mb-1">Пока нет входящих 360</div>
                    Сотрудник может запросить feedback в разделе Feedback. Рекомендуем минимум 3 ответа перед калибровкой.
                  </div>
                )}
              </div>
            </div>
          </Card>

          {/* Tabs */}
          <Card>
            <div className="p-1.5 flex gap-1 border-b border-ink-100">
              {[
                { k:'skills', label:'Skills', sub: scSkills.dimensions.length+' scorecards', color:'text-brand-700', cnt: completedDims('skills') },
                { k:'deliverables', label:'Deliverables', sub:'(Speed + Quality) × Complexity', color:'text-amber-700', cnt: completedDims('deliverables') },
                { k:'culture', label:'Culture', sub:'6 company values', color:'text-emerald-700', cnt: completedDims('culture') },
              ].map(t=>(
                <button key={t.k} onClick={()=>setTab(t.k)} className={`flex-1 px-4 py-3 rounded-xl text-left transition ${tab===t.k?'bg-brand-50':''}`}>
                  <div className={`text-sm font-bold ${tab===t.k?'text-brand-900':'text-ink-700'}`}>{t.label}</div>
                  <div className={`text-[11px] ${tab===t.k?'text-brand-700':'text-ink-500'}`}>{t.sub} · {t.cnt}/{scorecards[t.k].dimensions.length} готовы</div>
                </button>
              ))}
            </div>

            {/* Scorecard body: sub-dimensions */}
            {sc.__missing && (
              <div className="p-8">
                <div className="rounded-2xl border-2 border-dashed border-amber-300 bg-amber-50/40 p-8 text-center">
                  <div className="text-lg font-bold text-amber-900">Нет scorecard для роли «{sc.__roleLabel}»</div>
                  <div className="text-sm text-amber-800 mt-2 max-w-xl mx-auto">
                    Чтобы оценить навыки этого сотрудника, HR или CTO должны создать role-scoped scorecard для <code className="px-1.5 py-0.5 bg-amber-100 rounded text-[11px] font-mono">{sc.__roleKey || '—'}</code> в разделе Scorecard Library.
                  </div>
                  <div className="text-xs text-amber-700 mt-3">
                    Submit формы заблокирован, пока scorecard не появится. Deliverables и Culture (общие для всей компании) можно заполнять.
                  </div>
                </div>
              </div>
            )}
            {!sc.__missing && (
            <div className="grid md:grid-cols-[260px_1fr]">
              <div className="border-r border-ink-100 p-3 space-y-1 min-h-[420px]">
                <div className="px-2 pt-2 pb-3 text-[11px] uppercase tracking-wider text-ink-500 font-semibold">{sc.title}</div>
                {sc.dimensions.map((d,i)=>{
                  const lvl = deriveLevel(tab, i);
                  return (
                    <button key={i} onClick={()=>setActiveDim(i)} className={`w-full flex items-center gap-2 px-2.5 py-2 rounded-lg text-left text-sm ${activeDim===i?'bg-brand-100 text-brand-900 font-semibold':'text-ink-700 hover:bg-ink-50'}`}>
                      <div className={`w-5 h-5 shrink-0 rounded grid place-items-center text-[10px] font-bold ${lvl?'bg-emerald-500 text-white':'bg-ink-200 text-ink-500'}`}>{lvl?'✓':(i+1)}</div>
                      <div className="min-w-0 flex-1">
                        <div className="truncate">{d.name}</div>
                        <div className="text-[10px] text-ink-400 truncate">{d.desc}</div>
                      </div>
                      {lvl && <span className={masteryChip(lvl)}>{lvl}</span>}
                    </button>
                  );
                })}
                <div className="mt-4 p-3 rounded-lg bg-ink-50 text-[11px] text-ink-500">
                  <div className="font-semibold text-ink-700 mb-1">Правило Talent Bar</div>
                  Отвечаете «Да/Нет» на наблюдаемые поведения. Первый «Нет» — уровень определён. Subjective impressions не нужны.
                </div>
              </div>

              <div className="p-5">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="text-xs uppercase tracking-wider text-ink-500">{sc.title} — измерение</div>
                    <div className="text-lg font-extrabold tracking-tight">{sc.dimensions[activeDim].name}</div>
                    <div className="text-xs text-ink-500 mt-0.5">{sc.dimensions[activeDim].desc}</div>
                  </div>
                  {deriveLevel(tab, activeDim) && (
                    <div className="text-right">
                      <div className="text-[10px] uppercase tracking-wider text-ink-400">Определено</div>
                      <span className={masteryChip(deriveLevel(tab, activeDim))}>{deriveLevel(tab, activeDim)}</span>
                    </div>
                  )}
                </div>

                <div className="mt-5 space-y-2">
                  {sc.dimensions[activeDim].levels.map((lv, i) => {
                    const a = answers[tab][activeDim][lv.level];
                    /* Higher level is blocked if any previous level "stops" the ladder.
                       Poor has INVERTED semantics: 'yes' on Poor (red flags present) locks
                       at Poor and blocks higher. For Basic..Exceptional: 'no' blocks higher.
                       (fix 16 may 2026 — Talent Bar Poor inversion bug) */
                    const isBlocked = MASTERY.slice(0,i).some(pre => {
                      const ans = answers[tab][activeDim][pre];
                      return pre === 'Poor' ? ans === 'yes' : ans === 'no';
                    });
                    return (
                      <div key={lv.level} className={`rounded-xl border overflow-hidden ${isBlocked?'opacity-50 pointer-events-none border-ink-100':a==='yes'?'border-emerald-300 bg-emerald-50/40':a==='no'?'border-rose-300 bg-rose-50/40':'border-ink-200'}`}>
                        <div className="flex items-center gap-3 px-4 py-3">
                          <span className={masteryChip(lv.level)}>{lv.level}</span>
                          <div className="flex-1 text-xs text-ink-500">
                            {lv.level==='Poor' && 'Красные флаги — не должны встречаться'}
                            {lv.level==='Exceptional' && 'Достигают только лучшие в своей области'}
                          </div>
                          <div className="flex gap-1">
                            <button disabled={!canEdit} onClick={()=>setAnswer(lv.level,'yes')} className={`h-8 px-3 rounded-lg text-xs font-bold ${a==='yes'?'bg-emerald-500 text-white':'bg-white border border-ink-200 text-ink-600 hover:border-emerald-400'} disabled:opacity-40 disabled:cursor-not-allowed`}>Да</button>
                            <button disabled={!canEdit} onClick={()=>setAnswer(lv.level,'no')} className={`h-8 px-3 rounded-lg text-xs font-bold ${a==='no'?'bg-rose-500 text-white':'bg-white border border-ink-200 text-ink-600 hover:border-rose-400'} disabled:opacity-40 disabled:cursor-not-allowed`}>Нет</button>
                          </div>
                        </div>
                        <ul className="px-4 pb-3 space-y-1">
                          {lv.items.map((it,idx)=>(
                            <li key={idx} className="flex gap-2 text-[13px] text-ink-700">
                              <div className="w-1 h-1 rounded-full bg-ink-400 mt-2 shrink-0"></div>
                              <span>{it}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            )}

            <div className="p-5 border-t border-ink-100">
              <label className="text-xs font-semibold uppercase tracking-wider text-ink-500">Комментарий (для раздела «{sc.title}»)</label>
              <textarea
                value={comments[tab]}
                onChange={e=>setComments({...comments,[tab]:e.target.value})}
                rows={3}
                disabled={!canEdit}
                placeholder="Конкретные примеры за последнее полугодие. Ссылки на артефакты (PR, doc, metric dashboard) — обязательны."
                className="mt-2 w-full rounded-xl border border-ink-200 p-3 text-sm focus:outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100 disabled:bg-ink-50 disabled:cursor-not-allowed"
              />
              {canEdit && (
                <QualityCoachBox
                  getDraft={() => comments[tab] || ''}
                  feedbackType="manager_assessment"
                  competency={sc.title}
                  subjectEmployeeId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.employeeUuid(employeeId) : null}
                  cycleId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.cycleUuid(cycleId) : null}
                  disabled={!canEdit}
                  label={`Проверить комментарий по ${sc.title} (AI-коуч)`}
                />
              )}
            </div>
          </Card>

          {/* Supporting Documents */}
          <Card>
            <div className="p-5 flex items-center justify-between gap-3 border-b border-ink-100">
              <div>
                <div className="font-bold tracking-tight">Supporting Documents</div>
                <div className="text-xs text-ink-500 mt-0.5">Прикрепите PR, дашборды, RFC, 1:1 notes — артефакты подтверждают оценку</div>
              </div>
              <button
                disabled={!canEdit}
                onClick={()=>{ setDocDraft({ type:'link', title:'', url:'' }); setShowDocModal(true); }}
                className="h-9 px-3 rounded-lg bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700 disabled:bg-ink-200 disabled:cursor-not-allowed flex items-center gap-1.5">
                <Icon name="plus" className="w-3.5 h-3.5"/> Добавить
              </button>
            </div>
            <div className="p-3">
              {supportingDocs.length===0 ? (
                <div className="rounded-lg border border-dashed border-ink-200 p-8 text-center">
                  <div className="text-sm text-ink-500">Пока нет прикреплённых документов</div>
                  <div className="text-xs text-ink-400 mt-1">Добавьте ссылки на артефакты: PR, dashboard, doc, one-on-one notes</div>
                </div>
              ) : (
                <div className="divide-y divide-ink-100">
                  {supportingDocs.map((d,i)=>(
                    <div key={d.id||i} className="flex items-center gap-3 p-3">
                      <div className={`w-8 h-8 rounded-lg grid place-items-center shrink-0 ${d.type==='link'?'bg-brand-50 text-brand-700':'bg-amber-50 text-amber-700'}`}>
                        <Icon name={d.type==='link'?'link':'doc'} className="w-4 h-4"/>
                      </div>
                      <div className="min-w-0 flex-1">
                        <div className="text-sm font-semibold truncate">{d.title}</div>
                        <div className="text-[11px] text-ink-500 truncate">{d.url} · добавлено {d.addedAt}</div>
                      </div>
                      <span className="text-[10px] uppercase tracking-wider bg-ink-100 text-ink-600 px-2 py-0.5 rounded font-bold">{d.type}</span>
                      {canEdit && (
                        <button onClick={()=>setSupportingDocs(supportingDocs.filter((_,ix)=>ix!==i))} className="text-ink-400 hover:text-rose-600 p-1">
                          <Icon name="x" className="w-4 h-4"/>
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Card>

          {/* Add Supporting Doc Modal */}
          <Modal open={showDocModal} title="Добавить supporting document" onClose={()=>setShowDocModal(false)}>
            <div className="space-y-4">
              <div>
                <label className="text-xs font-semibold uppercase tracking-wider text-ink-500">Тип</label>
                <div className="mt-1.5 flex gap-2">
                  {['link','file'].map(t=>(
                    <button key={t} onClick={()=>setDocDraft({...docDraft, type:t})} className={`h-9 px-4 rounded-lg text-sm font-semibold ${docDraft.type===t?'bg-brand-600 text-white':'bg-ink-50 text-ink-600 hover:bg-ink-100'}`}>
                      {t==='link'?'Ссылка':'Файл'}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label className="text-xs font-semibold uppercase tracking-wider text-ink-500">Название</label>
                <input
                  value={docDraft.title}
                  onChange={e=>setDocDraft({...docDraft, title:e.target.value})}
                  placeholder="PR #4128 · ASR latency optimization"
                  className="mt-1.5 w-full h-10 rounded-lg border border-ink-200 px-3 text-sm focus:outline-none focus:border-brand-500"/>
              </div>
              <div>
                <label className="text-xs font-semibold uppercase tracking-wider text-ink-500">{docDraft.type==='link'?'URL':'Имя файла'}</label>
                <input
                  value={docDraft.url}
                  onChange={e=>setDocDraft({...docDraft, url:e.target.value})}
                  placeholder={docDraft.type==='link'?'https://github.com/...':'latency-dashboard.png'}
                  className="mt-1.5 w-full h-10 rounded-lg border border-ink-200 px-3 text-sm focus:outline-none focus:border-brand-500"/>
              </div>
              <div className="pt-3 border-t border-ink-100 flex gap-2 justify-end">
                <button onClick={()=>setShowDocModal(false)} className="h-10 px-4 rounded-xl border border-ink-200 text-sm font-semibold hover:bg-ink-50">Отмена</button>
                <button
                  disabled={!docDraft.title || !docDraft.url}
                  onClick={()=>{
                    const today = new Date().toISOString().slice(0,10);
                    setSupportingDocs([...supportingDocs, { id:'d-'+Math.random().toString(36).slice(2,8), ...docDraft, addedAt: today }]);
                    setShowDocModal(false);
                  }}
                  className="h-10 px-4 rounded-xl bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700 disabled:bg-ink-200 disabled:cursor-not-allowed">
                  Добавить
                </button>
              </div>
            </div>
          </Modal>

          {/* Overall preview + submit */}
          <Card>
            <CardHead title="Предварительный итог" subtitle="Автоматический расчёт по правилам Talent Bar"/>
            <div className="p-5 grid md:grid-cols-4 gap-3">
              {['skills','deliverables','culture'].map(k=>{
                const avg = k==='skills'?skillsAvg:k==='deliverables'?delAvg:cultureAvg;
                return (
                  <div key={k} className="rounded-xl border border-ink-100 p-3">
                    <div className="text-[10px] uppercase tracking-wider text-ink-500">{k}</div>
                    <div className="mt-1.5 font-mono text-2xl font-extrabold tracking-tight">{avg ? avg.toFixed(1) : '—'}</div>
                    <div className="text-[11px] text-ink-400">{avg ? MASTERY[Math.min(4,Math.round(avg)-1)] : 'не заполнено'}</div>
                  </div>
                );
              })}
              <div className={`rounded-xl border p-3 ${grade==='A-player'?'border-emerald-300 bg-emerald-50':grade==='Above bar'?'border-amber-300 bg-amber-50':grade==='Underperformer'?'border-rose-300 bg-rose-50':'border-ink-100'}`}>
                <div className="text-[10px] uppercase tracking-wider text-ink-500">Overall grade</div>
                <div className="mt-1.5 font-extrabold text-lg">{grade || '—'}</div>
                <div className="text-[11px] text-ink-500">Планка {emp.level || emp.seniority}: {talentBarFor(emp)}</div>
              </div>
            </div>
            <div className="px-5 pb-5 flex items-center gap-3 flex-wrap">
              {/* Build scores object: {skills:{dimName:lvl}, deliverables:{...}, culture:{...}} */}
              {(() => {
                const buildPatch = () => {
                  const scores = { skills:{}, deliverables:{}, culture:{} };
                  Object.keys(scorecards).forEach(k => {
                    scorecards[k].dimensions.forEach((d,i) => {
                      const lvl = deriveLevel(k, i);
                      if (lvl) scores[k][d.name] = lvl;
                    });
                  });
                  return { scores, comments, supportingDocs, derivedGrade: grade };
                };
                return (
                  <>
                    {canEdit && (
                      <>
                        <button
                          onClick={()=>{
                            store.saveManagerAssessmentDraft(employeeId, user.id, cycleId, buildPatch(), user.name||'Manager');
                            alert('Черновик Manager Assessment сохранён');
                          }}
                          className="h-10 px-4 rounded-xl border border-ink-200 text-sm font-semibold hover:bg-ink-50">
                          Сохранить черновик
                        </button>
                        <button
                          disabled={!allDone}
                          onClick={()=>{
                            if (!confirm('Отправить Manager Assessment на калибровку? После отправки форма станет read-only.')) return;
                            store.submitManagerAssessment(employeeId, user.id, cycleId, buildPatch(), user.name||'Manager');
                            alert('Manager Assessment отправлен на калибровку');
                          }}
                          className="h-10 px-4 rounded-xl bg-brand-600 text-white font-semibold text-sm hover:bg-brand-700 disabled:bg-ink-200 disabled:cursor-not-allowed">
                          Отправить на калибровку
                        </button>
                      </>
                    )}
                    {isSubmitted && (
                      <>
                        <div className="inline-flex items-center gap-2 h-10 px-4 rounded-xl bg-brand-50 border border-brand-200 text-sm text-brand-800 font-semibold">
                          <Icon name="check" className="w-4 h-4"/>
                          Отправлено {existingMA?.submittedAt}
                        </div>
                        {user.role?.includes('HR') || user.role?.includes('Admin') ? (
                          <>
                            <button
                              onClick={()=>{
                                if (!confirm('Залочить assessment? После lock изменения будут невозможны даже через re-open.')) return;
                                store.lockManagerAssessment(employeeId, cycleId, user.name||'HR Admin');
                              }}
                              className="h-10 px-4 rounded-xl bg-emerald-600 text-white font-semibold text-sm hover:bg-emerald-700">
                              Залочить (HR)
                            </button>
                            <button
                              onClick={()=>{
                                if (!confirm('Переоткрыть форму для редактирования? Статус вернётся в Re-opened.')) return;
                                store.reopenManagerAssessment(employeeId, cycleId, user.name||'HR Admin');
                              }}
                              className="h-10 px-4 rounded-xl bg-violet-600 text-white font-semibold text-sm hover:bg-violet-700">
                              Переоткрыть (HR)
                            </button>
                          </>
                        ) : null}
                      </>
                    )}
                    {isLocked && (
                      <div className="inline-flex items-center gap-2 h-10 px-4 rounded-xl bg-emerald-50 border border-emerald-200 text-sm text-emerald-800 font-semibold">
                        <Icon name="lock" className="w-4 h-4"/>
                        Locked — ушло в payroll/promo
                      </div>
                    )}
                    <div className="text-xs text-ink-400">
                      {!canEdit
                        ? (isSubmitted?'Read-only · ждёт calibration & lock':'Locked forever')
                        : (allDone? 'Все scorecards готовы · авто-расчёт подтверждён' : `Осталось: ${['skills','deliverables','culture'].filter(k=>completedDims(k)<scorecards[k].dimensions.length).length} разделов`)
                      }
                    </div>
                  </>
                );
              })()}
            </div>
          </Card>
        </div>

        {/* Right: history & reference */}
        <div className="space-y-5">
          <Card>
            <CardHead title="История" subtitle="Последние 4 полугодия"/>
            <div className="divide-y divide-ink-100">
              {(Array.isArray(HISTORY[emp.id]) && HISTORY[emp.id].length > 0) ? HISTORY[emp.id].map((h,i)=>(
                <div key={i} className="p-4">
                  <div className="flex items-center justify-between mb-2">
                    <div className="text-sm font-semibold">{h.cycle}</div>
                    <span className={gradeChip(h.overall)}>{h.overall}</span>
                  </div>
                  <div className="flex flex-wrap gap-1">
                    <span className={masteryChip(h.skills)}>S · {h.skills}</span>
                    <span className={masteryChip(h.deliverables)}>D · {h.deliverables}</span>
                    <span className={masteryChip(h.culture)}>C · {h.culture}</span>
                  </div>
                </div>
              )) : (
                <div className="p-5 text-xs text-ink-400 italic text-center">История появится после первого Performance Review</div>
              )}
            </div>
          </Card>

          <Card>
            <CardHead title="Формула итоговой оценки"/>
            <div className="p-5 space-y-3 text-sm">
              <div className="p-3 rounded-lg bg-ink-50 font-mono text-xs">
                <div className="text-ink-500">Deliverables =</div>
                <div className="text-ink-900">(Speed + Quality) × Complexity</div>
              </div>
              <div className="p-3 rounded-lg bg-ink-50 font-mono text-xs">
                <div className="text-ink-500">Overall =</div>
                <div className="text-ink-900">AVG(Skills, Deliverables, Culture) vs Talent Bar</div>
              </div>
              <ul className="text-xs text-ink-500 space-y-1 list-disc pl-5">
                <li>Δ ≥ +0.8 → <span className="font-medium text-emerald-700">A-player</span></li>
                <li>Δ ∈ [+0.0; +0.79] → <span className="font-medium text-amber-700">Above bar</span></li>
                <li>Δ ∈ [−0.39; −0.01] → <span className="font-medium text-ink-700">At bar</span></li>
                <li>Δ ∈ [−0.79; −0.40] → <span className="font-medium text-orange-700">Below bar</span></li>
                <li>Δ ≤ −0.8 → <span className="font-medium text-rose-700">Underperformer</span></li>
              </ul>
              <div className="text-[10px] text-ink-400">Δ = AVG(Skills, Deliverables, Culture) − Talent Bar</div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

/* ───────── REVIEWS (list) ───────── */
const ReviewsPage = ({ onOpen }) => {
  const { user, store } = useApp();
  /* Подтягиваем директов из живого store, а не из статической PEOPLE */
  const myDirects = (store.state.people || []).filter(
    p => p.managerId === user.id && p.active !== false && !p.placeholder && p.name && p.name !== '—'
  );
  const list = myDirects.length ? myDirects : [user];
  const [filter, setFilter] = useState('all');
  const [q, setQ] = useState('');

  /* Реальный статус берём из managerAssessments текущего цикла */
  const cycleId = ACTIVE_CYCLE.id;
  const statusOf = (personId) => {
    const ma = (store.state.managerAssessments || []).find(
      m => m.employeeId === personId && m.cycleId === cycleId
    );
    if (!ma) return 'todo';
    if (ma.status === 'submitted' || ma.status === 'locked') return 'done';
    return 'draft';
  };

  const withStatus = list.map(p => ({ p, status: statusOf(p.id) }));
  const filtered = withStatus.filter(({ p, status })=>{
    const matchesQ = !q || p.name.toLowerCase().includes(q.toLowerCase());
    if (!matchesQ) return false;
    if (filter === 'all') return true;
    if (filter === 'pending') return status === 'todo' || status === 'draft';
    if (filter === 'submitted') return status === 'done';
    return true;
  });

  return (
    <div className="p-8 space-y-5 fade-in">
      <Card>
        <div className="p-5 flex items-center gap-3">
          <div className="min-w-0 flex-1">
            <h2 className="text-lg font-bold tracking-tight">Reviews · {ACTIVE_CYCLE.quarter}</h2>
            <div className="text-xs text-ink-500 mt-0.5">{myDirects.length? `${myDirects.length} сотрудников в вашей команде`:'Ваш review заполняет ваш менеджер'}</div>
          </div>
          <div className="flex items-center gap-2">
            {['all','pending','submitted'].map(f=>(
              <button key={f} onClick={()=>setFilter(f)} className={`h-9 px-3 rounded-lg text-sm ${filter===f?'bg-brand-100 text-brand-800 font-semibold':'bg-ink-50 text-ink-600 hover:bg-ink-100'}`}>
                {f==='all'?'Все':f==='pending'?'В работе':'Отправлено'}
              </button>
            ))}
            <div className="flex items-center gap-1 px-3 h-9 rounded-lg bg-ink-50 border border-ink-100 w-[220px]">
              <Icon name="search" className="w-4 h-4 text-ink-400"/>
              <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Поиск" className="bg-transparent outline-none text-sm flex-1"/>
            </div>
          </div>
        </div>
      </Card>

      <Card>
        <div className="divide-y divide-ink-100">
          {filtered.length === 0 && (
            <div className="p-6 text-center text-[12px] text-ink-500">
              Нет сотрудников по выбранному фильтру.
            </div>
          )}
          {filtered.map(({ p, status })=>{
            const histArr = Array.isArray(HISTORY[p.id]) ? HISTORY[p.id] : [];
            const h = histArr.length ? histArr[histArr.length-1] : null;
            return (
              <div key={p.id} className="p-4 flex items-center gap-4 hover:bg-ink-50/60">
                <Avatar p={p} size={40}/>
                <div className="min-w-0 flex-1">
                  <div className="font-semibold">{p.name}</div>
                  <div className="text-xs text-ink-500">{p.role} · {p.seniority} · {p.team}</div>
                </div>
                <div className="hidden md:flex items-center gap-1.5">
                  {h ? (
                    <>
                      <span className={masteryChip(h.skills)}>Skills</span>
                      <span className={masteryChip(h.deliverables)}>Deliv</span>
                      <span className={masteryChip(h.culture)}>Cult</span>
                    </>
                  ) : (
                    <span className="text-[11px] text-ink-400 italic" title="История оценок появится после первого Performance Review">ещё не оценён</span>
                  )}
                </div>
                <div className="hidden md:block min-w-[110px]">
                  {status==='todo' && <span className="inline-flex items-center gap-1 text-xs text-ink-500"><div className="w-1.5 h-1.5 bg-ink-300 rounded-full"></div>Не начат</span>}
                  {status==='draft' && <span className="inline-flex items-center gap-1 text-xs text-amber-700"><div className="w-1.5 h-1.5 bg-amber-500 rounded-full"></div>Черновик</span>}
                  {status==='done' && <span className="inline-flex items-center gap-1 text-xs text-emerald-700"><div className="w-1.5 h-1.5 bg-emerald-500 rounded-full"></div>Отправлено</span>}
                </div>
                <button onClick={()=>onOpen(p.id)} className="h-9 px-3 rounded-lg bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700 flex items-center gap-1">
                  {status==='done'?'Просмотр':'Заполнить'} <Icon name="arrow" className="w-3.5 h-3.5"/>
                </button>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
};

/* ───────── SELF ASSESSMENT ───────── */
const SelfAssessmentPage = ({ onNav }) => {
  const { user, store } = useApp();
  const cycleId = ACTIVE_CYCLE.id;

  /* Load existing assessment (draft or submitted) */
  const existing = store.state.selfAssessments.find(sa => sa.employeeId===user.id && sa.cycleId===cycleId);
  const isLocked = existing?.status==='submitted';

  /* Pre-fetch 360 context: peers who already submitted feedback about me */
  const incomingFeedback = store.state.feedbackRequests
    .filter(fr => fr.subjectId===user.id && fr.responses.length>0)
    .flatMap(fr => fr.responses.map(r => ({ ...r, formId: fr.formId, anonymous: fr.anonymous })));
  const outgoingRequests = store.state.feedbackRequests
    .filter(fr => fr.requesterId===user.id);

  /* Form state */
  const seed = existing?.sections || {
    feedback360: { requestedFromIds: outgoingRequests.flatMap(r=>r.fromIds||[]), notes: '' },
    performance: { achievements:'', metrics:'', challenges:'' },
    leadership:  { values:'', behaviors:'', collaboration:'' },
    outcome:     { selfGrade:'', selfSkills:'', selfDeliverables:'', selfCulture:'', goalsNextPeriod:'' },
    review:      { agreed:false, signature:'' },
  };
  const [sections, setSections] = useState(seed);
  const [activeStep, setActiveStep] = useState(0);
  const [toast, setToast] = useState(null);

  const updateSection = (key, patch) => setSections(prev => ({ ...prev, [key]: { ...prev[key], ...patch } }));

  const handleSaveDraft = () => {
    store.saveSelfAssessmentDraft(user.id, cycleId, sections, user.name);
    setToast('Черновик сохранён');
    setTimeout(()=>setToast(null), 2000);
  };
  /* COMMIT_8 (audit may 2026, bug 9): убрали дефолтные значения
     'Intermediate'/'Above bar' в outcome — теперь они должны быть явно
     выбраны сотрудником. Без этого блокируем submit. */
  const outcomeIsComplete = () =>
    !!(sections.outcome.selfGrade && sections.outcome.selfSkills &&
       sections.outcome.selfDeliverables && sections.outcome.selfCulture);
  const handleSubmit = () => {
    if (!sections.performance.achievements?.trim() || !sections.leadership.values?.trim() || !sections.outcome.goalsNextPeriod?.trim()) {
      alert('Пожалуйста, заполните обязательные поля: Достижения, Values, Цели на следующий период');
      return;
    }
    if (!outcomeIsComplete()) {
      alert('Outcome: укажите overall grade и mastery-уровни по Skills / Deliverables / Culture');
      return;
    }
    if (!sections.review.agreed) {
      alert('Пожалуйста, подтвердите согласие в секции Review');
      return;
    }
    store.submitSelfAssessment(user.id, cycleId, sections, user.name);
    setToast('Self Assessment отправлен менеджеру');
    setTimeout(()=>setToast(null), 2500);
  };

  const steps = [
    { key:'feedback360', label:'360 Feedback',     icon:'chat',   short:'Собранные фидбеки' },
    { key:'performance', label:'Individual Performance', icon:'target', short:'WHAT — результаты' },
    { key:'leadership',  label:'Leadership Principles',  icon:'sparkle', short:'HOW — как работал' },
    { key:'outcome',     label:'Outcome',          icon:'grid',   short:'Самооценка + цели' },
    { key:'review',      label:'Review',           icon:'check',  short:'Проверка и подпись' },
  ];

  const Stepper = () => (
    <div className="flex items-center gap-0 border-b border-ink-100 pb-0">
      {steps.map((s, i) => {
        const active = i===activeStep;
        const done = i<activeStep;
        return (
          <button key={s.key} onClick={()=>setActiveStep(i)}
                  title={GLOSSARY[s.label] || ''}
                  className={`flex-1 flex items-center gap-2 px-4 py-3 text-sm border-b-2 transition
                    ${active?'border-brand-600 text-brand-700 font-semibold bg-brand-50/40'
                     : done?'border-emerald-300 text-emerald-700':'border-transparent text-ink-500 hover:bg-ink-50'}`}>
            <span className={`w-6 h-6 rounded-full grid place-items-center text-[11px] font-bold
                    ${active?'bg-brand-600 text-white': done?'bg-emerald-500 text-white':'bg-ink-100 text-ink-500'}`}>
              {done? <Icon name="check" className="w-3 h-3" stroke={2.4}/> : (i+1)}
            </span>
            <div className="text-left min-w-0">
              <div className="truncate">{s.label}</div>
              <div className="text-[11px] text-ink-400 truncate font-normal">{s.short}</div>
            </div>
          </button>
        );
      })}
    </div>
  );

  const sectionKey = steps[activeStep].key;

  return (
    <div className="p-8 space-y-5 fade-in">
      {/* Header */}
      <Card>
        <div className="p-5 flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-brand-600 text-white grid place-items-center">
            <Icon name="chat" className="w-6 h-6"/>
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-[11px] uppercase tracking-wider text-ink-400 font-medium">Self Assessment · {ACTIVE_CYCLE.name}</div>
            <h2 className="text-lg font-bold text-ink-900 truncate">{user.name} · {user.role}</h2>
            <div className="text-xs text-ink-500 mt-0.5">
              Дедлайн: <span className="font-medium text-ink-900">14 июня 2026</span>
              {isLocked
                ? <> · <span className="text-emerald-700 font-medium">✓ Отправлено {existing.submittedAt}</span></>
                : existing ? <> · <span className="text-amber-700">Черновик · сохранён {existing.lastSavedAt}</span></>
                : <> · <span className="text-ink-500">Не начато</span></>}
            </div>
          </div>
          <div className="flex items-center gap-2">
            {!isLocked && (
              <button onClick={handleSaveDraft} className="h-9 px-4 rounded-md text-sm text-ink-700 border border-ink-200 hover:bg-ink-50 flex items-center gap-2">
                <Icon name="book" className="w-4 h-4" stroke={1.8}/> Сохранить черновик
              </button>
            )}
            {!isLocked && (
              <button onClick={handleSubmit} className="h-9 px-4 rounded-md text-sm bg-brand-600 text-white hover:bg-brand-700 flex items-center gap-2 font-medium">
                <Icon name="check" className="w-4 h-4" stroke={2}/> Отправить менеджеру
              </button>
            )}
            {isLocked && (
              <span className="h-9 px-4 rounded-md text-sm bg-emerald-50 text-emerald-700 border border-emerald-200 flex items-center gap-2 font-medium">
                <Icon name="shield" className="w-4 h-4" stroke={1.8}/> Submitted · Locked
              </span>
            )}
          </div>
        </div>
        <Stepper/>
      </Card>

      {/* Toast */}
      {toast && (
        <div className="fixed bottom-6 right-6 z-50 bg-ink-900 text-white px-4 py-3 rounded-lg shadow-xl text-sm flex items-center gap-2">
          <Icon name="check" className="w-4 h-4 text-emerald-400" stroke={2.2}/> {toast}
        </div>
      )}

      {/* Section body */}
      {sectionKey==='feedback360' && (
        <Card>
          <CardHead title="1. 360 Feedback · Собранные фидбеки"
                    subtitle="До начала самооценки — запросите фидбек у коллег (до 5 stakeholders). Ответы появятся ниже по мере поступления."/>
          <div className="p-5 space-y-4">
            <div className="grid md:grid-cols-2 gap-4">
              <div className="rounded-lg border border-ink-100 p-4 bg-ink-50/40">
                <div className="text-xs uppercase tracking-wider text-ink-500 mb-2">Запрошено reviewers</div>
                <div className="text-2xl font-bold text-ink-900">{(sections.feedback360.requestedFromIds||[]).length} <span className="text-sm font-normal text-ink-500">/ 5 max</span></div>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {(sections.feedback360.requestedFromIds||[]).slice(0,6).map(pid => {
                    const p = byId(pid); if (!p) return null;
                    return (
                      <span key={pid} className="inline-flex items-center gap-1.5 bg-white border border-ink-100 rounded-full pl-1 pr-2.5 py-0.5 text-xs">
                        <Avatar p={p} size={18}/> {p.name}
                      </span>
                    );
                  })}
                </div>
                <button onClick={()=>onNav && onNav('feedback')} className="mt-3 text-xs text-brand-700 font-medium hover:underline flex items-center gap-1">
                  Запросить ещё фидбек <Icon name="arrow-right" className="w-3 h-3"/>
                </button>
              </div>
              <div className="rounded-lg border border-ink-100 p-4 bg-emerald-50/40">
                <div className="text-xs uppercase tracking-wider text-emerald-700 mb-2">Получено ответов</div>
                <div className="text-2xl font-bold text-ink-900">{incomingFeedback.length}</div>
                <div className="text-xs text-ink-500 mt-1">Все отзывы 360 в Freedom AI Labs — именные. Автор виден субъекту.</div>
              </div>
            </div>

            {/* Incoming feedback preview */}
            {incomingFeedback.length > 0 ? (
              <div className="space-y-2">
                <div className="text-xs uppercase tracking-wider text-ink-500 font-semibold">Ответы от ревьюеров</div>
                {incomingFeedback.map((r,i)=>{
                  const author = r.anonymous ? null : byId(r.fromId);
                  return (
                    <div key={i} className="rounded-lg border border-ink-100 p-3 bg-white">
                      <div className="flex items-center gap-2 mb-2">
                        {author
                          ? <><Avatar p={author} size={22}/><span className="text-sm font-medium">{author.name}</span><span className="text-xs text-ink-400">· {author.role}</span></>
                          : <><div className="w-[22px] h-[22px] rounded-full bg-ink-200 grid place-items-center"><Icon name="shield" className="w-3 h-3 text-ink-500"/></div><span className="text-sm font-medium text-ink-700">Анонимно</span></>}
                        <span className="ml-auto text-xs text-ink-400">{r.submittedAt}</span>
                      </div>
                      <div className="space-y-1 text-sm">
                        {Object.entries(r.answers||{}).slice(0,3).map(([k,v])=>(
                          <div key={k} className="text-ink-700"><span className="text-xs text-ink-400 uppercase tracking-wider mr-2">{k}:</span>{String(v).slice(0,180)}{String(v).length>180?'…':''}</div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="rounded-lg border-2 border-dashed border-ink-200 p-6 text-center text-sm text-ink-500">
                Пока нет входящих ответов. Вы можете продолжить self-assessment — ответы подтянутся автоматически.
              </div>
            )}

            <div>
              <label className="text-xs uppercase tracking-wider text-ink-500 font-semibold">Мои заметки по собранному фидбеку</label>
              <textarea rows={4} disabled={isLocked}
                value={sections.feedback360.notes}
                onChange={e=>updateSection('feedback360', { notes: e.target.value })}
                className="mt-1 w-full rounded-lg border border-ink-200 p-3 text-sm outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 disabled:bg-ink-50"
                placeholder="Темы, которые регулярно всплывают. Неожиданные инсайты. Что я хочу подтвердить или оспорить с менеджером…"/>
              {!isLocked && (
                <QualityCoachBox
                  getDraft={() => sections.feedback360.notes || ''}
                  feedbackType="self_assessment"
                  competency="360 feedback reflection"
                  subjectEmployeeId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.employeeUuid(user.id) : null}
                  cycleId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.cycleUuid(cycleId) : null}
                  disabled={isLocked}
                  label="Проверить рефлексию по 360-фидбеку (AI-коуч)"
                />
              )}
            </div>
          </div>
        </Card>
      )}

      {sectionKey==='performance' && (
        <Card>
          <CardHead title="2. Individual Performance · WHAT"
                    subtitle="Что именно ты сделал в этом полугодии. Конкретика, цифры, масштаб. Не процесс, а результат."/>
          <LeadershipActionsImport
            employeeId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.employeeUuid(user.id) : null}
            cycle={null}
            achievementsText={sections.performance.achievements}
            onInsert={(text) => updateSection('performance', { achievements: text })}
          />
          <div className="p-5 space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-ink-500 font-semibold">Ключевые достижения <span className="text-rose-500">*</span></label>
              <textarea rows={6} disabled={isLocked}
                value={sections.performance.achievements}
                onChange={e=>updateSection('performance', { achievements: e.target.value })}
                className="mt-1 w-full rounded-lg border border-ink-200 p-3 text-sm outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 disabled:bg-ink-50"
                placeholder="3–5 вещей, которыми ты гордишься. Что сделал? Какой был impact? Примеры: «снизил latency на 38%», «закрыл $200K deal», «запустил v2 фичи с 12% uplift»…"/>
              {!isLocked && (
                <QualityCoachBox
                  getDraft={() => sections.performance.achievements || ''}
                  feedbackType="self_assessment"
                  competency="achievements / impact"
                  subjectEmployeeId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.employeeUuid(user.id) : null}
                  cycleId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.cycleUuid(cycleId) : null}
                  disabled={isLocked}
                  label="Проверить формулировку достижений (AI-коуч)"
                />
              )}
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-ink-500 font-semibold">Impact-метрики</label>
              <textarea rows={3} disabled={isLocked}
                value={sections.performance.metrics}
                onChange={e=>updateSection('performance', { metrics: e.target.value })}
                className="mt-1 w-full rounded-lg border border-ink-200 p-3 text-sm font-mono outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 disabled:bg-ink-50"
                placeholder="Revenue · Retention · Latency · Throughput · Quality · Velocity. Одна строка — одна метрика."/>
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-ink-500 font-semibold">Сложности и чему научился</label>
              <textarea rows={4} disabled={isLocked}
                value={sections.performance.challenges}
                onChange={e=>updateSection('performance', { challenges: e.target.value })}
                className="mt-1 w-full rounded-lg border border-ink-200 p-3 text-sm outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 disabled:bg-ink-50"
                placeholder="Где было тяжело? Что пришлось переделать? Что теперь знаешь лучше?"/>
              {!isLocked && (
                <QualityCoachBox
                  getDraft={() => sections.performance.challenges || ''}
                  feedbackType="self_assessment"
                  competency="challenges / lessons learned"
                  subjectEmployeeId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.employeeUuid(user.id) : null}
                  cycleId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.cycleUuid(cycleId) : null}
                  disabled={isLocked}
                  label="Проверить рефлексию о сложностях (AI-коуч)"
                />
              )}
            </div>
          </div>
        </Card>
      )}

      {sectionKey==='leadership' && (
        <Card>
          <CardHead title="3. Leadership Principles · HOW"
                    subtitle="Как ты работал — через призму ценностей Freedom AI Labs. Culture = как ты достигаешь результата."/>
          <div className="p-5 space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-ink-500 font-semibold">Какие values жил этот период <span className="text-rose-500">*</span></label>
              <input type="text" disabled={isLocked}
                value={sections.leadership.values}
                onChange={e=>updateSection('leadership', { values: e.target.value })}
                className="mt-1 w-full rounded-lg border border-ink-200 p-2.5 text-sm outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 disabled:bg-ink-50"
                placeholder="Например: Bias to action · Radical ownership · No bullshit"/>
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-ink-500 font-semibold">Конкретные поведения</label>
              <textarea rows={4} disabled={isLocked}
                value={sections.leadership.behaviors}
                onChange={e=>updateSection('leadership', { behaviors: e.target.value })}
                className="mt-1 w-full rounded-lg border border-ink-200 p-3 text-sm outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 disabled:bg-ink-50"
                placeholder="Ситуация — поведение — результат. «Когда Х случилось, я Y, что привело к Z.» Минимум 1–2 примера."/>
              {!isLocked && (
                <QualityCoachBox
                  getDraft={() => sections.leadership.behaviors || ''}
                  feedbackType="self_assessment"
                  competency="leadership behaviors (STAR)"
                  subjectEmployeeId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.employeeUuid(user.id) : null}
                  cycleId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.cycleUuid(cycleId) : null}
                  disabled={isLocked}
                  label="Проверить STAR-примеры поведения (AI-коуч)"
                />
              )}
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-ink-500 font-semibold">Коллаборация и помощь другим</label>
              <textarea rows={4} disabled={isLocked}
                value={sections.leadership.collaboration}
                onChange={e=>updateSection('leadership', { collaboration: e.target.value })}
                className="mt-1 w-full rounded-lg border border-ink-200 p-3 text-sm outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 disabled:bg-ink-50"
                placeholder="Кому помог, кого менторил, что сделал для команды вне своих прямых обязанностей"/>
              {!isLocked && (
                <QualityCoachBox
                  getDraft={() => sections.leadership.collaboration || ''}
                  feedbackType="self_assessment"
                  competency="collaboration / mentoring"
                  subjectEmployeeId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.employeeUuid(user.id) : null}
                  cycleId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.cycleUuid(cycleId) : null}
                  disabled={isLocked}
                  label="Проверить описание коллаборации (AI-коуч)"
                />
              )}
            </div>
          </div>
        </Card>
      )}

      {sectionKey==='outcome' && (
        <Card>
          <CardHead title="4. Outcome · Самооценка"
                    subtitle="Как ты сам оцениваешь этот период и что хочешь в следующем. Менеджер увидит это до калибровки."/>
          <div className="p-5 space-y-5">
            <div>
              <div className="text-xs uppercase tracking-wider text-ink-500 font-semibold mb-2">Мой overall grade</div>
              <div className="grid grid-cols-3 gap-2">
                {['A-player','Above bar','Underperformer'].map(g=>(
                  <button key={g} disabled={isLocked}
                    onClick={()=>updateSection('outcome', { selfGrade: g })}
                    className={`rounded-lg p-3 border-2 text-sm font-medium transition
                      ${sections.outcome.selfGrade===g
                        ? g==='A-player' ? 'border-emerald-500 bg-emerald-50 text-emerald-800'
                          : g==='Above bar' ? 'border-amber-500 bg-amber-50 text-amber-800'
                          : 'border-rose-500 bg-rose-50 text-rose-800'
                        : 'border-ink-100 bg-white text-ink-500 hover:border-ink-300'}
                      disabled:opacity-50`}>
                    {g}
                  </button>
                ))}
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-4">
              {[
                { key:'selfSkills',       label:'Skills'       },
                { key:'selfDeliverables', label:'Deliverables' },
                { key:'selfCulture',      label:'Culture'      },
              ].map(({key, label})=>(
                <div key={key}>
                  <div className="text-xs uppercase tracking-wider text-ink-500 font-semibold mb-2">{label}</div>
                  <select disabled={isLocked}
                    value={sections.outcome[key] || ''}
                    onChange={e=>updateSection('outcome', { [key]: e.target.value })}
                    className={`w-full rounded-lg border p-2.5 text-sm outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 disabled:bg-ink-50 ${sections.outcome[key] ? 'border-ink-200 text-ink-900' : 'border-amber-300 text-ink-400'}`}>
                    <option value="" disabled>— выбрать уровень —</option>
                    {MASTERY.map(m=><option key={m} value={m}>{m}</option>)}
                  </select>
                </div>
              ))}
            </div>

            <div>
              <label className="text-xs uppercase tracking-wider text-ink-500 font-semibold">Цели на следующее полугодие <span className="text-rose-500">*</span></label>
              <textarea rows={4} disabled={isLocked}
                value={sections.outcome.goalsNextPeriod}
                onChange={e=>updateSection('outcome', { goalsNextPeriod: e.target.value })}
                className="mt-1 w-full rounded-lg border border-ink-200 p-3 text-sm outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 disabled:bg-ink-50"
                placeholder="Что хочешь достичь в H2? Рост навыков, проекты, growth area. Конкретно — будет трекаться."/>
              {!isLocked && (
                <QualityCoachBox
                  getDraft={() => sections.outcome.goalsNextPeriod || ''}
                  feedbackType="self_assessment"
                  competency="goals for next period"
                  subjectEmployeeId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.employeeUuid(user.id) : null}
                  cycleId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.cycleUuid(cycleId) : null}
                  disabled={isLocked}
                  label="Проверить SMART-цели на H2 (AI-коуч)"
                />
              )}
            </div>
          </div>
        </Card>
      )}

      {sectionKey==='review' && (
        <Card>
          <CardHead title="5. Review · Финальная проверка"
                    subtitle="Проверь ответы. После Submit форма блокируется — дальнейшие правки только через менеджера."/>
          <div className="p-5 space-y-4">
            {[
              { title:'360 Feedback', body: sections.feedback360.notes || '—' },
              { title:'Individual Performance', body:
                <>
                  <div className="text-xs text-ink-500 mb-1">Достижения</div>
                  <div className="whitespace-pre-wrap mb-2">{sections.performance.achievements || '—'}</div>
                  <div className="text-xs text-ink-500 mb-1">Impact-метрики</div>
                  <div className="font-mono text-xs whitespace-pre-wrap mb-2">{sections.performance.metrics || '—'}</div>
                  <div className="text-xs text-ink-500 mb-1">Сложности</div>
                  <div className="whitespace-pre-wrap">{sections.performance.challenges || '—'}</div>
                </>
              },
              { title:'Leadership Principles', body:
                <>
                  <div className="text-xs text-ink-500 mb-1">Values</div>
                  <div className="mb-2">{sections.leadership.values || '—'}</div>
                  <div className="text-xs text-ink-500 mb-1">Поведения</div>
                  <div className="whitespace-pre-wrap mb-2">{sections.leadership.behaviors || '—'}</div>
                  <div className="text-xs text-ink-500 mb-1">Коллаборация</div>
                  <div className="whitespace-pre-wrap">{sections.leadership.collaboration || '—'}</div>
                </>
              },
              { title:'Outcome', body:
                <>
                  <div className="flex flex-wrap gap-1.5 mb-2">
                    <span className={gradeChip(sections.outcome.selfGrade)}>{sections.outcome.selfGrade}</span>
                    <span className={masteryChip(sections.outcome.selfSkills)}>S · {sections.outcome.selfSkills}</span>
                    <span className={masteryChip(sections.outcome.selfDeliverables)}>D · {sections.outcome.selfDeliverables}</span>
                    <span className={masteryChip(sections.outcome.selfCulture)}>C · {sections.outcome.selfCulture}</span>
                  </div>
                  <div className="text-xs text-ink-500 mb-1">Цели на H2</div>
                  <div className="whitespace-pre-wrap">{sections.outcome.goalsNextPeriod || '—'}</div>
                </>
              },
            ].map((s,i)=>(
              <div key={i} className="rounded-lg border border-ink-100 p-4">
                <div className="text-xs uppercase tracking-wider text-brand-700 font-semibold mb-2">{s.title}</div>
                <div className="text-sm text-ink-800">{s.body}</div>
              </div>
            ))}

            <div className="rounded-lg border border-brand-200 bg-brand-50/60 p-4">
              <label className="flex items-start gap-3 cursor-pointer">
                <input type="checkbox" disabled={isLocked}
                  checked={sections.review.agreed}
                  onChange={e=>updateSection('review', { agreed: e.target.checked })}
                  className="mt-1 w-4 h-4 accent-brand-600"/>
                <div className="text-sm text-ink-800">
                  <div className="font-medium">Я подтверждаю, что самооценка честная и полная</div>
                  <div className="text-xs text-ink-500 mt-0.5">Эта форма станет основой для Manager Assessment и калибровки. После Submit — редактирование только через менеджера.</div>
                </div>
              </label>
              <div className="mt-3 pl-7">
                <label className="text-xs uppercase tracking-wider text-ink-500 font-semibold">Подпись (ФИО + дата)</label>
                <input type="text" disabled={isLocked}
                  value={sections.review.signature}
                  onChange={e=>updateSection('review', { signature: e.target.value })}
                  className="mt-1 w-full rounded-lg border border-ink-200 p-2.5 text-sm outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 disabled:bg-ink-50"
                  placeholder={`${user.name} · ${new Date().toISOString().slice(0,10)}`}/>
              </div>
            </div>
          </div>
        </Card>
      )}

      {/* Footer nav */}
      <div className="flex items-center gap-3">
        <button onClick={()=>setActiveStep(Math.max(0, activeStep-1))} disabled={activeStep===0}
                className="h-9 px-4 rounded-md text-sm border border-ink-200 text-ink-700 hover:bg-ink-50 disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-2">
          <Icon name="arrow-left" className="w-4 h-4"/> Назад
        </button>
        <div className="flex-1 text-center text-xs text-ink-500">
          Шаг {activeStep+1} из {steps.length} · {steps[activeStep].label}
        </div>
        {activeStep < steps.length-1 ? (
          (() => {
            /* COMMIT_8 (bug 9): на шаге Outcome блокируем 'Дальше', пока не
               выбраны overall grade и три mastery-уровня. */
            const blockOutcomeForward = sectionKey === 'outcome' && !outcomeIsComplete();
            return (
              <button onClick={()=>!blockOutcomeForward && setActiveStep(Math.min(steps.length-1, activeStep+1))}
                      disabled={blockOutcomeForward}
                      title={blockOutcomeForward ? 'Сначала выбери overall grade и mastery-уровни Skills / Deliverables / Culture' : ''}
                      className="h-9 px-4 rounded-md text-sm bg-ink-900 text-white hover:bg-ink-800 disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-2">
                Дальше <Icon name="arrow-right" className="w-4 h-4"/>
              </button>
            );
          })()
        ) : (
          !isLocked && (
            <button onClick={handleSubmit}
                    className="h-9 px-4 rounded-md text-sm bg-brand-600 text-white hover:bg-brand-700 flex items-center gap-2 font-medium">
              <Icon name="check" className="w-4 h-4" stroke={2}/> Отправить менеджеру
            </button>
          )
        )}
      </div>
    </div>
  );
};

/* ───────── CALIBRATION · TALENT BAR ───────── */
const CalibrationPage = () => {
  const { store, user } = useApp();
  const cycleId = ACTIVE_CYCLE.id;
  const teams = useMemo(()=>{
    const map = {};
    PEOPLE.forEach(p=>{
      map[p.team]=map[p.team]||{t:p.team, n:0, a:0, b:0, u:0};
      map[p.team].n++;
      if (p.currentGrade==='A-player') map[p.team].a++;
      else if (p.currentGrade==='Above bar') map[p.team].b++;
      else map[p.team].u++;
    });
    return Object.values(map);
  },[]);
  const outliers = teams.filter(t=>t.a/t.n > 0.25);

  /* Outliers & аномалии — выводим из реальных данных. До первой калибровки список пустой. */
  const suspicious = store.state.talentBarPlacements
    .filter(pl => pl.cycleId === cycleId)
    .map(pl => {
      const person = byId(pl.employeeId);
      if (!person) return null;
      const mgr = byId(person.managerId);
      let issue = null;
      /* Сотрудник оценён выше bar минимума для своей seniority на ≥2 уровня */
      const h = HISTORY[pl.employeeId] || [];
      const aStreak = h.filter(x => x.overall === 'A-player').length;
      if (aStreak >= 4) issue = `${aStreak} полугодия подряд A-player — проверить calibration`;
      else if (h.length >= 2 && h[h.length-2]?.overall === 'Above bar' && pl.grade === 'Underperformer') {
        issue = 'Резкое падение Above bar → Underperformer';
      }
      if (!issue) return null;
      return { emp: pl.employeeId, issue, mgr: mgr?.role || '—' };
    })
    .filter(Boolean);

  /* Talent Bar grid state.
     COMMIT_5 (30 apr 2026): seniorityFilter заменён на trackFilter (IC/Manager/Support) —
     согласованно с новой Big Tech ladder. Старое поле seniority всё ещё доступно
     через personLevel(p).track деривацию. */
  const [trackFilter, setTrackFilter] = useState('All');
  const [teamFilter, setTF] = useState('All');
  const [selectedEmp, setSelectedEmp] = useState(null);

  /* AI: Calibration Pack Synthesizer — кэш пакетов по employeeId */
  const [packCache, setPackCache] = useState({});   /* { [employeeId]: { loading, error, result } } */
  const runCalibrationPack = async (employeeLegacyId) => {
    if (!employeeLegacyId) return;
    setPackCache(prev => ({ ...prev, [employeeLegacyId]: { ...(prev[employeeLegacyId]||{}), loading: true, error: null } }));
    try {
      if (!REVIEW_SYNC.isReady()) throw new Error('Supabase ещё не загрузился');
      const empUuid = REVIEW_SYNC.employeeUuid(employeeLegacyId);
      const cycUuid = REVIEW_SYNC.cycleUuid(cycleId);
      if (!empUuid || !cycUuid) throw new Error('Не удалось сопоставить сотрудника/цикл с Supabase');
      const out = await AI_COACH.calibrationPack(empUuid, cycUuid);
      setPackCache(prev => ({ ...prev, [employeeLegacyId]: { loading: false, error: null, result: out?.result || null } }));
    } catch (e) {
      const detail = e?.detail || e?.message || 'Ошибка AI-синтезатора пакета';
      setPackCache(prev => ({ ...prev, [employeeLegacyId]: { loading: false, error: detail, result: null } }));
    }
  };

  const teamsList = Array.from(new Set(PEOPLE.map(p=>p.team)));

  /* Filter people in scope of the grid */
  const peopleInScope = store.state.people.filter(p => p.active!==false && !p.placeholder)
    .filter(p => trackFilter==='All' || personLevel(p).track===trackFilter)
    .filter(p => teamFilter==='All' || p.team===teamFilter);

  /* Place each person in grid cell by latest (skills × deliverables) from HISTORY */
  const grid = {};
  MASTERY.forEach(r=>{ grid[r]={}; MASTERY.forEach(c=>{ grid[r][c]=[]; }); });
  peopleInScope.forEach(p=>{
    const hist = HISTORY[p.id];
    if (!hist || !hist.length) return;
    const h = hist[hist.length-1];
    grid[h.skills][h.deliverables].push(p);
  });

  /* A-player cap (15–25%) — reactive to seniority + team filter.
     Показываем бадж только когда есть достаточно отградуированных людей в скоупе,
     иначе до первой калибровки / на пустом срезе бадж будет «залипшим». */
  const scopeGraded = peopleInScope.filter(p => p.currentGrade);
  const scopeAPlayer = scopeGraded.filter(p => p.currentGrade==='A-player');
  const aPlayerPct = scopeGraded.length ? scopeAPlayer.length / scopeGraded.length : 0;
  const capEligible = scopeGraded.length >= 4; /* на срезах <4 чел. cap не информативен */
  const overCap = capEligible && aPlayerPct > 0.25;
  const underCap = capEligible && aPlayerPct < 0.15;

  /* Для верхних KPI-карточек считаем по всей активной базе (глобальный cap) */
  const globalGraded = store.state.people.filter(p => p.active!==false && !p.placeholder && p.currentGrade);
  const globalAPlayerPct = globalGraded.length
    ? globalGraded.filter(p => p.currentGrade==='A-player').length / globalGraded.length
    : 0;

  return (
    <div className="p-8 space-y-5 fade-in">
      <div className="grid md:grid-cols-4 gap-4">
        <Stat label="Команд в калибровке" value={teams.length} hint="Все отделы"/>
        <Stat label="Outliers" value={outliers.length} hint={outliers.length ? 'A-player > 25%' : 'нет превышений cap'}/>
        <Stat label="A-player cap" value={globalGraded.length ? `${Math.round(globalAPlayerPct*100)}%` : '—'} hint={globalGraded.length ? 'Цель: 15–25%' : 'ждём Calibration'}/>
        <Stat label="CEO approval" value={globalGraded.length ? 'в очереди' : 'ещё не время'} hint="5 июля 2026"/>
      </div>

      {/* Talent Bar Grid · Skills × Deliverables */}
      <Card>
        <CardHead title="Talent Bar · Skills × Deliverables"
          subtitle={`H1 2026 · ${peopleInScope.length} сотрудников · Talent Bar проходит по минимальному уровню для текущего level (см. TALENT_BAR)`}
          right={
            <div className="flex items-center gap-2 flex-wrap">
              <div className="flex items-center gap-1 bg-ink-50 rounded-lg p-1">
                {[
                  ['All', 'Все'],
                  ['IC',  'IC'],
                  ['Manager', 'Manager'],
                  ['Support', 'Support'],
                ].map(([key, label])=>(
                  <button key={key} onClick={()=>setTrackFilter(key)}
                          className={`text-xs px-2.5 py-1 rounded-md whitespace-nowrap ${trackFilter===key?'bg-white shadow-card font-semibold':'text-ink-600 hover:text-ink-900'}`}>{label}</button>
                ))}
              </div>
              <div className="flex items-center gap-1 bg-ink-50 rounded-lg p-1 max-w-[340px] overflow-x-auto scrollbar">
                {['All',...teamsList].map(t=>(
                  <button key={t} onClick={()=>setTF(t)} className={`text-xs px-2.5 py-1 rounded-md whitespace-nowrap ${teamFilter===t?'bg-white shadow-card font-semibold':'text-ink-600 hover:text-ink-900'}`}>{t}</button>
                ))}
              </div>
              {overCap && <span className="text-[10px] font-bold uppercase bg-rose-100 text-rose-700 rounded px-2 py-1">CAP EXCEEDED · {Math.round(aPlayerPct*100)}%</span>}
              {underCap && <span className="text-[10px] font-bold uppercase bg-amber-100 text-amber-700 rounded px-2 py-1">A-player ниже 15%</span>}
            </div>
          }/>
        <div className="p-5 overflow-x-auto scrollbar">
          <div className="inline-grid gap-1.5" style={{gridTemplateColumns:`auto repeat(${MASTERY.length}, minmax(160px, 1fr))`}}>
            <div></div>
            {MASTERY.map(c=>(
              <div key={c} className="text-center pb-2">
                <span className={masteryChip(c)}>{c}</span>
                <div className="text-[10px] text-ink-400 mt-1">Deliverables →</div>
              </div>
            ))}
            {[...MASTERY].reverse().map(r=>(
              <Fragment key={r}>
                <div className="flex items-center pr-2">
                  <div className="text-right">
                    <span className={masteryChip(r)}>{r}</span>
                    <div className="text-[10px] text-ink-400">Skills ↑</div>
                  </div>
                </div>
                {MASTERY.map(c=>{
                  const cell = grid[r][c];
                  const rs = MASTERY_SCORE[r], cs = MASTERY_SCORE[c];
                  const avg = (rs+cs)/2;
                  let tone = 'bg-ink-50';
                  if (avg >= 4.5) tone='bg-emerald-50 ring-emerald-200';
                  else if (avg >= 3.5) tone='bg-emerald-50/60 ring-emerald-100';
                  else if (avg >= 2.5) tone='bg-amber-50 ring-amber-100';
                  else if (avg >= 1.5) tone='bg-rose-50 ring-rose-100';
                  else tone='bg-rose-100 ring-rose-200';
                  return (
                    <div key={c} className={`rounded-xl p-2.5 ring-1 ${tone} min-h-[110px]`}>
                      <div className="text-[10px] font-semibold text-ink-500 mb-1">{cell.length}</div>
                      <div className="flex flex-wrap gap-1">
                        {cell.slice(0,12).map(p=>(
                          <button key={p.id}
                            onClick={()=> setSelectedEmp(selectedEmp===p.id?null:p.id)}
                            title={`${p.name} · ${p.seniority} · ${p.team}`}
                            className={`${selectedEmp===p.id?'ring-2 ring-brand-500 rounded-full':''} hover:scale-110 transition`}>
                            <Avatar p={p} size={22}/>
                          </button>
                        ))}
                        {cell.length>12 && <span className="text-[10px] text-ink-500 self-center">+{cell.length-12}</span>}
                      </div>
                    </div>
                  );
                })}
              </Fragment>
            ))}
          </div>
          <div className="flex items-center gap-4 text-xs text-ink-500 mt-4 flex-wrap">
            <div className="flex items-center gap-1.5"><div className="w-3 h-3 rounded bg-emerald-200"></div>A-player zone · promo track</div>
            <div className="flex items-center gap-1.5"><div className="w-3 h-3 rounded bg-amber-200"></div>Above bar · retention</div>
            <div className="flex items-center gap-1.5"><div className="w-3 h-3 rounded bg-rose-200"></div>Underperformer · BoT</div>
            <div className="ml-auto text-ink-400">Клик на аватар — выбрать сотрудника</div>
          </div>
        </div>
      </Card>

      <Card>
        <CardHead title="Доля A-players по командам" subtitle="Правило: не более 25% от штата команды"/>
        <div className="p-5">
          <div className="space-y-3">
            {teams.sort((a,b)=>(b.a/b.n)-(a.a/a.n)).map(t=>{
              const apct = t.a/t.n, bpct = t.b/t.n, upct = t.u/t.n;
              const overCap = apct > 0.25;
              return (
                <div key={t.t} className="grid grid-cols-[160px_1fr_80px_60px] items-center gap-3">
                  <div className="font-semibold text-sm">{t.t}</div>
                  <div className="h-6 rounded-full bg-ink-100 overflow-hidden flex">
                    <div className="bg-emerald-500 h-full flex items-center justify-center text-[10px] text-white font-bold" style={{width:`${apct*100}%`}}>{t.a>0 && `${t.a}`}</div>
                    <div className="bg-amber-500 h-full flex items-center justify-center text-[10px] text-white font-bold" style={{width:`${bpct*100}%`}}>{t.b>0 && `${t.b}`}</div>
                    <div className="bg-rose-500 h-full flex items-center justify-center text-[10px] text-white font-bold" style={{width:`${upct*100}%`}}>{t.u>0 && `${t.u}`}</div>
                  </div>
                  <div className={`text-right text-sm font-mono ${overCap?'text-rose-600 font-bold':''}`}>{Math.round(apct*100)}%</div>
                  <div>{overCap && <span className="text-[10px] font-bold uppercase bg-rose-100 text-rose-700 rounded px-1.5 py-0.5">cap</span>}</div>
                </div>
              );
            })}
          </div>
          <div className="mt-6 flex items-center gap-4 text-xs">
            <div className="flex items-center gap-1.5"><div className="w-2.5 h-2.5 rounded bg-emerald-500"></div> A-player</div>
            <div className="flex items-center gap-1.5"><div className="w-2.5 h-2.5 rounded bg-amber-500"></div> Above bar</div>
            <div className="flex items-center gap-1.5"><div className="w-2.5 h-2.5 rounded bg-rose-500"></div> Underperformer</div>
          </div>
        </div>
      </Card>

      <div className="grid md:grid-cols-2 gap-5">
        <Card>
          <CardHead title="Outliers & аномалии" subtitle="Требуют проверки Performance Team"/>
          <div className="divide-y divide-ink-100">
            {suspicious.length === 0 ? (
              <div className="p-8 text-center">
                <Icon name="check" className="w-8 h-8 text-ink-300 mx-auto mb-2"/>
                <div className="text-sm font-semibold text-ink-700">Outliers пока нет</div>
                <div className="text-xs text-ink-500 mt-1">Список появится после завершения Manager Assessment и Calibration · Talent Bar review.</div>
              </div>
            ) : suspicious.map((s,i)=>{
              const p = byId(s.emp);
              return (
                <div key={i} className="p-4 flex items-center gap-3">
                  <Avatar p={p} size={36}/>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <div className="font-semibold text-sm truncate">{p.name}</div>
                      {p.currentGrade && <span className={gradeChip(p.currentGrade)}>{p.currentGrade}</span>}
                    </div>
                    <div className="text-xs text-ink-500 mt-0.5">{s.issue}</div>
                    <div className="text-[11px] text-ink-400 mt-0.5">Manager: {s.mgr}</div>
                  </div>
                  <div className="flex gap-1.5">
                    <button className="h-8 px-2.5 rounded-lg bg-ink-50 text-xs text-ink-700 hover:bg-ink-100">Обсудить</button>
                    <button className="h-8 px-2.5 rounded-lg bg-brand-600 text-white text-xs font-semibold hover:bg-brand-700">Корректировать</button>
                  </div>
                </div>
              );
            })}
          </div>
        </Card>

        <Card>
          <CardHead title="Manager bias report" subtitle="Сравнение оценок менеджеров vs cohort"/>
          {(() => {
            /* Считаем bias только когда есть реальные Manager Assessments по текущему циклу */
            const cycleAssessments = store.state.managerAssessments.filter(m => m.cycleId === cycleId && (m.status === 'submitted' || m.status === 'locked'));
            if (cycleAssessments.length === 0) {
              return (
                <div className="p-8 text-center">
                  <Icon name="badge" className="w-8 h-8 text-ink-300 mx-auto mb-2"/>
                  <div className="text-sm font-semibold text-ink-700">Manager Assessment ещё не собран</div>
                  <div className="text-xs text-ink-500 mt-1">Bias-отчёт появится автоматически, когда менеджеры подадут оценки в фазу Manager Assessment (15–28 июня).</div>
                </div>
              );
            }
            /* Аггрегируем по managerId: средняя derivedGrade-оценка vs cohort */
            const gradeScore = g => g === 'A-player' ? 5 : g === 'Above bar' ? 3 : g === 'Underperformer' ? 1 : null;
            const cohortAvg = (() => {
              const scores = cycleAssessments.map(m => gradeScore(m.derivedGrade)).filter(s => s !== null);
              return scores.length ? scores.reduce((a,b)=>a+b,0)/scores.length : 0;
            })();
            const byMgr = {};
            cycleAssessments.forEach(m => {
              const s = gradeScore(m.derivedGrade);
              if (s === null) return;
              byMgr[m.managerId] = byMgr[m.managerId] || { scores:[] };
              byMgr[m.managerId].scores.push(s);
            });
            const rows = Object.entries(byMgr).map(([mid, v]) => {
              const avg = v.scores.reduce((a,b)=>a+b,0)/v.scores.length;
              const bias = avg - cohortAvg;
              const mgr = byId(mid);
              return { m: mgr?.role || mid, avg, n: v.scores.length, bias, flag: Math.abs(bias) >= 0.5 };
            });
            return (
              <div className="p-5 space-y-3">
                {rows.map(b=>(
                  <div key={b.m} className="grid grid-cols-[1fr_70px_70px_80px] items-center gap-3 text-sm">
                    <div>
                      <div className="font-semibold flex items-center gap-2">{b.m}{b.flag && <span className="text-[10px] bg-amber-100 text-amber-700 rounded px-1.5 py-0.5 font-bold uppercase">check</span>}</div>
                      <div className="text-xs text-ink-500">{b.n} {b.n===1?'оценка':'оценок'}</div>
                    </div>
                    <div className="text-right font-mono">{b.avg.toFixed(1)}</div>
                    <div className="text-right font-mono text-ink-500">{cohortAvg.toFixed(1)}</div>
                    <div className={`text-right font-mono font-bold ${b.bias>0?'text-emerald-600':b.bias===0?'text-ink-500':'text-rose-600'}`}>{b.bias>=0?'+':'−'}{Math.abs(b.bias).toFixed(1)}</div>
                  </div>
                ))}
              </div>
            );
          })()}
        </Card>
      </div>

      {/* AI Calibration Pack Synthesizer — появляется, когда выбран сотрудник */}
      {selectedEmp && (() => {
        const p = byId(selectedEmp);
        if (!p) return null;
        const entry = packCache[selectedEmp] || {};
        const { loading, error, result } = entry;
        return (
          <Card>
            <CardHead
              title={`AI Calibration Pack · ${p.name}`}
              subtitle="1-страничный дайджест для Talent Bar: self-рейтинг, derivedGrade менеджера, темы 360, рекомендуемая ячейка. Логируется в app.calibration_packs."
              right={
                <div className="flex items-center gap-2">
                  <button type="button" onClick={()=>runCalibrationPack(selectedEmp)} disabled={loading}
                    className="h-8 px-3 rounded-lg bg-brand-600 text-white text-xs font-semibold hover:bg-brand-700 disabled:bg-ink-200 disabled:cursor-not-allowed flex items-center gap-1">
                    <Icon name="sparkle" className="w-3.5 h-3.5"/>
                    {loading ? 'Синтезирую…' : (result ? 'Пересинтезировать' : 'Собрать пакет')}
                  </button>
                  <button type="button" onClick={()=>setSelectedEmp(null)}
                    className="h-8 px-3 rounded-lg bg-ink-50 text-xs text-ink-700 hover:bg-ink-100">Закрыть</button>
                </div>
              }/>
            <div className="p-5 space-y-4">
              {!result && !error && !loading && (
                <div className="rounded-lg border border-dashed border-ink-200 bg-ink-50/30 p-4 text-xs text-ink-500">
                  Нажмите «Собрать пакет» — AI соберёт self-assessment, manager assessment, 360 ответы, evidence-ledger и предложит ячейку Talent Bar.
                  Пакет — подсказка для обсуждения, финальное решение за калибровочной встречей.
                </div>
              )}
              {loading && (
                <div className="text-sm text-ink-500 flex items-center gap-2"><Icon name="sparkle" className="w-4 h-4 animate-pulse text-brand-500"/>Собираю input → self / manager / 360 / evidence…</div>
              )}
              {error && (
                <div className="p-3 rounded-lg bg-rose-50 border border-rose-200 text-xs text-rose-700">{error}</div>
              )}
              {result && (
                <div className="space-y-4">
                  {result.summary && (
                    <div className="rounded-lg border border-brand-200 bg-brand-50/40 p-3 text-sm text-ink-800">
                      <div className="text-[11px] uppercase tracking-wider text-brand-700 font-bold mb-1">Executive summary</div>
                      {result.summary}
                    </div>
                  )}
                  <div className="grid md:grid-cols-3 gap-3 text-xs">
                    {result.recommended_talent_box && (
                      <div className="rounded-lg border border-ink-100 p-3">
                        <div className="text-[10px] uppercase tracking-wider text-ink-500 font-bold">AI рекомендация Talent Bar</div>
                        <div className="text-sm font-bold text-ink-900 mt-1">{result.recommended_talent_box.label || result.recommended_talent_box}</div>
                        {result.recommended_talent_box.confidence && (
                          <div className="text-[10px] text-ink-500 mt-1">Confidence: {result.recommended_talent_box.confidence}</div>
                        )}
                      </div>
                    )}
                    {result.self_rating && (
                      <div className="rounded-lg border border-ink-100 p-3">
                        <div className="text-[10px] uppercase tracking-wider text-ink-500 font-bold">Self rating</div>
                        <div className="text-sm font-bold text-ink-900 mt-1">{typeof result.self_rating === 'string' ? result.self_rating : JSON.stringify(result.self_rating)}</div>
                      </div>
                    )}
                    {result.manager_rating && (
                      <div className="rounded-lg border border-ink-100 p-3">
                        <div className="text-[10px] uppercase tracking-wider text-ink-500 font-bold">Manager rating</div>
                        <div className="text-sm font-bold text-ink-900 mt-1">{typeof result.manager_rating === 'string' ? result.manager_rating : JSON.stringify(result.manager_rating)}</div>
                      </div>
                    )}
                  </div>
                  {Array.isArray(result.strengths) && result.strengths.length > 0 && (
                    <div>
                      <div className="text-[11px] uppercase tracking-wider text-emerald-700 font-bold mb-1">Сильные стороны</div>
                      <ul className="space-y-1 text-xs text-ink-700">
                        {result.strengths.map((s, i) => <li key={i} className="flex gap-2"><span className="text-emerald-500">✓</span><span>{typeof s === 'string' ? s : s.description}</span></li>)}
                      </ul>
                    </div>
                  )}
                  {Array.isArray(result.growth_areas) && result.growth_areas.length > 0 && (
                    <div>
                      <div className="text-[11px] uppercase tracking-wider text-amber-700 font-bold mb-1">Growth areas</div>
                      <ul className="space-y-1 text-xs text-ink-700">
                        {result.growth_areas.map((s, i) => <li key={i} className="flex gap-2"><span className="text-amber-500">→</span><span>{typeof s === 'string' ? s : s.description}</span></li>)}
                      </ul>
                    </div>
                  )}
                  {Array.isArray(result.open_questions) && result.open_questions.length > 0 && (
                    <div className="rounded-lg bg-amber-50 border border-amber-200 p-3">
                      <div className="text-[11px] uppercase tracking-wider text-amber-900 font-bold mb-1">Вопросы к калибровочной встрече</div>
                      <ul className="space-y-1 text-xs text-amber-900">
                        {result.open_questions.map((q, i) => <li key={i}>• {typeof q === 'string' ? q : q.question}</li>)}
                      </ul>
                    </div>
                  )}
                  {Array.isArray(result.evidence) && result.evidence.length > 0 && (
                    <div>
                      <div className="text-[11px] uppercase tracking-wider text-ink-500 font-bold mb-1">Evidence ({result.evidence.length})</div>
                      <div className="space-y-1 max-h-[220px] overflow-y-auto">
                        {result.evidence.slice(0, 12).map((ev, i) => (
                          <div key={i} className="text-[11px] rounded-md bg-ink-50 border border-ink-100 p-2">
                            <div className="font-semibold text-ink-700">{ev.source || ev.source_type || 'evidence'}</div>
                            <div className="text-ink-600 line-clamp-2">{ev.summary || ev.text || ev.description}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <div className="text-[10px] text-ink-400 italic border-t border-ink-100 pt-2">AI-пакет — рекомендация, не решение. Финал за калибровкой. Вызов залогирован в app.ai_invocations и app.calibration_packs.</div>
                </div>
              )}
            </div>
          </Card>
        );
      })()}
    </div>
  );
};

/* ───────── HOLD PERFORMANCE CONVERSATION (Gate before Development/BoT) ───────── */
const ConversationsPage = ({ onOpen }) => {
  const { user, store } = useApp();
  const perms = permissions(user, store.state.people);
  const cycleId = ACTIVE_CYCLE.id;
  const isPerf = perms.fullAccess;
  const myDirects = directs(user.id);
  const isMgr = myDirects.length > 0 || perms.sysRole === 'manager';

  const [filter, setFilter] = useState('all');       /* all | pending | scheduled | held | acknowledged */
  const [scope, setScope] = useState(isPerf ? 'company' : 'team'); /* company | team | me */
  const [openConv, setOpenConv] = useState(null);     /* employeeId для модалки */
  const [scheduleFor, setScheduleFor] = useState(null); /* employeeId для schedule modal */
  const [ackFor, setAckFor] = useState(null);        /* employeeId — модалка подтверждения сотрудником */

  /* Конверсии в области видимости */
  const relevantPeople = (() => {
    if (scope==='company') return store.state.people.filter(p=>p.active);
    if (scope==='team') return store.state.people.filter(p=>p.active && myDirects.some(d=>d.id===p.id));
    return store.state.people.filter(p=>p.active && p.id===user.id);
  })();

  const rows = relevantPeople.map(p => {
    const ma = store.state.managerAssessments.find(m => m.employeeId===p.id && m.cycleId===cycleId);
    const placement = store.state.talentBarPlacements.find(x => x.employeeId===p.id && x.cycleId===cycleId);
    const conv = store.state.conversations.find(c => c.employeeId===p.id && c.cycleId===cycleId);
    const status = conv?.status || 'pending';
    const maReady = !!ma && (ma.status==='submitted' || ma.status==='locked');
    const calibrated = !!placement;
    const gateOpen = status==='acknowledged'; /* Development / BoT доступны только после acknowledged */
    return { person: p, ma, placement, conv, status, maReady, calibrated, gateOpen };
  });

  const filtered = rows.filter(r => filter==='all' ? true : r.status===filter);

  const counts = {
    all: rows.length,
    pending: rows.filter(r=>r.status==='pending').length,
    scheduled: rows.filter(r=>r.status==='scheduled').length,
    held: rows.filter(r=>r.status==='held').length,
    acknowledged: rows.filter(r=>r.status==='acknowledged').length,
  };

  const STATUS_TONE = {
    pending:      { bg:'bg-ink-100',     fg:'text-ink-700',     label:'Не начата',         dot:'bg-ink-400' },
    scheduled:    { bg:'bg-amber-100',   fg:'text-amber-800',   label:'Запланирована',     dot:'bg-amber-500' },
    held:         { bg:'bg-blue-100',    fg:'text-blue-800',    label:'Проведена · ждём ack', dot:'bg-blue-500' },
    acknowledged: { bg:'bg-emerald-100', fg:'text-emerald-800', label:'Подтверждена',      dot:'bg-emerald-500' },
  };

  const selectedRow = openConv ? rows.find(r => r.person.id===openConv) : null;
  const ackRow      = ackFor   ? rows.find(r => r.person.id===ackFor)   : null;
  const schedRow    = scheduleFor ? rows.find(r => r.person.id===scheduleFor) : null;

  /* локальное состояние модалки Hold */
  const [draftNotes, setDraftNotes] = useState('');
  const [draftNext, setDraftNext]   = useState('development');
  const [signed, setSigned]         = useState(false);

  useEffect(()=>{
    if (selectedRow) {
      setDraftNotes(selectedRow.conv?.notes || '');
      setDraftNext(selectedRow.conv?.nextStep || (selectedRow.person.currentGrade==='Underperformer' ? 'bot' : 'development'));
      setSigned(selectedRow.status==='held' || selectedRow.status==='acknowledged');
    }
  }, [openConv]);

  const [schedWhen, setSchedWhen] = useState('');
  useEffect(()=>{
    if (schedRow) setSchedWhen(schedRow.conv?.scheduledAt || '2026-07-10 15:00');
  }, [scheduleFor]);

  const [ackNote, setAckNote] = useState('');
  useEffect(()=>{
    if (ackRow) setAckNote(ackRow.conv?.acknowledgedNote || '');
  }, [ackFor]);

  return (
    <div className="p-6 space-y-5">
      {/* Header / overview */}
      <Card>
        <CardHead
          title="Hold Performance Conversation"
          subtitle={`${ACTIVE_CYCLE.name} · обязательный 1:1 debrief · gate перед Development Plan / BoT`}
        >
          <span className="text-xs px-2 py-1 rounded bg-amber-100 text-amber-800 font-semibold">Gate активен</span>
        </CardHead>
        <div className="p-5 grid grid-cols-2 md:grid-cols-5 gap-3">
          <div className="rounded-xl border border-ink-100 bg-white px-4 py-3">
            <div className="text-[11px] uppercase text-ink-400 tracking-wide">Всего</div>
            <div className="text-2xl font-semibold text-ink-900">{counts.all}</div>
          </div>
          <div className="rounded-xl border border-ink-200 bg-ink-50 px-4 py-3">
            <div className="text-[11px] uppercase text-ink-500 tracking-wide">Не начаты</div>
            <div className="text-2xl font-semibold text-ink-700">{counts.pending}</div>
          </div>
          <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
            <div className="text-[11px] uppercase text-amber-700 tracking-wide">Запланированы</div>
            <div className="text-2xl font-semibold text-amber-700">{counts.scheduled}</div>
          </div>
          <div className="rounded-xl border border-blue-200 bg-blue-50 px-4 py-3">
            <div className="text-[11px] uppercase text-blue-700 tracking-wide">Проведены · ждём ack</div>
            <div className="text-2xl font-semibold text-blue-700">{counts.held}</div>
          </div>
          <div className="rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3">
            <div className="text-[11px] uppercase text-emerald-700 tracking-wide">Подтверждены</div>
            <div className="text-2xl font-semibold text-emerald-700">{counts.acknowledged}</div>
          </div>
        </div>
        <div className="px-5 pb-5 flex flex-wrap items-center gap-2 justify-between border-t border-ink-100 pt-4">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-xs text-ink-500 font-semibold uppercase tracking-wider">Scope</span>
            {isPerf && <button onClick={()=>setScope('company')} className={`h-8 px-3 rounded-lg border text-xs font-semibold ${scope==='company'?'bg-brand-600 text-white border-brand-600':'border-ink-200 text-ink-700 hover:bg-ink-50'}`}>Вся компания</button>}
            {isMgr  && <button onClick={()=>setScope('team')}    className={`h-8 px-3 rounded-lg border text-xs font-semibold ${scope==='team'   ?'bg-brand-600 text-white border-brand-600':'border-ink-200 text-ink-700 hover:bg-ink-50'}`}>Моя команда</button>}
            <button onClick={()=>setScope('me')} className={`h-8 px-3 rounded-lg border text-xs font-semibold ${scope==='me'?'bg-brand-600 text-white border-brand-600':'border-ink-200 text-ink-700 hover:bg-ink-50'}`}>Я (как сотрудник)</button>
          </div>
          <div className="flex items-center gap-1.5 flex-wrap">
            {['all','pending','scheduled','held','acknowledged'].map(k => (
              <button key={k} onClick={()=>setFilter(k)}
                className={`h-8 px-3 rounded-lg border text-xs font-semibold capitalize ${filter===k?'bg-ink-900 text-white border-ink-900':'border-ink-200 text-ink-700 hover:bg-ink-50'}`}>
                {k==='all'?'Все':STATUS_TONE[k]?.label || k} · {counts[k]}
              </button>
            ))}
          </div>
        </div>
      </Card>

      {/* Main table */}
      <Card>
        <CardHead title="1:1 Debriefs" subtitle="Менеджер проводит, сотрудник подтверждает"/>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-ink-50 border-b border-ink-100 text-ink-500 text-[11px] uppercase tracking-wider">
                <th className="text-left px-5 py-2.5">Сотрудник</th>
                <th className="text-left px-3 py-2.5">Grade</th>
                <th className="text-left px-3 py-2.5">Talent Bar</th>
                <th className="text-left px-3 py-2.5">MA</th>
                <th className="text-left px-3 py-2.5">Статус 1:1</th>
                <th className="text-left px-3 py-2.5">Когда</th>
                <th className="text-left px-3 py-2.5">Next step</th>
                <th className="text-right px-5 py-2.5">Действия</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(r => {
                const tone = STATUS_TONE[r.status];
                const place = r.placement ? r.placement.grade : '—';
                const canHold = r.maReady && r.calibrated && user.id===r.person.manager;
                const canAck  = r.status==='held' && user.id===r.person.id;
                return (
                  <tr key={r.person.id} className="border-b border-ink-100 hover:bg-ink-50/40">
                    <td className="px-5 py-3">
                      <button onClick={()=>onOpen && onOpen(r.person.id)} className="text-left">
                        <div className="font-semibold text-ink-900">{r.person.name || 'TBD'}</div>
                        <div className="text-[11px] text-ink-500">{r.person.role} · {r.person.team}</div>
                      </button>
                    </td>
                    <td className="px-3 py-3">
                      <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold ${
                        r.person.currentGrade==='A-player'?'bg-emerald-100 text-emerald-700':
                        r.person.currentGrade==='Above bar'?'bg-brand-100 text-brand-700':
                        r.person.currentGrade==='Underperformer'?'bg-rose-100 text-rose-700':'bg-ink-100 text-ink-700'}`}>{r.person.currentGrade || '—'}</span>
                    </td>
                    <td className="px-3 py-3 text-xs text-ink-600 font-mono">{place}</td>
                    <td className="px-3 py-3 text-xs">
                      {r.maReady
                        ? <span className="text-emerald-700 font-semibold">✓ submitted</span>
                        : <span className="text-amber-700 font-semibold">waiting</span>}
                    </td>
                    <td className="px-3 py-3">
                      <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-[11px] font-semibold ${tone.bg} ${tone.fg}`}>
                        <span className={`w-1.5 h-1.5 rounded-full ${tone.dot}`}></span>
                        {tone.label}
                      </span>
                    </td>
                    <td className="px-3 py-3 text-xs text-ink-600 font-mono">
                      {r.conv?.heldAt || r.conv?.scheduledAt || '—'}
                    </td>
                    <td className="px-3 py-3">
                      {r.gateOpen
                        ? <span className={`text-[11px] px-2 py-0.5 rounded font-semibold ${r.conv?.nextStep==='bot'?'bg-rose-100 text-rose-700':'bg-emerald-100 text-emerald-700'}`}>
                            {r.conv?.nextStep==='bot' ? 'BoT · 6 нед' : 'Dev Plan · H2'}
                          </span>
                        : <span className="text-[11px] text-ink-400">🔒 закрыто</span>}
                    </td>
                    <td className="px-5 py-3 text-right">
                      <div className="inline-flex gap-1.5">
                        {!r.maReady && <span className="text-[11px] text-ink-400 italic">MA не готов</span>}
                        {r.maReady && !r.calibrated && <span className="text-[11px] text-ink-400 italic">нет Talent Bar</span>}
                        {r.maReady && r.calibrated && r.status==='pending' && user.id===r.person.manager && (
                          <button onClick={()=>setScheduleFor(r.person.id)} className="h-7 px-2.5 rounded-md border border-ink-200 text-ink-700 hover:bg-ink-50 text-[11px] font-semibold">Запланировать</button>
                        )}
                        {r.maReady && r.calibrated && canHold && (r.status==='pending' || r.status==='scheduled') && (
                          <button onClick={()=>setOpenConv(r.person.id)} className="h-7 px-2.5 rounded-md bg-brand-600 text-white text-[11px] font-semibold hover:bg-brand-700">Провести 1:1</button>
                        )}
                        {(r.status==='held' || r.status==='acknowledged') && (
                          <button onClick={()=>setOpenConv(r.person.id)} className="h-7 px-2.5 rounded-md border border-ink-200 text-ink-700 hover:bg-ink-50 text-[11px] font-semibold">Открыть</button>
                        )}
                        {canAck && (
                          <button onClick={()=>setAckFor(r.person.id)} className="h-7 px-2.5 rounded-md bg-emerald-600 text-white text-[11px] font-semibold hover:bg-emerald-700">Подтвердить</button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
              {filtered.length===0 && (
                <tr><td colSpan={8} className="px-5 py-10 text-center text-sm text-ink-500">Нет подходящих записей</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Gate summary */}
      <Card>
        <CardHead title="Правила Gate" subtitle="Hold Conversation = обязательный шаг"/>
        <div className="p-5 grid grid-cols-1 md:grid-cols-3 gap-3">
          <div className="rounded-xl border border-ink-100 bg-white p-4">
            <div className="text-xs uppercase tracking-wide text-ink-400 mb-1">Шаг 1 — Менеджер</div>
            <div className="font-semibold text-ink-900 mb-1">Провести 1:1</div>
            <div className="text-sm text-ink-600">Донести финальный grade, обсудить сильные/слабые стороны, Talent Bar placement. Зафиксировать notes и выбрать next step: Development Plan или BoT.</div>
          </div>
          <div className="rounded-xl border border-ink-100 bg-white p-4">
            <div className="text-xs uppercase tracking-wide text-ink-400 mb-1">Шаг 2 — Сотрудник</div>
            <div className="font-semibold text-ink-900 mb-1">Подтвердить debrief</div>
            <div className="text-sm text-ink-600">Acknowledge = я был на разговоре, grade/feedback услышан. Можно добавить комментарий или возражение. Без этого цикл не закрывается.</div>
          </div>
          <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-4">
            <div className="text-xs uppercase tracking-wide text-emerald-700 mb-1">Шаг 3 — Разблокируется</div>
            <div className="font-semibold text-emerald-900 mb-1">Development Plan / BoT</div>
            <div className="text-sm text-emerald-800">После acknowledged: performers получают доступ к Development Plan (2–3 SMART-цели на H2), underperformers — к BoT (6-нед PIP с halfway + final).</div>
          </div>
        </div>
      </Card>

      {/* Modal: schedule */}
      <Modal open={!!scheduleFor} onClose={()=>setScheduleFor(null)} title={`Запланировать 1:1 · ${schedRow?.person.name || ''}`}>
        <div className="space-y-3">
          <div className="text-sm text-ink-600">Выберите дату и время разговора. Сотруднику отправится уведомление.</div>
          <input type="text" value={schedWhen} onChange={e=>setSchedWhen(e.target.value)} placeholder="2026-07-10 15:00" className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm font-mono"/>
          <div className="flex justify-end gap-2">
            <button onClick={()=>setScheduleFor(null)} className="h-9 px-3 rounded-lg border border-ink-200 text-sm">Отмена</button>
            <button onClick={()=>{ store.scheduleConversation(schedRow.person.id, cycleId, schedWhen, user.name||'Manager'); setScheduleFor(null); }} className="h-9 px-3 rounded-lg bg-brand-600 text-white text-sm font-semibold">Запланировать</button>
          </div>
        </div>
      </Modal>

      {/* Modal: Hold conversation */}
      <Modal open={!!openConv} onClose={()=>setOpenConv(null)} title={selectedRow ? `1:1 Debrief · ${selectedRow.person.name || 'TBD'}` : ''}>
        {selectedRow && (
          <div className="space-y-4">
            {/* Context recap */}
            <div className="rounded-xl border border-ink-100 bg-ink-50/60 p-3 space-y-1.5 text-sm">
              <div className="flex justify-between"><span className="text-ink-500">Финальный grade</span>
                <span className={`px-1.5 py-0.5 rounded font-bold text-[11px] ${
                  selectedRow.person.currentGrade==='A-player'?'bg-emerald-100 text-emerald-700':
                  selectedRow.person.currentGrade==='Above bar'?'bg-brand-100 text-brand-700':
                  selectedRow.person.currentGrade==='Underperformer'?'bg-rose-100 text-rose-700':'bg-ink-100 text-ink-700'}`}>{selectedRow.person.currentGrade}</span></div>
              <div className="flex justify-between"><span className="text-ink-500">Talent Bar placement</span>
                <span className="font-mono text-ink-800">{selectedRow.placement ? selectedRow.placement.grade : '—'}</span></div>
              <div className="flex justify-between"><span className="text-ink-500">Manager Assessment</span>
                <span className="text-emerald-700 font-semibold">✓ submitted</span></div>
              {selectedRow.ma?.comments?.overall && (
                <div className="pt-2 border-t border-ink-200 mt-2 text-ink-700 italic">«{selectedRow.ma.comments.overall}»</div>
              )}
            </div>

            {/* Notes */}
            <div>
              <div className="text-sm font-semibold text-ink-900 mb-1">Notes из разговора</div>
              <textarea
                disabled={selectedRow.status==='acknowledged'}
                value={draftNotes}
                onChange={e=>setDraftNotes(e.target.value)}
                rows={5}
                placeholder="Что обсудили: сильные стороны, зоны роста, реакция сотрудника, договорённости."
                className={`w-full rounded-lg border border-ink-200 p-3 text-sm ${selectedRow.status==='acknowledged'?'bg-ink-50 text-ink-500':''}`}/>
            </div>

            {/* Next step */}
            <div>
              <div className="text-sm font-semibold text-ink-900 mb-1.5">Next step</div>
              <div className="grid grid-cols-2 gap-2">
                <label className={`rounded-xl border p-3 cursor-pointer ${draftNext==='development'?'border-emerald-400 bg-emerald-50':'border-ink-200'}`}>
                  <input type="radio" className="hidden" checked={draftNext==='development'} onChange={()=>setDraftNext('development')} disabled={selectedRow.status==='acknowledged'}/>
                  <div className="font-semibold text-emerald-800">Development Plan</div>
                  <div className="text-xs text-ink-600">Для A-player / Above bar · 2–3 SMART-цели на H2</div>
                </label>
                <label className={`rounded-xl border p-3 cursor-pointer ${draftNext==='bot'?'border-rose-400 bg-rose-50':'border-ink-200'}`}>
                  <input type="radio" className="hidden" checked={draftNext==='bot'} onChange={()=>setDraftNext('bot')} disabled={selectedRow.status==='acknowledged'}/>
                  <div className="font-semibold text-rose-800">BoT · Back on Track</div>
                  <div className="text-xs text-ink-600">Для Underperformer · 6-нед PIP с halfway + final</div>
                </label>
              </div>
            </div>

            {/* Manager signature */}
            <label className={`flex items-start gap-2.5 rounded-xl border p-3 ${signed?'border-emerald-400 bg-emerald-50':'border-ink-200 bg-white'} ${selectedRow.status==='acknowledged'?'opacity-70':''}`}>
              <input type="checkbox" className="mt-0.5" checked={signed} onChange={e=>setSigned(e.target.checked)} disabled={selectedRow.status==='acknowledged'}/>
              <div>
                <div className="text-sm font-semibold text-ink-900">Я провёл разговор и донёс grade</div>
                <div className="text-xs text-ink-600">Подпись менеджера · {user.name || 'Manager'} · обязательна для закрытия шага.</div>
              </div>
            </label>

            {/* Employee acknowledge (read-only here) */}
            {selectedRow.status==='acknowledged' && (
              <div className="rounded-xl border border-emerald-200 bg-emerald-50/70 p-3 text-sm">
                <div className="font-semibold text-emerald-800 mb-0.5">✓ Подтверждено сотрудником</div>
                <div className="text-xs text-emerald-700 font-mono">{selectedRow.conv.acknowledgedAt}</div>
                {selectedRow.conv.acknowledgedNote && <div className="text-ink-700 mt-1.5 italic">«{selectedRow.conv.acknowledgedNote}»</div>}
              </div>
            )}

            {/* Actions */}
            <div className="flex justify-end gap-2 pt-2 border-t border-ink-100">
              <button onClick={()=>setOpenConv(null)} className="h-10 px-3 rounded-lg border border-ink-200 text-sm">Закрыть</button>
              {selectedRow.status!=='acknowledged' && user.id===selectedRow.person.manager && (
                <button
                  disabled={!signed}
                  onClick={()=>{
                    store.holdConversation(selectedRow.person.id, cycleId, { notes: draftNotes, nextStep: draftNext }, user.name||'Manager');
                    setOpenConv(null);
                  }}
                  className={`h-10 px-4 rounded-lg text-sm font-semibold ${signed?'bg-brand-600 text-white hover:bg-brand-700':'bg-ink-100 text-ink-400 cursor-not-allowed'}`}>
                  {selectedRow.status==='held' ? 'Сохранить изменения' : 'Зафиксировать 1:1'}
                </button>
              )}
            </div>
          </div>
        )}
      </Modal>

      {/* Modal: Employee acknowledge */}
      <Modal open={!!ackFor} onClose={()=>setAckFor(null)} title={ackRow ? `Подтвердить debrief · ${ackRow.person.name || 'я'}` : ''}>
        {ackRow && (
          <div className="space-y-4">
            <div className="rounded-xl border border-ink-100 bg-ink-50/60 p-3 text-sm space-y-1">
              <div><span className="text-ink-500">Менеджер:</span> <span className="font-semibold">{byId(ackRow.person.manager).name}</span></div>
              <div><span className="text-ink-500">Разговор проведён:</span> <span className="font-mono">{ackRow.conv?.heldAt}</span></div>
              <div><span className="text-ink-500">Финальный grade:</span> <span className="font-bold">{ackRow.conv?.finalGrade}</span></div>
              <div><span className="text-ink-500">Next step:</span> <span className="font-semibold">{ackRow.conv?.nextStep==='bot'?'BoT · 6 нед':'Development Plan · H2'}</span></div>
              {ackRow.conv?.notes && <div className="pt-2 border-t border-ink-200 mt-2 italic text-ink-700">«{ackRow.conv.notes}»</div>}
            </div>
            <div>
              <div className="text-sm font-semibold text-ink-900 mb-1">Ваш комментарий (опционально)</div>
              <textarea value={ackNote} onChange={e=>setAckNote(e.target.value)} rows={3} placeholder="Согласен с оценкой / хочу добавить контекст / не согласен — объяснить" className="w-full rounded-lg border border-ink-200 p-3 text-sm"/>
            </div>
            <div className="rounded-xl border border-ink-200 bg-white p-3 text-xs text-ink-600">
              <b>Что означает acknowledge:</b> подтверждаю, что разговор состоялся и я услышал feedback. Это не означает автоматического согласия со всеми пунктами — вы можете добавить возражение в комментарии.
            </div>
            <div className="flex justify-end gap-2 pt-2 border-t border-ink-100">
              <button onClick={()=>setAckFor(null)} className="h-10 px-3 rounded-lg border border-ink-200 text-sm">Отмена</button>
              <button
                onClick={()=>{ store.acknowledgeConversation(ackRow.person.id, cycleId, { note: ackNote }, user.name||'Employee'); setAckFor(null); }}
                className="h-10 px-4 rounded-lg bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-700">
                ✓ Подтверждаю
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

/* ───────── DEVELOPMENT PLAN (A-player / Above bar) ───────── */
const DevelopmentPlanPage = ({ onOpen }) => {
  const { user, store } = useApp();
  const perms = permissions(user, store.state.people);
  const nextCycleId = 'h2-2026';
  const thisCycleId = ACTIVE_CYCLE.id;

  const isPerf = perms.canSeeOrgWide;     /* HR-admin или exec — видят company-wide список dev-планов */
  const myDirects = directs(user.id);
  const isMgr = myDirects.length > 0 || perms.sysRole === 'manager';

  /* Разблокировка: только acknowledged Conversation с nextStep='development' */
  const eligible = store.state.conversations
    .filter(c => c.status==='acknowledged' && c.nextStep==='development' && c.cycleId===thisCycleId)
    .map(c => {
      const person = store.state.people.find(p=>p.id===c.employeeId);
      const plan = store.state.devPlans.find(d => d.employeeId===c.employeeId && d.cycleId===nextCycleId);
      return { person, conv: c, plan };
    })
    .filter(r => r.person); /* только реальные люди */

  const scope = isPerf ? eligible
               : isMgr ? eligible.filter(r => myDirects.some(d=>d.id===r.person.id))
               : eligible.filter(r => r.person.id===user.id);

  const [openEmpId, setOpenEmpId] = useState(null);
  const openRow = openEmpId ? scope.find(r => r.person.id===openEmpId) : null;

  /* Редактор цели */
  const [editingGoalId, setEditingGoalId] = useState(null);
  const [goalDraft, setGoalDraft] = useState({ title:'', description:'', kpi:'', due:'', type:'SMART', progress:0, status:'not_started' });
  const [themeDraft, setThemeDraft] = useState('');

  /* AI suggest + Notion push state */
  const [aiSuggest, setAiSuggest] = useState({ loading:false, error:null, result:null });
  const [notionPush, setNotionPush] = useState({ loading:false, error:null, result:null });
  /* canUseAi — HR + exec + manager (suggest dev-goals AI). exec тоже может вызывать AI org-wide. */
  const canUseAi = perms.fullHRAccess || perms.execReadOnly || perms.sysRole === 'manager';
  /* canPushNotion — push dev-планов в Notion. Только hr_admin (exec не пишет в HR-системы). */
  const canPushNotion = perms.fullHRAccess;

  useEffect(()=>{
    if (openRow) setThemeDraft(openRow.plan?.theme || '');
    /* Сбрасываем AI-панели при смене открытого сотрудника */
    setAiSuggest({ loading:false, error:null, result:null });
    setNotionPush({ loading:false, error:null, result:null });
  }, [openEmpId]);

  const withPlan = scope.filter(r => r.plan);
  const withoutPlan = scope.filter(r => !r.plan);

  const avgProgress = withPlan.length
    ? Math.round(withPlan.reduce((acc,r)=>{
        const goals = r.plan?.goals || [];
        if (!goals.length) return acc;
        const p = goals.reduce((a,g)=>a+(g.progress||0),0)/goals.length;
        return acc + p;
      }, 0) / withPlan.length)
    : 0;

  const goalStatusTone = {
    on_track:    { bg:'bg-emerald-100', fg:'text-emerald-700', label:'On track' },
    at_risk:     { bg:'bg-amber-100',   fg:'text-amber-700',   label:'At risk' },
    off_track:   { bg:'bg-rose-100',    fg:'text-rose-700',    label:'Off track' },
    done:        { bg:'bg-brand-100',   fg:'text-brand-700',   label:'Done' },
    not_started: { bg:'bg-ink-100',     fg:'text-ink-600',     label:'Not started' },
  };

  const saveTheme = () => {
    if (!openRow) return;
    store.upsertDevPlan(openRow.person.id, nextCycleId, { theme: themeDraft }, user.name||'Manager');
  };

  const resetGoalDraft = () => setGoalDraft({ title:'', description:'', kpi:'', due:'', type:'SMART', progress:0, status:'not_started' });

  const addOrUpdateGoal = () => {
    if (!openRow || !goalDraft.title.trim()) return;
    const plan = openRow.plan;
    if (editingGoalId && plan) {
      store.updateDevPlanGoal(openRow.person.id, nextCycleId, editingGoalId, goalDraft, user.name||'Manager');
    } else {
      const newGoals = [ ...(plan?.goals || []), { ...goalDraft, id: 'g-'+Math.random().toString(36).slice(2,7) } ];
      store.upsertDevPlan(openRow.person.id, nextCycleId, { goals: newGoals }, user.name||'Manager');
    }
    setEditingGoalId(null);
    resetGoalDraft();
  };

  const removeGoal = (gid) => {
    if (!openRow?.plan) return;
    const newGoals = openRow.plan.goals.filter(g=>g.id!==gid);
    store.upsertDevPlan(openRow.person.id, nextCycleId, { goals: newGoals }, user.name||'Manager');
  };

  /* AI-предложение dev plan — тянет evidence + calibration и просит 3-5 SMART-целей */
  const runAiSuggest = async () => {
    if (!openRow) return;
    setAiSuggest({ loading:true, error:null, result:null });
    try {
      if (!window.__reviewSync?.isReady()) throw new Error('Supabase sync ещё не готов');
      const empUuid = window.__reviewSync.employeeUuid(openRow.person.id);
      /* AI-план строится на evidence из ТЕКУЩЕГО цикла (для следующего цикла) */
      const cycUuid = window.__reviewSync.cycleUuid(thisCycleId);
      if (!empUuid || !cycUuid) throw new Error('Не найдены UUID сотрудника или цикла');
      const out = await window.__aiCoach.devPlanSuggest(empUuid, cycUuid);
      setAiSuggest({ loading:false, error:null, result: out?.result || { suggestions: [] } });
    } catch (e) {
      setAiSuggest({ loading:false, error: (e && (e.detail || e.message)) || 'Ошибка AI', result:null });
    }
  };

  /* Применить одну AI-рекомендацию как новую цель */
  const applyAiSuggestion = (s) => {
    if (!openRow) return;
    const newGoal = {
      id: 'g-'+Math.random().toString(36).slice(2,7),
      title: (s.goal || '').slice(0, 200),
      description: s.why || '',
      kpi: Array.isArray(s.success_metrics) ? s.success_metrics.join(' · ') : (s.success_metrics || ''),
      due: s.timeline || '',
      type: 'SMART',
      progress: 0,
      status: 'not_started',
    };
    const existing = openRow.plan?.goals || [];
    store.upsertDevPlan(openRow.person.id, nextCycleId, { goals: [...existing, newGoal] }, user.name||'Manager');
  };

  /* Применить ВСЕ AI-рекомендации сразу (очищает текущие и заменяет) */
  const applyAllAiSuggestions = () => {
    if (!openRow || !aiSuggest.result?.suggestions) return;
    if (!confirm('Заменить текущие цели на AI-рекомендации? Текущие будут удалены.')) return;
    const newGoals = aiSuggest.result.suggestions.map(s => ({
      id: 'g-'+Math.random().toString(36).slice(2,7),
      title: (s.goal || '').slice(0, 200),
      description: s.why || '',
      kpi: Array.isArray(s.success_metrics) ? s.success_metrics.join(' · ') : (s.success_metrics || ''),
      due: s.timeline || '',
      type: 'SMART',
      progress: 0,
      status: 'not_started',
    }));
    store.upsertDevPlan(openRow.person.id, nextCycleId, { goals: newGoals }, user.name||'Manager');
  };

  /* Push плана в Notion — вызывает notion-sync с action=push_dev_plan */
  const runPushNotion = async () => {
    if (!openRow) return;
    setNotionPush({ loading:true, error:null, result:null });
    try {
      if (!window.__reviewSync?.isReady()) throw new Error('Supabase sync ещё не готов');
      const empUuid = window.__reviewSync.employeeUuid(openRow.person.id);
      const cycUuid = window.__reviewSync.cycleUuid(nextCycleId);
      if (!empUuid || !cycUuid) throw new Error('Не найдены UUID сотрудника или цикла');
      const sb = supabase;
      if (!sb) throw new Error('Supabase client не инициализирован');
      /* Явно тянем access_token — иначе supabase-js может прислать publishable-ключ вместо JWT */
      const sess = await sb.auth.getSession();
      const accessToken = sess?.data?.session?.access_token;
      if (!accessToken) throw new Error('Нет активной сессии — войдите через Google SSO заново');
      const { data, error } = await sb.functions.invoke('notion-sync', {
        body: { action: 'push_dev_plan', employee_id: empUuid, cycle_id: cycUuid },
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (error) {
        let detail = null;
        try { detail = error.context?.body ? await error.context.body.text() : null; } catch(_){}
        throw new Error(detail || error.message || 'Notion push failed');
      }
      if (data && data.error) throw new Error(data.detail || data.error);
      setNotionPush({ loading:false, error:null, result: data });
    } catch (e) {
      setNotionPush({ loading:false, error: e.message || 'Ошибка Notion push', result:null });
    }
  };

  return (
    <div className="p-6 space-y-5">
      <Card>
        <CardHead title="Development Plan · H2 2026" subtitle="Для A-player / Above bar · 2–3 SMART-цели на полугодие">
          <span className="text-xs px-2 py-1 rounded bg-emerald-100 text-emerald-800 font-semibold">Performers track</span>
        </CardHead>
        <div className="p-5 grid grid-cols-2 md:grid-cols-4 gap-3">
          <div className="rounded-xl border border-ink-100 bg-white px-4 py-3">
            <div className="text-[11px] uppercase text-ink-400 tracking-wide">Eligible</div>
            <div className="text-2xl font-semibold text-ink-900">{scope.length}</div>
            <div className="text-[11px] text-ink-500 mt-0.5">После acknowledged 1:1</div>
          </div>
          <div className="rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3">
            <div className="text-[11px] uppercase text-emerald-700 tracking-wide">С планом</div>
            <div className="text-2xl font-semibold text-emerald-700">{withPlan.length}</div>
          </div>
          <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
            <div className="text-[11px] uppercase text-amber-700 tracking-wide">Без плана</div>
            <div className="text-2xl font-semibold text-amber-700">{withoutPlan.length}</div>
          </div>
          <div className="rounded-xl border border-brand-200 bg-brand-50 px-4 py-3">
            <div className="text-[11px] uppercase text-brand-700 tracking-wide">Средний progress</div>
            <div className="text-2xl font-semibold text-brand-700">{avgProgress}%</div>
          </div>
        </div>
      </Card>

      <Card>
        <CardHead title="Сотрудники с Development Plan" subtitle="Кликните для редактирования целей"/>
        <div className="divide-y divide-ink-100">
          {scope.map(r => {
            const goals = r.plan?.goals || [];
            const prog = goals.length ? Math.round(goals.reduce((a,g)=>a+(g.progress||0),0)/goals.length) : 0;
            return (
              <div key={r.person.id} className="px-5 py-4 flex items-center gap-4 hover:bg-ink-50/40">
                <Avatar p={r.person} size={42}/>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <button onClick={()=>onOpen && onOpen(r.person.id)} className="font-semibold text-ink-900 truncate text-left">{r.person.name}</button>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold ${r.person.currentGrade==='A-player'?'bg-emerald-100 text-emerald-700':'bg-brand-100 text-brand-700'}`}>{r.person.currentGrade}</span>
                  </div>
                  <div className="text-xs text-ink-500 truncate">{r.person.role} · {r.person.team}</div>
                  {r.plan?.theme && <div className="text-xs text-ink-700 mt-1 italic truncate">«{r.plan.theme}»</div>}
                </div>
                <div className="w-40 shrink-0">
                  <div className="text-[11px] text-ink-500 mb-0.5">{goals.length} цели · {prog}%</div>
                  <div className="h-1.5 rounded-full bg-ink-100 overflow-hidden">
                    <div className="h-full bg-emerald-500" style={{width: prog+'%'}}></div>
                  </div>
                </div>
                <button onClick={()=>{ setOpenEmpId(r.person.id); setEditingGoalId(null); resetGoalDraft(); }}
                  className="h-8 px-3 rounded-lg border border-ink-200 text-xs font-semibold hover:bg-ink-50">
                  {r.plan ? 'Редактировать' : 'Создать план'}
                </button>
              </div>
            );
          })}
          {scope.length===0 && (
            <div className="p-10 text-center text-sm text-ink-500">
              <Icon name="lock" className="w-6 h-6 mx-auto text-ink-400 mb-2"/>
              Нет eligible сотрудников. Development Plan открывается только после acknowledged Performance Conversation.
            </div>
          )}
        </div>
      </Card>

      {/* Editor Modal */}
      <Modal open={!!openEmpId} onClose={()=>{ setOpenEmpId(null); setEditingGoalId(null); resetGoalDraft(); }} title={openRow ? `Development Plan · ${openRow.person.name}` : ''}>
        {openRow && (
          <div className="space-y-4">
            {/* Theme */}
            <div>
              <div className="text-xs uppercase tracking-wide text-ink-400 mb-1">Фокус H2 (одна строка)</div>
              <div className="flex gap-2">
                <input value={themeDraft} onChange={e=>setThemeDraft(e.target.value)}
                  placeholder="Например: Grow into Staff-level: cross-team влияние + тех. лидерство"
                  className="flex-1 h-10 px-3 rounded-lg border border-ink-200 text-sm"/>
                <button onClick={saveTheme} className="h-10 px-3 rounded-lg bg-brand-600 text-white text-sm font-semibold">Сохранить</button>
              </div>
            </div>

            {/* AI Dev Plan suggest — тянет evidence + calibration и предлагает 3-5 SMART-целей */}
            {canUseAi && (
              <div className="rounded-xl border border-ink-100 bg-ink-50/40">
                <div className="flex items-center justify-between px-3 py-2 border-b border-ink-100">
                  <div className="flex items-center gap-2 text-xs font-semibold text-ink-600 uppercase tracking-wider">
                    <Icon name="sparkle" className="w-3.5 h-3.5 text-brand-600"/>
                    AI-предложение плана (на основе evidence + feedback + calibration)
                  </div>
                  <button type="button" onClick={runAiSuggest} disabled={aiSuggest.loading}
                    className="h-7 px-3 rounded-md bg-brand-600 text-white text-xs font-semibold hover:bg-brand-700 disabled:bg-ink-200 disabled:cursor-not-allowed">
                    {aiSuggest.loading ? 'Генерирую…' : (aiSuggest.result ? 'Пересгенерировать' : 'Предложить черновик')}
                  </button>
                </div>
                {aiSuggest.error && (
                  <div className="p-3 text-xs text-rose-700 bg-rose-50 border-t border-rose-100">{String(aiSuggest.error)}</div>
                )}
                {aiSuggest.result && Array.isArray(aiSuggest.result.suggestions) && aiSuggest.result.suggestions.length > 0 && (
                  <div className="p-3 space-y-2">
                    <div className="flex items-center justify-between">
                      <div className="text-[11px] text-ink-500">Найдено <b>{aiSuggest.result.suggestions.length}</b> рекомендаций. Можно применить по одной или все сразу.</div>
                      <button onClick={applyAllAiSuggestions} className="h-6 px-2 rounded border border-emerald-300 text-emerald-700 bg-emerald-50 text-[11px] font-semibold hover:bg-emerald-100">Применить все (заменить)</button>
                    </div>
                    {aiSuggest.result.suggestions.map((s, i) => (
                      <div key={i} className="rounded-lg border border-ink-200 bg-white p-2.5 text-xs space-y-1">
                        <div className="flex items-start gap-2">
                          <span className="shrink-0 h-5 px-1.5 rounded bg-brand-100 text-brand-700 text-[10px] font-bold tabular-nums">{i+1}</span>
                          <div className="flex-1 min-w-0">
                            <div className="font-semibold text-ink-900">{s.goal}</div>
                            {s.competency && <span className="inline-block mt-0.5 text-[10px] px-1.5 py-0.5 rounded bg-ink-100 text-ink-700 font-semibold">{s.competency}</span>}
                            {s.why && <div className="mt-1 text-ink-600 italic">Зачем: {s.why}</div>}
                            {Array.isArray(s.success_metrics) && s.success_metrics.length>0 && (
                              <div className="mt-1 text-ink-700"><b>Метрики:</b> {s.success_metrics.join(' · ')}</div>
                            )}
                            <div className="mt-1 flex flex-wrap gap-2 text-[10px] text-ink-500">
                              {s.timeline && <span>⏱ {s.timeline}</span>}
                              {Array.isArray(s.resources) && s.resources.length>0 && <span>📚 {s.resources.slice(0,3).join(', ')}</span>}
                              {Array.isArray(s.based_on_evidence_ids) && s.based_on_evidence_ids.length>0 && <span>🔗 {s.based_on_evidence_ids.length} evidence</span>}
                            </div>
                          </div>
                          <button onClick={()=>applyAiSuggestion(s)} className="shrink-0 h-7 px-2 rounded border border-brand-300 text-brand-700 bg-brand-50 text-[11px] font-semibold hover:bg-brand-100">+ В план</button>
                        </div>
                      </div>
                    ))}
                    <div className="text-[10px] text-ink-400 pt-1 border-t border-ink-100">
                      AI-рекомендации — это предложение. Менеджер проверяет evidence, редактирует формулировку и подтверждает с сотрудником в 1:1.
                    </div>
                  </div>
                )}
                {aiSuggest.result && (!aiSuggest.result.suggestions || aiSuggest.result.suggestions.length===0) && (
                  <div className="p-3 text-xs text-ink-500">AI не предложил целей — возможно, недостаточно evidence. Добавьте 360/Manager Assessment и повторите.</div>
                )}
              </div>
            )}

            {/* Push dev plan в Notion-страницу сотрудника (только HR/Exec) */}
            {canPushNotion && openRow.plan && (
              <div className="rounded-xl border border-ink-100 bg-ink-50/40">
                <div className="flex items-center justify-between px-3 py-2 border-b border-ink-100">
                  <div className="flex items-center gap-2 text-xs font-semibold text-ink-600 uppercase tracking-wider">
                    <Icon name="link" className="w-3.5 h-3.5 text-brand-600"/>
                    Sync плана в Notion (страница сотрудника)
                  </div>
                  <button type="button" onClick={runPushNotion} disabled={notionPush.loading}
                    className="h-7 px-3 rounded-md bg-ink-900 text-white text-xs font-semibold hover:bg-ink-800 disabled:bg-ink-200 disabled:cursor-not-allowed">
                    {notionPush.loading ? 'Отправляю…' : 'Отправить в Notion'}
                  </button>
                </div>
                {notionPush.error && (
                  <div className="p-3 text-xs text-rose-700 bg-rose-50 border-t border-rose-100">{String(notionPush.error)}</div>
                )}
                {notionPush.result && (
                  <div className="p-3 text-xs text-emerald-700 bg-emerald-50 border-t border-emerald-100">
                    <div className="font-semibold">✓ План добавлен на страницу сотрудника в Notion</div>
                    <div className="text-[11px] text-ink-600 mt-0.5">Блоков записано: {notionPush.result.blocks_appended ?? '—'}</div>
                    {notionPush.result.notion_page_url && (
                      <a href={notionPush.result.notion_page_url} target="_blank" rel="noopener noreferrer"
                         className="inline-block mt-1 text-brand-700 underline break-all">
                        {notionPush.result.notion_page_url}
                      </a>
                    )}
                    <div className="text-[10px] text-ink-500 mt-1">Запись зафиксирована в evidence_ledger как notion_dev_plan_push.</div>
                  </div>
                )}
                {!notionPush.result && !notionPush.error && (
                  <div className="p-3 text-[11px] text-ink-500">
                    Добавит блок «Development Plan» с темой + целями в конец страницы сотрудника в Notion. Перед отправкой убедитесь, что сотрудник связан с Notion-страницей (sync Employees).
                  </div>
                )}
              </div>
            )}

            {/* Goals list */}
            <div>
              <div className="text-xs uppercase tracking-wide text-ink-400 mb-1.5">Цели · {openRow.plan?.goals?.length || 0} / 3 рекомендуется</div>
              <div className="space-y-2">
                {(openRow.plan?.goals || []).map(g => {
                  const tone = goalStatusTone[g.status] || goalStatusTone.not_started;
                  return (
                    <div key={g.id} className="rounded-xl border border-ink-100 bg-white p-3">
                      <div className="flex items-start gap-2">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className="font-semibold text-ink-900 text-sm">{g.title}</span>
                            <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold ${g.type==='Stretch'?'bg-amber-100 text-amber-700':'bg-brand-100 text-brand-700'}`}>{g.type}</span>
                            <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold ${tone.bg} ${tone.fg}`}>{tone.label}</span>
                            {g.due && <span className="text-[10px] text-ink-500">due {g.due}</span>}
                          </div>
                          {g.description && <div className="text-xs text-ink-600 mt-1">{g.description}</div>}
                          {g.kpi && <div className="text-xs text-ink-700 mt-1"><b>KPI:</b> {g.kpi}</div>}
                          <div className="flex items-center gap-2 mt-2">
                            <div className="flex-1 h-1.5 rounded-full bg-ink-100 overflow-hidden">
                              <div className="h-full bg-emerald-500" style={{width: (g.progress||0)+'%'}}></div>
                            </div>
                            <div className="text-[11px] font-mono text-ink-600 w-10 text-right">{g.progress||0}%</div>
                          </div>
                        </div>
                        <div className="flex flex-col gap-1 shrink-0">
                          <button onClick={()=>{ setEditingGoalId(g.id); setGoalDraft({ title:g.title, description:g.description||'', kpi:g.kpi||'', due:g.due||'', type:g.type||'SMART', progress:g.progress||0, status:g.status||'not_started' }); }}
                            className="h-7 px-2 rounded border border-ink-200 text-[11px] font-semibold hover:bg-ink-50">Изменить</button>
                          <button onClick={()=>removeGoal(g.id)}
                            className="h-7 px-2 rounded border border-rose-200 text-rose-700 text-[11px] font-semibold hover:bg-rose-50">Удалить</button>
                        </div>
                      </div>
                    </div>
                  );
                })}
                {(!openRow.plan?.goals || openRow.plan.goals.length===0) && (
                  <div className="rounded-xl border border-dashed border-ink-200 bg-ink-50/40 p-4 text-center text-xs text-ink-500">Пока нет целей — добавьте 2–3 SMART</div>
                )}
              </div>
            </div>

            {/* Goal editor */}
            <div className="rounded-xl border border-brand-200 bg-brand-50/50 p-3 space-y-2">
              <div className="text-xs font-bold uppercase tracking-wide text-brand-700">{editingGoalId ? 'Изменение цели' : 'Новая цель'}</div>
              <input value={goalDraft.title} onChange={e=>setGoalDraft({...goalDraft, title:e.target.value})} placeholder="Название цели" className="w-full h-9 px-3 rounded-lg border border-ink-200 text-sm"/>
              <textarea value={goalDraft.description} onChange={e=>setGoalDraft({...goalDraft, description:e.target.value})} rows={2} placeholder="Описание (контекст, зачем)" className="w-full rounded-lg border border-ink-200 p-2 text-sm"/>
              <input value={goalDraft.kpi} onChange={e=>setGoalDraft({...goalDraft, kpi:e.target.value})} placeholder="KPI / как поймём что достигнута" className="w-full h-9 px-3 rounded-lg border border-ink-200 text-sm"/>
              <div className="grid grid-cols-3 gap-2">
                <input value={goalDraft.due} onChange={e=>setGoalDraft({...goalDraft, due:e.target.value})} placeholder="2026-10-30" className="h-9 px-3 rounded-lg border border-ink-200 text-sm font-mono"/>
                <select value={goalDraft.type} onChange={e=>setGoalDraft({...goalDraft, type:e.target.value})} className="h-9 px-3 rounded-lg border border-ink-200 text-sm">
                  <option value="SMART">SMART</option>
                  <option value="Stretch">Stretch</option>
                </select>
                <select value={goalDraft.status} onChange={e=>setGoalDraft({...goalDraft, status:e.target.value})} className="h-9 px-3 rounded-lg border border-ink-200 text-sm">
                  <option value="not_started">Not started</option>
                  <option value="on_track">On track</option>
                  <option value="at_risk">At risk</option>
                  <option value="off_track">Off track</option>
                  <option value="done">Done</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-ink-500 w-20">Progress</span>
                <input type="range" min="0" max="100" step="5" value={goalDraft.progress} onChange={e=>setGoalDraft({...goalDraft, progress:Number(e.target.value)})} className="flex-1"/>
                <span className="text-xs font-mono w-10 text-right">{goalDraft.progress}%</span>
              </div>
              <div className="flex justify-end gap-2">
                {editingGoalId && <button onClick={()=>{ setEditingGoalId(null); resetGoalDraft(); }} className="h-8 px-3 rounded-lg border border-ink-200 text-xs font-semibold">Отмена</button>}
                <button onClick={addOrUpdateGoal} disabled={!goalDraft.title.trim()} className={`h-8 px-3 rounded-lg text-xs font-semibold ${goalDraft.title.trim()?'bg-brand-600 text-white':'bg-ink-100 text-ink-400 cursor-not-allowed'}`}>{editingGoalId ? 'Сохранить' : '+ Добавить цель'}</button>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

/* ───────── PEOPLE / PROFILE ───────── */
/* ───────── ORG CHART ─────────
 * Miro-style top-down org tree. Builds a layout by computing subtree widths
 * (simple Reingold-Tilford-like sweep) and renders nodes + SVG connectors. */
const NODE_W = 210;
const NODE_H = 92;
const COL_GAP = 28;
const ROW_H = 150;
const CELL_W = NODE_W + COL_GAP;

const buildOrgLayout = (people) => {
  const byId = Object.fromEntries(people.map(p=>[p.id,p]));
  const childrenOf = {};
  people.forEach(p => {
    const mgr = p.managerId && byId[p.managerId] ? p.managerId : '__root__';
    (childrenOf[mgr] = childrenOf[mgr] || []).push(p.id);
  });
  // sort siblings by level rank then name for stable layout (COMMIT_5: level-aware)
  const levelRank = {
    M4:0, IC6:0,
    M3:1, IC5:1,
    M2:2, IC4:2, S3:2,
    M1:3, IC3:3, S2:3,
    IC2:4, S1:4,
    IC1:5,
  };
  const seniorityRank = { Director:0, VP:1, Lead:2, Senior:3, Mid:4, Junior:5 };
  const rankFor = (p) => {
    if (p?.level && levelRank[p.level] !== undefined) return levelRank[p.level];
    return seniorityRank[p?.seniority] ?? 9;
  };
  Object.values(childrenOf).forEach(arr => arr.sort((a,b)=>{
    const pa=byId[a], pb=byId[b];
    return rankFor(pa) - rankFor(pb) || pa.role.localeCompare(pb.role);
  }));
  const subtreeWidth = {};
  const computeW = (id) => {
    const kids = childrenOf[id] || [];
    if (!kids.length) return (subtreeWidth[id]=1);
    return (subtreeWidth[id] = kids.reduce((s,c)=>s+computeW(c),0));
  };
  const roots = childrenOf['__root__'] || [];
  roots.forEach(computeW);
  const totalUnits = roots.reduce((s,r)=>s+subtreeWidth[r],0);
  const positions = {};
  const place = (id, unitStart, depth) => {
    const w = subtreeWidth[id];
    const cx = (unitStart + w/2) * CELL_W;
    positions[id] = { x: cx - NODE_W/2, y: depth * ROW_H, cx, cy: depth * ROW_H + NODE_H/2, depth };
    let u = unitStart;
    (childrenOf[id]||[]).forEach(c => { place(c, u, depth+1); u += subtreeWidth[c]; });
  };
  let offset = 0;
  roots.forEach(r => { place(r, offset, 0); offset += subtreeWidth[r]; });
  const maxDepth = Math.max(0, ...Object.values(positions).map(p=>p.depth));
  return {
    positions,
    byId,
    edges: people.filter(p=>p.managerId && byId[p.managerId]).map(p=>({from:p.managerId, to:p.id})),
    width: totalUnits * CELL_W,
    height: (maxDepth+1) * ROW_H + NODE_H,
  };
};

/* Focused interactive org view — Workday-style.
   Показывает: менеджер фокус-человека → сам фокус + peers (siblings) → его directs.
   Клик на любую карточку — пересдвигает фокус на неё.
   Мелкая иконка справа от имени — открывает профиль.
   Badge «+N» — сколько ещё подчинённых у этого человека (не видны в текущем срезе). */
const FocusOrgChart = ({ people, focusId, onFocus, onOpen, dottedRels = [] }) => {
  const byId = useMemo(() => Object.fromEntries(people.map(p=>[p.id,p])), [people]);
  const focus = byId[focusId] || people[0];
  if (!focus) return <div className="p-6 text-sm text-ink-500">Не найдено</div>;
  /* Matrix: для каждого сотрудника считаем количество dotted-связей (по email) */
  const dottedCountByEmail = useMemo(() => {
    const m = {};
    (dottedRels || []).forEach(r => {
      if (r.relationship !== 'dotted') return;
      const k = (r.employee_email || '').toLowerCase();
      m[k] = (m[k] || 0) + 1;
    });
    return m;
  }, [dottedRels]);
  const dottedCountFor = (p) => dottedCountByEmail[(p?.email || '').toLowerCase()] || 0;

  const manager = focus.managerId && byId[focus.managerId] ? byId[focus.managerId] : null;
  const siblings = people
    .filter(p => p.id !== focus.id && (p.managerId || null) === (focus.managerId || null))
    .sort((a,b)=>(a.name||a.role||'').localeCompare(b.name||b.role||''));
  const directs = people
    .filter(p => p.managerId === focus.id)
    .sort((a,b)=>(a.name||a.role||'').localeCompare(b.name||b.role||''));
  const directsCountOf = (id) => people.filter(p => p.managerId === id).length;
  /* Matrix: люди, у кого focus является dotted-куратором (по email).
     Исключаем тех, кто уже в solid-directs — чтобы не дублировать. */
  const focusEmail = (focus.email || '').toLowerCase();
  const dottedDirectEmails = (dottedRels || [])
    .filter(r => r.relationship === 'dotted' && (r.manager_email || '').toLowerCase() === focusEmail)
    .map(r => (r.employee_email || '').toLowerCase());
  const dottedDirects = people
    .filter(p => {
      if (!p.email) return false;
      if (directs.some(d => d.id === p.id)) return false;
      return dottedDirectEmails.includes(p.email.toLowerCase());
    })
    .sort((a,b)=>(a.name||a.role||'').localeCompare(b.name||b.role||''));

  /* Фокус-человек всегда по центру ряда — чтобы подчинённые (центрированный ряд
     ниже) однозначно читались как ЕГО команда. Соседей сортируем (ручной порядок
     для директов CEO, иначе по алфавиту) и раскладываем поровну слева/справа. */
  const ORG_LEVEL_ORDER = {
    'saparalieva.a@choco.kz': 0, // Айканыш
    'bakibayev.t@choco.kz':   1, // Тимур (Head of AI LABS Academy)
    'ushurova.l@choco.kz':    2, // Лейли (HRD)
  };
  const peersSorted = [...siblings].sort((a,b)=>{
    const ra = ORG_LEVEL_ORDER[(a.email||'').toLowerCase()] ?? 100;
    const rb = ORG_LEVEL_ORDER[(b.email||'').toLowerCase()] ?? 100;
    return ra - rb || (a.name||a.role||'').localeCompare(b.name||b.role||'');
  });
  const _half = Math.floor(peersSorted.length / 2);
  const levelRow = [...peersSorted.slice(0, _half), focus, ...peersSorted.slice(_half)];

  /* Путь CEO → ... → focus */
  const path = [];
  let cur = focus;
  const seen = new Set();
  while (cur && cur.managerId && byId[cur.managerId] && !seen.has(cur.managerId)) {
    seen.add(cur.managerId);
    cur = byId[cur.managerId];
    path.unshift(cur);
  }

  const NodeCard = ({ p, highlight=false, small=false }) => {
    const subs = directsCountOf(p.id);
    const showSubsBadge = subs > 0 && p.id !== focus.id;
    const st = personStatus(p);
    const isVacant = st === 'vacant';
    const isOnLeave = st === 'onLeave';
    const borderCls = highlight
      ? 'border-brand-500 ring-2 ring-brand-100'
      : isVacant
        ? 'border-ink-300 border-dashed bg-ink-50/40 hover:border-ink-400'
        : isOnLeave
          ? 'border-amber-200 hover:border-amber-400'
          : 'border-ink-100 hover:border-brand-300';
    return (
      <div className="flex flex-col items-center gap-1 shrink-0">
        <div className={`relative rounded-xl transition-all border-2 shadow-card hover:shadow-pop ${isVacant?'':'bg-white'} ${borderCls}`}
             style={{ width: small ? 190 : 220, opacity: isVacant ? 0.85 : 1 }}>
          <button
            onClick={() => onFocus(p.id)}
            className="w-full text-left flex items-center gap-2.5 px-3 py-2.5 rounded-xl"
            title={p.id === focus.id ? 'Это текущий фокус' : 'Нажмите — сфокусироваться на этом человеке'}
          >
            <Avatar p={p} size={small ? 34 : 40}/>
            <div className="min-w-0 flex-1">
              <div className={`${small?'text-[12.5px]':'text-[13px]'} font-semibold truncate leading-tight ${isVacant?'italic text-ink-500':'text-ink-900'}`}>{p.name || p.role}</div>
              <div className={`${small?'text-[10.5px]':'text-[11px]'} text-ink-500 truncate leading-tight mt-0.5`}>{p.role}</div>
              <div className="flex items-center gap-1.5 mt-1 flex-wrap">
                {p.team && <span className="text-[9px] text-ink-400 truncate">{p.team}</span>}
                {isVacant && (
                  <span className="text-[9px] px-1.5 py-0.5 rounded-full border border-dashed border-ink-300 text-ink-500 font-semibold uppercase tracking-wider">Vacant</span>
                )}
                {isOnLeave && (
                  <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-amber-50 text-amber-700 border border-amber-200 font-semibold uppercase tracking-wider">Отпуск</span>
                )}
                {showSubsBadge && (
                  <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-brand-50 text-brand-700 font-semibold">+{subs}</span>
                )}
                {dottedCountFor(p) > 0 && (
                  <span
                    className="text-[9px] px-1.5 py-0.5 rounded-full bg-violet-50 text-violet-700 border border-dashed border-violet-300 font-semibold uppercase tracking-wider"
                    title="Matrix: dotted-куратор по продукту/проекту. См. карточку сотрудника."
                  >
                    ⋯ {dottedCountFor(p)}
                  </span>
                )}
              </div>
            </div>
          </button>
          <button
            onClick={(e)=>{ e.stopPropagation(); onOpen(p.id); }}
            className="absolute top-1.5 right-1.5 w-6 h-6 rounded-md hover:bg-ink-100 flex items-center justify-center text-ink-400 hover:text-ink-700"
            title="Открыть профиль"
          >
            <Icon name="eye" className="w-3.5 h-3.5"/>
          </button>
        </div>
      </div>
    );
  };

  const Connector = () => <div className="w-px h-6 bg-ink-200"/>;
  const RowLabel = ({ children, hint }) => (
    <div className="text-[10px] uppercase tracking-[.14em] text-ink-400 font-semibold flex items-center gap-2">
      {children}{hint && <span className="text-[10px] normal-case tracking-normal text-ink-300 font-normal">· {hint}</span>}
    </div>
  );

  return (
    <div className="p-6 bg-[#FAFBFD] rounded-xl overflow-auto" style={{maxHeight:'72vh'}}>
      {/* Breadcrumb */}
      {path.length > 0 && (
        <div className="flex items-center gap-1.5 text-[11px] mb-5 flex-wrap">
          <span className="font-semibold text-ink-400 uppercase tracking-wider">Путь:</span>
          {path.map((p, i) => (
            <Fragment key={p.id}>
              <button onClick={()=>onFocus(p.id)} className="text-ink-600 hover:text-brand-600 hover:underline">{p.name || p.role}</button>
              <span className="text-ink-300">›</span>
            </Fragment>
          ))}
          <span className="font-semibold text-ink-900">{focus.name || focus.role}</span>
        </div>
      )}

      <div className="flex flex-col items-center gap-2">
        {/* Manager row */}
        {manager && (
          <>
            <RowLabel>Менеджер</RowLabel>
            <NodeCard p={manager}/>
            <Connector/>
          </>
        )}

        {/* Focus + siblings row */}
        <RowLabel hint={siblings.length > 0 ? `${siblings.length + 1} чел. в команде` : 'top-level'}>
          {manager ? 'Уровень' : 'Верх структуры'}
        </RowLabel>
        <div className="flex flex-wrap gap-3 justify-center items-start max-w-full">
          {levelRow.slice(0, 7).map(p => <NodeCard key={p.id} p={p} highlight={p.id===focus.id}/>)}
          {levelRow.length > 7 && (
            <div className="self-center text-xs text-ink-500 px-2">+{levelRow.length - 7} еще</div>
          )}
        </div>

        {/* Directs row (solid) */}
        {directs.length > 0 && (
          <>
            <Connector/>
            <RowLabel hint={`${directs.length} ${directs.length===1?'человек':'чел.'}`}>Подчинённые</RowLabel>
            <div className="flex flex-wrap gap-3 justify-center items-start max-w-full">
              {directs.map(d => <NodeCard key={d.id} p={d} small/>)}
            </div>
          </>
        )}

        {/* Dotted-directs row — кого focus курирует по продукту/проекту (matrix).
            Без вертикальной линии-коннектора (она путает с solid-tree); явный
            заголовок с именем focus'а, чтобы было ясно, чей это блок. */}
        {dottedDirects.length > 0 && (
          <div className="w-full mt-8 px-4 py-4 rounded-2xl border-2 border-dashed border-violet-300 bg-violet-50/40">
            <div className="flex items-center gap-2 mb-3 flex-wrap">
              <Avatar p={focus} size={28}/>
              <div className="text-[12px] font-semibold text-violet-900">
                {focus.name || focus.role}
                <span className="text-violet-700 font-normal"> курирует по продукту / проекту </span>
                <span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded border bg-white text-violet-700 border-violet-300 font-semibold ml-1">dotted · matrix</span>
              </div>
              <span className="text-[11px] text-violet-500">· {dottedDirects.length} {dottedDirects.length===1?'человек':'чел.'}</span>
            </div>
            <div className="text-[11px] text-violet-700/80 mb-3 italic">
              Эти люди формально подчиняются другому manager'у (solid line), но {focus.name?.split(' ')[0] || 'этот человек'} даёт им направление по продукту, попадает в их 360-feedback и видит их работу в калибровке.
            </div>
            <div className="flex flex-wrap gap-3 justify-start items-start">
              {dottedDirects.map(d => <NodeCard key={'dot-'+d.id} p={d} small/>)}
            </div>
          </div>
        )}

        {directs.length === 0 && dottedDirects.length === 0 && !manager && (
          <div className="text-sm text-ink-500 mt-2">У {focus.name || focus.role} нет менеджера, solid- и dotted-подчинённых в активном составе.</div>
        )}
      </div>

      <div className="text-center text-[11px] text-ink-400 mt-6 px-4">
        Клик на карточке — пересдвинуть фокус · иконка <Icon name="eye" className="w-3 h-3 inline align-middle"/> справа сверху — открыть профиль · бейдж <span className="text-[9px] px-1 py-0.5 rounded-full bg-brand-50 text-brand-700 font-semibold">+N</span> показывает скрытых подчинённых
      </div>
    </div>
  );
};

const OrgChart = ({ people, onOpen, showGrades = false, dottedRels = [] }) => {
  const { positions, edges, width, height } = buildOrgLayout(people);
  const gradeBorder = g => g==='A-player' ? '#10B981' : g==='Underperformer' ? '#EF4444' : '#D0D4E4';
  /* Matrix: dotted-edges (solid пунктирные кривые между manager и employee). */
  const peopleByEmail = useMemo(() => Object.fromEntries(
    (people || []).filter(p => p.email).map(p => [p.email.toLowerCase(), p])
  ), [people]);
  const dottedEdges = useMemo(() => (dottedRels || [])
    .filter(r => r.relationship === 'dotted')
    .map(r => {
      const e = peopleByEmail[(r.employee_email || '').toLowerCase()];
      const m = peopleByEmail[(r.manager_email || '').toLowerCase()];
      if (!e || !m) return null;
      return { from: m.id, to: e.id };
    })
    .filter(Boolean), [dottedRels, peopleByEmail]);
  const dottedCountByEmail = useMemo(() => {
    const m = {};
    (dottedRels || []).forEach(r => {
      if (r.relationship !== 'dotted') return;
      const k = (r.employee_email || '').toLowerCase();
      m[k] = (m[k] || 0) + 1;
    });
    return m;
  }, [dottedRels]);
  return (
    <div className="relative overflow-auto border border-ink-100 rounded-xl bg-[#FAFBFD]" style={{maxHeight:'72vh'}}>
      {dottedEdges.length > 0 && (
        <div className="absolute top-3 right-3 z-10 text-[10px] bg-white/90 backdrop-blur px-2.5 py-1.5 rounded-md border border-ink-100 flex items-center gap-3">
          <span className="flex items-center gap-1.5"><span className="inline-block w-4 h-px bg-ink-400"></span><span className="text-ink-600">solid (manager)</span></span>
          <span className="flex items-center gap-1.5"><span className="inline-block w-4 h-px border-t border-dashed border-violet-400"></span><span className="text-violet-700">dotted (matrix)</span></span>
        </div>
      )}
      <div className="relative" style={{ width: width+40, height: height+40, padding: 20 }}>
        {/* connector lines */}
        <svg className="absolute inset-0 pointer-events-none" width={width+40} height={height+40}>
          {edges.map(e => {
            const a = positions[e.from], b = positions[e.to];
            if (!a || !b) return null;
            const x1 = a.cx + 20, y1 = a.y + NODE_H + 20;
            const x2 = b.cx + 20, y2 = b.y + 20;
            const mid = y1 + (y2-y1)/2;
            const d = `M ${x1} ${y1} L ${x1} ${mid} L ${x2} ${mid} L ${x2} ${y2}`;
            return <path key={e.from+'-'+e.to} d={d} stroke="#94A3B8" strokeWidth={1.3} fill="none" strokeLinecap="round"/>;
          })}
          {/* dotted matrix edges — bezier-кривые поверх solid дерева */}
          {dottedEdges.map((e, idx) => {
            const a = positions[e.from], b = positions[e.to];
            if (!a || !b) return null;
            const x1 = a.cx + 20, y1 = a.y + NODE_H/2 + 20;
            const x2 = b.cx + 20, y2 = b.y + NODE_H/2 + 20;
            const dx = (x1 + x2) / 2;
            const dy = Math.min(y1, y2) - 30;
            const d = `M ${x1} ${y1} Q ${dx} ${dy} ${x2} ${y2}`;
            return <path key={'dotted-'+idx+'-'+e.from+'-'+e.to} d={d}
              stroke="#A78BFA" strokeWidth={1} fill="none"
              strokeDasharray="5 3" opacity={0.55} strokeLinecap="round"/>;
          })}
        </svg>
        {/* nodes */}
        {people.map(p => {
          const pos = positions[p.id];
          if (!pos) return null;
          const st = personStatus(p);
          const isVacant = st === 'vacant';
          const isOnLeave = st === 'onLeave';
          const borderColor = showGrades
            ? gradeBorder(p.currentGrade)
            : isVacant ? '#CBD1E0' : isOnLeave ? '#FCD34D' : '#E6E9F2';
          const borderStyle = isVacant ? 'dashed' : 'solid';
          const bgColor = isVacant ? '#F5F6FA' : '#FFFFFF';
          return (
            <button key={p.id}
              onClick={()=>onOpen(p.id)}
              className="absolute rounded-xl shadow-card hover:shadow-pop transition-shadow text-left flex items-center gap-2.5 px-3 py-2.5"
              style={{ left: pos.x+20, top: pos.y+20, width: NODE_W, height: NODE_H, border: `1.5px ${borderStyle} ${borderColor}`, background: bgColor, opacity: isVacant ? 0.85 : 1 }}>
              <Avatar p={p} size={36}/>
              <div className="min-w-0 flex-1">
                <div className={`text-[12.5px] font-semibold truncate leading-tight ${isVacant?'italic text-ink-500':'text-ink-900'}`}>{p.name || p.role}</div>
                <div className="text-[10.5px] text-ink-500 truncate leading-tight mt-0.5">{p.role}</div>
                <div className="flex items-center gap-1.5 mt-1.5 flex-wrap">
                  {p.team && <span className="text-[9px] text-ink-400 truncate">{p.team}</span>}
                  {isVacant && (
                    <span className="text-[9px] px-1.5 py-0.5 rounded-full font-semibold border border-dashed border-ink-300 text-ink-500 bg-white">Vacant</span>
                  )}
                  {isOnLeave && (
                    <span className="text-[9px] px-1.5 py-0.5 rounded-full font-semibold bg-amber-50 text-amber-700 border border-amber-200">Отпуск</span>
                  )}
                  {(dottedCountByEmail[(p.email||'').toLowerCase()] || 0) > 0 && (
                    <span className="text-[9px] px-1.5 py-0.5 rounded-full font-semibold bg-violet-50 text-violet-700 border border-dashed border-violet-300" title="Matrix: dotted-куратор по продукту/проекту">
                      ⋯ {dottedCountByEmail[(p.email||'').toLowerCase()]}
                    </span>
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

const PeoplePage = ({ onOpen, onGoHRAdmin }) => {
  const { user, store, dottedRels = [] } = useApp();
  const perms = permissions(user, store.state.people);
  const showGrades = perms.canSeeOrgWide; /* HR + exec видят grades всех; managers видят grade своих directs в «Мои reviews». */
  const canEditPeople = perms.canSeeHRAdmin; /* только hr_admin — exec не редактирует employees */
  const allPeople = store.state.people;
  const activePeople = allPeople.filter(p => p.active !== false);
  const byIdLocal = (id) => allPeople.find(x => x.id === id);
  const [view, setView] = useState('chart'); /* 'chart' | 'grid' */
  const [chartMode, setChartMode] = useState('focus'); /* 'focus' | 'full' */
  const [focusId, setFocusId] = useState(user?.id || activePeople[0]?.id);
  const [team, setTeam] = useState('All');
  const [track, setTrack] = useState('All');
  const [level, setLevel] = useState('All');
  const [statusFilter, setStatusFilter] = useState('All'); /* All | active | vacant | onLeave */
  const [gradeFilter, setGradeFilter] = useState('All');   /* All | A-player | Above bar | On track | Underperformer */
  const [q, setQ] = useState('');
  /* Список людей для фильтрации: для status==='vacant' нужно показать и неактивные позиции */
  const filterPool = (statusFilter === 'All' || statusFilter === 'active')
    ? allPeople.filter(p => p.active !== false)
    : allPeople; /* vacancies/onLeave могут быть active=false */
  const teams = Array.from(new Set(allPeople.map(p=>p.team).filter(Boolean))).sort();
  const allLevels = Object.keys(LEVELS);
  const qLower = q.trim().toLowerCase();
  const list = filterPool
    .filter(p => team==='All' || p.team===team)
    .filter(p => track==='All' || personLevel(p).track===track)
    .filter(p => level==='All' || personLevel(p).level===level)
    .filter(p => statusFilter==='All' || personStatus(p)===statusFilter)
    .filter(p => !showGrades || gradeFilter==='All' || (p.currentGrade||'') === gradeFilter)
    .filter(p => !qLower
      || (p.name||'').toLowerCase().includes(qLower)
      || (p.role||'').toLowerCase().includes(qLower)
      || (p.email||'').toLowerCase().includes(qLower)
      || (p.team||'').toLowerCase().includes(qLower));
  const activeFiltersCount = (team!=='All'?1:0) + (track!=='All'?1:0) + (level!=='All'?1:0) + (statusFilter!=='All'?1:0) + (showGrades && gradeFilter!=='All'?1:0);
  const resetFilters = () => { setTeam('All'); setTrack('All'); setLevel('All'); setStatusFilter('All'); setGradeFilter('All'); };
  return (
    <div className="p-8 space-y-5 fade-in">
      <Card>
        <div className="p-5 flex items-center gap-3 flex-wrap">
          <div className="flex-1 min-w-0">
            <h2 className="text-lg font-bold tracking-tight">Freedom AI Labs · {activePeople.length} чел.</h2>
            <div className="text-xs text-ink-500">Внутри Choco · Алматы · обновляется автоматически из HR Admin</div>
          </div>
          <div className="flex items-center gap-1 bg-ink-50 rounded-lg p-1">
            <button onClick={()=>setView('chart')} className={`text-xs px-2.5 py-1 rounded-md flex items-center gap-1.5 ${view==='chart'?'bg-white shadow-card font-semibold':'text-ink-600 hover:text-ink-900'}`}>
              <Icon name="target" className="w-3.5 h-3.5"/>Орг-чарт
            </button>
            <button onClick={()=>setView('grid')} className={`text-xs px-2.5 py-1 rounded-md flex items-center gap-1.5 ${view==='grid'?'bg-white shadow-card font-semibold':'text-ink-600 hover:text-ink-900'}`}>
              <Icon name="grid" className="w-3.5 h-3.5"/>Список
            </button>
          </div>
        </div>
      </Card>

      {view==='chart' ? (
        <Card>
          <CardHead
            title="Организационная структура"
            subtitle={chartMode==='focus'
              ? 'Фокус на одном человеке — менеджер сверху, команда в ряд, подчинённые снизу. Клик на карточку — сдвинуть фокус.'
              : 'Полное дерево организации · прокрутите горизонтально. Grades — в Калибровке и Reviews.'}
            right={
              <div className="flex items-center gap-2">
                <div className="flex items-center gap-1 bg-ink-50 rounded-lg p-1">
                  <button onClick={()=>setChartMode('focus')} className={`text-xs px-2.5 py-1 rounded-md ${chartMode==='focus'?'bg-white shadow-card font-semibold':'text-ink-600 hover:text-ink-900'}`}>
                    Моя команда
                  </button>
                  <button onClick={()=>setChartMode('full')} className={`text-xs px-2.5 py-1 rounded-md ${chartMode==='full'?'bg-white shadow-card font-semibold':'text-ink-600 hover:text-ink-900'}`}>
                    Вся структура
                  </button>
                </div>
                {chartMode==='focus' && user && focusId !== user.id && (
                  <button onClick={()=>setFocusId(user.id)} className="text-[11px] px-2.5 py-1 rounded-lg border border-ink-200 hover:bg-ink-50 text-ink-700 font-semibold">
                    ← Ко мне
                  </button>
                )}
              </div>
            }
          />
          <div className="p-4">
            {chartMode==='focus' ? (
              <FocusOrgChart people={activePeople} focusId={focusId} onFocus={setFocusId} onOpen={onOpen} dottedRels={dottedRels}/>
            ) : (
              <OrgChart people={activePeople} onOpen={onOpen} showGrades={false} dottedRels={dottedRels}/>
            )}
            {chartMode==='full' && (
              <div className="mt-3 text-[11px] text-ink-500 px-2">
                Прокрутите горизонтально — дерево содержит {activePeople.length} человек. Нажмите на карточку, чтобы открыть профиль.
              </div>
            )}
          </div>
        </Card>
      ) : (
        <React.Fragment>
          {canEditPeople && (
            <Card>
              <div className="p-4 flex items-center gap-3 flex-wrap bg-brand-50/40 rounded-xl">
                <div className="w-9 h-9 rounded-lg bg-brand-100 text-brand-700 flex items-center justify-center flex-shrink-0">
                  <Icon name="users" className="w-4 h-4"/>
                </div>
                <div className="flex-1 min-w-[220px]">
                  <div className="text-sm font-semibold text-ink-900">Редактирование сотрудников</div>
                  <div className="text-xs text-ink-500">Добавление, изменение и деактивация — в HR Admin. Орг-структура и этот список обновятся автоматически.</div>
                </div>
                {onGoHRAdmin && (
                  <button onClick={onGoHRAdmin} className="text-xs px-3 py-2 rounded-lg bg-ink-900 text-white font-semibold hover:bg-ink-800 flex items-center gap-1.5">
                    Перейти в HR Admin <Icon name="chev" className="w-3.5 h-3.5"/>
                  </button>
                )}
              </div>
            </Card>
          )}
          <Card>
            <div className="p-4 border-b border-ink-100 space-y-3">
              {/* Ряд 1: поиск + счётчик */}
              <div className="flex items-center gap-3 flex-wrap">
                <div className="relative flex-1 min-w-[220px]">
                  <Icon name="search" className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink-400"/>
                  <input
                    type="text"
                    value={q}
                    onChange={e=>setQ(e.target.value)}
                    placeholder="Поиск по имени, роли, email или команде…"
                    className="w-full pl-9 pr-3 py-2 text-sm border border-ink-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-200 focus:border-brand-400"
                  />
                </div>
                <div className="text-xs text-ink-500 whitespace-nowrap">
                  Показано <span className="font-semibold text-ink-900">{list.length}</span> из {filterPool.length}
                </div>
              </div>
              {/* Ряд 2: селекторы фильтров */}
              <div className="flex items-center gap-2 flex-wrap">
                <div className="flex items-center gap-1.5">
                  <Icon name="target" className="w-3.5 h-3.5 text-ink-400"/>
                  <span className="text-[11px] uppercase tracking-wider text-ink-500 font-semibold">Фильтры</span>
                </div>
                {/* Team */}
                <select
                  value={team}
                  onChange={e=>setTeam(e.target.value)}
                  className={`text-xs px-2.5 py-1.5 rounded-lg border bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-200 ${team==='All'?'border-ink-200 text-ink-700':'border-brand-300 text-brand-700 font-semibold bg-brand-50'}`}
                >
                  <option value="All">Команда · все</option>
                  {teams.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
                {/* Track */}
                <select
                  value={track}
                  onChange={e=>setTrack(e.target.value)}
                  className={`text-xs px-2.5 py-1.5 rounded-lg border bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-200 ${track==='All'?'border-ink-200 text-ink-700':'border-brand-300 text-brand-700 font-semibold bg-brand-50'}`}
                >
                  <option value="All">Трек · все</option>
                  {Object.entries(TRACKS).map(([k,v]) => <option key={k} value={k}>{v.label}</option>)}
                </select>
                {/* Level */}
                <select
                  value={level}
                  onChange={e=>setLevel(e.target.value)}
                  className={`text-xs px-2.5 py-1.5 rounded-lg border bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-200 ${level==='All'?'border-ink-200 text-ink-700':'border-brand-300 text-brand-700 font-semibold bg-brand-50'}`}
                >
                  <option value="All">Уровень · все</option>
                  {allLevels.filter(lv => track==='All' || LEVELS[lv].track===track).map(lv => (
                    <option key={lv} value={lv}>{LEVELS[lv].label}</option>
                  ))}
                </select>
                {/* Status */}
                <select
                  value={statusFilter}
                  onChange={e=>setStatusFilter(e.target.value)}
                  className={`text-xs px-2.5 py-1.5 rounded-lg border bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-200 ${statusFilter==='All'?'border-ink-200 text-ink-700':'border-brand-300 text-brand-700 font-semibold bg-brand-50'}`}
                >
                  <option value="All">Статус · все</option>
                  <option value="active">Работает</option>
                  <option value="vacant">Вакансия</option>
                  <option value="onLeave">В отпуске</option>
                </select>
                {/* Grade — RBAC gated */}
                {showGrades && (
                  <select
                    value={gradeFilter}
                    onChange={e=>setGradeFilter(e.target.value)}
                    className={`text-xs px-2.5 py-1.5 rounded-lg border bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-200 ${gradeFilter==='All'?'border-ink-200 text-ink-700':'border-brand-300 text-brand-700 font-semibold bg-brand-50'}`}
                    title="Grade виден только HR / Director"
                  >
                    <option value="All">Grade · все</option>
                    <option value="A-player">A-player</option>
                    <option value="Above bar">Above bar</option>
                    <option value="Underperformer">Underperformer</option>
                  </select>
                )}
                {activeFiltersCount > 0 && (
                  <button
                    onClick={resetFilters}
                    className="text-[11px] px-2.5 py-1.5 rounded-lg border border-ink-200 text-ink-600 hover:bg-ink-50 hover:text-ink-900 flex items-center gap-1"
                  >
                    Сбросить ({activeFiltersCount})
                  </button>
                )}
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-ink-50/60 text-[11px] uppercase tracking-wider text-ink-500">
                  <tr>
                    <th className="text-left font-semibold px-4 py-3">Сотрудник</th>
                    <th className="text-left font-semibold px-4 py-3">Роль</th>
                    <th className="text-left font-semibold px-4 py-3">Level</th>
                    <th className="text-left font-semibold px-4 py-3">Команда</th>
                    <th className="text-left font-semibold px-4 py-3">Менеджер</th>
                    <th className="text-left font-semibold px-4 py-3">Статус</th>
                    {showGrades && <th className="text-left font-semibold px-4 py-3">Grade</th>}
                  </tr>
                </thead>
                <tbody>
                  {list.length === 0 ? (
                    <tr>
                      <td colSpan={showGrades ? 7 : 6} className="px-4 py-10 text-center text-xs text-ink-400">
                        Никого не нашли. Попробуйте изменить поиск или сбросить фильтры.
                      </td>
                    </tr>
                  ) : list.map(p => {
                    const mgr = p.managerId ? byIdLocal(p.managerId) : null;
                    const lv = personLevel(p).level;
                    const st = personStatus(p);
                    const isVacant = st === 'vacant';
                    return (
                      <tr
                        key={p.id}
                        onClick={()=>onOpen(p.id)}
                        className="border-t border-ink-100 hover:bg-brand-50/30 cursor-pointer transition-colors"
                      >
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-3 min-w-0">
                            <Avatar p={p} size={36}/>
                            <div className="min-w-0">
                              <div className={`font-semibold truncate ${isVacant?'italic text-ink-500':'text-ink-900'}`}>{p.name || p.role || '—'}</div>
                              <div className="text-[11px] text-ink-500 truncate">{p.email || '—'}</div>
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-ink-700">{p.role || '—'}</td>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <span
                              className={`text-[10px] px-1.5 py-0.5 rounded border font-semibold ${LEVEL_TONE(lv)}`}
                              title={LEVELS[lv]?.label}
                            >{lv}</span>
                            <span className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold">{p.seniority || ''}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-ink-700">
                          <div className="truncate">{p.team || '—'}</div>
                          {p.subteam && <div className="text-[11px] text-ink-400 truncate">{p.subteam}</div>}
                        </td>
                        <td className="px-4 py-3 text-ink-700">
                          {mgr ? (
                            <div className="flex items-center gap-2 min-w-0">
                              <Avatar p={mgr} size={24}/>
                              <span className="truncate">{mgr.name}</span>
                            </div>
                          ) : <span className="text-ink-400">—</span>}
                        </td>
                        <td className="px-4 py-3">
                          <span className={`text-[10px] px-1.5 py-0.5 rounded-full border font-semibold ${STATUS_CHIP[st]}`}>{STATUS_LABEL[st]}</span>
                        </td>
                        {showGrades && (
                          <td className="px-4 py-3">
                            {p.currentGrade
                              ? <span className={gradeChip(p.currentGrade)}>{p.currentGrade}</span>
                              : <span className="text-ink-400">—</span>}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Card>
        </React.Fragment>
      )}
    </div>
  );
};

const ProfilePage = ({ personId, onBack, onFill }) => {
  const { store, dottedRels = [] } = useApp();
  const people = store.state.people;
  const liveById = (id) => people.find(x=>x.id===id) || byId(id);
  const p = liveById(personId);
  if (!p) return <div className="p-8 text-sm text-ink-500">Сотрудник не найден (возможно деактивирован). <button className="underline" onClick={onBack}>Назад</button></div>;
  const hist = HISTORY[p.id] || HISTORY[personId] || [];
  const latest = hist.length ? hist[hist.length-1] : { cycle:'—', skills:'Intermediate', deliverables:'Intermediate', culture:'Intermediate', overall: p.currentGrade || 'On track' };
  const mgr = p.managerId ? liveById(p.managerId) : null;
  /* Matrix: dotted-кураторы для p */
  const pEmail = (p.email || '').toLowerCase();
  const pDottedMgrs = dottedRels.filter(r => r.relationship === 'dotted' && (r.employee_email || '').toLowerCase() === pEmail);
  const team = people.filter(x=>x.active!==false && x.team===p.team && x.id!==p.id);
  const chartData = hist.map(h=>({
    q:h.cycle, skills:MASTERY_SCORE[h.skills], deliv:MASTERY_SCORE[h.deliverables], cult:MASTERY_SCORE[h.culture],
  }));
  const radarData = [
    { d:'Skills', v: MASTERY_SCORE[latest.skills], full:5 },
    { d:'Deliverables', v: MASTERY_SCORE[latest.deliverables], full:5 },
    { d:'Culture', v: MASTERY_SCORE[latest.culture], full:5 },
  ];
  const aplayerCount = hist.filter(h=>h.overall==='A-player').length;
  const eligible = aplayerCount>=2 && p.tenure>=1.0;
  return (
    <div className="p-8 space-y-5 fade-in">
      <div className="flex items-center gap-2 text-sm text-ink-500">
        <button onClick={onBack} className="hover:text-ink-900 flex items-center gap-1"><Icon name="chev" className="w-4 h-4 rotate-180"/> Команда</button>
        <span>/</span>
        <span className="text-ink-900 font-semibold">{p.name}</span>
      </div>

      <div className="grid lg:grid-cols-[1fr_360px] gap-5">
        <div className="space-y-5">
          <Card>
            <div className="p-6 flex items-center gap-5">
              <Avatar p={p} size={72}/>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <h2 className="text-2xl font-extrabold tracking-tight">{p.name}</h2>
                  {(() => { const lv = personLevel(p).level; return (
                    <span className={`text-[11px] px-2 py-0.5 rounded border font-semibold ${LEVEL_TONE(lv)}`} title={LEVELS[lv]?.label}>{lv}</span>
                  ); })()}
                  {p.currentGrade
                    ? <span className={gradeChip(p.currentGrade)}>{p.currentGrade}</span>
                    : <span className="text-[11px] px-2 py-0.5 rounded-full bg-ink-100 text-ink-500 italic" title="Grade появится после Calibration · Talent Bar review">ещё не оценён</span>}
                </div>
                <div className="text-sm text-ink-600 mt-1">{p.role} · {p.seniority} · {p.team}</div>
                <div className="text-xs text-ink-500 mt-1 flex items-center gap-3 flex-wrap">
                  <span>{p.email}</span>
                  {mgr && (
                    <span>Менеджер: <span className="text-ink-900 font-semibold">{mgr.name}</span>
                      <span className="ml-1 text-[9px] px-1.5 py-0.5 rounded border bg-brand-50 text-brand-700 border-brand-200 uppercase tracking-wider font-semibold" title="Solid line: пишет финальный Manager Assessment">solid</span>
                    </span>
                  )}
                  {pDottedMgrs.map((r,i) => (
                    <span key={'pdotted-'+i}>Куратор: <span className="text-ink-900 font-semibold">{r.manager_name}</span>
                      <span className="ml-1 text-[9px] px-1.5 py-0.5 rounded border bg-violet-50 text-violet-700 border-violet-200 uppercase tracking-wider font-semibold" title="Dotted line: продуктовый/проектный куратор">dotted</span>
                    </span>
                  ))}
                  <span>Стаж: {formatTenure(p.tenure)}</span>
                  <span>Bar {p.level || p.seniority}: <span className={masteryChip(talentBarFor(p))}>{talentBarFor(p)}</span></span>
                  {p.levelSince && <span>Уровень с: <span className="text-ink-900 font-semibold">{p.levelSince}</span></span>}
                </div>
              </div>
              <button onClick={()=>onFill(p.id)} className="h-10 px-4 rounded-xl bg-brand-600 text-white font-semibold text-sm hover:bg-brand-700">Заполнить scorecard</button>
            </div>
          </Card>

          <MatrixCollaboration p={p}/>

          <Card>
            <CardHead title="Performance history" subtitle={`${hist.length} последних полугодия`}/>
            <div className="p-5 h-[280px]">
              <ResponsiveContainer>
                <LineChart data={chartData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#E6E9F2" vertical={false}/>
                  <XAxis dataKey="q" tick={{fontSize:11, fill:'#6B7594'}} axisLine={false} tickLine={false}/>
                  <YAxis domain={[1,5]} tick={{fontSize:11, fill:'#6B7594'}} axisLine={false} tickLine={false} ticks={[1,2,3,4,5]} tickFormatter={v=>MASTERY[v-1].slice(0,4)}/>
                  <Tooltip contentStyle={{borderRadius:12, fontSize:12}}/>
                  <Legend wrapperStyle={{fontSize:12}}/>
                  <Line type="monotone" dataKey="skills" name="Skills" stroke="#3B82F6" strokeWidth={2.5} dot={{r:4}}/>
                  <Line type="monotone" dataKey="deliv" name="Deliverables" stroke="#F59E0B" strokeWidth={2.5} dot={{r:4}}/>
                  <Line type="monotone" dataKey="cult" name="Culture" stroke="#10B981" strokeWidth={2.5} dot={{r:4}}/>
                </LineChart>
              </ResponsiveContainer>
            </div>
          </Card>

          <div className="grid md:grid-cols-2 gap-5">
            <Card>
              <CardHead title="Competency radar" subtitle={`Последнее полугодие: ${latest.cycle}`}/>
              <div className="p-5 h-[260px]">
                <ResponsiveContainer>
                  <RadarChart data={radarData}>
                    <PolarGrid stroke="#E6E9F2"/>
                    <PolarAngleAxis dataKey="d" tick={{fontSize:11, fill:'#6B7594'}}/>
                    <PolarRadiusAxis domain={[0,5]} tick={{fontSize:10, fill:'#9AA2BE'}}/>
                    <Radar name="Level" dataKey="v" stroke="#1D4E89" fill="#3B82F6" fillOpacity={0.35}/>
                  </RadarChart>
                </ResponsiveContainer>
              </div>
            </Card>
            <Card>
              <CardHead title="Promotion eligibility" subtitle="Оформляется после Calibration · Talent Bar"/>
              <div className="p-5 space-y-3">
                <div className={`rounded-xl p-4 ${eligible?'bg-emerald-50 ring-1 ring-emerald-200':'bg-ink-50 ring-1 ring-ink-100'}`}>
                  <div className="flex items-center gap-2 mb-2">
                    <div className={`w-8 h-8 rounded-full grid place-items-center ${eligible?'bg-emerald-500 text-white':'bg-ink-200 text-ink-500'}`}><Icon name={eligible?'check':'lock'} className="w-4 h-4"/></div>
                    <div>
                      <div className="font-bold text-sm">{eligible? 'Auto-eligible':'Ещё не готов'}</div>
                      <div className="text-xs text-ink-500">{eligible?'Триггер сработал — рассмотреть к следующему циклу':'Требуется больше циклов A-player'}</div>
                    </div>
                  </div>
                </div>
                <ul className="text-sm space-y-2">
                  <li className="flex items-center gap-2"><Icon name={aplayerCount>=2?'check':'close'} className={`w-4 h-4 ${aplayerCount>=2?'text-emerald-600':'text-ink-400'}`}/> A-player ≥ 2 из последних 4: <span className="font-mono ml-auto">{aplayerCount}/4</span></li>
                  <li className="flex items-center gap-2"><Icon name={p.tenure>=1?'check':'close'} className={`w-4 h-4 ${p.tenure>=1?'text-emerald-600':'text-ink-400'}`}/> Стаж ≥ 1 год на уровне: <span className="font-mono ml-auto">{p.tenure.toFixed(1)}</span></li>
                  <li className="flex items-center gap-2"><Icon name="check" className="w-4 h-4 text-emerald-600"/> Нет Below bar / Unsatisfactory</li>
                </ul>
              </div>
            </Card>
          </div>
        </div>

        <div className="space-y-5">
          <Card>
            <CardHead title="Команда"/>
            <div className="divide-y divide-ink-100">
              {team.slice(0,6).map(t=>(
                <div key={t.id} className="p-3 flex items-center gap-3">
                  <Avatar p={t} size={28}/>
                  <div className="min-w-0 flex-1">
                    <div className="text-sm font-semibold truncate">{t.name}</div>
                    <div className="text-xs text-ink-500 truncate">{t.role}</div>
                  </div>
                </div>
              ))}
            </div>
          </Card>

          <Card>
            <CardHead title="История оценок"/>
            <div className="divide-y divide-ink-100">
              {hist.slice().reverse().map(h=>(
                <div key={h.cycle} className="p-3">
                  <div className="flex items-center justify-between mb-1">
                    <div className="text-sm font-semibold">{h.cycle}</div>
                    <span className={gradeChip(h.overall)}>{h.overall}</span>
                  </div>
                  <div className="flex gap-1 flex-wrap">
                    <span className={masteryChip(h.skills)}>S·{h.skills}</span>
                    <span className={masteryChip(h.deliverables)}>D·{h.deliverables}</span>
                    <span className={masteryChip(h.culture)}>C·{h.culture}</span>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

/* ───────── MATRIX COLLABORATION (Phase 3.2 + 3.3) ─────────
   Показывается на Profile page если между current user и target есть dotted-связь.
   - Если ты dotted-куратор: можешь добавить Stream Context Note к Manager Assessment
     и сделать Promo Endorsement (recommend/neutral/concern).
   - Если target — твой dotted-куратор: просто info-баннер. */
const MatrixCollaboration = ({ p }) => {
  const { user, dottedRels = [] } = useApp();
  const myEmail = (user?.email || '').toLowerCase();
  const pEmail = (p?.email || '').toLowerCase();

  const iAmDottedMgr = useMemo(() =>
    dottedRels.some(r => r.relationship === 'dotted'
      && (r.employee_email || '').toLowerCase() === pEmail
      && (r.manager_email || '').toLowerCase() === myEmail
    ), [dottedRels, pEmail, myEmail]);
  const pIsMyDottedMgr = useMemo(() =>
    dottedRels.some(r => r.relationship === 'dotted'
      && (r.employee_email || '').toLowerCase() === myEmail
      && (r.manager_email || '').toLowerCase() === pEmail
    ), [dottedRels, pEmail, myEmail]);

  const [ctx, setCtx] = useState({ manager_assessment_id: null, promo_decision_id: null });
  const [notes, setNotes] = useState([]);
  const [endorsements, setEndorsements] = useState([]);
  const [noteDraft, setNoteDraft] = useState('');
  const [voteDraft, setVoteDraft] = useState('recommend');
  const [endorseComment, setEndorseComment] = useState('');
  const [busy, setBusy] = useState({ note:false, endorse:false });
  const [err, setErr] = useState({ note:'', endorse:'' });

  const reload = useCallback(async () => {
    if (!pEmail || !supabase || (!iAmDottedMgr && !pIsMyDottedMgr)) return;
    try {
      const { data: c } = await supabase.rpc('get_employee_current_cycle_context', { p_employee_email: pEmail });
      const next = c || { manager_assessment_id: null, promo_decision_id: null };
      setCtx(next);
      if (next.manager_assessment_id) {
        const r = await supabase.rpc('list_assessment_notes', { p_assessment_id: next.manager_assessment_id });
        setNotes(Array.isArray(r.data) ? r.data : []);
      } else {
        setNotes([]);
      }
      if (next.promo_decision_id) {
        const r = await supabase.rpc('list_promo_endorsements', { p_promo_decision_id: next.promo_decision_id });
        setEndorsements(Array.isArray(r.data) ? r.data : []);
      } else {
        setEndorsements([]);
      }
    } catch (e) {
      console.warn('[matrix-collab] load failed:', e?.message || e);
    }
  }, [pEmail, iAmDottedMgr, pIsMyDottedMgr]);
  useEffect(() => { reload(); }, [reload]);

  const submitNote = async () => {
    if (!noteDraft.trim() || !ctx.manager_assessment_id) return;
    setBusy(b => ({ ...b, note:true })); setErr(e => ({ ...e, note:'' }));
    try {
      const { error } = await supabase.rpc('add_dotted_context_note', {
        p_assessment_id: ctx.manager_assessment_id, p_note: noteDraft.trim(),
      });
      if (error) throw error;
      setNoteDraft('');
      await reload();
    } catch (e) {
      setErr(x => ({ ...x, note: e.message || String(e) }));
    } finally {
      setBusy(b => ({ ...b, note:false }));
    }
  };

  const submitEndorsement = async () => {
    if (!ctx.promo_decision_id) return;
    setBusy(b => ({ ...b, endorse:true })); setErr(e => ({ ...e, endorse:'' }));
    try {
      const { error } = await supabase.rpc('endorse_promo', {
        p_promo_decision_id: ctx.promo_decision_id,
        p_vote: voteDraft,
        p_comment: endorseComment.trim() || null,
      });
      if (error) throw error;
      setEndorseComment('');
      await reload();
    } catch (e) {
      setErr(x => ({ ...x, endorse: e.message || String(e) }));
    } finally {
      setBusy(b => ({ ...b, endorse:false }));
    }
  };

  if (!iAmDottedMgr && !pIsMyDottedMgr) return null;

  const voteTone = (v) => v === 'recommend' ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
    : v === 'concern' ? 'bg-rose-50 text-rose-700 border-rose-200'
    : 'bg-ink-50 text-ink-700 border-ink-200';
  const voteLabel = (v) => v === 'recommend' ? 'Recommend' : v === 'concern' ? 'Concern' : 'Neutral';

  return (
    <Card>
      <CardHead title="Matrix collaboration" subtitle="Phase 3 · через dotted-связь"/>
      <div className="p-5 space-y-5">
        {pIsMyDottedMgr && (
          <div className="px-3 py-2.5 rounded-lg bg-violet-50 border border-violet-200 text-[12px] text-violet-900">
            <b>{p.name?.split(' ')[0] || 'Этот человек'}</b> — твой dotted-куратор по продукту / проекту.
            Видит твою работу в калибровке, может добавить product context к Manager Assessment и endorse'ит твоё promo.
            Финальную performance-оценку всё равно пишет solid manager.
          </div>
        )}

        {iAmDottedMgr && (
          <>
            <div className="px-3 py-2.5 rounded-lg bg-violet-50 border border-violet-200 text-[12px] text-violet-900">
              Ты — dotted-куратор <b>{p.name || p.role}</b>. Видишь его performance-данные read-only;
              можешь добавлять Stream Context Notes и endorse'ить promo. Финальную оценку пишет solid manager.
            </div>

            {/* ─── Stream Context Notes ─── */}
            <div className="border-t border-ink-100 pt-4">
              <div className="text-[11px] uppercase tracking-wider text-ink-700 font-semibold mb-2">Stream Context Notes</div>
              {!ctx.manager_assessment_id && (
                <div className="text-[11px] text-ink-500 italic">Manager Assessment ещё не создан в текущем цикле — solid manager должен заполнить его первым.</div>
              )}
              {ctx.manager_assessment_id && (
                <>
                  {notes.length > 0 ? (
                    <div className="space-y-2 mb-3">
                      {notes.map(n => (
                        <div key={n.id} className="px-3 py-2 rounded-lg bg-violet-50/50 border border-violet-100 text-[12px]">
                          <div className="text-ink-900">{n.note}</div>
                          <div className="text-[10px] text-ink-500 mt-1">{n.author_name} · {new Date(n.created_at).toLocaleDateString('ru-RU')}</div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-[11px] text-ink-500 italic mb-3">Заметок пока нет. Добавь первую — она будет видна solid manager'у при финализации.</div>
                  )}
                  <textarea
                    value={noteDraft}
                    onChange={e => setNoteDraft(e.target.value)}
                    rows={2}
                    placeholder="Что ты как продуктовый/проектный куратор хочешь добавить к оценке: контекст работы, специфические достижения по продукту, риски…"
                    className="w-full px-3 py-2 rounded-lg border border-ink-200 text-[12px]"
                  />
                  <div className="flex items-center justify-end gap-2 mt-2">
                    {err.note && <span className="text-[11px] text-rose-600">{err.note}</span>}
                    <button
                      onClick={submitNote}
                      disabled={!noteDraft.trim() || busy.note}
                      className="h-8 px-3 rounded-lg bg-violet-600 text-white text-xs font-semibold hover:bg-violet-700 disabled:opacity-50"
                    >
                      {busy.note ? 'Сохраняю…' : 'Добавить note'}
                    </button>
                  </div>
                </>
              )}
            </div>

            {/* ─── Promo Endorsement ─── */}
            <div className="border-t border-ink-100 pt-4">
              <div className="text-[11px] uppercase tracking-wider text-ink-700 font-semibold mb-2">Promo Endorsement</div>
              {!ctx.promo_decision_id && (
                <div className="text-[11px] text-ink-500 italic">Активного promo decision у этого сотрудника сейчас нет.</div>
              )}
              {ctx.promo_decision_id && (
                <>
                  {endorsements.length > 0 && (
                    <div className="space-y-2 mb-3">
                      {endorsements.map(en => (
                        <div key={en.id} className="px-3 py-2 rounded-lg bg-white border border-ink-200 text-[12px] flex items-start gap-3">
                          <span className={`text-[10px] px-2 py-0.5 rounded border font-semibold uppercase tracking-wider whitespace-nowrap ${voteTone(en.vote)}`}>{voteLabel(en.vote)}</span>
                          <div className="flex-1 min-w-0">
                            {en.comment && <div className="text-ink-900">{en.comment}</div>}
                            <div className="text-[10px] text-ink-500 mt-0.5">{en.endorser_name} · {en.endorser_title} · {new Date(en.created_at).toLocaleDateString('ru-RU')}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  <div className="flex items-center gap-2 mb-2">
                    {['recommend','neutral','concern'].map(v => (
                      <label key={v} className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border cursor-pointer text-[11px] font-semibold ${voteDraft===v ? voteTone(v) : 'bg-white border-ink-200 text-ink-600 hover:bg-ink-50'}`}>
                        <input type="radio" name="vote" value={v} checked={voteDraft===v} onChange={()=>setVoteDraft(v)} className="accent-violet-600"/>
                        {voteLabel(v)}
                      </label>
                    ))}
                  </div>
                  <textarea
                    value={endorseComment}
                    onChange={e => setEndorseComment(e.target.value)}
                    rows={2}
                    placeholder="Комментарий (необязательно). CEO увидит при approval."
                    className="w-full px-3 py-2 rounded-lg border border-ink-200 text-[12px]"
                  />
                  <div className="flex items-center justify-end gap-2 mt-2">
                    {err.endorse && <span className="text-[11px] text-rose-600">{err.endorse}</span>}
                    <button
                      onClick={submitEndorsement}
                      disabled={busy.endorse}
                      className="h-8 px-3 rounded-lg bg-violet-600 text-white text-xs font-semibold hover:bg-violet-700 disabled:opacity-50"
                    >
                      {busy.endorse ? 'Сохраняю…' : (endorsements.some(en => (en.endorser_email||'').toLowerCase() === myEmail) ? 'Обновить endorsement' : 'Endorse')}
                    </button>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </Card>
  );
};

/* ───────── PROMOTIONS ───────── */
const PromotionsPage = () => {
  const candidates = PEOPLE.filter(p=>{
    const hist = Array.isArray(HISTORY[p.id]) ? HISTORY[p.id] : [];
    const aCount = hist.filter(h=>h.overall==='A-player').length;
    return aCount>=2 && p.tenure>=1.0;
  });
  return (
    <div className="p-8 space-y-5 fade-in">
      <Card>
        <CardHead title="Цикл повышений" subtitle="Каждые 6 месяцев. Auto-flag → Validation → Approval → Announcement" right={
          <button className="h-9 px-3 rounded-lg bg-brand-600 text-white font-semibold text-sm hover:bg-brand-700">Начать цикл</button>
        }/>
        <div className="p-5 grid md:grid-cols-4 gap-4">
          {[
            { n:1, t:'Automatic flag', d:'Performance team присылает менеджерам список A-player ≥1 год', status:'done'},
            { n:2, t:'Validation / Rejection', d:'Менеджер утверждает или отклоняет с обоснованием (STAR)', status:'active'},
            { n:3, t:'Approval', d:'Business lead → Vertical lead → CEO / Founder', status:'pending'},
            { n:4, t:'Announcement', d:'Объявление + обновление уровня и роли в системе', status:'pending'},
          ].map(s=>(
            <div key={s.n} className={`relative rounded-xl p-4 border ${s.status==='active'?'border-brand-300 bg-brand-50':s.status==='done'?'border-emerald-200 bg-emerald-50/40':'border-ink-100'}`}>
              <div className={`w-7 h-7 rounded-full grid place-items-center text-xs font-bold mb-2 ${s.status==='done'?'bg-emerald-500 text-white':s.status==='active'?'bg-brand-600 text-white':'bg-ink-100 text-ink-500'}`}>{s.n}</div>
              <div className="font-bold text-sm">{s.t}</div>
              <div className="text-xs text-ink-500 mt-1">{s.d}</div>
            </div>
          ))}
        </div>
      </Card>

      <Card>
        <CardHead title={`Auto-eligible кандидаты · ${candidates.length}`} subtitle="A-player / Above bar ≥2 полугодия подряд + ≥1 год на уровне"/>
        <div className="divide-y divide-ink-100">
          {candidates.map(p=>{
            const hist = Array.isArray(HISTORY[p.id]) ? HISTORY[p.id] : [];
            const aCount = hist.filter(h=>h.overall==='A-player').length;
            const nextSeniority = SENIORITY[Math.min(SENIORITY.length-1, SENIORITY.indexOf(p.seniority)+1)];
            return (
              <div key={p.id} className="p-4 grid md:grid-cols-[1fr_auto_auto_auto] items-center gap-4">
                <div className="flex items-center gap-3">
                  <Avatar p={p}/>
                  <div>
                    <div className="font-semibold">{p.name}</div>
                    <div className="text-xs text-ink-500">{p.role} · Manager: {byId(p.managerId)?.name || '—'}</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <span className="px-2 py-0.5 rounded bg-ink-100 text-ink-700 text-xs font-semibold">{p.seniority}</span>
                  <Icon name="arrow" className="w-4 h-4 text-ink-400"/>
                  <span className="px-2 py-0.5 rounded bg-brand-100 text-brand-800 text-xs font-semibold">{nextSeniority}</span>
                </div>
                <div className="text-right">
                  <div className="text-xs text-ink-500">A-player</div>
                  <div className="font-mono font-bold">{aCount}/4</div>
                </div>
                <div className="flex gap-1.5">
                  <button className="h-9 px-3 rounded-lg border border-ink-200 text-sm hover:bg-ink-50">Отклонить</button>
                  <button className="h-9 px-3 rounded-lg bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-700">Утвердить</button>
                </div>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
};

/* ───────── PIP ───────── */
const PipPage = () => {
  const { store } = useApp();
  /* Активный BoT определяется реальными кейсами из store.state.botCases.
     До завершения первой Calibration BoT-кейсов нет — показываем empty state.
     Placeholder/vacancy сотрудников (без имени) фильтруем — на них нельзя запускать PIP. */
  const activeBots = store.state.botCases.filter(b => {
    if (b.status !== 'active' && b.status !== 'halfway-done') return false;
    const emp = byId(b.employeeId) || (store.state.people || []).find(p => p.id === b.employeeId);
    if (!emp) return false;
    if (emp.placeholder) return false;
    if (!emp.name || emp.name === '—' || emp.name.trim() === '') return false;
    return true;
  });
  const activeCase = activeBots[0] || null;
  if (!activeCase) {
    return (
      <div className="p-8 fade-in">
        <Card>
          <div className="p-12 text-center">
            <Icon name="warn" className="w-12 h-12 text-ink-300 mx-auto mb-4"/>
            <div className="text-lg font-semibold text-ink-700">Активных PIP нет</div>
            <div className="text-sm text-ink-500 mt-2 max-w-lg mx-auto">
              Back on Track (BoT, 6-нед PIP) запускается только после Calibration · Talent Bar и Hold Performance Conversation
              для сотрудников с grade <b>Underperformer</b>. Первый цикл H1 2026 ещё в фазе Feedback &amp; Self-Assessment.
            </div>
          </div>
        </Card>
      </div>
    );
  }
  const pip = byId(activeCase.employeeId) || (store.state.people || []).find(p => p.id === activeCase.employeeId);
  const conv = store.state.conversations.find(c=>c.employeeId===activeCase.employeeId && c.cycleId===ACTIVE_CYCLE.id);
  const gateOpen = conv?.status==='acknowledged';
  const steps = [
    { n:1, t:'Kick-off', w:'Неделя 0', body:'HR уведомляет менеджера, проходит процесс PIP', status:'done' },
    { n:2, t:'Offer choice', w:'Неделя 0', body:'Employee выбирает: severance или PIP', status:'done' },
    { n:3, t:'Cause discussion', w:'Неделя 0', body:'Менеджер обсуждает причины недостаточной эффективности', status:'done' },
    { n:4, t:'Starting the cycle', w:'Неделя 1', body:'Менеджер + HR инициируют 6-недельный цикл', status:'done' },
    { n:5, t:'Setting SMART goals', w:'Неделя 1', body:'KPI зафиксированы письменно', status:'done' },
    { n:6, t:'Check-point', w:'Неделя 5', body:'Промежуточная проверка прогресса', status:'active' },
    { n:7, t:'Recommendation', w:'Неделя 6', body:'Менеджер готовит рекомендацию по PIP', status:'pending' },
    { n:8, t:'Committee meeting', w:'Неделя 6', body:'Line manager + его менеджер + HR', status:'pending' },
    { n:9, t:'Committee decision', w:'Неделя 6', body:'Продолжить работу или прекратить по контракту', status:'pending' },
  ];
  return (
    <div className="p-8 space-y-5 fade-in">
      <Card>
        <div className="p-6 flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-rose-100 text-rose-700 grid place-items-center">
            <Icon name="warn" className="w-6 h-6"/>
          </div>
          <div className="flex-1">
            <h2 className="text-lg font-bold tracking-tight">Performance Improvement Plan</h2>
            <div className="text-xs text-ink-500">Активный BoT: 1 · Запланированные: 0 · Завершённые за полугодие: 0</div>
          </div>
        </div>
      </Card>

      {/* Gate: Hold Performance Conversation */}
      <Card>
        <div className={`p-4 flex items-start gap-3 rounded-2xl ${gateOpen?'bg-emerald-50 border border-emerald-200':'bg-amber-50 border border-amber-300'}`}>
          <div className={`w-9 h-9 rounded-lg grid place-items-center shrink-0 ${gateOpen?'bg-emerald-100 text-emerald-700':'bg-amber-100 text-amber-700'}`}>
            <Icon name={gateOpen?'ok':'lock'} className="w-5 h-5"/>
          </div>
          <div className="flex-1">
            <div className={`text-sm font-bold ${gateOpen?'text-emerald-900':'text-amber-900'}`}>
              {gateOpen ? 'Gate открыт: Performance Conversation подтверждена сотрудником' : 'Gate закрыт: сначала Hold Performance Conversation'}
            </div>
            <div className={`text-xs mt-0.5 ${gateOpen?'text-emerald-800':'text-amber-800'}`}>
              {gateOpen
                ? `${pip.name} подтвердил debrief · ${conv.acknowledgedAt} · BoT разблокирован`
                : `BoT не может стартовать, пока менеджер не проведёт 1:1 и сотрудник не acknowledge результат. Статус: ${conv?.status || 'pending'}.`}
            </div>
          </div>
          {!gateOpen && (
            <button onClick={()=>{ window.location.hash=''; /* just a hint */ }} className="h-9 px-3 rounded-lg bg-white border border-amber-300 text-amber-800 text-xs font-semibold hover:bg-amber-100">Открыть Performance Talks →</button>
          )}
        </div>
      </Card>

      <Card>
        <CardHead title={`Активный PIP · ${pip.name}`} subtitle={`${pip.role} · ${pip.team} · Начат ${activeCase.startDate || '—'}`} right={
          <div className="text-[11px] font-semibold uppercase px-2 py-1 bg-rose-100 text-rose-700 rounded">{activeCase.status==='halfway-done'?'3/6 недель':activeCase.status==='active'?'идёт':'—'}</div>
        }/>
        <div className="p-5">
          <div className="grid md:grid-cols-[240px_1fr] gap-6">
            <div>
              <Avatar p={pip} size={60}/>
              <div className="mt-3">
                <div className="font-bold">{pip.name}</div>
                <div className="text-xs text-ink-500">{pip.role}</div>
                <div className="text-xs text-ink-500">Manager: {byId(pip.managerId)?.name}</div>
              </div>
              <div className="mt-4 space-y-2">
                <div className="p-3 rounded-xl bg-rose-50 border border-rose-200">
                  <div className="text-[10px] uppercase tracking-wider text-rose-700 font-bold">Причина</div>
                  <div className="text-sm mt-1">{activeCase.reason || 'Причина не указана — менеджер заполняет при старте BoT.'}</div>
                </div>
                <div className="p-3 rounded-xl bg-brand-50 border border-brand-200">
                  <div className="text-[10px] uppercase tracking-wider text-brand-700 font-bold">SMART-цели</div>
                  {activeCase.smartGoals && activeCase.smartGoals.length > 0 ? (
                    <ul className="text-sm mt-1 space-y-1 list-disc pl-4">
                      {activeCase.smartGoals.map(g => (
                        <li key={g.id}>{g.title}</li>
                      ))}
                    </ul>
                  ) : (
                    <div className="text-xs text-ink-500 italic mt-1">SMART-цели ещё не заданы (Шаг 5: Setting SMART goals).</div>
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className="relative pl-12 before:absolute before:left-[18px] before:top-2 before:bottom-2 before:w-0.5 before:bg-ink-100">
                {steps.map(s=>(
                  <div key={s.n} className="relative pb-5 last:pb-0">
                    <div className={`absolute -left-[34px] top-0.5 w-7 h-7 rounded-full grid place-items-center text-[11px] font-bold ring-4 ring-white ${s.status==='done'?'bg-emerald-500 text-white':s.status==='active'?'bg-brand-600 text-white':'bg-ink-200 text-ink-500'}`}>
                      {s.status==='done'?'✓':s.n}
                    </div>
                    <div className="flex items-center gap-2 flex-wrap">
                      <div className="font-semibold text-sm">{s.t}</div>
                      <span className="text-[10px] uppercase tracking-wider bg-ink-100 text-ink-600 rounded px-1.5 py-0.5">{s.w}</span>
                      {s.status==='active' && <span className="text-[10px] uppercase tracking-wider bg-brand-100 text-brand-700 rounded px-1.5 py-0.5 font-bold">сейчас</span>}
                    </div>
                    <div className="text-xs text-ink-500 mt-1">{s.body}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Halfway + Final checkpoint */}
      {(() => {
        const botCase = store.state.botCases.find(b => b.employeeId===pip.id);
        if (!botCase) return null;
        return (
          <Card>
            <CardHead title="Checkpoints" subtitle={`Halfway · ${botCase.halfwayDate} · Final · ${botCase.finalDate}`}/>
            <div className="p-5 grid md:grid-cols-2 gap-4">
              {/* Halfway */}
              <div className={`rounded-2xl border p-4 ${botCase.halfwayResult ? (botCase.halfwayResult.verdict==='on_track'?'border-emerald-200 bg-emerald-50/60': botCase.halfwayResult.verdict==='at_risk'?'border-amber-200 bg-amber-50/60':'border-rose-200 bg-rose-50/60') : 'border-ink-200 bg-white'}`}>
                <div className="flex items-center justify-between mb-2">
                  <div>
                    <div className="text-xs uppercase tracking-wide text-ink-500">Halfway · week 3</div>
                    <div className="font-bold text-ink-900">{botCase.halfwayDate}</div>
                  </div>
                  {botCase.halfwayResult
                    ? <span className={`text-[11px] px-2 py-0.5 rounded font-bold ${botCase.halfwayResult.verdict==='on_track'?'bg-emerald-100 text-emerald-700':botCase.halfwayResult.verdict==='at_risk'?'bg-amber-100 text-amber-700':'bg-rose-100 text-rose-700'}`}>{botCase.halfwayResult.verdict.replace('_',' ')}</span>
                    : <span className="text-[11px] px-2 py-0.5 rounded font-bold bg-ink-100 text-ink-600">pending</span>}
                </div>
                {botCase.halfwayResult
                  ? <div className="text-sm text-ink-700 italic">«{botCase.halfwayResult.note}»</div>
                  : (
                    <div className="space-y-1.5">
                      <div className="text-xs text-ink-600">Записать промежуточный вердикт: on track / at risk / off track + краткий note.</div>
                      <div className="flex gap-1.5 pt-1">
                        <button onClick={()=>store.recordBotHalfway(pip.id, botCase.cycleId, { verdict:'on_track', note:'Прогресс по целям соответствует плану.' }, 'Manager')} className="h-8 px-2 rounded-lg border border-emerald-300 text-emerald-700 text-xs font-semibold hover:bg-emerald-50">On track</button>
                        <button onClick={()=>store.recordBotHalfway(pip.id, botCase.cycleId, { verdict:'at_risk', note:'Часть целей под угрозой — нужна более плотная поддержка.' }, 'Manager')} className="h-8 px-2 rounded-lg border border-amber-300 text-amber-700 text-xs font-semibold hover:bg-amber-50">At risk</button>
                        <button onClick={()=>store.recordBotHalfway(pip.id, botCase.cycleId, { verdict:'off_track', note:'Цели не достигаются, подготовка к exit сценарию.' }, 'Manager')} className="h-8 px-2 rounded-lg border border-rose-300 text-rose-700 text-xs font-semibold hover:bg-rose-50">Off track</button>
                      </div>
                    </div>
                  )}
              </div>

              {/* Final */}
              <div className={`rounded-2xl border p-4 ${botCase.finalResult ? (botCase.finalResult.decision==='continue'?'border-emerald-200 bg-emerald-50/60': botCase.finalResult.decision==='extend'?'border-amber-200 bg-amber-50/60':'border-rose-200 bg-rose-50/60') : 'border-ink-200 bg-white'}`}>
                <div className="flex items-center justify-between mb-2">
                  <div>
                    <div className="text-xs uppercase tracking-wide text-ink-500">Final · week 6 · committee</div>
                    <div className="font-bold text-ink-900">{botCase.finalDate}</div>
                  </div>
                  {botCase.finalResult
                    ? <span className={`text-[11px] px-2 py-0.5 rounded font-bold ${botCase.finalResult.decision==='continue'?'bg-emerald-100 text-emerald-700':botCase.finalResult.decision==='extend'?'bg-amber-100 text-amber-700':'bg-rose-100 text-rose-700'}`}>{botCase.finalResult.decision}</span>
                    : <span className="text-[11px] px-2 py-0.5 rounded font-bold bg-ink-100 text-ink-600">pending</span>}
                </div>
                {botCase.finalResult
                  ? <div className="text-sm text-ink-700 italic">«{botCase.finalResult.note}»</div>
                  : (
                    <div className="space-y-1.5">
                      <div className="text-xs text-ink-600">Committee = line manager + skip-level + HR. Три опции: continue / extend / exit.</div>
                      <div className="flex gap-1.5 pt-1">
                        <button onClick={()=>store.recordBotFinal(pip.id, botCase.cycleId, { decision:'continue', note:'Цели достигнуты — сотрудник возвращается в обычный цикл.' }, 'Committee')} className="h-8 px-2 rounded-lg border border-emerald-300 text-emerald-700 text-xs font-semibold hover:bg-emerald-50">Continue</button>
                        <button onClick={()=>store.recordBotFinal(pip.id, botCase.cycleId, { decision:'extend', note:'Есть прогресс, но нужно ещё 4 недели до финального решения.' }, 'Committee')} className="h-8 px-2 rounded-lg border border-amber-300 text-amber-700 text-xs font-semibold hover:bg-amber-50">Extend +4w</button>
                        <button onClick={()=>store.recordBotFinal(pip.id, botCase.cycleId, { decision:'exit', note:'Цели не достигнуты — прекращение контракта.' }, 'Committee')} className="h-8 px-2 rounded-lg border border-rose-300 text-rose-700 text-xs font-semibold hover:bg-rose-50">Exit</button>
                      </div>
                    </div>
                  )}
              </div>
            </div>

            {/* SMART goals checklist */}
            <div className="px-5 pb-5">
              <div className="text-xs uppercase tracking-wide text-ink-500 mb-2">SMART-цели · отметки менеджера</div>
              <div className="space-y-2">
                {botCase.smartGoals.map(g => (
                  <label key={g.id} className={`flex items-start gap-2.5 rounded-xl border p-3 cursor-pointer ${g.met?'border-emerald-300 bg-emerald-50/60':'border-ink-200 bg-white'}`}>
                    <input type="checkbox" checked={g.met} onChange={e=>store.toggleBotGoal(pip.id, botCase.cycleId, g.id, e.target.checked, 'Manager')} className="mt-0.5"/>
                    <div className="flex-1">
                      <div className={`text-sm font-semibold ${g.met?'line-through text-ink-500':'text-ink-900'}`}>{g.title}</div>
                      {g.note && <div className="text-xs text-ink-600 mt-0.5">{g.note}</div>}
                    </div>
                  </label>
                ))}
                {botCase.smartGoals.length===0 && <div className="text-xs text-ink-500 italic p-2">SMART-цели не заданы.</div>}
              </div>
            </div>
          </Card>
        );
      })()}
    </div>
  );
};

/* ───────── HISTORY ───────── */
const HistoryPage = () => {
  const { user } = useApp();
  const h = Array.isArray(HISTORY[user.id]) ? HISTORY[user.id] : [];
  const hasHistory = h.length > 0;
  const data = h.map(x=>({ q:x.cycle, skills:MASTERY_SCORE[x.skills], deliv:MASTERY_SCORE[x.deliverables], cult:MASTERY_SCORE[x.culture], overall: (MASTERY_SCORE[x.skills]+MASTERY_SCORE[x.deliverables]+MASTERY_SCORE[x.culture])/3 }));

  if (!hasHistory) {
    return (
      <div className="p-8 space-y-5 fade-in">
        <Card>
          <CardHead title="Моя история" subtitle={`${user.name} · ${user.role}`}/>
          <div className="p-12 text-center">
            <div className="w-14 h-14 mx-auto rounded-full bg-ink-50 grid place-items-center mb-4">
              <Icon name="chart" className="w-6 h-6 text-ink-400"/>
            </div>
            <div className="text-sm font-semibold text-ink-700 mb-1">История ещё не накоплена</div>
            <div className="text-xs text-ink-500 max-w-sm mx-auto">
              Performance Review цикл H1 2026 — первый официальный цикл FreedomOS. После его завершения здесь появится тренд по Skills · Deliverables · Culture, а также Grade по каждому полугодию.
            </div>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="p-8 space-y-5 fade-in">
      <Card>
        <CardHead title="Моя история" subtitle={`${user.name} · ${user.role}`}/>
        <div className="p-5 h-[340px]">
          <ResponsiveContainer>
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E6E9F2" vertical={false}/>
              <XAxis dataKey="q" tick={{fontSize:11, fill:'#6B7594'}} axisLine={false} tickLine={false}/>
              <YAxis domain={[1,5]} ticks={[1,2,3,4,5]} tickFormatter={v=>MASTERY[v-1]} tick={{fontSize:11, fill:'#6B7594'}} axisLine={false} tickLine={false}/>
              <Tooltip contentStyle={{borderRadius:12, fontSize:12}}/>
              <Legend wrapperStyle={{fontSize:12}}/>
              <Line type="monotone" dataKey="skills" name="Skills" stroke="#3B82F6" strokeWidth={2.5} dot/>
              <Line type="monotone" dataKey="deliv" name="Deliverables" stroke="#F59E0B" strokeWidth={2.5} dot/>
              <Line type="monotone" dataKey="cult" name="Culture" stroke="#10B981" strokeWidth={2.5} dot/>
              <Line type="monotone" dataKey="overall" name="Overall" stroke="#0B2545" strokeWidth={3} strokeDasharray="4 4" dot/>
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Card>

      <Card>
        <CardHead title="Grades по полугодиям"/>
        <div className="divide-y divide-ink-100">
          {h.slice().reverse().map(x=>(
            <div key={x.cycle} className="p-4 grid grid-cols-[100px_1fr_auto] items-center gap-3">
              <div className="text-sm font-semibold">{x.cycle}</div>
              <div className="flex gap-1.5">
                <span className={masteryChip(x.skills)}>S·{x.skills}</span>
                <span className={masteryChip(x.deliverables)}>D·{x.deliverables}</span>
                <span className={masteryChip(x.culture)}>C·{x.culture}</span>
              </div>
              <span className={gradeChip(x.overall)}>{x.overall}</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

/* ───────── ANALYTICS ───────── */
const AnalyticsPage = () => {
  const { store } = useApp();
  const peopleAll = store.state.people.filter(p => p.active !== false && !p.placeholder && p.name && p.name !== '—');
  const teams = Array.from(new Set(peopleAll.map(p=>p.team))).filter(Boolean);

  /* Реальные оценки из Manager Assessments текущего цикла (submitted/locked).
     Каждый assessment содержит scores: { skills:{dim:level}, deliverables:{...}, culture:{...} }.
     Среднее по категории = среднее MASTERY_SCORE[level] по всем dimensions. */
  const submittedMA = (store.state.managerAssessments || []).filter(
    ma => ma.cycleId === ACTIVE_CYCLE.id && (ma.status === 'submitted' || ma.status === 'locked') && ma.scores
  );
  const peopleById = Object.fromEntries(peopleAll.map(p => [p.id, p]));

  const avgCategory = (ma, cat) => {
    const dims = ma.scores && ma.scores[cat] ? Object.values(ma.scores[cat]) : [];
    const nums = dims.map(lvl => MASTERY_SCORE[lvl]).filter(v => typeof v === 'number');
    return nums.length ? nums.reduce((a,b)=>a+b, 0) / nums.length : null;
  };

  /* Группируем по командам: для каждой команды — submitted MA тех людей,
     которые сейчас в команде. Среднее по категории — среднее по MA этой команды. */
  const data = teams.map(t => {
    const inT = peopleAll.filter(p => p.team === t);
    const maOfTeam = submittedMA.filter(ma => {
      const emp = peopleById[ma.employeeId];
      return emp && emp.team === t;
    });
    const catAvg = (cat) => {
      const vals = maOfTeam.map(ma => avgCategory(ma, cat)).filter(v => v !== null);
      return vals.length ? vals.reduce((a,b)=>a+b,0) / vals.length : 0;
    };
    const graded = inT.filter(p => p.currentGrade);
    const gradeAvg = graded.length
      ? graded.reduce((a,p)=>a+(p.currentGrade==='A-player'?5:p.currentGrade==='Above bar'?3.5:2),0)/graded.length
      : 0;
    return {
      team: t,
      n: inT.length,
      assessed: maOfTeam.length,
      avg: gradeAvg,
      skills: catAvg('skills'),
      deliv:  catAvg('deliverables'),
      cult:   catAvg('culture'),
    };
  });

  /* Распределение Skills — частоты уровней по всем dimensions skills из submitted MA. */
  const levelCounts = { Poor:0, Basic:0, Intermediate:0, Advanced:0, Exceptional:0 };
  submittedMA.forEach(ma => {
    const skillDims = ma.scores && ma.scores.skills ? Object.values(ma.scores.skills) : [];
    skillDims.forEach(lvl => { if (levelCounts[lvl] !== undefined) levelCounts[lvl]++; });
  });
  const skillsDist = MASTERY.map(m => ({ level: m, n: levelCounts[m] }));

  /* Показываем аналитику, только если есть хотя бы один submitted Manager Assessment. */
  const hasData = submittedMA.length > 0;

  if (!hasData) {
    return (
      <div className="p-8 fade-in">
        <Card>
          <div className="p-12 text-center">
            <Icon name="trend" className="w-12 h-12 text-ink-300 mx-auto mb-4"/>
            <div className="text-lg font-semibold text-ink-700">Аналитика появится после первой Calibration</div>
            <div className="text-sm text-ink-500 mt-2 max-w-lg mx-auto">
              Графики «Скоринг по командам», «Распределение Skills» и Heat-map считаются по реальным оценкам Talent Bar.
              Первый цикл Performance Review (H1 2026) сейчас в фазе <b>Feedback &amp; Self-Assessment</b>.
              После Manager Assessment (15–28 июня) и Calibration · Talent Bar review (29 июня) аналитика заполнится автоматически.
            </div>
          </div>
        </Card>
      </div>
    );
  }
  return (
    <div className="p-8 space-y-5 fade-in">
      <div className="grid md:grid-cols-3 gap-5">
        <Card className="md:col-span-2">
          <CardHead title="Скоринг по командам" subtitle="Средний grade (1–5) по каждому отделу"/>
          <div className="p-5 h-[300px]">
            <ResponsiveContainer>
              <BarChart data={data}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E6E9F2" vertical={false}/>
                <XAxis dataKey="team" tick={{fontSize:11, fill:'#6B7594'}} axisLine={false} tickLine={false}/>
                <YAxis domain={[0,5]} tick={{fontSize:11, fill:'#6B7594'}} axisLine={false} tickLine={false}/>
                <Tooltip contentStyle={{borderRadius:12, fontSize:12}}/>
                <Legend wrapperStyle={{fontSize:12}}/>
                <Bar dataKey="skills" name="Skills" fill="#3B82F6" radius={[6,6,0,0]}/>
                <Bar dataKey="deliv" name="Deliverables" fill="#F59E0B" radius={[6,6,0,0]}/>
                <Bar dataKey="cult" name="Culture" fill="#10B981" radius={[6,6,0,0]}/>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Card>
        <Card>
          <CardHead title="Распределение Skills"/>
          <div className="p-5 h-[300px]">
            <ResponsiveContainer>
              <PieChart>
                <Pie data={skillsDist} dataKey="n" nameKey="level" innerRadius={50} outerRadius={90} paddingAngle={2}>
                  {skillsDist.map((d,i)=><Cell key={i} fill={['#EF4444','#818CF8','#FBBF24','#4ADE80','#10B981'][i]}/>)}
                </Pie>
                <Tooltip contentStyle={{borderRadius:12, fontSize:12}}/>
                <Legend wrapperStyle={{fontSize:11}}/>
              </PieChart>
            </ResponsiveContainer>
          </div>
        </Card>
      </div>

      <Card>
        <CardHead title="Heat-map: Командa × Измерение"/>
        <div className="p-5 overflow-x-auto scrollbar">
          <table className="w-full text-sm">
            <thead>
              <tr>
                <th className="text-left text-xs uppercase tracking-wider text-ink-500 px-3 py-2">Команда</th>
                {['Skills','Deliverables','Culture'].map(d=>(<th key={d} className="text-center text-xs uppercase tracking-wider text-ink-500 px-3 py-2">{d}</th>))}
                <th className="text-center text-xs uppercase tracking-wider text-ink-500 px-3 py-2">Overall</th>
              </tr>
            </thead>
            <tbody>
              {data.map(t=>{
                const Cell = ({ v }) => {
                  if (!v || v <= 0) {
                    return <td className="px-3 py-2"><div className="rounded-lg px-2 py-1 text-center font-mono text-ink-400 bg-ink-50">—</div></td>;
                  }
                  const c = v>=4.3?'bg-emerald-200 text-emerald-900':v>=3.5?'bg-emerald-50 text-emerald-800':v>=2.5?'bg-amber-50 text-amber-800':'bg-rose-50 text-rose-800';
                  return <td className="px-3 py-2"><div className={`rounded-lg px-2 py-1 text-center font-mono font-bold ${c}`}>{v.toFixed(2)}</div></td>;
                };
                const nonZero = [t.skills, t.deliv, t.cult].filter(v => v > 0);
                const overall = nonZero.length ? nonZero.reduce((a,b)=>a+b,0) / nonZero.length : 0;
                return (
                  <tr key={t.team} className="border-t border-ink-100">
                    <td className="px-3 py-2 font-semibold">{t.team} <span className="text-[11px] text-ink-400 font-normal">· {t.assessed}/{t.n}</span></td>
                    <Cell v={t.skills}/>
                    <Cell v={t.deliv}/>
                    <Cell v={t.cult}/>
                    <Cell v={overall}/>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
};

/* ───────── PERFORMANCE TEAM · Organization & mandate ─────────
   Страница для прозрачности: кто отвечает за процесс ревью, какие команды обслуживают,
   за какие фазы цикла отвечают. Открыта для всей компании (HR/CEO/Manager/Employee). */
const PerfTeamOrgPage = () => {
  const { store } = useContext(AppContext);
  const allPeople = store.state.people;

  /* Нагрузка: всего активных сотрудников в компании, исключая саму Performance Team */
  const servedHeadcount = allPeople.filter(p => p.active && p.team !== 'Performance Team' && !p.placeholder).length;
  const teamsCovered = new Set(allPeople.filter(p => p.active && p.team !== 'Performance Team' && !p.placeholder).map(p => p.team)).size;

  /* Owned phases — берём из ACTIVE_CYCLE.stages по совпадению owner */
  const ownedPhases = (ACTIVE_CYCLE.stages || []).filter(ph =>
    typeof ph.owner === 'string' && ph.owner.toLowerCase().includes('performance team')
  );

  const mandates = [
    { icon:'cycle',  title:'Процесс полугодового review', body:'Запуск, фасилитация и закрытие цикла H1/H2: Self Assessment → 360 → Manager Assessment → Calibration → Conversations → Decisions.' },
    { icon:'grid',   title:'Calibration · Talent Bar review', body:'Модерация ревью с лидерами по фреймворку Skills × Deliverables × Culture × Seniority bar. Контроль cap A-player ≤ 25%.' },
    { icon:'shield', title:'Промо и compensation gates', body:'Сбор Promo Recommendations, согласование с CEO, публикация изменений уровней и грейдов.' },
    { icon:'warn',   title:'Back on Track (PIP)',     body:'Запуск 6-недельных циклов для Underperformer, halfway/final checkpoint, escalation в Committee.' },
    { icon:'doc',    title:'Scorecards & Forms',     body:'Дизайн форм оценки, шкал, Skills × Deliverables × Culture, версионирование шаблонов.' },
    { icon:'users',  title:'People analytics',       body:'Отчёты по distribution grade, manager bias, retention A-player, attrition по cohort.' },
  ];

  /* Lifecycle процессов: последовательность того, что Performance Team выполняет в течение цикла */
  const processFlow = [
    { n:1, title:'Kickoff цикла',        body:'Формы, дедлайны, коммуникация в компанию.',             artefact:'Cycle plan + launch post' },
    { n:2, title:'Feedback collection',   body:'Self Assessment + 360 Peer Feedback сбор и валидация.', artefact:'Self ✕ 360 raw data' },
    { n:3, title:'Manager Assessment',    body:'Поддержка менеджеров: шаблоны, 1:1 гайды, STAR примеры.', artefact:'Filled Manager Scorecards' },
    { n:4, title:'Calibration · Talent Bar', body:'Фасилитация сессий, контроль cap A-player ≤ 25%.',    artefact:'Final grade distribution' },
    { n:5, title:'Performance Conversations', body:'Hold-Performance-Conversation gate перед Development Plan / BoT.', artefact:'Signed-off debriefs' },
    { n:6, title:'Decisions & closure',   body:'Promo, BoT запуск, cycle retrospective, lessons learned.', artefact:'Promo list + BoT cases + retro' },
  ];

  return (
    <div className="p-8 space-y-5 fade-in">
      {/* Header */}
      <Card>
        <div className="p-6 flex items-start gap-4">
          <div className="w-12 h-12 rounded-xl bg-brand-100 text-brand-700 grid place-items-center">
            <Icon name="shield" className="w-6 h-6"/>
          </div>
          <div className="flex-1">
            <h2 className="text-lg font-bold tracking-tight">Performance Team · Процессы и зоны ответственности</h2>
            <div className="text-xs text-ink-500 mt-1">Что Performance Team делает в течение цикла, какие решения владеет и в каких фазах участвует. Состав команды и структура настраиваются в HR Admin по мере найма.</div>
          </div>
        </div>
      </Card>

      {/* KPI bar — process-oriented, не headcount */}
      <div className="grid md:grid-cols-4 gap-4">
        <Stat label="Направлений mandate" value={mandates.length} hint="Зоны ответственности"/>
        <Stat label="Фазы цикла под управлением" value={`${ownedPhases.length} / ${ACTIVE_CYCLE.stages?.length || 0}`} hint={ACTIVE_CYCLE.name}/>
        <Stat label="Сотрудников обслуживается" value={servedHeadcount} hint="Active · вне Performance Team"/>
        <Stat label="Команд покрыто" value={teamsCovered} hint="Бизнес-команды с процессами"/>
      </div>

      {/* Process Lifecycle — «что делает команда в течение цикла» */}
      <Card>
        <CardHead title="Жизненный цикл процесса" subtitle="Последовательность действий Performance Team в рамках одного полугодового цикла"/>
        <div className="p-5 grid md:grid-cols-2 lg:grid-cols-3 gap-3">
          {processFlow.map(s => (
            <div key={s.n} className="relative p-4 rounded-xl border border-ink-100 bg-white">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-7 h-7 rounded-full bg-brand-600 text-white grid place-items-center text-xs font-bold">{s.n}</div>
                <div className="font-semibold text-sm">{s.title}</div>
              </div>
              <div className="text-xs text-ink-500 mb-2">{s.body}</div>
              <div className="text-[10px] uppercase tracking-wider text-ink-400 font-bold">Артефакт</div>
              <div className="text-[11px] text-ink-700">{s.artefact}</div>
            </div>
          ))}
        </div>
      </Card>

      {/* Mandate */}
      <Card>
        <CardHead title="Зоны ответственности" subtitle={`${mandates.length} направлений mandate · что Performance Team владеет end-to-end`}/>
        <div className="p-5 grid md:grid-cols-2 gap-4">
          {mandates.map(m => (
            <div key={m.title} className="flex gap-3 p-4 rounded-xl border border-ink-100 bg-white">
              <div className="w-10 h-10 rounded-lg bg-brand-50 text-brand-700 grid place-items-center shrink-0">
                <Icon name={m.icon} className="w-5 h-5"/>
              </div>
              <div className="min-w-0">
                <div className="font-semibold text-sm">{m.title}</div>
                <div className="text-xs text-ink-500 mt-1">{m.body}</div>
              </div>
            </div>
          ))}
        </div>
      </Card>

      {/* Owned phases of active cycle */}
      <Card>
        <CardHead title={`Фазы цикла ${ACTIVE_CYCLE.name} под управлением Performance Team`} subtitle={`${ownedPhases.length} из ${ACTIVE_CYCLE.stages?.length || 0} фаз`}/>
        <div className="p-5">
          {ownedPhases.length > 0 ? (
            <div className="space-y-2">
              {ownedPhases.map(ph => (
                <div key={ph.key} className="flex items-center gap-3 p-3 rounded-xl border border-ink-100 bg-white">
                  <div className="w-9 h-9 rounded-lg bg-ink-50 text-ink-600 grid place-items-center shrink-0">
                    <Icon name={ph.icon} className="w-4 h-4"/>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-sm">{ph.label}</div>
                    <div className="text-[11px] text-ink-500">{ph.start} → {ph.end} · {ph.duration} · owner: {ph.owner}</div>
                  </div>
                  <span className={`text-[10px] uppercase tracking-wider px-2 py-0.5 rounded font-bold ${ph.status==='active'?'bg-brand-100 text-brand-700':ph.status==='done'?'bg-emerald-100 text-emerald-700':'bg-ink-100 text-ink-600'}`}>{ph.status}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-sm text-ink-500 italic">Фазы цикла пока не привязаны явно к Performance Team.</div>
          )}
        </div>
      </Card>
    </div>
  );
};

/* ───────── HIRING / VACANCIES ───────── */
const HiringPage = () => {
  const { store, user } = useApp();
  const perms = permissions(user, store.state.people);
  const canManage = perms.fullAccess;

  const vacancies = Array.isArray(store.state.vacancies) ? store.state.vacancies : [];

  const [filterTeam, setFilterTeam] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [mode, setMode] = useState(null);   /* null | 'add' | 'edit' */
  const [editing, setEditing] = useState(null);
  const [confirmDel, setConfirmDel] = useState(null);

  const teams = ['all', ...Array.from(new Set(vacancies.map(v=>v.team).filter(Boolean)))];
  const statuses = ['all','sourcing','interviewing','offer'];

  const filtered = vacancies.filter(v =>
    (filterTeam==='all' || v.team===filterTeam) &&
    (filterStatus==='all' || v.status===filterStatus)
  );

  const byPriority = { high:0, med:0, low:0 };
  vacancies.forEach(v=>{ if (byPriority[v.priority]!==undefined) byPriority[v.priority]++; });

  const byTeam = {};
  vacancies.forEach(v=>{ if (v.team) byTeam[v.team] = (byTeam[v.team]||0)+1; });

  const statusChip = (s) => {
    const map = {
      sourcing:     'bg-ink-100 text-ink-700',
      interviewing: 'bg-amber-100 text-amber-800',
      offer:        'bg-emerald-100 text-emerald-800',
    }[s] || 'bg-ink-100 text-ink-700';
    const labels = { sourcing:'Sourcing', interviewing:'Interviewing', offer:'Offer' };
    return <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-semibold uppercase tracking-wider ${map}`}>{labels[s]||s}</span>;
  };
  const prioChip = (p) => {
    const map = {
      high: 'bg-rose-100 text-rose-800',
      med:  'bg-amber-100 text-amber-800',
      low:  'bg-ink-100 text-ink-700',
    }[p] || 'bg-ink-100 text-ink-700';
    return <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold uppercase ${map}`}>{p}</span>;
  };

  const daysSince = (iso) => {
    if (!iso) return 0;
    const start = new Date(iso);
    if (isNaN(start.getTime())) return 0;
    const now = new Date('2026-04-18');
    return Math.max(0, Math.round((now-start)/86400000/7));
  };

  const totalCount = vacancies.length;
  const peopleCount = PEOPLE.length;
  const sumFte = peopleCount + totalCount;
  const avgWeeks = totalCount > 0
    ? Math.round(vacancies.reduce((a,v)=>a+daysSince(v.openedDate),0)/totalCount)
    : 0;

  const handleSave = (vac) => {
    if (mode === 'edit' && editing) {
      store.updateVacancy(editing.id, vac, user.name);
    } else {
      store.addVacancy(vac, user.name);
    }
    setMode(null); setEditing(null);
  };
  const handleDelete = (id) => {
    store.deleteVacancy(id, user.name);
    setConfirmDel(null);
  };

  return (
    <div className="p-8 space-y-5 fade-in">
      {/* Header KPIs */}
      <div className="grid md:grid-cols-4 gap-4">
        <Stat label="Открытые позиции" value={totalCount} hint={`Freedom AI Labs · всего штата ${sumFte}`}/>
        <Stat label="High priority" value={byPriority.high} delta={byPriority.high>0?`+${byPriority.high}`:'0'} hint="Критичные gap'ы" color="under"/>
        <Stat label="На этапе offer" value={vacancies.filter(v=>v.status==='offer').length} hint="Ожидаем подписи"/>
        <Stat label="Средний cycle-time" value={`${avgWeeks} нед`} hint="С момента открытия"/>
      </div>

      {/* Headcount plan */}
      <Card>
        <CardHead title="Headcount план · H2 2026" subtitle={`${peopleCount} текущих + ${totalCount} вакансий → ${sumFte} FTE к концу полугодия`}/>
        <div className="p-5">
          {sumFte > 0 ? (
            <div className="h-8 rounded-full bg-ink-100 overflow-hidden flex">
              <div className="bg-brand-600 h-full flex items-center justify-center text-[11px] text-white font-bold"
                   style={{width:`${(peopleCount/sumFte)*100}%`}}>
                {peopleCount} текущие
              </div>
              {totalCount > 0 && (
                <div className="bg-amber-400 h-full flex items-center justify-center text-[11px] text-amber-900 font-bold"
                     style={{width:`${(totalCount/sumFte)*100}%`}}>
                  +{totalCount} hiring
                </div>
              )}
            </div>
          ) : (
            <div className="text-xs text-ink-400 italic">Нет данных по headcount</div>
          )}
          <div className="mt-3 text-xs text-ink-500">
            При закрытии всех открытых вакансий Freedom AI Labs вырастет с <b>{peopleCount}</b> до <b>{sumFte}</b> FTE.
          </div>
        </div>
      </Card>

      {/* By team */}
      {Object.keys(byTeam).length > 0 && (
        <Card>
          <CardHead title="Вакансии по командам" subtitle="Распределение нагрузки на рекрутинг"/>
          <div className="p-5 grid md:grid-cols-2 lg:grid-cols-3 gap-3">
            {Object.entries(byTeam).sort((a,b)=>b[1]-a[1]).map(([t,n])=>(
              <div key={t} className="flex items-center justify-between border border-ink-100 rounded-xl px-4 py-3 hover:bg-ink-50/40">
                <div className="font-semibold text-sm">{t}</div>
                <div className="flex items-center gap-2">
                  <div className="text-lg font-extrabold text-brand-700">{n}</div>
                  <span className="text-[10px] uppercase tracking-wider text-ink-400">open</span>
                </div>
              </div>
            ))}
          </div>
        </Card>
      )}

      {/* Filters + Table */}
      <Card>
        <CardHead
          title="Все вакансии"
          subtitle={`${filtered.length} из ${totalCount} позиций`}
          right={
            <div className="flex gap-2 items-center">
              <select value={filterTeam} onChange={e=>setFilterTeam(e.target.value)} className="border border-ink-200 rounded-lg px-2 h-8 text-xs bg-white">
                {teams.map(t=><option key={t} value={t}>{t==='all'?'Все команды':t}</option>)}
              </select>
              <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} className="border border-ink-200 rounded-lg px-2 h-8 text-xs bg-white">
                {statuses.map(s=><option key={s} value={s}>{s==='all'?'Все статусы':s}</option>)}
              </select>
              {canManage && (
                <button
                  onClick={()=>{ setEditing(null); setMode('add'); }}
                  className="ml-1 inline-flex items-center gap-1.5 h-8 px-3 rounded-lg bg-brand-700 text-white text-xs font-semibold hover:bg-brand-800"
                >
                  <Icon name="plus" className="w-3.5 h-3.5"/>
                  Новая вакансия
                </button>
              )}
            </div>
          }
        />
        <div className="overflow-x-auto scrollbar">
          <table className="w-full text-sm">
            <thead className="bg-ink-50 text-xs uppercase tracking-wider text-ink-500">
              <tr>
                <th className="text-left px-5 py-3 font-semibold">Роль</th>
                <th className="text-left px-5 py-3 font-semibold">Seniority</th>
                <th className="text-left px-5 py-3 font-semibold">Команда · sub-team</th>
                <th className="text-left px-5 py-3 font-semibold">Hiring Manager</th>
                <th className="text-left px-5 py-3 font-semibold">Статус</th>
                <th className="text-left px-5 py-3 font-semibold">Prio</th>
                <th className="text-right px-5 py-3 font-semibold">Открыто</th>
                <th className="text-left px-5 py-3 font-semibold">Примечание</th>
                {canManage && <th className="text-right px-5 py-3 font-semibold">Действия</th>}
              </tr>
            </thead>
            <tbody className="divide-y divide-ink-100">
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={canManage ? 9 : 8} className="px-5 py-10 text-center text-xs text-ink-400 italic">
                    Нет вакансий с такими фильтрами
                  </td>
                </tr>
              )}
              {filtered.map(v=>{
                const mgr = byId(v.managerId) || (store.state.people || []).find(p => p.id === v.managerId);
                const weeks = daysSince(v.openedDate);
                const stale = weeks >= 8;
                return (
                  <tr key={v.id} className="hover:bg-ink-50/40">
                    <td className="px-5 py-3 font-semibold">{v.role}</td>
                    <td className="px-5 py-3 text-ink-600">{v.seniority}</td>
                    <td className="px-5 py-3 text-ink-600">
                      <div>{v.team}</div>
                      <div className="text-xs text-ink-400">{v.subteam}</div>
                    </td>
                    <td className="px-5 py-3">
                      {mgr ? (
                        <div className="flex items-center gap-2">
                          <Avatar p={mgr} size={24}/>
                          <span className="text-xs text-ink-700">{mgr.name || mgr.role}</span>
                        </div>
                      ) : <span className="text-ink-400 text-xs">—</span>}
                    </td>
                    <td className="px-5 py-3">{statusChip(v.status)}</td>
                    <td className="px-5 py-3">{prioChip(v.priority)}</td>
                    <td className="px-5 py-3 text-right">
                      <span className={`font-mono text-xs ${stale?'text-rose-600 font-bold':'text-ink-500'}`}>{weeks} нед</span>
                    </td>
                    <td className="px-5 py-3 text-xs text-ink-600 max-w-[260px]">{v.candidate}</td>
                    {canManage && (
                      <td className="px-5 py-3 text-right">
                        <div className="inline-flex items-center gap-1">
                          <button
                            onClick={()=>{ setEditing(v); setMode('edit'); }}
                            className="w-7 h-7 rounded-lg hover:bg-brand-50 text-brand-700 flex items-center justify-center"
                            title="Редактировать"
                          >
                            <Icon name="edit" className="w-3.5 h-3.5"/>
                          </button>
                          <button
                            onClick={()=>setConfirmDel(v)}
                            className="w-7 h-7 rounded-lg hover:bg-rose-50 text-rose-600 flex items-center justify-center"
                            title="Закрыть/удалить"
                          >
                            <Icon name="close" className="w-3.5 h-3.5"/>
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Integration note */}
      <Card>
        <CardHead title="Integration с Performance Platform" subtitle="Как hiring стыкуется с циклом"/>
        <div className="p-5 grid md:grid-cols-3 gap-4">
          <div className="rounded-2xl p-5 border border-brand-200 bg-brand-50/60">
            <div className="font-bold mb-2 flex items-center gap-2"><Icon name="badge" className="w-4 h-4 text-brand-700"/>Onboarding → Scorecard</div>
            <div className="text-sm text-ink-700 leading-relaxed">
              При подписании offer позиция автоматически создаёт <b>first review</b> в ближайшем полугодовом цикле.
              Первые 3 мес — формальный probation без понижения до Underperformer.
            </div>
          </div>
          <div className="rounded-2xl p-5 border border-amber-200 bg-amber-50/60">
            <div className="font-bold mb-2 flex items-center gap-2"><Icon name="target" className="w-4 h-4 text-amber-700"/>Leveling consistency</div>
            <div className="text-sm text-ink-700 leading-relaxed">
              Seniority уровень в offer определяется через interview loop + Hiring Manager review.
              Талант-бар при найме — Intermediate на ≥2 из 3 измерений (Skills, Deliverables, Culture).
            </div>
          </div>
          <div className="rounded-2xl p-5 border border-emerald-200 bg-emerald-50/60">
            <div className="font-bold mb-2 flex items-center gap-2"><Icon name="users" className="w-4 h-4 text-emerald-700"/>A-player cap recheck</div>
            <div className="text-sm text-ink-700 leading-relaxed">
              После закрытия вакансии Performance Team пересчитывает 25% cap по команде.
              Новые A-players в probation <b>не учитываются</b> первое полугодие.
            </div>
          </div>
        </div>
      </Card>

      {/* Add / Edit Vacancy modal */}
      <Modal
        open={mode === 'add' || mode === 'edit'}
        title={mode === 'edit' ? `Редактировать вакансию · ${editing?.role || ''}` : 'Новая вакансия'}
        onClose={()=>{ setMode(null); setEditing(null); }}
      >
        <VacancyForm
          initial={editing}
          peopleList={store.state.people || []}
          onSave={handleSave}
          onCancel={()=>{ setMode(null); setEditing(null); }}
        />
      </Modal>

      {/* Confirm delete */}
      <Modal
        open={!!confirmDel}
        title="Закрыть вакансию?"
        onClose={()=>setConfirmDel(null)}
      >
        {confirmDel && (
          <div className="space-y-4">
            <div className="text-sm text-ink-700">
              Вы собираетесь удалить вакансию <b>{confirmDel.role}</b> ({confirmDel.team}{confirmDel.subteam?` · ${confirmDel.subteam}`:''}).
              Это действие нельзя отменить.
            </div>
            <div className="flex justify-end gap-2">
              <button onClick={()=>setConfirmDel(null)} className="h-9 px-4 rounded-lg border border-ink-200 text-sm hover:bg-ink-50">Отмена</button>
              <button onClick={()=>handleDelete(confirmDel.id)} className="h-9 px-4 rounded-lg bg-rose-600 text-white text-sm font-semibold hover:bg-rose-700">Удалить</button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

/* ───────── VACANCY FORM ───────── */
const VacancyForm = ({ initial, onSave, onCancel, peopleList=[] }) => {
  const empty = {
    role:'', roleKey:'ml_engineer', seniority:'Mid', team:'Software Engineering', subteam:'',
    managerId:'', status:'sourcing', priority:'med',
    openedDate: new Date().toISOString().slice(0,10),
    candidate:'',
  };
  const [form, setForm] = useState(initial ? { ...empty, ...initial } : empty);
  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const teamsAll = Array.from(new Set(peopleList.map(p=>p.team).filter(Boolean))).sort();
  const allRoleKeys = Object.keys(ROLES);
  /* Для select Hiring Manager — только активные сотрудники с именем */
  const mgrCandidates = peopleList
    .filter(p => p.active !== false && !p.placeholder && p.name)
    .sort((a,b)=> (a.name||'').localeCompare(b.name||''));

  const submit = () => {
    const role = (form.role || '').trim();
    if (!role) { alert('Укажите роль'); return; }
    onSave({ ...form, role });
  };
  const onKeyDown = (e) => {
    /* Enter в любом поле (кроме textarea) → submit; Esc → cancel */
    if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
      submit();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      onCancel();
    }
  };

  return (
    <div className="space-y-4" onKeyDown={onKeyDown}>
      <div className="grid md:grid-cols-2 gap-4">
        <Field label="Роль (название позиции)">
          <input
            value={form.role || ''}
            onChange={e=>set('role', e.target.value)}
            className="w-full border border-ink-200 rounded-lg px-3 h-10 text-sm"
            placeholder="ML Engineer · Personalization"
            autoFocus
          />
        </Field>
        <Field label="Тип роли (role family)">
          <select
            value={ROLES[form.roleKey] ? form.roleKey : 'ml_engineer'}
            onChange={e=>set('roleKey', e.target.value)}
            className="w-full border border-ink-200 rounded-lg px-3 h-10 text-sm bg-white"
          >
            {allRoleKeys.map(k => (
              <option key={k} value={k}>{ROLES[k].label} ({k})</option>
            ))}
          </select>
        </Field>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <Field label="Seniority">
          <select
            value={form.seniority || 'Mid'}
            onChange={e=>set('seniority', e.target.value)}
            className="w-full border border-ink-200 rounded-lg px-3 h-10 text-sm bg-white"
          >
            {SENIORITY.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </Field>
        <Field label="Команда">
          <input
            list="vacancy-teams"
            value={form.team || ''}
            onChange={e=>set('team', e.target.value)}
            className="w-full border border-ink-200 rounded-lg px-3 h-10 text-sm"
            placeholder="AI LABS"
          />
          <datalist id="vacancy-teams">
            {teamsAll.map(t => <option key={t} value={t}/>)}
          </datalist>
        </Field>
        <Field label="Sub-team">
          <input
            value={form.subteam || ''}
            onChange={e=>set('subteam', e.target.value)}
            className="w-full border border-ink-200 rounded-lg px-3 h-10 text-sm"
            placeholder="Personalization"
          />
        </Field>
      </div>

      <Field label="Hiring Manager">
        <select
          value={form.managerId || ''}
          onChange={e=>set('managerId', e.target.value)}
          className="w-full border border-ink-200 rounded-lg px-3 h-10 text-sm bg-white"
        >
          <option value="">— не назначен —</option>
          {mgrCandidates.map(p => (
            <option key={p.id} value={p.id}>
              {p.name} · {p.role} · {p.team}
            </option>
          ))}
        </select>
      </Field>

      <div className="grid md:grid-cols-3 gap-4">
        <Field label="Статус">
          <select
            value={form.status || 'sourcing'}
            onChange={e=>set('status', e.target.value)}
            className="w-full border border-ink-200 rounded-lg px-3 h-10 text-sm bg-white"
          >
            <option value="sourcing">Sourcing</option>
            <option value="interviewing">Interviewing</option>
            <option value="offer">Offer</option>
          </select>
        </Field>
        <Field label="Приоритет">
          <select
            value={form.priority || 'med'}
            onChange={e=>set('priority', e.target.value)}
            className="w-full border border-ink-200 rounded-lg px-3 h-10 text-sm bg-white"
          >
            <option value="high">High</option>
            <option value="med">Medium</option>
            <option value="low">Low</option>
          </select>
        </Field>
        <Field label="Дата открытия">
          <input
            type="date"
            value={form.openedDate || ''}
            onChange={e=>set('openedDate', e.target.value)}
            className="w-full border border-ink-200 rounded-lg px-3 h-10 text-sm"
          />
        </Field>
      </div>

      <Field label="Примечание / кандидат">
        <textarea
          value={form.candidate || ''}
          onChange={e=>set('candidate', e.target.value)}
          rows={2}
          className="w-full border border-ink-200 rounded-lg px-3 py-2 text-sm"
          placeholder="Имя кандидата · стадия · комментарий"
        />
      </Field>

      <div className="flex justify-end gap-2 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="h-9 px-4 rounded-lg border border-ink-200 text-sm hover:bg-ink-50"
        >Отмена</button>
        <button
          type="button"
          onClick={submit}
          className="h-9 px-4 rounded-lg bg-brand-700 text-white text-sm font-semibold hover:bg-brand-800"
        >
          {initial ? 'Сохранить' : 'Открыть вакансию'}
        </button>
      </div>
    </div>
  );
};

/* ───────── HR ADMIN PAGE ───────── */
const EMPTY_PERSON = {
  id:'', name:'', role:'', roleKey:'ops', seniority:'Mid', team:'', subteam:'',
  managerId:'', avatar:'', color:'brand', tenure:0,
  /* base/equity удалены 22 apr 2026 — в системе не хранятся и не отображаются */
  /* currentGrade задаётся только после прохождения Talent Bar review — новый сотрудник стартует без grade */
  currentGrade: null, email:'', sysRole:'employee',
  startDate:'', birthDate:'', status:'active', photoUrl:'',
  track:'IC', level:'IC3', levelSince:'',
  /* Notion-импорт: расширенные поля сотрудника */
  nameEn:'', phone:'', telegram:'', department:'', workFormat:'',
  lifecycleStage:'active',
};

/* Статус: active (работает) | vacant (позиция открыта) | onLeave (в отпуске/декрете) */
const personStatus = (p) => {
  if (!p) return 'active';
  if (p.status) return p.status;
  if (p.placeholder || !p.name) return 'vacant';
  return 'active';
};
const STATUS_LABEL = { active:'Работает', vacant:'Вакансия', onLeave:'В отпуске' };
const STATUS_CHIP  = {
  active:  'bg-emerald-50 text-emerald-700 border-emerald-200',
  vacant:  'bg-ink-50 text-ink-500 border-ink-200 border-dashed',
  onLeave: 'bg-amber-50 text-amber-700 border-amber-200',
};

/* ───────── CAREER LADDER (IC / Manager / Support) ─────────
   Модель Radford / Big Tech (Google L-track, Meta E-track, Stripe L).
   3 трека, каждый уровень — устойчивая характеристика (не путать с performance grade). */
const TRACKS = {
  IC:      { label:'Individual Contributor', short:'IC', tone:'bg-brand-50 text-brand-700 border-brand-200', levels:['IC1','IC2','IC3','IC4','IC5','IC6'] },
  Manager: { label:'People Manager',         short:'M',  tone:'bg-violet-50 text-violet-700 border-violet-200', levels:['M1','M2','M3','M4'] },
  Support: { label:'Support / Operations',   short:'S',  tone:'bg-amber-50 text-amber-700 border-amber-200',   levels:['S1','S2','S3'] },
};

/* Критерии уровней — Scope, Complexity, Impact, Leadership (как в GitLab Handbook / Stripe ladder).
   При калибровке и промо используется этот словарь. */
const LEVELS = {
  /* ── IC track ── */
  IC1: { track:'IC', label:'IC1 · Junior',     seniorityHint:'Junior',            salaryBand:'Entry',
         scope:'Задачи под наставничеством — well-scoped, small features',
         complexity:'Хорошо изученные паттерны, учится применять стандарты команды',
         impact:'Локальный impact внутри sprint',
         leadership:'Нет, учится самостоятельности',
         peerAt:['Google L3','Meta E3','Amazon SDE I (L4)','Stripe L0/L1'] },
  IC2: { track:'IC', label:'IC2 · Associate',   seniorityHint:'Junior',           salaryBand:'Mid-Entry',
         scope:'Фичи в рамках одного модуля, пишет чистый код с ревью',
         complexity:'Решает типовые задачи самостоятельно, задаёт уточняющие вопросы',
         impact:'Доставляет sprint commitments без дополнительной поддержки',
         leadership:'Пара-программинг с джунами; code review простых PR',
         peerAt:['Google L3','Meta E3','Amazon SDE I','Stripe L1'] },
  IC3: { track:'IC', label:'IC3 · Mid',         seniorityHint:'Mid',              salaryBand:'Mid',
         scope:'Владеет фичей целиком от дизайна до прода; участвует в планировании',
         complexity:'Самостоятельно декомпозирует нетривиальные задачи, разбирается в новом стеке',
         impact:'Устойчивый вклад в roadmap команды',
         leadership:'Менторит IC1-IC2, ведёт код-ревью, пишет design docs',
         peerAt:['Google L4','Meta E4','Amazon SDE II (L5)','Stripe L2'] },
  IC4: { track:'IC', label:'IC4 · Senior',      seniorityHint:'Senior',           salaryBand:'Senior',
         scope:'Owner крупной области/сервиса; влияет на архитектуру команды',
         complexity:'Находит и решает ambiguous проблемы, анализирует trade-off',
         impact:'Материальный вклад в OKR квартала; тех-решения переживают реорганизации',
         leadership:'Tech lead для 2-4 человек; инициирует процессы, ведёт hiring loops',
         peerAt:['Google L5 Senior','Meta E5','Amazon Senior SDE (L6)','Stripe L3'] },
  IC5: { track:'IC', label:'IC5 · Staff',       seniorityHint:'Lead',             salaryBand:'Staff',
         scope:'Cross-team технические инициативы, owner critical систем компании',
         complexity:'Системное мышление, превращает organizational problems в технические решения',
         impact:'Влияние на roadmap нескольких команд; решения делают год-квартал',
         leadership:'Tech lead группы команд; mentor для IC4-M2; представитель engineering на руководящих встречах',
         peerAt:['Google L6 Staff','Meta E6','Amazon Principal (L7)','Stripe L4'] },
  IC6: { track:'IC', label:'IC6 · Principal',   seniorityHint:'Lead',             salaryBand:'Principal',
         scope:'Company-wide tech strategy; единственный на всю компанию expert в домене',
         complexity:'Определяет multi-year технические направления; находит problems, которых команда ещё не видит',
         impact:'Архитектура уровня всего продукта; mentor для всех Staff+',
         leadership:'Authority без management — команды следуют за техническим видением',
         peerAt:['Google L7 Senior Staff','Meta E7','Amazon Sr Principal (L8)','Stripe L5'] },

  /* ── Manager track ── */
  M1: { track:'Manager', label:'M1 · Team Lead',    seniorityHint:'Senior',  salaryBand:'Senior+',
        scope:'Small team (3-6 чел.) одной функции; первая людская ответственность',
        complexity:'Balance hands-on coding (30-50%) и people management',
        impact:'Доставка команды; развитие людей; нанимает сам',
        leadership:'1:1, performance conversations, hiring; коучит IC3-IC4',
        peerAt:['Google M3','Meta M1','Amazon Manager (L6)','Stripe M1'] },
  M2: { track:'Manager', label:'M2 · Manager',       seniorityHint:'Lead',    salaryBand:'Manager',
        scope:'Команда 6-12 человек; полный цикл найма/развития/увольнения',
        complexity:'Strategy для одной функции; ресурс-аллокация; cross-team coordination',
        impact:'OKR команды; retention и engagement; pipeline promotions',
        leadership:'Людской менеджмент full-time; растит под-менеджеров; calibration participant',
        peerAt:['Google M4','Meta M2','Amazon Sr Manager (L7)','Stripe M2'] },
  M3: { track:'Manager', label:'M3 · Senior Manager', seniorityHint:'Lead', salaryBand:'Senior Manager',
        scope:'Несколько команд (15-30 чел.) или стратегически важная функция',
        complexity:'Многоуровневая организация; политика компании; влияние на C-level решения',
        impact:'Функция уровня департамента; cross-functional delivery',
        leadership:'Ведёт M1-M2; chair calibration; бюджет и headcount planning',
        peerAt:['Google M5','Meta D1','Amazon Director (L8)','Stripe M3'] },
  M4: { track:'Manager', label:'M4 · Director',      seniorityHint:'Director', salaryBand:'Director',
        scope:'Вся функция компании (Engineering, Product, Sales)',
        complexity:'Company strategy; board exposure; M&A участие',
        impact:'Бизнес-результаты компании; культура функции',
        leadership:'C-level team; public face функции; mentor всех M3',
        peerAt:['Google M6-M7','Meta D2-V','Amazon VP (L10)','Stripe M4-M5'] },

  /* ── Support track ── */
  S1: { track:'Support', label:'S1 · Specialist',    seniorityHint:'Junior',  salaryBand:'Entry',
        scope:'Operational tasks по инструкциям; admin, coordination',
        complexity:'Стандартные процедуры, учится системам компании',
        impact:'Держит операционный поток без сбоев',
        leadership:'Нет',
        peerAt:['Radford S1','Yandex P1-P2','Kaspi S1'] },
  S2: { track:'Support', label:'S2 · Senior Specialist', seniorityHint:'Mid', salaryBand:'Mid',
        scope:'Владеет operational доменом (HR ops, Office, Finance ops)',
        complexity:'Улучшает процессы, пишет SOP, ведёт vendor management',
        impact:'Качество operational функции; экономит время команде',
        leadership:'Онбордит S1; Subject matter expert',
        peerAt:['Radford S2-S3','Yandex P3','Kaspi S2'] },
  S3: { track:'Support', label:'S3 · Lead Specialist',   seniorityHint:'Senior', salaryBand:'Senior',
        scope:'Owner operational функции (Head of HR Ops, Office Manager и т.п.)',
        complexity:'Стратегия operations; программы на всю компанию',
        impact:'Функция, которая либо есть, либо нет в компании',
        leadership:'Ведёт команду S1-S2; partners с C-level по своей функции',
        peerAt:['Radford S4-S5','Yandex P4-P5','Kaspi S3-S4'] },
};

const LEVEL_TONE = (level) => {
  if (!level) return 'bg-ink-50 text-ink-600 border-ink-200';
  if (level.startsWith('IC')) return 'bg-brand-50 text-brand-700 border-brand-200';
  if (level.startsWith('M'))  return 'bg-violet-50 text-violet-700 border-violet-200';
  if (level.startsWith('S'))  return 'bg-amber-50 text-amber-700 border-amber-200';
  return 'bg-ink-50 text-ink-600 border-ink-200';
};

/* Автоматический маппинг seniority → level — если у сотрудника ещё не выставлен уровень */
const guessLevel = (p) => {
  if (!p) return { track:'IC', level:'IC3' };
  if (p.track && p.level && LEVELS[p.level]) return { track:p.track, level:p.level };
  const role = (p.role || '').toLowerCase();
  const seniority = (p.seniority || '').toLowerCase();
  const sys = p.sysRole || 'employee';

  /* Executives.
     COMMIT_5 (30 apr 2026): расширили регекс — раньше «CTO», «CPO», «CRDO» и
     прочие CXO-аббревиатуры не попадали под /ceo|founder|chief/i и ошибочно
     сваливались в M2/M3. Теперь все C-level-должности корректно мапятся в M4. */
  const titleClean = (p.role || '').trim();
  if (/^(ceo|cto|cpo|crdo|cfo|coo|chro|ciso|cio|cso|cmo|cdo|cro|cco|chief|founder|co-?founder|exec(utive)? director)$/i.test(titleClean))
    return { track:'Manager', level:'M4' };
  if (sys === 'director') return { track:'Manager', level:'M4' };
  if (/head of|^vp[\s,]/i.test(p.role)) return { track:'Manager', level:'M3' };

  /* Manager track */
  if (/manager|stream lead|team lead/i.test(p.role)) {
    if (/senior|head/i.test(p.role)) return { track:'Manager', level:'M3' };
    return { track:'Manager', level:'M2' };
  }
  if (sys === 'manager') return { track:'Manager', level:'M2' };

  /* Support track */
  if (/hr|recruiter|office|admin|people ops|ops manager|coordinator|operations/i.test(p.role)) {
    if (seniority === 'lead' || /head/i.test(p.role)) return { track:'Support', level:'S3' };
    if (seniority === 'senior') return { track:'Support', level:'S3' };
    if (seniority === 'mid') return { track:'Support', level:'S2' };
    return { track:'Support', level:'S1' };
  }

  /* IC fallback (инженеры, дизайнеры, analysts, product) */
  if (seniority === 'lead')   return { track:'IC', level:'IC5' };
  if (seniority === 'senior') return { track:'IC', level:'IC4' };
  if (seniority === 'mid')    return { track:'IC', level:'IC3' };
  if (seniority === 'junior') return { track:'IC', level:'IC2' };
  return { track:'IC', level:'IC3' };
};

/* Гарантированно возвращает {track, level} для любого person — с fallback через guessLevel */
const personLevel = (p) => {
  if (!p) return { track:'IC', level:'IC3' };
  /* COMMIT_8 fix (16 may 2026): case-insensitive level/track lookup.
     Supabase sync и старые версии PersonForm иногда сохраняли level в lowercase
     ('m3', 'm4', 'manager'). Тогда LEVELS[p.level] = undefined → fallback на
     guessLevel(p), который для HR-backup-admin'ов (sysRole='hr', напр. Тимур
     COO u30) возвращал {track:'Support', level:'S3'} — на UI был "S3 Lead"
     вместо ожидаемого "M3 · Senior Manager". Фикс — нормализация регистра. */
  const lvKey = String(p.level || '').toUpperCase();
  if (lvKey && LEVELS[lvKey]) {
    const trackIn = String(p.track || '').toLowerCase();
    const trackNorm = trackIn === 'manager' ? 'Manager'
                    : trackIn === 'ic'      ? 'IC'
                    : trackIn === 'support' ? 'Support'
                    : (p.track || LEVELS[lvKey].track);
    return { track: trackNorm, level: lvKey };
  }
  return guessLevel(p);
};

const PersonForm = ({ initial, onSave, onCancel, peopleList }) => {
  /* BUG-FIX (apr 2026): раньше форма стартовала с EMPTY_PERSON.track='IC', level='IC3',
     поэтому HR открывал профиль CEO и видел "IC3·Mid" — а при сохранении эти дефолты
     затирали smart-fallback из guessLevel(). Теперь, если у сотрудника нет явных track/level,
     инициализируем из guessLevel(initial) — для CEO/Director это даст {Manager, M4}. */
  const seedLevel = useMemo(() => {
    /* 18 may 2026 fix: case-insensitive lookup. Supabase syncs lowercase ('m3', 'ic4'),
       LEVELS keys uppercase. Без toUpperCase() форма игнорировала корректное значение
       из БД и срывалась на guessLevel() override (CTO → M4 для Куаныша даже если в БД m3). */
    const lvKey = String(initial?.level || '').toUpperCase();
    const trackIn = String(initial?.track || '').toLowerCase();
    const trackNorm = trackIn === 'manager' ? 'Manager'
                    : trackIn === 'ic'      ? 'IC'
                    : trackIn === 'support' ? 'Support'
                    : initial?.track;
    if (initial && trackNorm && lvKey && LEVELS[lvKey]) {
      return { track: trackNorm, level: lvKey };
    }
    return guessLevel({ ...EMPTY_PERSON, ...initial });
  }, []);
  const [form, setForm] = useState({ ...EMPTY_PERSON, ...initial, track: seedLevel.track, level: seedLevel.level });
  const [photoUploading, setPhotoUploading] = useState(false);
  const [photoError, setPhotoError] = useState('');
  const set = (k,v) => setForm(f => ({...f,[k]:v}));
  const makeAvatar = (name) => name ? name.trim().split(/\s+/).map(w=>w[0]).slice(0,2).join('').toUpperCase() : '';

  /* ───── Matrix management (29 apr 2026): solid (form.managerId) + до 2 dotted'ов ─────
     При open editor — подгружаем актуальный список dotted из БД через RPC list_employee_managers.
     При save — diff'аем и шлём set_employee_dotted_managers. */
  const [dottedEmails, setDottedEmails] = useState([]);
  const [dottedLoading, setDottedLoading] = useState(false);
  const [dottedError, setDottedError] = useState('');
  const [dottedSaving, setDottedSaving] = useState(false);
  const initialEmail = (initial?.email || '').toLowerCase().trim();
  useEffect(() => {
    if (!initialEmail || !supabase) return;
    setDottedLoading(true);
    (async () => {
      try {
        const { data, error } = await supabase.rpc('list_employee_managers', {
          p_employee_email: initialEmail,
        });
        if (error) throw error;
        const dotted = (data || []).filter(r => r.relationship === 'dotted').map(r => r.manager_email);
        setDottedEmails(dotted);
      } catch (e) {
        setDottedError('Не удалось загрузить dotted: ' + (e.message || String(e)));
      } finally {
        setDottedLoading(false);
      }
    })();
  }, [initialEmail]);
  const dottedCandidates = useMemo(() => {
    const solidId = form.managerId;
    return (peopleList || [])
      .filter(p => p.email && p.id !== form.id && p.id !== solidId)
      .sort((a,b) => {
        const rank = (p) => p.sysRole === 'director' ? 0 : p.sysRole === 'hr' ? 1 : p.sysRole === 'manager' ? 2 : 3;
        return rank(a) - rank(b) || (a.name || '').localeCompare(b.name || '');
      });
  }, [peopleList, form.id, form.managerId]);
  const setDottedSlot = (slotIdx, newEmail) => {
    setDottedEmails(prev => {
      const next = [...prev];
      if (newEmail) {
        next[slotIdx] = newEmail;
      } else {
        next.splice(slotIdx, 1);
      }
      const seen = new Set();
      return next.filter(e => e && !seen.has(e) && seen.add(e)).slice(0, 2);
    });
  };

  /* Загрузка фото в Supabase Storage (employee-photos) + RPC set_employee_photo.
     Fallback: если email не привязан к DB-записи, сохраняем URL только локально. */
  const handlePhotoFile = async (file) => {
    if (!file) return;
    setPhotoError('');
    if (!/^image\/(jpeg|jpg|png|webp)$/i.test(file.type)) {
      setPhotoError('Только JPG, PNG или WebP.'); return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setPhotoError('Файл больше 5 МБ.'); return;
    }
    if (!supabase) {
      setPhotoError('Supabase не инициализирован. Введите URL вручную ниже.'); return;
    }
    const email = (form.email || '').toLowerCase().trim();
    const dbId = window.__empDbIdByEmail?.[email];
    if (!email) {
      setPhotoError('Сначала заполните Email — фото привязывается к email.'); return;
    }
    if (!dbId) {
      setPhotoError(`Email ${email} не найден в базе (employees). Сохраните сотрудника, дождитесь sync, потом загрузите фото.`); return;
    }
    setPhotoUploading(true);
    try {
      const ext = (file.name.split('.').pop() || 'jpg').toLowerCase().replace(/[^a-z0-9]/g,'').slice(0,4) || 'jpg';
      const key = `${dbId}.${ext}`;
      const up = await supabase.storage
        .from('employee-photos')
        .upload(key, file, { upsert: true, contentType: file.type, cacheControl: '3600' });
      if (up.error) throw up.error;
      const { data: pub } = supabase.storage
        .from('employee-photos')
        .getPublicUrl(key);
      const publicUrl = pub?.publicUrl ? `${pub.publicUrl}?v=${Date.now()}` : '';
      if (!publicUrl) throw new Error('Не получилось получить publicUrl');
      const rpc = await supabase.rpc('set_employee_photo', {
        p_employee_id: dbId, p_url: publicUrl,
      });
      if (rpc.error) throw rpc.error;
      set('photoUrl', publicUrl);
    } catch (e) {
      setPhotoError(e.message || String(e));
    } finally {
      setPhotoUploading(false);
    }
  };

  const handlePhotoRemove = async () => {
    setPhotoError('');
    const email = (form.email || '').toLowerCase().trim();
    const dbId = window.__empDbIdByEmail?.[email];
    if (supabase && dbId) {
      try {
        await supabase.rpc('set_employee_photo', { p_employee_id: dbId, p_url: null });
      } catch (e) { setPhotoError(e.message || String(e)); }
    }
    set('photoUrl', '');
  };
  const handleSave = async () => {
    if (!form.role) { alert('Укажите роль (обязательно)'); return; }
    const id = form.id || ('u'+Math.random().toString(36).slice(2,6));
    const avatar = form.avatar || (form.name ? makeAvatar(form.name) : '');
    const finalEmail = form.email || (form.name ? `${avatar.toLowerCase()}@choco.kz` : null);

    /* COMMIT_5 (30 apr 2026): автодеривация seniority из выбранного level
       (для backward compat с HISTORY / talentBarPlacements / старыми гридами).
       Если по какой-то причине level пустой — оставляем существующий seniority. */
    const lv = form.level || personLevel(form).level;
    const derivedSeniority = (LEVELS[lv]?.seniorityHint) || form.seniority || 'Mid';

    /* COMMIT_9 (16 may 2026): порядок изменён — сначала БД, потом локальный store.
       Раньше: onSave вызывался ПЕРВЫМ, parent тут же закрывал модал (setMode(null)),
       и если RPC падал — пользователь видел только мелкую красную плашку на исчезающем
       модале (т.е. практически НЕ видел). Сейчас при ошибке RPC: alert + модал остаётся
       открытым + dottedError = подсказка, чтобы исправить и попробовать снова.
       См. project_site_audit_may2026.md и аудит 16 мая для root cause (teams.code NOT NULL). */
    if (finalEmail && supabase) {
      setDottedSaving(true);
      setDottedError('');
      try {
        const mgrEmail = form.managerId
          ? ((peopleList || []).find(p => p.id === form.managerId)?.email || null)
          : null;
        const SYS_ROLE_TO_DB = { hr:'hr_admin', director:'exec', manager:'manager', employee:'employee' };
        const dbRole = SYS_ROLE_TO_DB[form.sysRole || 'employee'] || 'employee';
        /* hr_upsert_employee — синхронизирует профиль в БД (по email или legacy_id).
           level в БД — lowercase enum (ic1..ic6, m1..m4, s1..s3); RPC сам нормализует. */
        const upsertRes = await supabase.rpc('hr_upsert_employee', {
          p_email:         finalEmail.toLowerCase().trim(),
          p_full_name:     form.name || form.role || finalEmail,
          p_title:         form.role || null,
          p_role:          dbRole,
          p_level:         form.level ? String(form.level).toLowerCase() : null, /* lowercase для enum */
          p_team_name:     form.team || null,
          p_subteam:       form.subteam || null,
          p_manager_email: mgrEmail,
          p_photo_url:     form.photoUrl || null,
          p_legacy_id:     id,
          p_phone:         form.phone || null,
          p_telegram:      form.telegram || null,
          p_date_of_birth: form.birthDate || null,
          p_start_date:    form.startDate || null,
          p_active:        form.active !== false,
          p_placeholder:   !form.name,
          /* 18 may 2026 fix (mig 0063): передаём track иначе RPC оставит NULL/предыдущее.
             Frontend form.track в UpperCase ('IC'/'Manager'/'Support'), DB enum lowercase. */
          p_track:         form.track
            ? String(form.track).toLowerCase()
            : null,
        });
        if (upsertRes.error) throw upsertRes.error;

        /* Dotted-менеджеры — тоже до закрытия модала. */
        const { error: dottedErr } = await supabase.rpc('set_employee_dotted_managers', {
          p_employee_email: finalEmail.toLowerCase().trim(),
          p_manager_emails: dottedEmails.filter(Boolean),
        });
        if (dottedErr) throw dottedErr;
      } catch (e) {
        const msg = e.message || String(e);
        setDottedError('БД-синхронизация: ' + msg);
        setDottedSaving(false);
        /* Делаем ошибку максимально заметной — alert не позволит её пропустить.
           Модал НЕ закрываем — пользователь может исправить и нажать «Сохранить» снова. */
        alert('Не удалось сохранить в БД:\n\n' + msg + '\n\nДанные НЕ сохранены. Исправьте и нажмите «Сохранить» снова.');
        return;
      } finally {
        setDottedSaving(false);
      }
    }

    /* Локальный store обновляем только после успешного DB-save (или если supabase вообще нет). */
    onSave({ ...form, id, avatar, email: finalEmail, seniority: derivedSeniority });
  };
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3">
        <Field label="Имя и Фамилия"><input className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.name} onChange={e=>set('name',e.target.value)} placeholder="Напр. Алдияр Какимов" /></Field>
        <Field label="Email"><input className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="ak@choco.kz" /></Field>
        <Field label="Должность (role)"><input className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.role} onChange={e=>set('role',e.target.value)} placeholder="Напр. ML Engineer · Personalization" /></Field>
        <Field label="Категория (roleKey)">
          {/* COMMIT_5 (30 apr 2026): дропдаун генерируется из ROLES (источник правды).
              Раньше был захардкоженный список ['research','ops','product','design','ceo'],
              который НЕ содержал реальных значений из seed (head/ml_engineer/pm/ops),
              поэтому при сохранении профиля Head of AI Assistant (roleKey='head')
              дропдаун подставлял `product` и роль терялась → matrix scorecard не находился. */}
          <select className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.roleKey} onChange={e=>set('roleKey',e.target.value)}>
            {Object.keys(ROLES).map(k=>(
              <option key={k} value={k}>{k} · {ROLES[k].label}</option>
            ))}
          </select>
        </Field>
        {/* COMMIT_5 (30 apr 2026): убрали legacy Seniority dropdown.
            Источник правды теперь — Track + Level (см. ниже).
            Seniority по-прежнему есть в form-state и автодеривится при save
            для backward compat с HISTORY и старыми placement'ами. */}
        <Field label="Career Track">
          <select
            className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm"
            value={form.track || personLevel(form).track}
            onChange={e=>{
              const newTrack = e.target.value;
              const currentLevelOk = LEVELS[form.level] && LEVELS[form.level].track === newTrack;
              const fallback = TRACKS[newTrack].levels[Math.min(2, TRACKS[newTrack].levels.length - 1)];
              set('track', newTrack);
              if (!currentLevelOk) set('level', fallback);
            }}>
            {Object.keys(TRACKS).map(t=><option key={t} value={t}>{TRACKS[t].label}</option>)}
          </select>
        </Field>
        <Field label="Level">
          <select
            className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm"
            value={form.level || personLevel(form).level}
            onChange={e=>set('level', e.target.value)}>
            {(TRACKS[form.track || personLevel(form).track]?.levels || []).map(lv => (
              <option key={lv} value={lv}>{LEVELS[lv].label}</option>
            ))}
          </select>
          <div className="text-[11px] text-ink-400 mt-1 leading-snug">
            {LEVELS[form.level]?.scope || LEVELS[personLevel(form).level]?.scope}
          </div>
        </Field>
        <Field label="Seniority · авто (legacy)">
          <div className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm bg-ink-50/60 flex items-center justify-between">
            {(() => {
              const lv = form.level || personLevel(form).level;
              const hint = LEVELS[lv]?.seniorityHint || form.seniority || 'Mid';
              const bar = TALENT_BAR[lv] || TALENT_BAR[hint] || 'Intermediate';
              return (
                <>
                  <span className="font-mono text-xs">{hint}</span>
                  <span className="text-[10px] uppercase tracking-wider text-ink-500">
                    Talent bar: <span className={masteryChip(bar)}>{bar}</span>
                  </span>
                </>
              );
            })()}
          </div>
          <div className="text-[11px] text-ink-500 mt-1">
            Деривится из Level автоматически. Используется в HISTORY и старых
            расчётах для совместимости. Менять напрямую нельзя.
          </div>
        </Field>
        <Field label="Дата последнего промо (levelSince)">
          <input type="date" className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm"
                 value={form.levelSince || ''} onChange={e=>set('levelSince', e.target.value)} />
        </Field>
        <Field label="Команда (team)"><input className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.team} onChange={e=>set('team',e.target.value)} placeholder="AI LABS / Revenue / Freedom Speech" /></Field>
        <Field label="Подкоманда (subteam)"><input className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.subteam} onChange={e=>set('subteam',e.target.value)} placeholder="Personalization / R&D" /></Field>
        <Field label="Manager">
          <select className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.managerId} onChange={e=>set('managerId',e.target.value)}>
            <option value="">— нет (top-level) —</option>
            {peopleList.filter(p=>p.id!==form.id).map(p => <option key={p.id} value={p.id}>{p.name || p.role} · {p.role}</option>)}
          </select>
        </Field>
        <Field label="Current Grade · read-only">
          <div className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm bg-ink-50/60 flex items-center justify-between">
            {form.currentGrade
              ? <span className={`text-xs px-2 py-0.5 rounded-full ${form.currentGrade==='A-player'?'bg-emerald-100 text-emerald-700':form.currentGrade==='Above bar'?'bg-brand-100 text-brand-700':'bg-rose-100 text-rose-700'}`}>{form.currentGrade}</span>
              : <span className="text-ink-400 italic">ещё не оценён</span>}
            <span className="text-[10px] uppercase tracking-wider text-ink-400">через Calibration</span>
          </div>
          <div className="text-[11px] text-ink-500 mt-1">Grade назначается только после Calibration · Talent Bar review. HR не может выставить его вручную — это защищает процесс от bias.</div>
        </Field>
        <Field label="Уровень доступа (System Role)">
          <select className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.sysRole || 'employee'} onChange={e=>set('sysRole',e.target.value)}>
            <option value="director">Директор — полный доступ</option>
            <option value="hr">HR / Performance Team — полный доступ</option>
            <option value="manager">Менеджер — команда</option>
            <option value="employee">Сотрудник — свой профиль</option>
          </select>
        </Field>
        <Field label="Color (аватар)">
          <select className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.color} onChange={e=>set('color',e.target.value)}>
            {['brand','violet','accent'].map(c=><option key={c} value={c}>{c}</option>)}
          </select>
        </Field>
        <Field label="Avatar (2-3 буквы)"><input className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.avatar} onChange={e=>set('avatar',e.target.value.toUpperCase().slice(0,3))} placeholder="Автозаполнение из имени" /></Field>
        <Field label="Tenure · авто"><div className="w-full h-10 px-3 rounded-lg border border-ink-100 bg-ink-50 text-sm flex items-center text-ink-700">
          {/* COMMIT_7.3 (16 may 2026) + 7.5 UX: read-only display, формат адаптивный:
              < 1 мес — дни; < 1 год — месяцы; >= 1 год — годы+месяцы.
              Math на клиенте, чтобы видеть live при изменении startDate в форме.
              На бэке VIEW employee_pii даёт numeric для других потребителей. */}
          {(() => {
            if (!form.startDate) return <span className="text-ink-400 italic">введи «Дата начала работы»</span>;
            const ms = Date.now() - new Date(form.startDate).getTime();
            if (ms < 0) return <span className="text-amber-600">дата ещё не наступила</span>;
            const days = Math.floor(ms / 86400000);
            if (days < 31) return days + ' дн.';
            const totalMonths = Math.floor(days / 30.4375);
            if (totalMonths < 12) return totalMonths + ' мес.';
            const years = Math.floor(totalMonths / 12);
            const months = totalMonths % 12;
            return months > 0 ? (years + ' лет ' + months + ' мес.') : (years + ' лет');
          })()}
        </div></Field>
        <Field label="Статус">
          <select className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.status || 'active'} onChange={e=>set('status', e.target.value)}>
            <option value="active">Работает</option>
            <option value="vacant">Вакансия (позиция открыта)</option>
            <option value="onLeave">В отпуске / декрете</option>
          </select>
        </Field>
        <Field label="Дата начала работы"><input type="date" className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.startDate || ''} onChange={e=>set('startDate', e.target.value)} /></Field>
        <Field label="Дата рождения"><input type="date" className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.birthDate || ''} onChange={e=>set('birthDate', e.target.value)} /></Field>
      </div>
      {/* ───── Matrix management: dotted-менеджеры (макс 2) ───── */}
      {(() => {
        const liveEmail = (form.email || '').toLowerCase().trim();
        const placeholderEmail = liveEmail.endsWith('.placeholder@choco.kz');
        const canPick = !!liveEmail && !placeholderEmail;
        return (
          <div className="border-t border-ink-100 pt-4 mt-2">
            <div className="flex items-center justify-between mb-2">
              <div>
                <div className="text-[12px] uppercase tracking-wider text-ink-700 font-semibold">Matrix management</div>
                <div className="text-[11px] text-ink-500 mt-0.5">
                  Solid manager (выше) пишет финальный Manager Assessment. Dotted'ы — продуктовые/проектные руководители: автоматически попадают в 360 feedback. Максимум 2 dotted.
                </div>
              </div>
              {dottedLoading && <span className="text-[11px] text-ink-400">загружаю…</span>}
              {dottedSaving && <span className="text-[11px] text-amber-600">сохраняю dotted…</span>}
            </div>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Dotted manager #1 (необязательно)">
                <select
                  className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm"
                  value={dottedEmails[0] || ''}
                  onChange={e => setDottedSlot(0, e.target.value)}
                  disabled={!canPick}
                >
                  <option value="">— нет —</option>
                  {dottedCandidates.filter(p => p.email !== dottedEmails[1]).map(p => (
                    <option key={p.id} value={p.email}>
                      {p.name || p.role} · {p.role}
                    </option>
                  ))}
                </select>
              </Field>
              <Field label="Dotted manager #2 (необязательно)">
                <select
                  className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm"
                  value={dottedEmails[1] || ''}
                  onChange={e => setDottedSlot(1, e.target.value)}
                  disabled={!canPick || !dottedEmails[0]}
                >
                  <option value="">— нет —</option>
                  {dottedCandidates.filter(p => p.email !== dottedEmails[0]).map(p => (
                    <option key={p.id} value={p.email}>
                      {p.name || p.role} · {p.role}
                    </option>
                  ))}
                </select>
              </Field>
            </div>
            {!liveEmail && (
              <div className="text-[11px] text-ink-500 mt-2 italic">
                Введи email сотрудника в поле выше — после этого можно будет выбрать dotted-менеджеров.
              </div>
            )}
            {placeholderEmail && (
              <div className="text-[11px] text-amber-700 mt-2 italic px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg">
                Этот email — placeholder ({liveEmail}). Замени на реальный @choco.kz, чтобы dotted-менеджеры синхронизировались с БД (там сотрудник идентифицируется по email).
              </div>
            )}
            {dottedError && (
              <div className="text-[11px] text-rose-600 mt-2 px-3 py-2 bg-rose-50 border border-rose-200 rounded-lg">{dottedError}</div>
            )}
          </div>
        );
      })()}
      <div className="grid grid-cols-[80px_1fr] gap-3 items-start pt-2">
        <Avatar p={{ ...form, placeholder:false, avatar: form.avatar || (form.name ? form.name.trim().split(/\s+/).map(w=>w[0]).slice(0,2).join('').toUpperCase() : '??') }} size={64}/>
        <Field label="Фото">
          <div className="flex items-center gap-2">
            <label className={`inline-flex items-center gap-2 h-10 px-3 rounded-lg border border-ink-200 text-sm cursor-pointer hover:bg-ink-50 ${photoUploading ? 'opacity-50 pointer-events-none' : ''}`}>
              <input
                type="file"
                accept="image/jpeg,image/png,image/webp"
                className="hidden"
                disabled={photoUploading}
                onChange={e => { const f = e.target.files?.[0]; if (f) handlePhotoFile(f); e.target.value = ''; }}
              />
              {photoUploading ? 'Загружаю…' : (form.photoUrl ? 'Заменить фото' : 'Загрузить фото')}
            </label>
            {form.photoUrl && !photoUploading && (
              <button type="button" onClick={handlePhotoRemove}
                      className="h-10 px-3 rounded-lg border border-ink-200 text-sm text-ink-600 hover:bg-ink-50">
                Удалить
              </button>
            )}
          </div>
          {photoError && (
            <div className="text-xs text-rose-700 mt-2 px-3 py-2 bg-rose-50 border border-rose-200 rounded-lg break-words">
              <span className="font-medium">Загрузка фото не удалась:</span> {photoError}
            </div>
          )}
          <div className="text-[11px] text-ink-400 mt-1">
            JPG/PNG/WebP до 5 МБ. Храним в Supabase Storage — не пропадёт при Clear site data.
            Пусто — покажется плашка с инициалами (ничего не уходит на внешние CDN).
          </div>
          {/* Fallback: ручной URL для Google Drive / внешних ссылок */}
          <details className="mt-2">
            <summary className="text-[11px] text-ink-500 cursor-pointer hover:text-ink-700">Или вставить URL вручную</summary>
            <input
              className="mt-1 w-full h-9 px-3 rounded-lg border border-ink-200 text-sm"
              value={form.photoUrl || ''}
              onChange={e=>set('photoUrl', e.target.value.trim())}
              placeholder="https://…"
            />
          </details>
        </Field>
      </div>
      <div className="flex justify-end gap-2 pt-2 border-t border-ink-100">
        <button onClick={onCancel} className="h-10 px-4 rounded-lg border border-ink-200 text-sm font-semibold hover:bg-ink-50">Отмена</button>
        <button onClick={handleSave} className="h-10 px-4 rounded-lg bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700">Сохранить</button>
      </div>
    </div>
  );
};

const Field = ({ label, children }) => (
  <label className="block">
    <div className="text-[11px] uppercase tracking-wider text-ink-500 font-semibold mb-1">{label}</div>
    {children}
  </label>
);

const Modal = ({ open, title, children, onClose, wide=false }) => {
  /* Закрываем только если mouseDown И mouseUp оба на backdrop. Это защищает
     от случайного закрытия при drag-to-select внутри input'а (когда курсор
     уезжает на тёмный фон во время выделения текста). */
  const downOnBackdrop = useRef(false);
  if (!open) return null;
  const handleBackdropDown = (e) => { downOnBackdrop.current = (e.target === e.currentTarget); };
  const handleBackdropUp   = (e) => {
    if (downOnBackdrop.current && e.target === e.currentTarget) onClose();
    downOnBackdrop.current = false;
  };
  return (
    <div
      className="fixed inset-0 z-50 bg-ink-900/40 backdrop-blur-sm flex items-center justify-center p-4"
      onMouseDown={handleBackdropDown}
      onMouseUp={handleBackdropUp}
    >
      <div
        className={`bg-white rounded-2xl shadow-pop w-full ${wide?'max-w-4xl':'max-w-2xl'} max-h-[90vh] overflow-y-auto`}
        onMouseDown={e=>e.stopPropagation()}
        onMouseUp={e=>e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-ink-100 sticky top-0 bg-white">
          <div className="font-bold">{title}</div>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-ink-100 flex items-center justify-center"><Icon name="close" className="w-4 h-4"/></button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
};

const HRAdminPage = ({ onOpen }) => {
  const { store, user } = useApp();
  const people = store.state.people;
  const [mode, setMode] = useState(null); // null | 'add' | 'edit'
  const [editing, setEditing] = useState(null);
  const [importOpen, setImportOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [showInactive, setShowInactive] = useState(false);
  const [fTeam, setFTeam] = useState('All');
  const [fTrack, setFTrack] = useState('All');
  const [fLevel, setFLevel] = useState('All');
  const [fStatus, setFStatus] = useState('All');     /* All | active | vacant | onLeave */
  const [fGrade, setFGrade] = useState('All');       /* All | A-player | Above bar | Underperformer */
  const [fAccess, setFAccess] = useState('All');     /* All | director | hr | manager | employee */
  const [fNoMgr, setFNoMgr] = useState(false);       /* boolean — без менеджера */
  const [csvText, setCsvText] = useState('name,role,roleKey,seniority,team,subteam,managerId,avatar,color,currentGrade,sysRole\nЖанат Тленчиев,ML Engineer,research,Senior,AI LABS,Personalization,u2,ЖТ,violet,,employee');

  const teamsAll = Array.from(new Set(people.map(p=>p.team).filter(Boolean))).sort();
  const allLevelsHR = Object.keys(LEVELS);
  /* Быстрый lookup менеджера по id — чтобы рендер строк не был O(N²) */
  const peopleById = Object.fromEntries(people.map(pp => [pp.id, pp]));

  const filtered = people.filter(p => {
    if (!showInactive && p.active===false) return false;
    if (fTeam !== 'All' && p.team !== fTeam) return false;
    if (fTrack !== 'All' && personLevel(p).track !== fTrack) return false;
    if (fLevel !== 'All' && personLevel(p).level !== fLevel) return false;
    if (fStatus !== 'All' && personStatus(p) !== fStatus) return false;
    if (fGrade !== 'All' && (p.currentGrade||'') !== fGrade) return false;
    if (fAccess !== 'All' && (p.sysRole||'employee') !== fAccess) return false;
    if (fNoMgr && p.managerId) return false;
    if (!search) return true;
    const q = search.toLowerCase();
    return (p.name||'').toLowerCase().includes(q)
      || (p.role||'').toLowerCase().includes(q)
      || (p.team||'').toLowerCase().includes(q)
      || (p.email||'').toLowerCase().includes(q);
  });

  const activeFiltersHR = (fTeam!=='All'?1:0) + (fTrack!=='All'?1:0) + (fLevel!=='All'?1:0) + (fStatus!=='All'?1:0) + (fGrade!=='All'?1:0) + (fAccess!=='All'?1:0) + (fNoMgr?1:0);
  const resetFiltersHR = () => { setFTeam('All'); setFTrack('All'); setFLevel('All'); setFStatus('All'); setFGrade('All'); setFAccess('All'); setFNoMgr(false); };

  const handleAdd = (p) => { store.addPerson(p, user.name); setMode(null); };
  const handleUpdate = (p) => { store.updatePerson(p.id, p, user.name); setMode(null); setEditing(null); };
  /* deactivate/reactivate — синхронизируем с БД через RPC hr_set_employee_active.
     Если в БД сотрудника нет (placeholder без upsert), просто молчим — локальный state
     обновится в любом случае. */
  const syncActiveToDb = async (personId, nextActive) => {
    if (!supabase) return;
    const p = store.state.people.find(x => x.id === personId);
    const email = (p?.email || '').toLowerCase().trim();
    if (!email || email.endsWith('.placeholder@choco.kz')) return;
    try {
      await supabase.rpc('hr_set_employee_active', { p_email: email, p_active: nextActive });
    } catch (e) { console.warn('[hr_set_employee_active]', e?.message || e); }
  };
  const handleDeactivate = (id) => {
    if (confirm('Деактивировать сотрудника? Данные сохранятся, но он исчезнет из активных списков.')) {
      store.deactivatePerson(id, user.name);
      syncActiveToDb(id, false);
    }
  };
  const handleReactivate = (id) => {
    store.reactivatePerson(id, user.name);
    syncActiveToDb(id, true);
  };

  const handleImport = () => {
    try {
      const rows = parseCSV(csvText);
      if (!rows.length) { alert('CSV пуст'); return; }
      const mapped = rows.map(r => ({
        id:'u'+Math.random().toString(36).slice(2,6),
        name:r.name||'', role:r.role||'Unknown role', roleKey:r.roleKey||'ops',
        seniority:r.seniority||'Mid', team:r.team||'', subteam:r.subteam||'',
        managerId:r.managerId||'', avatar:r.avatar||(r.name?r.name.split(/\s+/).map(w=>w[0]).slice(0,2).join('').toUpperCase():''),
        color:r.color||'brand', tenure:parseFloat(r.tenure)||0,
        /* base/equity из CSV игнорируются (22 apr 2026) — не храним comp */
        currentGrade: r.currentGrade || null,
        sysRole: (['director','hr','manager','employee'].includes(r.sysRole) ? r.sysRole : 'employee'),
        email:r.email||'', active:true, hasName:!!r.name, placeholder:!r.name,
      }));
      store.bulkImportPeople(mapped, user.name);
      setImportOpen(false);
      alert(`Импортировано: ${mapped.length} сотрудников`);
    } catch (e) { alert('Ошибка парсинга CSV: '+e.message); }
  };

  const handleExport = () => {
    const csv = toCSV(people, ['id','name','role','roleKey','seniority','team','subteam','managerId','avatar','color','tenure','currentGrade','sysRole','email','active']);
    downloadText(`employees_${new Date().toISOString().slice(0,10)}.csv`, csv);
  };

  return (
    <div className="p-8 space-y-5 fade-in">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-[.18em] text-ink-400 mb-1">HR Admin</div>
          <h2 className="text-2xl font-extrabold">Управление сотрудниками</h2>
          <div className="text-sm text-ink-500 mt-0.5">{people.filter(p=>p.active!==false).length} активных · {people.filter(p=>p.active===false).length} деактивированных</div>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={handleExport} className="h-10 px-3 rounded-lg border border-ink-200 text-sm font-semibold hover:bg-ink-50 flex items-center gap-1.5"><Icon name="export" className="w-4 h-4"/>Export CSV</button>
          <button onClick={()=>setImportOpen(true)} className="h-10 px-3 rounded-lg border border-ink-200 text-sm font-semibold hover:bg-ink-50 flex items-center gap-1.5"><Icon name="import" className="w-4 h-4"/>Import CSV</button>
          <button onClick={()=>{ setEditing(null); setMode('add'); }} className="h-10 px-4 rounded-lg bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700 flex items-center gap-1.5"><Icon name="plus" className="w-4 h-4"/>Добавить сотрудника</button>
        </div>
      </div>

      <Card>
        <div className="p-4 border-b border-ink-100 space-y-3">
          {/* Ряд 1: поиск + чекбоксы + счётчик */}
          <div className="flex items-center gap-3 flex-wrap">
            <div className="flex items-center gap-2 flex-1 min-w-[240px] border border-ink-200 rounded-lg px-3 h-9 bg-white">
              <Icon name="search" className="w-4 h-4 text-ink-400 shrink-0"/>
              <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Поиск по имени, роли, команде, email…" className="flex-1 text-sm outline-none bg-transparent"/>
            </div>
            <label className="flex items-center gap-2 text-xs text-ink-600 cursor-pointer">
              <input type="checkbox" checked={showInactive} onChange={e=>setShowInactive(e.target.checked)} />
              Показать деактивированных
            </label>
            <label className="flex items-center gap-2 text-xs text-ink-600 cursor-pointer">
              <input type="checkbox" checked={fNoMgr} onChange={e=>setFNoMgr(e.target.checked)} />
              Без менеджера
            </label>
            <div className="text-xs text-ink-500 whitespace-nowrap">
              Показано <span className="font-semibold text-ink-900">{filtered.length}</span> из {people.length}
            </div>
          </div>
          {/* Ряд 2: фильтры */}
          <div className="flex items-center gap-2 flex-wrap">
            <div className="flex items-center gap-1.5">
              <Icon name="target" className="w-3.5 h-3.5 text-ink-400"/>
              <span className="text-[11px] uppercase tracking-wider text-ink-500 font-semibold">Фильтры базы</span>
            </div>
            <select
              value={fTeam}
              onChange={e=>setFTeam(e.target.value)}
              className={`text-xs px-2.5 py-1.5 rounded-lg border bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-200 ${fTeam==='All'?'border-ink-200 text-ink-700':'border-brand-300 text-brand-700 font-semibold bg-brand-50'}`}
            >
              <option value="All">Команда · все</option>
              {teamsAll.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
            <select
              value={fTrack}
              onChange={e=>setFTrack(e.target.value)}
              className={`text-xs px-2.5 py-1.5 rounded-lg border bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-200 ${fTrack==='All'?'border-ink-200 text-ink-700':'border-brand-300 text-brand-700 font-semibold bg-brand-50'}`}
            >
              <option value="All">Трек · все</option>
              {Object.entries(TRACKS).map(([k,v]) => <option key={k} value={k}>{v.label}</option>)}
            </select>
            <select
              value={fLevel}
              onChange={e=>setFLevel(e.target.value)}
              className={`text-xs px-2.5 py-1.5 rounded-lg border bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-200 ${fLevel==='All'?'border-ink-200 text-ink-700':'border-brand-300 text-brand-700 font-semibold bg-brand-50'}`}
            >
              <option value="All">Уровень · все</option>
              {allLevelsHR.filter(lv => fTrack==='All' || LEVELS[lv].track===fTrack).map(lv => (
                <option key={lv} value={lv}>{LEVELS[lv].label}</option>
              ))}
            </select>
            <select
              value={fStatus}
              onChange={e=>setFStatus(e.target.value)}
              className={`text-xs px-2.5 py-1.5 rounded-lg border bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-200 ${fStatus==='All'?'border-ink-200 text-ink-700':'border-brand-300 text-brand-700 font-semibold bg-brand-50'}`}
            >
              <option value="All">Статус · все</option>
              <option value="active">Работает</option>
              <option value="vacant">Вакансия</option>
              <option value="onLeave">В отпуске</option>
            </select>
            <select
              value={fGrade}
              onChange={e=>setFGrade(e.target.value)}
              className={`text-xs px-2.5 py-1.5 rounded-lg border bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-200 ${fGrade==='All'?'border-ink-200 text-ink-700':'border-brand-300 text-brand-700 font-semibold bg-brand-50'}`}
            >
              <option value="All">Grade · все</option>
              <option value="A-player">A-player</option>
              <option value="Above bar">Above bar</option>
              <option value="Underperformer">Underperformer</option>
            </select>
            <select
              value={fAccess}
              onChange={e=>setFAccess(e.target.value)}
              className={`text-xs px-2.5 py-1.5 rounded-lg border bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-200 ${fAccess==='All'?'border-ink-200 text-ink-700':'border-brand-300 text-brand-700 font-semibold bg-brand-50'}`}
              title="Уровень доступа в системе (sysRole)"
            >
              <option value="All">Доступ · все</option>
              {Object.entries(ROLE_LABELS).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
            </select>
            {activeFiltersHR > 0 && (
              <button
                onClick={resetFiltersHR}
                className="text-[11px] px-2.5 py-1.5 rounded-lg border border-ink-200 text-ink-600 hover:bg-ink-50 hover:text-ink-900 flex items-center gap-1"
              >
                Сбросить ({activeFiltersHR})
              </button>
            )}
          </div>
        </div>
        <div className="divide-y divide-ink-100">
          <div className="grid grid-cols-[48px_2fr_2fr_1fr_1fr_1fr_140px] gap-3 px-5 py-2 text-[11px] uppercase tracking-wider font-semibold text-ink-500 bg-ink-50/50">
            <div></div><div>Сотрудник</div><div>Роль / Команда</div><div>Seniority</div><div>Менеджер</div><div>Доступ</div><div className="text-right">Действия</div>
          </div>
          {filtered.map(p=>{
            const sys = p.sysRole || 'employee';
            const st = personStatus(p);
            const isVacant = st === 'vacant';
            const isOnLeave = st === 'onLeave';
            return (
            <div key={p.id} className={`grid grid-cols-[48px_2fr_2fr_1fr_1fr_1fr_140px] gap-3 px-5 py-3 items-center text-sm ${p.active===false?'opacity-50':''}`}>
              <Avatar p={p} size={40}/>
              <div>
                <div className="flex items-center gap-2">
                  <span className={`font-semibold ${isVacant?'italic text-ink-400':''}`}>{p.name || p.role}</span>
                  {isVacant && <span className="text-[10px] px-1.5 py-0.5 rounded-full font-semibold border border-dashed border-ink-300 text-ink-500 bg-white">Vacant</span>}
                  {isOnLeave && <span className="text-[10px] px-1.5 py-0.5 rounded-full font-semibold bg-amber-50 text-amber-700 border border-amber-200">Отпуск</span>}
                </div>
                <div className="text-xs text-ink-500">
                  {p.email || '— без email'}
                  {p.startDate && <span className="ml-2">· с {p.startDate}</span>}
                </div>
              </div>
              <div>
                <div className="text-ink-700">{p.role}</div>
                <div className="text-xs text-ink-500">{p.team}{p.subteam?` · ${p.subteam}`:''}</div>
              </div>
              <div className="flex items-center gap-1.5 flex-wrap">
                {(() => { const lv = personLevel(p).level; return (
                  <span className={`text-[10px] px-1.5 py-0.5 rounded border font-semibold ${LEVEL_TONE(lv)}`} title={LEVELS[lv]?.label}>{lv}</span>
                ); })()}
                <span className="text-[11px] text-ink-600">{p.seniority}</span>
              </div>
              <div>
                {(() => {
                  const mgr = p.managerId ? peopleById[p.managerId] : null;
                  if (!mgr) return <span className="text-xs text-ink-400 italic">— нет руководителя</span>;
                  return (
                    <button
                      onClick={()=>onOpen && onOpen(mgr.id)}
                      className="flex items-center gap-2 text-left hover:bg-ink-50 -mx-1 px-1 py-0.5 rounded transition w-full min-w-0"
                      title={`Открыть профиль: ${mgr.name||mgr.role}`}>
                      <Avatar p={mgr} size={28}/>
                      <div className="min-w-0 flex-1">
                        <div className="text-xs font-semibold text-ink-800 truncate">{mgr.name || mgr.role}</div>
                        <div className="text-[10px] text-ink-500 truncate">{mgr.role}</div>
                      </div>
                    </button>
                  );
                })()}
              </div>
              <div><span className={`text-[10px] px-1.5 py-0.5 rounded border ${ROLE_TONE[sys]}`}>{ROLE_LABELS[sys]}</span></div>
              <div className="flex items-center justify-end gap-1">
                <button onClick={()=>onOpen && onOpen(p.id)} className="w-8 h-8 rounded-lg hover:bg-ink-100 flex items-center justify-center" title="Открыть профиль"><Icon name="eye" className="w-4 h-4 text-ink-600"/></button>
                <button onClick={()=>{ setEditing(p); setMode('edit'); }} className="w-8 h-8 rounded-lg hover:bg-ink-100 flex items-center justify-center" title="Редактировать"><Icon name="edit" className="w-4 h-4 text-ink-600"/></button>
                {p.active===false
                  ? <button onClick={()=>handleReactivate(p.id)} className="h-8 px-2 rounded-lg border border-emerald-200 text-emerald-700 text-xs font-semibold hover:bg-emerald-50">Вернуть</button>
                  : <button onClick={()=>handleDeactivate(p.id)} className="w-8 h-8 rounded-lg hover:bg-rose-50 flex items-center justify-center" title="Деактивировать"><Icon name="trash" className="w-4 h-4 text-rose-600"/></button>
                }
              </div>
            </div>
            );
          })}
          {filtered.length===0 && <div className="p-8 text-center text-ink-500 text-sm">Никого не нашлось по фильтрам</div>}
        </div>
      </Card>

      <Modal open={mode==='add' || mode==='edit'} title={mode==='add'?'Добавить сотрудника':`Редактировать: ${editing?.name||editing?.role||''}`} onClose={()=>{setMode(null); setEditing(null);}} wide>
        <PersonForm initial={editing||{}} peopleList={people.filter(p=>p.active!==false)} onSave={mode==='add'?handleAdd:handleUpdate} onCancel={()=>{setMode(null); setEditing(null);}}/>
      </Modal>

      <Modal open={importOpen} title="Импорт сотрудников из CSV" onClose={()=>setImportOpen(false)} wide>
        <div className="space-y-3">
          <div className="text-sm text-ink-600">
            Колонки: <code className="bg-ink-100 px-1 rounded text-xs">name,role,roleKey,seniority,team,subteam,managerId,avatar,color,currentGrade,email,tenure</code>. Обязательные — <code className="bg-ink-100 px-1 rounded text-xs">role</code>.
          </div>
          <textarea value={csvText} onChange={e=>setCsvText(e.target.value)} rows={10} className="w-full p-3 rounded-lg border border-ink-200 text-xs font-mono"/>
          <div className="flex justify-end gap-2">
            <button onClick={()=>setImportOpen(false)} className="h-10 px-4 rounded-lg border border-ink-200 text-sm font-semibold">Отмена</button>
            <button onClick={handleImport} className="h-10 px-4 rounded-lg bg-brand-600 text-white text-sm font-semibold">Импортировать</button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

/* ───────── 360 FEEDBACK PAGES ───────── */
const FeedbackPage = ({ onAnswer, onOpen }) => {
  const { store, user } = useApp();
  const [tab, setTab] = useState('inbox');
  const [creating, setCreating] = useState(false);
  const [creatingUpward, setCreatingUpward] = useState(false);
  const [givingUpward, setGivingUpward] = useState(false);

  const inbound = store.state.feedbackRequests.filter(fr =>
    (fr.fromIds||[]).includes(user.id) &&
    !fr.responses.some(r => r.fromId===user.id)
  );
  const requested = store.state.feedbackRequests.filter(fr => fr.requesterId === user.id);
  const aboutMe = store.state.feedbackRequests.filter(fr => fr.subjectId === user.id);

  /* My manager (from PEOPLE lookup) */
  const myManager = user.managerId ? (store.state.people.find(p=>p.id===user.id)?.managerId
    ? store.state.people.find(p=>p.id===user.people?.find?.(p=>p.id===user.managerId)?.id)
    : null) : null;
  /* Simpler: find manager directly */
  const manager = (() => {
    const me = store.state.people.find(p=>p.id===user.id) || byId(user.id);
    if (!me?.managerId) return null;
    return store.state.people.find(p=>p.id===me.managerId) || byId(me.managerId);
  })();

  /* My direct reports — for upward feedback aggregation */
  const myDirects = store.state.people.filter(p=>p.managerId===user.id && p.active!==false);
  const upwardOnMe = aboutMe.filter(fr => {
    const form = store.state.forms.find(f=>f.id===fr.formId);
    return form?.type==='upward';
  });
  const upwardResponseCount = upwardOnMe.reduce((a,fr)=>a+fr.responses.length,0);

  const getPerson = (id) => store.state.people.find(p=>p.id===id) || byId(id);
  const getForm = (id) => store.state.forms.find(f=>f.id===id);

  const tabBtn = (key, label, count) => (
    <button onClick={()=>setTab(key)} className={`h-8 px-3 rounded-md text-[12px] font-medium flex items-center gap-2 ${tab===key?'bg-brand-600 text-white':'bg-white text-ink-700 border border-ink-200 hover:bg-ink-50'}`}>
      {label}{count>0 && <span className={`text-[10px] px-1.5 py-0.5 rounded ${tab===key?'bg-white/20':'bg-ink-100 text-ink-700'}`}>{count}</span>}
    </button>
  );

  const upwardForm = store.state.forms.find(f=>f.type==='upward');

  return (
    <div className="p-8 space-y-5 fade-in">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-[.18em] text-ink-400 mb-1">360-Feedback · Peer + Upward</div>
          <h2 className="text-2xl font-extrabold">Фидбек</h2>
          <div className="text-sm text-ink-500 mt-0.5">Запрашивайте обратную связь у коллег (до 5 stakeholders), давайте upward feedback вашему менеджеру, отвечайте на входящие запросы.</div>
        </div>
        <div className="flex items-center gap-2">
          {manager && upwardForm && (
            <button onClick={()=>setGivingUpward(true)}
                    className="h-10 px-4 rounded-lg border border-brand-300 text-brand-700 hover:bg-brand-50 text-sm font-semibold flex items-center gap-1.5">
              <Icon name="shield" className="w-4 h-4"/>Upward Feedback на {manager.name.split(' ')[0]}
            </button>
          )}
          <button onClick={()=>setCreating(true)} className="h-10 px-4 rounded-lg bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700 flex items-center gap-1.5"><Icon name="plus" className="w-4 h-4"/>Запросить фидбек</button>
        </div>
      </div>

      <div className="flex gap-2 flex-wrap">
        {tabBtn('inbox',`Входящие (мне нужно ответить)`, inbound.length)}
        {tabBtn('sent','Мои запросы', requested.length)}
        {tabBtn('about','Обо мне', aboutMe.length)}
        {myDirects.length>0 && tabBtn('upward',`Upward feedback (от моей команды)`, upwardResponseCount)}
      </div>

      {tab==='inbox' && (
        <Card>
          <CardHead title="Входящие запросы" subtitle="Ожидают вашего ответа"/>
          <div className="divide-y divide-ink-100">
            {inbound.length===0 && <div className="p-8 text-center text-sm text-ink-500">Нет незакрытых запросов. Спасибо!</div>}
            {inbound.map(fr => {
              const subject = getPerson(fr.subjectId);
              const form = getForm(fr.formId);
              return (
                <div key={fr.id} className="p-5 flex items-center gap-4">
                  <Avatar p={subject} size={44}/>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold">О ком: {subject.name || subject.role}</div>
                    <div className="text-xs text-ink-500">Форма: {form?.name || fr.formId} · {fr.anonymous?'Анонимно':'Именовано'} · Дедлайн: {fr.dueDate}</div>
                  </div>
                  <button onClick={()=>onAnswer(fr.id)} className="h-9 px-3 rounded-lg bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700">Заполнить</button>
                </div>
              );
            })}
          </div>
        </Card>
      )}

      {tab==='sent' && (
        <Card>
          <CardHead title="Запросы, которые я отправил" subtitle="Статус сбора"/>
          <div className="divide-y divide-ink-100">
            {requested.length===0 && <div className="p-8 text-center text-sm text-ink-500">Вы пока не отправляли запросов. Нажмите «Запросить фидбек».</div>}
            {requested.map(fr => {
              const subject = getPerson(fr.subjectId);
              const form = getForm(fr.formId);
              const total = (fr.fromIds||[]).length || fr.responses.length;
              const done = fr.responses.length;
              return (
                <div key={fr.id} className="p-5 space-y-2">
                  <div className="flex items-center gap-3">
                    <Avatar p={subject} size={36}/>
                    <div className="flex-1">
                      <div className="font-semibold">О: {subject.name || subject.role}</div>
                      <div className="text-xs text-ink-500">{form?.name} · отправлено {fr.sentAt} · дедлайн {fr.dueDate}</div>
                    </div>
                    <div className="text-sm font-semibold">{done}/{total}</div>
                  </div>
                  <div className="h-1.5 bg-ink-100 rounded-full overflow-hidden">
                    <div className="h-full bg-brand-500 rounded-full" style={{width: total?`${done/total*100}%`:'0%'}}></div>
                  </div>
                </div>
              );
            })}
          </div>
        </Card>
      )}

      {tab==='about' && (
        <Card>
          <CardHead title="Фидбек обо мне" subtitle="Агрегированные ответы"/>
          <div className="divide-y divide-ink-100">
            {aboutMe.length===0 && <div className="p-8 text-center text-sm text-ink-500">Про вас пока никто не оставлял фидбек.</div>}
            {aboutMe.map(fr => {
              const form = getForm(fr.formId);
              return (
                <div key={fr.id} className="p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-lg bg-brand-50 text-brand-700 grid place-items-center"><Icon name="chat" className="w-5 h-5"/></div>
                    <div className="flex-1">
                      <div className="font-semibold">{form?.name || fr.formId}</div>
                      <div className="text-xs text-ink-500">{fr.responses.length} ответов · {fr.anonymous?'анонимно':'именовано'}</div>
                    </div>
                  </div>
                  <div className="space-y-3">
                    {(form?.questions||[]).map(q => (
                      <div key={q.id} className="bg-ink-50/50 rounded-lg p-3">
                        <div className="text-sm font-semibold mb-1">{q.text}</div>
                        <div className="text-xs text-ink-500 mb-2">{q.type==='rating'?`rating 1–${q.scale||5}`:q.type==='likert'?'likert':q.type}</div>
                        <div className="space-y-1">
                          {fr.responses.map(r => (
                            <div key={r.id+q.id} className="text-sm border-l-2 border-brand-300 pl-2">
                              <span className="text-ink-500 text-xs">{fr.anonymous?'Аноним':(getPerson(r.fromId).name || getPerson(r.fromId).role)}:</span> <span>{String(r.answers[q.id] ?? '—')}</span>
                            </div>
                          ))}
                          {fr.responses.length===0 && <div className="text-xs text-ink-400 italic">Ещё нет ответов</div>}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </Card>
      )}

      {tab==='upward' && (
        <Card>
          <CardHead title="Upward Feedback · Что говорит моя команда"
                    subtitle="Открытый именной фидбек от direct reports. Используйте для роста как менеджер — а не как аргумент в спорах с командой."
                    right={
                      <button onClick={()=>setCreatingUpward(true)} className="h-8 px-3 rounded-md bg-brand-600 text-white text-xs font-semibold hover:bg-brand-700 flex items-center gap-1">
                        <Icon name="plus" className="w-3.5 h-3.5"/>Запустить сбор
                      </button>
                    }/>
          <div className="p-5 space-y-4">
            {/* Status bar */}
            <div className="grid md:grid-cols-3 gap-3">
              <div className="rounded-lg border border-ink-100 p-3 bg-white">
                <div className="text-[10px] uppercase tracking-wider text-ink-500 font-semibold">Ответов получено</div>
                <div className="text-xl font-bold mt-0.5">{upwardResponseCount}</div>
              </div>
              <div className="rounded-lg border border-ink-100 p-3 bg-white">
                <div className="text-[10px] uppercase tracking-wider text-ink-500 font-semibold">Response rate</div>
                <div className="text-xl font-bold mt-0.5">{myDirects.length ? Math.round(upwardResponseCount/myDirects.length*100) : 0}% <span className="text-xs font-normal text-ink-500">({upwardResponseCount}/{myDirects.length})</span></div>
              </div>
              <div className="rounded-lg border border-ink-100 p-3 bg-white">
                <div className="text-[10px] uppercase tracking-wider text-ink-500 font-semibold">Цикл</div>
                <div className="text-xl font-bold mt-0.5">{ACTIVE_CYCLE.period}</div>
              </div>
            </div>

            <div className="space-y-3">
              {upwardOnMe.map(fr => {
                const form = getForm(fr.formId);
                return (
                  <div key={fr.id} className="rounded-lg border border-ink-100 p-4">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-8 h-8 rounded-md bg-brand-50 text-brand-700 grid place-items-center"><Icon name="shield" className="w-4 h-4"/></div>
                      <div className="flex-1">
                        <div className="text-sm font-semibold">{form?.name || 'Upward feedback'}</div>
                        <div className="text-[11px] text-ink-500">{fr.responses.length} ответов · дедлайн {fr.dueDate}</div>
                      </div>
                    </div>
                    <div className="space-y-2.5">
                      {(form?.questions||[]).map(q=>{
                        const responsesWithAnswer = fr.responses.filter(r => r.answers?.[q.id]!=null && r.answers?.[q.id]!=='');
                        if (!responsesWithAnswer.length) return null;
                        /* Aggregate numeric; show snippets for text */
                        if (q.type==='rating') {
                          const nums = responsesWithAnswer.map(r=>Number(r.answers[q.id])).filter(x=>!isNaN(x));
                          const avg = nums.reduce((a,b)=>a+b,0)/Math.max(1,nums.length);
                          return (
                            <div key={q.id} className="bg-ink-50/40 rounded-md p-3">
                              <div className="text-sm font-medium">{q.text}</div>
                              <div className="mt-1.5 flex items-center gap-3">
                                <div className="flex-1 h-2 bg-ink-200 rounded-full overflow-hidden">
                                  <div className="h-full bg-brand-600 rounded-full" style={{width:`${avg/(q.scale||5)*100}%`}}></div>
                                </div>
                                <div className="text-sm font-mono font-bold text-brand-700 w-14 text-right">{avg.toFixed(2)} / {q.scale||5}</div>
                              </div>
                              <div className="text-[10px] text-ink-400 mt-1 flex flex-wrap gap-x-2">
                                <span>N = {nums.length}</span>
                                {responsesWithAnswer.map(r=>{
                                  const author = getPerson(r.fromId);
                                  return <span key={r.id}>· {author?.name?.split(' ')[0] || '—'}: <span className="font-mono font-semibold text-ink-600">{String(r.answers[q.id])}</span></span>;
                                })}
                              </div>
                            </div>
                          );
                        }
                        return (
                          <div key={q.id} className="bg-ink-50/40 rounded-md p-3">
                            <div className="text-sm font-medium mb-2">{q.text}</div>
                            <div className="space-y-1.5">
                              {responsesWithAnswer.map(r=>{
                                const author = getPerson(r.fromId);
                                return (
                                  <div key={r.id} className="text-sm text-ink-700 border-l-2 border-brand-300 pl-2.5">
                                    <span className="text-[11px] text-ink-500 mr-1.5 font-medium">{author?.name || '—'}{author?.role?` · ${author.role}`:''}:</span>{String(r.answers[q.id])}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
              {upwardOnMe.length===0 && (
                <div className="rounded-lg border-2 border-dashed border-ink-200 p-6 text-center text-sm text-ink-500">
                  Цикл upward feedback не запускался. Нажмите «Запустить сбор».
                </div>
              )}
            </div>
          </div>
        </Card>
      )}

      <Modal open={creating} title="Запросить 360-фидбек" onClose={()=>setCreating(false)} wide>
        <RequestFeedbackForm
          onSubmit={(req)=>{ store.createFeedbackRequest(req, user.name); setCreating(false); }}
          onCancel={()=>setCreating(false)}
          hint={`Запрашивайте до ${(store.state.settings?.requestFeedbackMax)||5} reviewers. Для upward feedback менеджеру — используйте кнопку «Upward Feedback» в шапке.`}
        />
      </Modal>

      {/* Manager запускает цикл сбора upward feedback от своей команды */}
      <Modal open={creatingUpward} title="Запустить сбор Upward Feedback" onClose={()=>setCreatingUpward(false)} wide>
        <RequestFeedbackForm
          lockedSubject={user.id}
          lockedForm={upwardForm?.id}
          hint="Upward feedback на вас от direct reports. Фидбек именной — вы увидите, кто что написал. Приглашайте только тех, кто в прямом подчинении."
          onSubmit={(req)=>{ store.createFeedbackRequest({...req, anonymous:false}, user.name); setCreatingUpward(false); }}
          onCancel={()=>setCreatingUpward(false)}
        />
      </Modal>

      {/* Employee даёт upward feedback на своего менеджера */}
      <Modal open={givingUpward} title={manager ? `Upward Feedback на ${manager.name}` : 'Upward Feedback'} onClose={()=>setGivingUpward(false)} wide>
        {manager && upwardForm && (
          <InlineUpwardFeedback
            manager={manager}
            form={upwardForm}
            onSubmit={(answers)=>{
              /* Ищем уже существующий Upward-запрос для менеджера, иначе создаём */
              const existing = store.state.feedbackRequests.find(fr =>
                fr.subjectId===manager.id && fr.formId===upwardForm.id && fr.status==='in_progress'
              );
              if (existing) {
                store.submitFeedbackResponse(existing.id, { fromId:user.id, answers }, user.name);
              } else {
                const tempReq = {
                  requesterId: user.id,
                  subjectId: manager.id,
                  formId: upwardForm.id,
                  fromIds: [user.id],
                  anonymous: false,
                  dueDate: new Date(Date.now()+7*864e5).toISOString().slice(0,10),
                };
                store.createFeedbackRequest(tempReq, 'System');
                /* NB: in a real backend, we'd then call submitFeedbackResponse; here the request is in_progress */
              }
              setGivingUpward(false);
              alert('Спасибо! Upward feedback отправлен — менеджер увидит ваше имя.');
            }}
            onCancel={()=>setGivingUpward(false)}
          />
        )}
      </Modal>
    </div>
  );
};

/* Inline upward form — рендерит вопросы шаблона и собирает answers */
const InlineUpwardFeedback = ({ manager, form, onSubmit, onCancel }) => {
  const [answers, setAnswers] = useState({});
  const setA = (qid, v) => setAnswers(s=>({ ...s, [qid]: v }));
  const handle = () => {
    const missing = (form.questions||[]).filter(q=>q.required && (answers[q.id]==null || answers[q.id]===''));
    if (missing.length) { alert('Заполните обязательные поля: '+missing.map(q=>q.text).join(', ')); return; }
    onSubmit(answers);
  };
  return (
    <div className="space-y-4">
      <div className="rounded-lg bg-amber-50 border border-amber-200 p-3 text-xs text-amber-900 flex items-start gap-2">
        <Icon name="info" className="w-4 h-4 mt-0.5 shrink-0"/>
        <div>
          Upward feedback нужен, чтобы менеджер знал, как расти и что менять в работе с командой.
        </div>
      </div>
      <div className="flex items-center gap-3 p-3 rounded-lg border border-ink-100 bg-ink-50/40">
        <Avatar p={manager} size={40}/>
        <div>
          <div className="text-sm font-semibold">{manager.name}</div>
          <div className="text-xs text-ink-500">{manager.role}</div>
        </div>
      </div>
      {(form.questions||[]).map(q=>(
        <div key={q.id} className="space-y-1.5">
          <div className="text-sm font-medium">
            {q.text}{q.required && <span className="text-rose-500 ml-1">*</span>}
            <span className="text-[10px] text-ink-400 ml-2 uppercase tracking-wider">{q.type}{q.scale?` 1–${q.scale}`:''}</span>
          </div>
          {q.type==='rating' ? (
            <div className="flex gap-1.5">
              {Array.from({length:q.scale||5}).map((_,i)=>{
                const val = i+1;
                const active = answers[q.id]===val;
                return (
                  <button key={val} onClick={()=>setA(q.id, val)}
                          className={`w-10 h-10 rounded-md text-sm font-bold transition border ${active?'bg-brand-600 text-white border-brand-600':'bg-white text-ink-600 border-ink-200 hover:border-brand-300'}`}>
                    {val}
                  </button>
                );
              })}
            </div>
          ) : q.type==='likert' ? (
            <div className="grid grid-cols-5 gap-1.5">
              {['strongly_disagree','disagree','neutral','agree','strongly_agree'].map(opt=>{
                const active = answers[q.id]===opt;
                return (
                  <button key={opt} onClick={()=>setA(q.id, opt)}
                          className={`py-2 rounded-md text-[11px] font-medium transition border ${active?'bg-brand-600 text-white border-brand-600':'bg-white text-ink-600 border-ink-200 hover:border-brand-300'}`}>
                    {opt.replace('_',' ')}
                  </button>
                );
              })}
            </div>
          ) : (
            <>
              <textarea rows={3} value={answers[q.id]||''} onChange={e=>setA(q.id, e.target.value)}
                        className="w-full rounded-lg border border-ink-200 p-2.5 text-sm outline-none focus:ring-2 focus:ring-brand-500"
                        placeholder="Конкретный пример поведения / ситуации — помогает менеджеру понять контекст"/>
              <QualityCoachBox
                getDraft={() => answers[q.id] || ''}
                feedbackType="upward_feedback"
                competency={q.text}
                subjectEmployeeId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.employeeUuid(manager.id) : null}
                cycleId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.cycleUuid(ACTIVE_CYCLE.id) : null}
                disabled={false}
                label="Проверить ответ по этому вопросу (AI-коуч)"
              />
            </>
          )}
        </div>
      ))}
      <div className="flex justify-end gap-2 pt-2 border-t border-ink-100">
        <button onClick={onCancel} className="h-10 px-4 rounded-lg border border-ink-200 text-sm font-semibold">Отмена</button>
        <button onClick={handle} className="h-10 px-4 rounded-lg bg-brand-600 text-white text-sm font-semibold">Отправить</button>
      </div>
    </div>
  );
};

const RequestFeedbackForm = ({ onSubmit, onCancel, lockedForm, lockedSubject, hint }) => {
  const { store, user, dottedRels = [] } = useApp();
  const MAX_REVIEWERS = (store.state.settings?.requestFeedbackMax) || 5;
  const [subjectId, setSubjectId] = useState(lockedSubject || '');
  const [formId, setFormId] = useState(lockedForm || store.state.forms[0]?.id || '');
  const [fromIds, setFromIds] = useState([]);
  const [autoAddedDotted, setAutoAddedDotted] = useState([]);   /* какие dotted-куртаторы предложены автоматически */
  /* Freedom AI Labs policy: 360 всегда identified (enforced by DB migration 0025). */
  const anonymous = false;
  const [dueDate, setDueDate] = useState(new Date(Date.now()+10*864e5).toISOString().slice(0,10));

  const people = store.state.people.filter(p=>p.active!==false && p.id!==user.id);
  /* Matrix: dotted-куртаторы для текущего subject — авто-suggest как reviewers. */
  const dottedReviewerIds = useMemo(() => {
    if (!subjectId) return [];
    const subj = store.state.people.find(p => p.id === subjectId);
    if (!subj?.email) return [];
    const sEmail = subj.email.toLowerCase();
    const dottedEmails = (dottedRels || [])
      .filter(r => r.relationship === 'dotted' && (r.employee_email || '').toLowerCase() === sEmail)
      .map(r => (r.manager_email || '').toLowerCase());
    if (!dottedEmails.length) return [];
    return store.state.people
      .filter(p => p.email && dottedEmails.includes(p.email.toLowerCase()) && p.id !== user.id && p.active !== false)
      .map(p => p.id);
  }, [subjectId, dottedRels, store.state.people, user.id]);
  /* при смене subject — подмешиваем dotted'ов в preselect (один раз на смену subject). */
  useEffect(() => {
    if (!dottedReviewerIds.length) return;
    setFromIds(prev => {
      const merged = Array.from(new Set([...prev, ...dottedReviewerIds]));
      return merged.slice(0, MAX_REVIEWERS);
    });
    setAutoAddedDotted(dottedReviewerIds);
  }, [dottedReviewerIds.join(',')]);
  const isDottedReviewer = (pid) => dottedReviewerIds.includes(pid);
  const toggle = (id) => setFromIds(x => {
    if (x.includes(id)) return x.filter(i=>i!==id);
    if (x.length >= MAX_REVIEWERS) { alert(`Максимум ${MAX_REVIEWERS} reviewers за один запрос`); return x; }
    return [...x, id];
  });

  const submit = () => {
    if (!subjectId) { alert('Выберите, о ком запросить фидбек'); return; }
    if (!formId) { alert('Выберите форму'); return; }
    if (!fromIds.length) { alert('Выберите хотя бы одного reviewer'); return; }
    if (fromIds.length > MAX_REVIEWERS) { alert(`Максимум ${MAX_REVIEWERS} reviewers`); return; }
    onSubmit({ requesterId:user.id, subjectId, formId, fromIds, anonymous, dueDate });
  };

  const subjectPerson = subjectId ? (store.state.people.find(p=>p.id===subjectId) || byId(subjectId)) : null;

  return (
    <div className="space-y-4">
      {hint && (
        <div className="rounded-lg bg-brand-50 border border-brand-200 p-3 text-xs text-brand-800">
          {hint}
        </div>
      )}
      <Field label="О ком запрашиваем фидбек">
        {lockedSubject && subjectPerson ? (
          <div className="flex items-center gap-2 px-3 h-10 rounded-lg border border-ink-200 bg-ink-50">
            <Avatar p={subjectPerson} size={24}/>
            <span className="text-sm font-medium">{subjectPerson.name || subjectPerson.role}</span>
            <span className="text-xs text-ink-500">· {subjectPerson.role}</span>
          </div>
        ) : (
          <select className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={subjectId} onChange={e=>setSubjectId(e.target.value)}>
            <option value="">— выберите —</option>
            {people.map(p=><option key={p.id} value={p.id}>{p.name||p.role} · {p.role}</option>)}
          </select>
        )}
      </Field>
      <Field label="Форма / шаблон вопросов">
        {lockedForm ? (
          <div className="flex items-center gap-2 px-3 h-10 rounded-lg border border-ink-200 bg-ink-50 text-sm">
            {store.state.forms.find(f=>f.id===lockedForm)?.name}
            <span className="text-xs text-ink-500">(шаблон зафиксирован)</span>
          </div>
        ) : (
          <select className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={formId} onChange={e=>setFormId(e.target.value)}>
            {store.state.forms.map(f=><option key={f.id} value={f.id}>{f.name} ({f.type})</option>)}
          </select>
        )}
      </Field>
      <Field label="Дедлайн">
        <input type="date" className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={dueDate} onChange={e=>setDueDate(e.target.value)}/>
      </Field>
      <div className="flex items-start gap-2 p-3 rounded-lg bg-ink-50 border border-ink-200 text-xs text-ink-600">
        <Icon name="shield" className="w-3.5 h-3.5 mt-0.5 text-ink-400"/>
        <span>Все отзывы 360 в Freedom AI Labs — <b>именные</b>. Автор виден субъекту и HR. Политика зафиксирована в БД и её нельзя обойти.</span>
      </div>
      <Field label={<>Кого попросить дать фидбек <span className={`ml-1 px-1.5 py-0.5 rounded-full text-[10px] font-semibold ${fromIds.length>=MAX_REVIEWERS?'bg-amber-100 text-amber-800':'bg-ink-100 text-ink-600'}`}>{fromIds.length} / {MAX_REVIEWERS} max</span></>}>
        {autoAddedDotted.length > 0 && (
          <div className="mb-2 px-3 py-2 rounded-lg bg-violet-50 border border-violet-200 text-[11px] text-violet-800 flex items-start gap-2">
            <Icon name="users" className="w-3.5 h-3.5 mt-0.5"/>
            <span>Авто-добавлены dotted-куртаторы из matrix-структуры ({autoAddedDotted.length}). Снимите чек-бокс если не нужны.</span>
          </div>
        )}
        <div className="max-h-[220px] overflow-y-auto border border-ink-200 rounded-lg p-2 space-y-1">
          {people.map(p => {
            const checked = fromIds.includes(p.id);
            const disabled = !checked && fromIds.length >= MAX_REVIEWERS;
            const isDotted = isDottedReviewer(p.id);
            return (
              <label key={p.id} className={`flex items-center gap-2 p-1.5 rounded cursor-pointer ${disabled?'opacity-40 cursor-not-allowed':'hover:bg-ink-50'} ${isDotted?'bg-violet-50/40':''}`}>
                <input type="checkbox" checked={checked} onChange={()=>toggle(p.id)} disabled={disabled}/>
                <Avatar p={p} size={28}/>
                <div className="flex-1 text-sm flex items-center gap-2">
                  <div>
                    <div className={p.placeholder?'italic text-ink-400':''}>{p.name||p.role}</div>
                    <div className="text-[11px] text-ink-500">{p.role}</div>
                  </div>
                  {isDotted && <span className="text-[9px] px-1.5 py-0.5 rounded border bg-violet-100 text-violet-700 border-violet-300 uppercase tracking-wider font-semibold">dotted</span>}
                </div>
              </label>
            );
          })}
        </div>
      </Field>
      <div className="flex justify-end gap-2 pt-2 border-t border-ink-100">
        <button onClick={onCancel} className="h-10 px-4 rounded-lg border border-ink-200 text-sm font-semibold">Отмена</button>
        <button onClick={submit} className="h-10 px-4 rounded-lg bg-brand-600 text-white text-sm font-semibold">Отправить запрос</button>
      </div>
    </div>
  );
};

const AnswerFeedbackPage = ({ requestId, onBack }) => {
  const { store, user } = useApp();
  const fr = store.state.feedbackRequests.find(f=>f.id===requestId);
  const form = fr && store.state.forms.find(f=>f.id===fr.formId);
  const subject = fr && (store.state.people.find(p=>p.id===fr.subjectId) || byId(fr.subjectId));
  const [answers, setAnswers] = useState({});

  if (!fr || !form) return <div className="p-8">Запрос не найден. <button onClick={onBack} className="text-brand-700 font-semibold">Назад</button></div>;

  const set = (qid,v) => setAnswers(a=>({...a,[qid]:v}));
  const submit = () => {
    const missing = form.questions.filter(q=>q.required && (answers[q.id]===undefined || answers[q.id]===''));
    if (missing.length) { alert('Обязательные вопросы не заполнены: '+missing.map(q=>q.text).join('; ')); return; }
    store.submitFeedbackResponse(requestId, { fromId:user.id, answers }, user.name);
    alert('Спасибо! Фидбек отправлен.');
    onBack();
  };

  return (
    <div className="p-8 space-y-5 fade-in max-w-3xl">
      <button onClick={onBack} className="text-sm text-ink-600 hover:text-ink-900 flex items-center gap-1"><Icon name="chev" className="w-3 h-3 rotate-180"/>Назад к фидбеку</button>
      <Card>
        <div className="p-5 border-b border-ink-100 flex items-center gap-3">
          <Avatar p={subject} size={48}/>
          <div>
            <div className="text-xs uppercase tracking-wider text-ink-500">Фидбек о:</div>
            <div className="font-bold text-lg">{subject.name || subject.role}</div>
            <div className="text-xs text-ink-500">Форма: {form.name}{fr.anonymous && ' · Ваше имя будет скрыто'}</div>
          </div>
        </div>
        <div className="p-5 space-y-5">
          {form.questions.map((q,i)=>(
            <div key={q.id}>
              <div className="text-sm font-semibold mb-2">{i+1}. {q.text} {q.required && <span className="text-rose-500">*</span>}</div>
              {q.type==='rating' && (
                <div className="flex gap-2">
                  {Array.from({length:q.scale||5}).map((_,n)=>(
                    <button key={n} onClick={()=>set(q.id,n+1)} className={`w-10 h-10 rounded-lg border text-sm font-bold ${answers[q.id]===n+1?'bg-brand-600 text-white border-brand-600':'border-ink-200 hover:bg-ink-50'}`}>{n+1}</button>
                  ))}
                </div>
              )}
              {q.type==='likert' && (
                <div className="flex gap-2 flex-wrap">
                  {[['strongly_disagree','Совсем нет'],['disagree','Скорее нет'],['neutral','Нейтрально'],['agree','Скорее да'],['strongly_agree','Абсолютно да']].map(([v,l])=>(
                    <button key={v} onClick={()=>set(q.id,v)} className={`h-10 px-3 rounded-lg border text-sm ${answers[q.id]===v?'bg-brand-600 text-white border-brand-600':'border-ink-200 hover:bg-ink-50'}`}>{l}</button>
                  ))}
                </div>
              )}
              {q.type==='text' && (
                <>
                  <textarea value={answers[q.id]||''} onChange={e=>set(q.id,e.target.value)} rows={3} className="w-full p-3 rounded-lg border border-ink-200 text-sm"/>
                  <QualityCoachBox
                    getDraft={() => answers[q.id] || ''}
                    feedbackType={fr.anonymous ? '360_anonymous' : '360_identified'}
                    competency={q.text}
                    subjectEmployeeId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.employeeUuid(fr.subjectId) : null}
                    cycleId={REVIEW_SYNC.isReady() ? REVIEW_SYNC.cycleUuid(fr.cycleId || ACTIVE_CYCLE.id) : null}
                    disabled={false}
                    label={`Проверить ответ: «${q.text.slice(0,40)}${q.text.length>40?'…':''}» (AI-коуч)`}
                  />
                </>
              )}
              {q.type==='multi' && (q.options||[]).map(opt=>(
                <label key={opt} className="flex items-center gap-2 text-sm py-1"><input type="radio" name={q.id} checked={answers[q.id]===opt} onChange={()=>set(q.id,opt)}/>{opt}</label>
              ))}
            </div>
          ))}
          <div className="flex justify-end gap-2 pt-3 border-t border-ink-100">
            <button onClick={onBack} className="h-10 px-4 rounded-lg border border-ink-200 text-sm font-semibold">Отмена</button>
            <button onClick={submit} className="h-10 px-4 rounded-lg bg-brand-600 text-white text-sm font-semibold">Отправить</button>
          </div>
        </div>
      </Card>
    </div>
  );
};

/* ───────── FORM BUILDER PAGE ───────── */
const FormBuilderPage = () => {
  const { store, user } = useApp();
  const forms = store.state.forms;
  const [editing, setEditing] = useState(null); // form being edited
  const [creating, setCreating] = useState(false);

  return (
    <div className="p-8 space-y-5 fade-in">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-[.18em] text-ink-400 mb-1">Form Builder</div>
          <h2 className="text-2xl font-extrabold">Конструктор форм</h2>
          <div className="text-sm text-ink-500 mt-0.5">Настройте свои формы для scorecards, 360, self-assessment. Разные типы вопросов, обязательность, порядок.</div>
        </div>
        <button onClick={()=>setCreating(true)} className="h-10 px-4 rounded-lg bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700 flex items-center gap-1.5"><Icon name="plus" className="w-4 h-4"/>Новая форма</button>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {forms.map(f => (
          <Card key={f.id}>
            <div className="p-5">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <div className="font-bold text-base">{f.name}</div>
                  <div className="text-xs text-ink-500 mt-0.5">Тип: <span className="font-semibold">{f.type}</span> · Создана {f.createdAt}</div>
                </div>
                <div className="flex items-center gap-1">
                  <button onClick={()=>setEditing(f)} className="w-8 h-8 rounded-lg hover:bg-ink-100 flex items-center justify-center" title="Редактировать"><Icon name="edit" className="w-4 h-4"/></button>
                  <button onClick={()=>{ if(confirm('Удалить форму?')) store.deleteForm(f.id, user.name); }} className="w-8 h-8 rounded-lg hover:bg-rose-50 flex items-center justify-center" title="Удалить"><Icon name="trash" className="w-4 h-4 text-rose-600"/></button>
                </div>
              </div>
              <div className="text-xs text-ink-600 mb-2">{f.questions.length} вопросов:</div>
              <ol className="space-y-1 text-xs text-ink-700 list-decimal list-inside">
                {f.questions.slice(0,4).map(q => <li key={q.id} className="truncate">{q.text} <span className="text-ink-400">[{q.type}]</span></li>)}
                {f.questions.length>4 && <li className="text-ink-500">+ ещё {f.questions.length-4}…</li>}
              </ol>
            </div>
          </Card>
        ))}
      </div>

      <Modal open={creating || !!editing} title={creating?'Новая форма':`Редактирование: ${editing?.name||''}`} onClose={()=>{setCreating(false); setEditing(null);}} wide>
        <FormEditor initial={editing||{name:'',type:'peer',questions:[]}} onSave={(form)=>{
          if (editing) { store.updateForm(editing.id, form, user.name); setEditing(null); }
          else { store.addForm(form, user.name); setCreating(false); }
        }} onCancel={()=>{setCreating(false); setEditing(null);}}/>
      </Modal>
    </div>
  );
};

const FormEditor = ({ initial, onSave, onCancel }) => {
  const [name, setName] = useState(initial.name||'');
  const [type, setType] = useState(initial.type||'peer');
  const [questions, setQuestions] = useState(initial.questions||[]);

  const addQ = (type) => setQuestions(qs => [...qs, { id:'q'+Math.random().toString(36).slice(2,6), type, text:'Новый вопрос', required:false, ...(type==='rating'?{scale:5}:{}), ...(type==='multi'?{options:['Опция 1','Опция 2']}:{}) }]);
  const updQ = (id, patch) => setQuestions(qs => qs.map(q=>q.id===id?{...q,...patch}:q));
  const rmQ = (id) => setQuestions(qs => qs.filter(q=>q.id!==id));
  const moveQ = (id, dir) => setQuestions(qs => {
    const i = qs.findIndex(q=>q.id===id);
    if (i<0) return qs;
    const j = dir==='up'?i-1:i+1;
    if (j<0 || j>=qs.length) return qs;
    const copy = [...qs];
    [copy[i],copy[j]] = [copy[j],copy[i]];
    return copy;
  });

  const save = () => {
    if (!name.trim()) { alert('Укажите название формы'); return; }
    if (questions.length===0) { alert('Добавьте хотя бы один вопрос'); return; }
    onSave({ name, type, questions });
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3">
        <Field label="Название"><input className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={name} onChange={e=>setName(e.target.value)}/></Field>
        <Field label="Тип">
          <select className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={type} onChange={e=>setType(e.target.value)}>
            <option value="peer">Peer (коллега о коллеге)</option>
            <option value="upward">Upward (на менеджера)</option>
            <option value="downward">Manager scorecard</option>
            <option value="self">Self-assessment</option>
            <option value="custom">Custom</option>
          </select>
        </Field>
      </div>

      <div className="border border-ink-200 rounded-lg">
        <div className="p-3 border-b border-ink-100 flex items-center justify-between">
          <div className="text-sm font-semibold">Вопросы ({questions.length})</div>
          <div className="flex gap-2 flex-wrap">
            {[['rating','Rating 1–N'],['likert','Likert'],['text','Text'],['multi','Multi-choice']].map(([t,l])=>(
              <button key={t} onClick={()=>addQ(t)} className="h-8 px-2 rounded-lg border border-ink-200 text-xs font-semibold hover:bg-ink-50 flex items-center gap-1"><Icon name="plus" className="w-3 h-3"/>{l}</button>
            ))}
          </div>
        </div>
        <div className="divide-y divide-ink-100">
          {questions.length===0 && <div className="p-6 text-center text-ink-500 text-sm">Ещё нет вопросов. Добавьте из панели выше.</div>}
          {questions.map((q,i)=>(
            <div key={q.id} className="p-4 space-y-2">
              <div className="flex items-start gap-2">
                <div className="w-7 h-7 rounded bg-ink-100 text-ink-600 text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">{i+1}</div>
                <div className="flex-1 space-y-2">
                  <input value={q.text} onChange={e=>updQ(q.id,{text:e.target.value})} className="w-full h-9 px-3 rounded-lg border border-ink-200 text-sm" placeholder="Текст вопроса"/>
                  <div className="flex items-center gap-3 flex-wrap text-xs">
                    <span className="px-2 py-0.5 rounded bg-ink-100 text-ink-700 font-semibold uppercase">{q.type}</span>
                    <label className="flex items-center gap-1"><input type="checkbox" checked={q.required} onChange={e=>updQ(q.id,{required:e.target.checked})}/>обязательный</label>
                    {q.type==='rating' && <label className="flex items-center gap-1">шкала: <input type="number" min="3" max="10" value={q.scale||5} onChange={e=>updQ(q.id,{scale:parseInt(e.target.value)||5})} className="w-14 h-7 px-2 rounded border border-ink-200"/></label>}
                    {q.type==='multi' && <input value={(q.options||[]).join(', ')} onChange={e=>updQ(q.id,{options:e.target.value.split(',').map(s=>s.trim()).filter(Boolean)})} placeholder="Опция 1, Опция 2, …" className="flex-1 h-7 px-2 rounded border border-ink-200"/>}
                  </div>
                </div>
                <div className="flex flex-col gap-1">
                  <button onClick={()=>moveQ(q.id,'up')} disabled={i===0} className="w-7 h-7 rounded hover:bg-ink-100 disabled:opacity-30" title="Вверх"><Icon name="chevd" className="w-3 h-3 rotate-180 mx-auto"/></button>
                  <button onClick={()=>moveQ(q.id,'down')} disabled={i===questions.length-1} className="w-7 h-7 rounded hover:bg-ink-100 disabled:opacity-30" title="Вниз"><Icon name="chevd" className="w-3 h-3 mx-auto"/></button>
                </div>
                <button onClick={()=>rmQ(q.id)} className="w-7 h-7 rounded hover:bg-rose-50 text-rose-600" title="Удалить"><Icon name="trash" className="w-4 h-4 mx-auto"/></button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-ink-50/50 rounded-lg p-4">
        <div className="text-xs uppercase tracking-wider text-ink-500 font-semibold mb-2">Preview</div>
        <div className="space-y-3">
          {questions.map((q,i)=>(
            <div key={q.id} className="bg-white rounded p-3 border border-ink-100">
              <div className="text-sm font-semibold mb-1.5">{i+1}. {q.text} {q.required && <span className="text-rose-500">*</span>}</div>
              {q.type==='rating' && <div className="flex gap-1.5">{Array.from({length:q.scale||5}).map((_,n)=><div key={n} className="w-7 h-7 rounded border border-ink-200 text-xs flex items-center justify-center">{n+1}</div>)}</div>}
              {q.type==='likert' && <div className="flex gap-1.5 flex-wrap">{['—','-','0','+','++'].map(l=><div key={l} className="h-7 px-2 rounded border border-ink-200 text-xs flex items-center">{l}</div>)}</div>}
              {q.type==='text' && <div className="h-12 rounded border border-ink-200 bg-ink-50"></div>}
              {q.type==='multi' && <div className="space-y-1 text-xs">{(q.options||[]).map(o=><div key={o} className="flex items-center gap-1.5"><div className="w-3 h-3 rounded-full border border-ink-300"/>{o}</div>)}</div>}
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-end gap-2 pt-2 border-t border-ink-100">
        <button onClick={onCancel} className="h-10 px-4 rounded-lg border border-ink-200 text-sm font-semibold">Отмена</button>
        <button onClick={save} className="h-10 px-4 rounded-lg bg-brand-600 text-white text-sm font-semibold">Сохранить форму</button>
      </div>
    </div>
  );
};

/* ───────── SETTINGS PAGE ───────── */
/* ───────────────────────────────────────────────────────────────────────
   CyclePhaseControlCard — HR-only управление фазой активного цикла.
   Критично: это "рубильник видимости" для сотрудников. RLS-политики
   mgr_assess_select и fb_resp_select разрешают сотруднику видеть
   Manager Assessment и 360-фидбек ТОЛЬКО когда cycle.phase IN ('delivery','closed').
   Ratings видны сотруднику только при locked=true (отдельная семантика).
   До этого — результаты спрятаны от всех, кроме автора, менеджера, HR и exec.

   Фазы (enum app.cycle_phase):
     planning → self_assessment → feedback_collection → manager_assessment →
     calibration → delivery → closed
   ─────────────────────────────────────────────────────────────────────── */
const PHASE_META = {
  planning:             { ru:'Планирование',           nextHint:'Открыть self-assessment и сбор 360',                   visibility:'Никто из сотрудников ещё не подаёт'},
  self_assessment:      { ru:'Self Assessment',        nextHint:'Открыть фазу сбора 360 фидбека',                       visibility:'Сотрудники заполняют свои Self. Видно только автору и HR'},
  feedback_collection:  { ru:'Feedback & 360',         nextHint:'Передать менеджерам на Manager Assessment',            visibility:'Авторы видят свои отзывы. Subject пока не видит (ждёт delivery)'},
  manager_assessment:   { ru:'Manager Assessment',     nextHint:'Передать на Calibration (Talent Bar review)',          visibility:'Менеджер пишет scorecards. Сотрудник ещё не видит оценку'},
  calibration:          { ru:'Calibration',            nextHint:'После утверждения CEO — перевести в Delivery',          visibility:'Performance Team ведёт калибровку. Ratings ещё не locked'},
  delivery:             { ru:'Delivery',               nextHint:'После проведённых 1:1 — перевести в Closed',            visibility:'СОТРУДНИКИ ВИДЯТ: свой Manager Assessment, 360-отзывы (автор указан). Если rating locked — видят и его'},
  closed:               { ru:'Closed',                 nextHint:'Цикл закрыт. Следующий — открыть новый в Admin DB',     visibility:'Всё видно. Цикл в архиве'},
};
const PHASE_ORDER = ['planning','self_assessment','feedback_collection','manager_assessment','calibration','delivery','closed'];

const CyclePhaseControlCard = () => {
  const [cycle, setCycle]       = useState(null);  /* {id, code, name, phase, ...} */
  const [loading, setLoading]   = useState(true);
  const [saving,  setSaving]    = useState(false);
  const [err, setErr]           = useState(null);
  const [lockCount, setLockCount] = useState({ ratings:0, locked:0 });

  const sb = (typeof window !== 'undefined') ? supabase : null;

  const refresh = async () => {
    if (!sb) { setErr('Supabase не инициализирован'); setLoading(false); return; }
    setLoading(true); setErr(null);
    try {
      const { data, error } = await sb.from('cycles').select('*').eq('is_current', true).maybeSingle();
      if (error) throw error;
      setCycle(data || null);
      /* Сколько ratings по текущему циклу уже залочено */
      if (data?.id) {
        const r = await sb.from('ratings').select('id, locked', { count:'exact', head:false }).eq('cycle_id', data.id);
        if (!r.error && Array.isArray(r.data)) {
          setLockCount({ ratings: r.data.length, locked: r.data.filter(x=>x.locked).length });
        }
      }
    } catch (e) {
      setErr(e.message || String(e));
    } finally { setLoading(false); }
  };
  useEffect(() => { refresh(); /* один раз на маунт */ }, []);

  const advance = async (targetPhase) => {
    if (!cycle || !sb) return;
    if (!confirm(`Перевести цикл «${cycle.name}» в фазу «${PHASE_META[targetPhase]?.ru || targetPhase}»?\n\nВидимость:\n${PHASE_META[targetPhase]?.visibility || ''}`)) return;
    setSaving(true); setErr(null);
    try {
      const { error } = await sb.from('cycles').update({ phase: targetPhase }).eq('id', cycle.id);
      if (error) throw error;
      await refresh();
    } catch (e) {
      setErr(e.message || String(e));
    } finally { setSaving(false); }
  };

  const lockAllRatings = async () => {
    if (!cycle || !sb) return;
    if (!confirm(`Зафиксировать ВСЕ ratings цикла «${cycle.name}» (locked=true)?\nПосле этого сотрудники увидят свой финальный grade на своём профиле.\nОтменить можно только через HR-админа (unlock одной записи).`)) return;
    setSaving(true); setErr(null);
    try {
      const { error } = await sb.from('ratings').update({ locked: true }).eq('cycle_id', cycle.id).eq('locked', false);
      if (error) throw error;
      await refresh();
      alert('Ratings зафиксированы. Сотрудники увидят свой grade на профиле.');
    } catch (e) {
      setErr(e.message || String(e));
    } finally { setSaving(false); }
  };

  if (loading) {
    return <Card><CardHead title="Фаза активного цикла" subtitle="Загрузка..."/><div className="p-5 text-sm text-ink-500">Получаем состояние цикла из Supabase…</div></Card>;
  }
  if (!cycle) {
    return <Card><CardHead title="Фаза активного цикла" subtitle="Цикл не найден"/><div className="p-5 text-sm text-rose-700">Нет активного цикла (is_current=true). {err && `Ошибка: ${err}`}</div></Card>;
  }

  const curIdx  = PHASE_ORDER.indexOf(cycle.phase);
  const nextPh  = curIdx >= 0 && curIdx < PHASE_ORDER.length - 1 ? PHASE_ORDER[curIdx + 1] : null;
  const prevPh  = curIdx > 0 ? PHASE_ORDER[curIdx - 1] : null;
  const isDelivery = cycle.phase === 'delivery' || cycle.phase === 'closed';

  return (
    <Card>
      <CardHead title="Фаза активного цикла (рубильник видимости)" subtitle={`${cycle.name} · code: ${cycle.code} · управляется HR/CEO`}/>
      <div className="p-5 space-y-4">
        {/* Текущая фаза */}
        <div className="flex items-start justify-between gap-4 p-4 rounded-xl bg-brand-50 border border-brand-200">
          <div>
            <div className="text-[10px] uppercase tracking-[.18em] text-brand-700 font-bold">Текущая фаза</div>
            <div className="text-lg font-bold text-ink-900 mt-0.5">{PHASE_META[cycle.phase]?.ru || cycle.phase}</div>
            <div className="text-xs text-ink-600 mt-1">{PHASE_META[cycle.phase]?.visibility}</div>
          </div>
          <div className="text-right shrink-0">
            <div className="text-[10px] uppercase tracking-[.18em] text-ink-400 font-bold">Шаг</div>
            <div className="text-sm font-bold text-ink-700">{curIdx+1} / {PHASE_ORDER.length}</div>
          </div>
        </div>

        {/* Шаги */}
        <div className="flex items-center gap-1 flex-wrap">
          {PHASE_ORDER.map((ph, i) => (
            <React.Fragment key={ph}>
              <div className={`px-2.5 py-1 rounded-md text-[11px] font-semibold border ${
                i < curIdx ? 'bg-ink-100 text-ink-600 border-ink-200' :
                i === curIdx ? 'bg-brand-600 text-white border-brand-700' :
                'bg-white text-ink-500 border-ink-200'
              }`}>
                {PHASE_META[ph]?.ru || ph}
              </div>
              {i < PHASE_ORDER.length - 1 && <span className="text-ink-300 text-xs">→</span>}
            </React.Fragment>
          ))}
        </div>

        {/* Действия */}
        <div className="grid md:grid-cols-2 gap-3">
          <div className="p-4 rounded-xl border border-ink-100 bg-white">
            <div className="text-[10px] uppercase tracking-[.18em] text-ink-400 font-bold mb-1">Следующий шаг</div>
            {nextPh ? (
              <>
                <div className="font-semibold text-sm">Перевести в «{PHASE_META[nextPh]?.ru || nextPh}»</div>
                <div className="text-xs text-ink-500 mt-1">{PHASE_META[cycle.phase]?.nextHint}</div>
                <div className="text-[11px] text-ink-600 mt-2 p-2 rounded bg-ink-50 border border-ink-100">
                  <b>Что изменится:</b> {PHASE_META[nextPh]?.visibility}
                </div>
                <button
                  onClick={() => advance(nextPh)}
                  disabled={saving}
                  className="mt-3 w-full h-10 px-3 rounded-lg bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700 disabled:opacity-50"
                >
                  {saving ? 'Сохраняем…' : `→ ${PHASE_META[nextPh]?.ru || nextPh}`}
                </button>
              </>
            ) : (
              <div className="text-xs text-ink-500">Цикл в финальной фазе. Следующий цикл открывается через Admin DB.</div>
            )}
          </div>

          <div className="p-4 rounded-xl border border-ink-100 bg-white">
            <div className="text-[10px] uppercase tracking-[.18em] text-ink-400 font-bold mb-1">Откатить назад</div>
            {prevPh ? (
              <>
                <div className="font-semibold text-sm">Вернуть в «{PHASE_META[prevPh]?.ru || prevPh}»</div>
                <div className="text-xs text-ink-500 mt-1">На случай ошибки перевода. Сотрудники снова перестанут видеть результаты.</div>
                <button
                  onClick={() => advance(prevPh)}
                  disabled={saving}
                  className="mt-3 w-full h-10 px-3 rounded-lg border border-ink-200 text-ink-700 text-sm font-semibold hover:bg-ink-50 disabled:opacity-50"
                >
                  ← {PHASE_META[prevPh]?.ru || prevPh}
                </button>
              </>
            ) : (
              <div className="text-xs text-ink-500">Цикл в начальной фазе — отката нет.</div>
            )}
          </div>
        </div>

        {/* Lock ratings — отдельная семантика */}
        <div className="p-4 rounded-xl border border-amber-200 bg-amber-50">
          <div className="flex items-start gap-3">
            <Icon name="shield" className="w-5 h-5 text-amber-700 mt-0.5 shrink-0"/>
            <div className="flex-1">
              <div className="font-semibold text-sm text-ink-900">Фиксация ratings (отдельно от фазы)</div>
              <div className="text-xs text-ink-600 mt-1">
                Ratings видны сотруднику только когда <code className="px-1 rounded bg-white border border-amber-200">locked=true</code>. Обычный порядок:
                <br/>• После Calibration и одобрения CEO → перевести цикл в <b>Delivery</b>.
                <br/>• Затем нажать «Зафиксировать все ratings» — сотрудники увидят финальный grade на профиле.
              </div>
              <div className="text-[11px] text-ink-700 mt-2">
                Текущий цикл: ratings total <b>{lockCount.ratings}</b> · locked <b>{lockCount.locked}</b>
              </div>
              <button
                onClick={lockAllRatings}
                disabled={saving || !isDelivery || lockCount.ratings === 0 || lockCount.locked === lockCount.ratings}
                className="mt-3 h-10 px-4 rounded-lg bg-amber-600 text-white text-sm font-semibold hover:bg-amber-700 disabled:opacity-50 disabled:cursor-not-allowed"
                title={!isDelivery ? 'Сначала переведите цикл в Delivery' : ''}
              >
                {saving ? 'Фиксируем…' : 'Зафиксировать все ratings (locked=true)'}
              </button>
              {!isDelivery && <div className="text-[11px] text-amber-800 mt-2">Действие активно только в фазах Delivery / Closed.</div>}
            </div>
          </div>
        </div>

        {err && <div className="p-3 rounded-lg bg-rose-50 border border-rose-200 text-xs text-rose-800">Ошибка: {err}</div>}
      </div>
    </Card>
  );
};

const SettingsPage = () => {
  const { store, user } = useApp();
  const s = store.state.settings;
  const [form, setForm] = useState(s);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const save = () => { store.updateSettings(form, user.name); alert('Сохранено'); };

  const handleExport = (what) => {
    if (what==='people') {
      /* 22 apr 2026: убрали tenure + base + equity из экспорта.
         Salary/comp не нужны в системе ни в каком виде — данные
         больше не гидратируются во фронтенд (см. useEffect ниже). */
      const csv = toCSV(store.state.people, ['id','name','role','seniority','team','subteam','managerId','currentGrade','active']);
      downloadText(`people_${new Date().toISOString().slice(0,10)}.csv`, csv);
    }
    if (what==='feedback') {
      const rows = store.state.feedbackRequests.flatMap(fr => fr.responses.map(r => ({
        requestId:fr.id, subjectId:fr.subjectId, formId:fr.formId, anonymous:fr.anonymous,
        responseId:r.id, fromId:fr.anonymous?'':r.fromId, submittedAt:r.submittedAt,
        answers: JSON.stringify(r.answers),
      })));
      downloadText(`feedback_${new Date().toISOString().slice(0,10)}.csv`, toCSV(rows, ['requestId','subjectId','formId','anonymous','responseId','fromId','submittedAt','answers']));
    }
    if (what==='audit') {
      downloadText(`audit_log_${new Date().toISOString().slice(0,10)}.csv`, toCSV(store.state.auditLog, ['id','at','who','action']));
    }
  };

  return (
    <div className="p-8 space-y-5 fade-in max-w-5xl">
      <div>
        <div className="text-xs uppercase tracking-[.18em] text-ink-400 mb-1">Admin Panel</div>
        <h2 className="text-2xl font-extrabold">Настройки</h2>
        <div className="text-sm text-ink-500 mt-0.5">Цикл, шкала, notifications, export, audit log.</div>
      </div>

      {/* HR-only: фаза активного цикла. Это то, что определяет, когда сотрудники
          начнут видеть Manager Assessment, 360-отзывы и финальные ratings. */}
      <CyclePhaseControlCard/>

      <Card>
        <CardHead title="Фазы таймлайна (6 фаз)" subtitle="Названия, ответственные и даты для блока «Активный цикл». После сохранения таймлайн обновится."/>
        <div className="p-5 space-y-2">
          <div className="grid grid-cols-12 gap-2 text-[10px] uppercase tracking-wide text-ink-400 px-1">
            <div className="col-span-1">#</div><div className="col-span-4">Фаза</div><div className="col-span-3">Ответственные</div><div className="col-span-2">Начало</div><div className="col-span-2">Конец</div>
          </div>
          {(() => {
            const phases = (Array.isArray(form.cyclePhases) && form.cyclePhases.length) ? form.cyclePhases : ACTIVE_CYCLE.stages;
            const setPhase = (i, patch) => set('cyclePhases', phases.map((p, idx) => idx === i ? { ...p, ...patch } : p));
            return phases.map((p, i) => (
              <div key={p.key || i} className="grid grid-cols-12 gap-2 items-center">
                <div className="col-span-1 text-[12px] text-ink-400 text-center">{i + 1}</div>
                <input className="col-span-4 h-9 px-2 rounded-lg border border-ink-200 text-sm" value={p.label || ''} onChange={e => setPhase(i, { label: e.target.value })} placeholder="Название фазы"/>
                <input className="col-span-3 h-9 px-2 rounded-lg border border-ink-200 text-sm" value={p.owner || ''} onChange={e => setPhase(i, { owner: e.target.value })} placeholder="Кто"/>
                <input type="date" className="col-span-2 h-9 px-2 rounded-lg border border-ink-200 text-sm" value={p.start || ''} onChange={e => setPhase(i, { start: e.target.value })}/>
                <input type="date" className="col-span-2 h-9 px-2 rounded-lg border border-ink-200 text-sm" value={p.end || ''} onChange={e => setPhase(i, { end: e.target.value })}/>
              </div>
            ));
          })()}
          <div className="text-[11px] text-ink-400 pt-1">Сохрани кнопкой внизу страницы. Метки локальные (хранятся в этом браузере), как и остальные параметры цикла.</div>
        </div>
      </Card>

      <div className="grid md:grid-cols-2 gap-4">
        <Card>
          <CardHead title="Параметры цикла (локальные метки)" subtitle="Текстовые поля для отчётов · реальная фаза — выше"/>
          <div className="p-5 space-y-3">
            <Field label="Название цикла"><input className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.cycleName} onChange={e=>set('cycleName',e.target.value)}/></Field>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Начало"><input type="date" className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.cycleStart} onChange={e=>set('cycleStart',e.target.value)}/></Field>
              <Field label="Конец"><input type="date" className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.cycleEnd} onChange={e=>set('cycleEnd',e.target.value)}/></Field>
              <Field label="Дедлайн scorecard"><input type="date" className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.scorecardDeadline} onChange={e=>set('scorecardDeadline',e.target.value)}/></Field>
              <Field label="Калибровка"><input type="date" className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.calibrationDate} onChange={e=>set('calibrationDate',e.target.value)}/></Field>
            </div>
          </div>
        </Card>

        <Card>
          <CardHead title="Rating scale & grades" subtitle="Шкала оценок и финальные градации"/>
          <div className="p-5 space-y-3">
            <Field label="Rating scale (через запятую)">
              <input className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.ratingScale.join(', ')} onChange={e=>set('ratingScale',e.target.value.split(',').map(s=>s.trim()).filter(Boolean))}/>
            </Field>
            <Field label="Grades">
              <input className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.grades.join(', ')} onChange={e=>set('grades',e.target.value.split(',').map(s=>s.trim()).filter(Boolean))}/>
            </Field>
            <Field label="A-player cap (% от штата)">
              <input type="number" className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.aPlayerCapPct} onChange={e=>set('aPlayerCapPct',parseInt(e.target.value)||0)}/>
            </Field>
          </div>
        </Card>

        <Card>
          <CardHead title="Notifications" subtitle="Шаблоны и правила"/>
          <div className="p-5 space-y-3">
            <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.notifyOnScorecardOpen} onChange={e=>set('notifyOnScorecardOpen',e.target.checked)}/>Уведомлять об открытии scorecard</label>
            <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.notifyOnCalibration} onChange={e=>set('notifyOnCalibration',e.target.checked)}/>Уведомлять о калибровке</label>
            <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.notifyOnFeedbackRequest} onChange={e=>set('notifyOnFeedbackRequest',e.target.checked)}/>Уведомлять о запросе фидбека</label>
            <Field label="За сколько дней напоминать"><input type="number" className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm" value={form.reminderDaysBefore} onChange={e=>set('reminderDaysBefore',parseInt(e.target.value)||0)}/></Field>
            <Field label="Шаблон email (плейсхолдеры: {name}, {deadline})">
              <textarea rows={3} className="w-full p-3 rounded-lg border border-ink-200 text-sm" value={form.notifyEmailTemplate} onChange={e=>set('notifyEmailTemplate',e.target.value)}/>
            </Field>
          </div>
        </Card>

        <Card>
          <CardHead title="Export" subtitle="Выгрузка в CSV"/>
          <div className="p-5 space-y-2">
            <button onClick={()=>handleExport('people')} className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm font-semibold hover:bg-ink-50 flex items-center gap-2"><Icon name="export" className="w-4 h-4"/>Сотрудники ({store.state.people.length})</button>
            <button onClick={()=>handleExport('feedback')} className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm font-semibold hover:bg-ink-50 flex items-center gap-2"><Icon name="export" className="w-4 h-4"/>Фидбек-ответы</button>
            <button onClick={()=>handleExport('audit')} className="w-full h-10 px-3 rounded-lg border border-ink-200 text-sm font-semibold hover:bg-ink-50 flex items-center gap-2"><Icon name="export" className="w-4 h-4"/>Audit log ({store.state.auditLog.length})</button>
          </div>
        </Card>
      </div>

      <div className="flex justify-end gap-2">
        <button onClick={()=>{ if(confirm('Сбросить ВСЕ данные (сотрудники, фидбек, формы, настройки)? Это нельзя отменить.')) store.resetStore(); }} className="h-10 px-4 rounded-lg border border-rose-200 text-rose-700 text-sm font-semibold hover:bg-rose-50">Сброс всего хранилища</button>
        <button onClick={save} className="h-10 px-4 rounded-lg bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700">Сохранить настройки</button>
      </div>

      <Card>
        <CardHead title="Audit log" subtitle="История изменений (кто, что, когда)"/>
        <div className="max-h-[360px] overflow-y-auto divide-y divide-ink-100">
          {store.state.auditLog.map(a => (
            <div key={a.id} className="px-5 py-2.5 text-sm flex items-start gap-3">
              <div className="text-xs text-ink-400 font-mono w-32 shrink-0">{a.at}</div>
              <div className="font-semibold w-40 shrink-0 text-ink-700">{a.who}</div>
              <div className="flex-1 text-ink-600">{a.action}</div>
            </div>
          ))}
          {store.state.auditLog.length===0 && <div className="p-8 text-center text-sm text-ink-500">Пока нет записей</div>}
        </div>
      </Card>
    </div>
  );
};

/* ───────── CAREER LADDER PAGE ───────── */
const CareerLadderPage = ({ onOpen }) => {
  const { store, user } = useApp();
  const people = store.state.people.filter(p => p.active !== false);
  /* 18 may 2026 fix: счётчики «НА УРОВНЕ N» и список сотрудников на уровне
     видны только HR/Exec/менеджерам (с directs). Обычным сотрудникам показываем
     чистый educational view: scope, complexity, impact, leadership, criteria,
     эквиваленты у других компаний — БЕЗ агрегатов по штату и без ФИО.
     Свой собственный уровень «Вы здесь» остаётся видимым каждому. */
  const perms = permissions(user, store.state.people);
  const myDirects = (store.state.people || []).filter(p =>
    p.managerId === user?.id && p.active !== false && !p.placeholder && p.name && p.name !== '—'
  );
  const canSeeRoster = perms.canSeeOrgWide || perms.sysRole === 'manager' || myDirects.length > 0;
  const [track, setTrack] = useState('IC');
  const [expandedLevel, setExpandedLevel] = useState(null);

  const levelsInTrack = TRACKS[track].levels;
  const peopleAtLevel = (lv) => people.filter(p => personLevel(p).level === lv);
  const myLevel = user ? personLevel(user).level : null;

  return (
    <div className="p-8 space-y-5 fade-in">
      {/* Header */}
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-[.18em] text-ink-400 mb-1">Career Architecture</div>
          <h2 className="text-2xl font-extrabold">Лестница карьерного роста</h2>
          <div className="text-sm text-ink-500 mt-0.5">
            3 трека · {Object.values(TRACKS).reduce((a,t)=>a+t.levels.length,0)} уровней · построено по модели Radford / Big Tech (Google, Meta, Stripe)
          </div>
        </div>
        {user && myLevel && (
          <div className="flex items-center gap-2 bg-brand-50 border border-brand-200 rounded-xl px-4 py-2">
            <span className="text-[11px] uppercase tracking-wider text-brand-700 font-semibold">Ваш уровень</span>
            <span className={`text-xs px-2 py-0.5 rounded border font-bold ${LEVEL_TONE(myLevel)}`}>{myLevel}</span>
            <span className="text-xs text-ink-700">{LEVELS[myLevel]?.label}</span>
          </div>
        )}
      </div>

      {/* Track switcher */}
      <Card>
        <div className="p-4 flex items-center gap-3 flex-wrap">
          <div className="text-xs uppercase tracking-wider text-ink-500 font-semibold">Трек:</div>
          <div className="flex items-center gap-1 bg-ink-50 rounded-lg p-1">
            {Object.keys(TRACKS).map(tr => (
              <button key={tr} onClick={()=>{setTrack(tr); setExpandedLevel(null);}}
                className={`text-xs px-3 py-1.5 rounded-md font-semibold flex items-center gap-2 ${track===tr?'bg-white shadow-card text-ink-900':'text-ink-600 hover:text-ink-900'}`}>
                <span className={`text-[10px] px-1.5 py-0.5 rounded border ${TRACKS[tr].tone}`}>{TRACKS[tr].short}</span>
                {TRACKS[tr].label}
                <span className="text-[10px] text-ink-400">· {TRACKS[tr].levels.length}</span>
              </button>
            ))}
          </div>
        </div>
      </Card>

      {/* Levels list */}
      <div className="space-y-3">
        {levelsInTrack.map((lv, idx) => {
          const info = LEVELS[lv];
          const folks = peopleAtLevel(lv);
          const isMe = lv === myLevel;
          const open = expandedLevel === lv;
          return (
            <Card key={lv}>
              <button
                onClick={()=>setExpandedLevel(open ? null : lv)}
                className="w-full p-5 flex items-center gap-4 text-left hover:bg-ink-50/40 rounded-t-xl transition"
              >
                <div className={`w-12 h-12 rounded-xl border-2 flex items-center justify-center font-bold text-sm ${LEVEL_TONE(lv)}`}>
                  {lv}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <div className="text-base font-bold text-ink-900">{info.label}</div>
                    {isMe && <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-brand-600 text-white font-semibold uppercase tracking-wider">Вы здесь</span>}
                    <span className="text-[10px] uppercase tracking-wider text-ink-400">Band: {info.salaryBand}</span>
                  </div>
                  <div className="text-xs text-ink-600 mt-1 line-clamp-1">{info.scope}</div>
                </div>
                <div className="flex items-center gap-3 shrink-0">
                  {canSeeRoster && (
                    <div className="text-right">
                      <div className="text-[11px] uppercase tracking-wider text-ink-400 font-semibold">На уровне</div>
                      <div className="text-lg font-bold text-ink-900">{folks.length}</div>
                    </div>
                  )}
                  <Icon name="chev" className={`w-4 h-4 text-ink-400 transition-transform ${open?'rotate-90':''}`}/>
                </div>
              </button>

              {open && (
                <div className="border-t border-ink-100 px-5 pb-5 pt-4 bg-ink-50/30">
                  {/* Criteria grid */}
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div className="bg-white rounded-lg p-4 border border-ink-100">
                      <div className="text-[10px] uppercase tracking-[.16em] text-ink-400 font-semibold mb-1.5">Scope / Область</div>
                      <div className="text-sm text-ink-800 leading-relaxed">{info.scope}</div>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-ink-100">
                      <div className="text-[10px] uppercase tracking-[.16em] text-ink-400 font-semibold mb-1.5">Complexity / Сложность</div>
                      <div className="text-sm text-ink-800 leading-relaxed">{info.complexity}</div>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-ink-100">
                      <div className="text-[10px] uppercase tracking-[.16em] text-ink-400 font-semibold mb-1.5">Impact / Влияние</div>
                      <div className="text-sm text-ink-800 leading-relaxed">{info.impact}</div>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-ink-100">
                      <div className="text-[10px] uppercase tracking-[.16em] text-ink-400 font-semibold mb-1.5">Leadership / Лидерство</div>
                      <div className="text-sm text-ink-800 leading-relaxed">{info.leadership}</div>
                    </div>
                  </div>

                  {/* Peer at other companies */}
                  <div className="bg-white rounded-lg p-4 border border-ink-100 mb-4">
                    <div className="text-[10px] uppercase tracking-[.16em] text-ink-400 font-semibold mb-2">Эквивалент в других компаниях</div>
                    <div className="flex flex-wrap gap-1.5">
                      {(info.peerAt || []).map((peer, i) => (
                        <span key={i} className="text-[11px] px-2 py-1 rounded bg-ink-100 text-ink-700 font-medium">{peer}</span>
                      ))}
                    </div>
                  </div>

                  {/* People at this level — видно только HR/Exec/менеджерам */}
                  {canSeeRoster ? (
                    folks.length > 0 ? (
                      <div>
                        <div className="text-[10px] uppercase tracking-[.16em] text-ink-400 font-semibold mb-2">Сотрудники на {lv} ({folks.length})</div>
                        <div className="flex flex-wrap gap-2">
                          {folks.map(p => (
                            <button key={p.id} onClick={()=>onOpen && onOpen(p.id)}
                              className="flex items-center gap-2 bg-white rounded-lg px-2.5 py-1.5 border border-ink-100 hover:border-brand-300 hover:shadow-card transition">
                              <Avatar p={p} size={24}/>
                              <div className="text-left">
                                <div className="text-xs font-semibold text-ink-900 leading-tight">{p.name || p.role}</div>
                                <div className="text-[10px] text-ink-500 leading-tight">{p.team || p.role}</div>
                              </div>
                            </button>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div className="text-xs text-ink-400 italic">На этом уровне пока никого нет в компании.</div>
                    )
                  ) : (
                    isMe && (
                      <div className="text-xs text-ink-500 italic flex items-center gap-2">
                        <Icon name="user" className="w-3.5 h-3.5"/>
                        Это ваш текущий уровень. Подробный состав по уровням виден HR-команде и менеджерам.
                      </div>
                    )
                  )}

                  {/* Next level hint */}
                  {idx < levelsInTrack.length - 1 && (
                    <div className="mt-4 pt-4 border-t border-ink-100 flex items-center gap-2 text-xs text-ink-600">
                      <Icon name="trend" className="w-3.5 h-3.5 text-brand-600"/>
                      <span>Следующий уровень:</span>
                      <span className={`text-[10px] px-1.5 py-0.5 rounded border font-semibold ${LEVEL_TONE(levelsInTrack[idx+1])}`}>{levelsInTrack[idx+1]}</span>
                      <span className="text-ink-500">{LEVELS[levelsInTrack[idx+1]]?.label}</span>
                    </div>
                  )}
                </div>
              )}
            </Card>
          );
        })}
      </div>

      {/* Footer note */}
      <Card>
        <div className="p-5 text-xs text-ink-500 leading-relaxed">
          <div className="font-semibold text-ink-700 mb-2">Как работает карта:</div>
          <ul className="space-y-1 list-disc pl-5">
            <li><strong>Level</strong> — устойчивая характеристика роли (меняется только через promotion). Независима от <strong>performance grade</strong>, который пересматривается каждый цикл.</li>
            <li><strong>Треки симметричны</strong>: IC4 ≈ M1 по уровню ответственности и компенсации; переход IC↔M — это не повышение, а смена трека.</li>
            <li><strong>Калибровка</strong>: на калибровочных встречах сотрудники сравниваются внутри peer group своего уровня (IC4 vs IC4), а не со всей компанией.</li>
            <li><strong>Promotion</strong>: номинация идёт, когда сотрудник демонстрирует scope/impact следующего уровня в течение 2+ циклов подряд (A-player grade или Above bar + impact evidence).</li>
          </ul>
        </div>
      </Card>
    </div>
  );
};

/* DB-role → UI sysRole (source of truth — app.employees.role).
   До 29 apr 2026 sysRole брался из deriveSysRole(seed) по титулу — exec получали 'director'
   автоматически по титулу 'CTO'/'CPO'/etc. и через permissions() видели HR-панель.
   Теперь: если AuthScreen вернул dbRole — он перекрывает seed-deriveSysRole. */
const DB_ROLE_TO_SYSROLE = {
  hr_admin: 'hr',
  exec:     'director',
  manager:  'manager',
  employee: 'employee',
};

/* ───────── ROOT ───────── */
const App = () => {
  const [userId, setUserId] = useState(null);
  const [dbRole, setDbRole] = useState(null);   /* роль из app.employees, source of truth */
  const [page, setPage] = useState('home');
  const [viewPerson, setViewPerson] = useState(null);
  const [fillId, setFillId] = useState(null);
  const [answerFeedbackId, setAnswerFeedbackId] = useState(null);

  /* Matrix management (29 apr 2026, Phase 2): bootstrap всех active solid+dotted связей.
     dottedRels — массив {relationship, employee_email, manager_email, manager_name, manager_title}.
     Помещаем в AppContext, чтобы Profile / OrgChart / FeedbackPage могли синхронно
     строить badge'и и pre-select reviewers без лишних запросов. */
  const [dottedRels, setDottedRels] = useState([]);
  const reloadDottedRels = useCallback(async () => {
    if (!supabase) return;
    try {
      const { data, error } = await supabase.rpc('list_all_active_managers');
      if (error) throw error;
      setDottedRels(Array.isArray(data) ? data : []);
    } catch (e) {
      console.warn('[matrix] failed to load dotted rels:', e?.message || e);
    }
  }, []);
  useEffect(() => { reloadDottedRels(); }, [reloadDottedRels]);

  const store = useStore();

  /* user enrichment — sysRole берётся из DB-роли (если AuthScreen её передал),
     иначе fallback на seed-deriveSysRole для демо-режима без auth.
     COMMIT_5 fix v5 (30 apr 2026): HR-admin override применяется ПОСЛЕ DB-mapping.
     В БД Айканыш сохранена с role='exec' (из старой эпохи RBAC), что мапится в
     sysRole='director' и закрывает ей HR Admin / Settings. Email/title-override
     поверх dbRole возвращает её доступ без обязательной правки в БД. */
  const user = userId ? (() => {
    const fresh = byId(userId); /* из in-memory PEOPLE — source of truth для seed sysRole */
    const stored = store.state.people.find(p=>p.id===userId);
    const base = stored || fresh;
    if (!base) return null;
    const sysRoleFromDb = dbRole ? DB_ROLE_TO_SYSROLE[dbRole] : null;
    let resolvedSysRole = sysRoleFromDb || base.sysRole || fresh?.sysRole || 'employee';
    /* HR-admin override (idempotent) — поднимает доступ для HR-titled позиций
       и явных email-ов, перебивая dbRole='exec'. */
    const userEmail = (base.email || '').toLowerCase().trim();
    const userTitle = base.role || '';
    if (HR_ADMIN_EMAILS.has(userEmail) || HR_ADMIN_TITLES.test(userTitle)) {
      resolvedSysRole = 'hr';
    }
    return {
      ...base,
      sysRole: resolvedSysRole,
      dbRole, /* прокидываем raw DB-role для отладки/observability */
    };
  })() : null;

  /* AuthScreen передаёт (id, dbRole, syntheticProfile?) — обновляем state и
     при необходимости заливаем synthetic person в store (если сотрудник из БД,
     но отсутствует в seed RAW_PEOPLE — например, новый из Notion-sync). */
  const handleAuthPick = (id, role, synthetic) => {
    if (synthetic && !store.state.people.find(p => p.id === id)) {
      store.addPerson(synthetic, 'AuthScreen synthetic fallback');
    }
    setUserId(id);
    if (role !== undefined) setDbRole(role || null);
  };

  if (!user) return <AuthScreen onPick={handleAuthPick} livePeople={store.state.people} />;

  const pageTitles = {
    home:['Обзор', store.state.settings.cycleName],
    cycle:['Активный цикл', ACTIVE_CYCLE.name],
    myprofile:['Мой профиль', `${user.role} · ${user.seniority} · ${user.team}`],
    selfassessment:['Self Assessment', `${ACTIVE_CYCLE.name} · 5 секций`],
    reviews:['Reviews', 'Заполнение scorecards'],
    scorecards:['Scorecard Library', 'Единые стандарты оценки'],
    calibration:['Калибровка · Talent Bar', 'Skills × Deliverables · Performance Team'],
    conversations:['Performance Talks', 'Hold 1:1 debrief · gate перед Dev Plan / BoT'],
    development:['Development Plan', 'A-player / Above bar · H2 2026 SMART-цели'],
    people:['Команда', `${store.state.people.filter(p=>p.active).length} сотрудников`],
    ladder:['Career Ladder', 'IC · Manager · Support — матрица уровней'],
    profile:['Профиль', viewPerson?(store.state.people.find(p=>p.id===viewPerson)?.name || byId(viewPerson).name):''],
    promotions:['Promotions', 'Цикл повышений'],
    pip:['BoT · PIP Tracker', '6-week plan · halfway + final checkpoint'],
    perfteam:['Performance Team', 'Organization & mandate'],
    hiring:['Hiring · Вакансии', `${VACANCIES.length} открытых позиций`],
    history:['История', 'Мои тренды'],
    analytics:['Аналитика команды', 'Team-level'],
    enps:['eNPS · Пульс', 'Анонимный опрос команды'],
    enpsdash:['eNPS · Аналитика', 'Team-level eNPS'],
    hradmin:['HR Admin', 'Управление сотрудниками'],
    feedback:['360 Feedback', 'Запросы и ответы'],
    forms:['Конструктор форм', 'Scorecards & questionnaires'],
    settings:['Настройки', 'Цикл, scale, notifications, audit'],
    answer:['Ответ на фидбек', ''],
    fill:['Scorecard', fillId?(store.state.people.find(p=>p.id===fillId)?.name || byId(fillId).name):''],
  };
  const [t, st] = pageTitles[page] || ['', ''];

  const Content = () => {
    const perms = permissions(user, store.state.people);
    /* RBAC route guard — защищает от прямой навигации к закрытым страницам */
    const forbidden = {
      calibration: !perms.canSeeCalibration,
      promotions:  !perms.canSeePromotions,
      pip:         !perms.canSeePIP,
      perfteam:    !perms.canSeePerfTeam,
      hiring:      !perms.canSeeHiring,
      analytics:   !perms.canSeeAnalytics,
      enpsdash:    !perms.canSeeAnalytics,
      hradmin:     !perms.canSeeHRAdmin,
      forms:       !perms.canSeeForms,
      settings:    !perms.canSeeSettings,
    };
    if (forbidden[page]) return <Dashboard onNav={setPage}/>;
    if (page==='fill' && fillId) return <ScorecardFill employeeId={fillId} onBack={()=>{ setFillId(null); setPage('reviews'); }}/>;
    if (page==='profile' && viewPerson) return <ProfilePage personId={viewPerson} onBack={()=>{setViewPerson(null); setPage('people');}} onFill={(id)=>{setFillId(id); setPage('fill');}}/>;
    if (page==='answer' && answerFeedbackId) return <AnswerFeedbackPage requestId={answerFeedbackId} onBack={()=>{setAnswerFeedbackId(null); setPage('feedback');}}/>;
    switch (page) {
      case 'home': return <Dashboard onNav={setPage}/>;
      case 'cycle': return <CyclePage/>;
      case 'myprofile': return <MyProfilePage onNav={setPage}/>;
      case 'selfassessment': return <SelfAssessmentPage onNav={setPage}/>;
      case 'reviews': return <ReviewsPage onOpen={(id)=>{setFillId(id); setPage('fill');}}/>;
      case 'scorecards': return <ScorecardLibrary canEdit={perms.isHR || perms.isDirector}/>;
      case 'calibration': return <CalibrationPage/>;
      case 'conversations': return <ConversationsPage onOpen={(id)=>{setViewPerson(id); setPage('profile');}}/>;
      case 'development': return <DevelopmentPlanPage onOpen={(id)=>{setViewPerson(id); setPage('profile');}}/>;
      case 'people': return <PeoplePage onOpen={(id)=>{setViewPerson(id); setPage('profile');}} onGoHRAdmin={()=>setPage('hradmin')}/>;
      case 'ladder': return <CareerLadderPage onOpen={(id)=>{setViewPerson(id); setPage('profile');}}/>;
      case 'promotions': return <PromotionsPage/>;
      case 'pip': return <PipPage/>;
      case 'perfteam': return <PerfTeamOrgPage/>;
      case 'hiring': return <HiringPage/>;
      case 'history': return <HistoryPage/>;
      case 'analytics': return <AnalyticsPage/>;
      case 'enps': return <EnpsSurveyPage/>;
      case 'enpsdash': return <EnpsDashboardPage/>;
      case 'hradmin': return <HRAdminPage onOpen={(id)=>{setViewPerson(id); setPage('profile');}}/>;
      case 'feedback': return <FeedbackPage onAnswer={(id)=>{setAnswerFeedbackId(id); setPage('answer');}} onOpen={(id)=>{setViewPerson(id); setPage('profile');}}/>;
      case 'forms': return <FormBuilderPage/>;
      case 'settings': return <SettingsPage/>;
      default: return <Dashboard onNav={setPage}/>;
    }
  };

  return (
    <AppContext.Provider value={{ user, store, dottedRels, reloadDottedRels }}>
      <div className="flex min-h-screen bg-ink-50">
        <Sidebar current={page} onNav={setPage}/>
        <div className="flex-1 min-w-0 flex flex-col">
          <Topbar title={t} subtitle={st} onLogout={async ()=>{
            try { if (supabase) await supabase.auth.signOut(); } catch(_){}
            try { localStorage.removeItem('sb-suvmndafexpyzyivvjcu-auth-token'); } catch(_){}
            setUserId(null);
            setDbRole(null);
          }}/>
          <main className="flex-1 min-w-0 overflow-x-hidden">
            <Content/>
          </main>
        </div>
      </div>
    </AppContext.Provider>
  );
};

function LeadershipActionsImport({ employeeId, cycle, achievementsText, onInsert }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);      // evidence_ledger rows
  const [open, setOpen] = useState(true);
  const [selected, setSelected] = useState({}); // { [id]: true }
  const [expandedGroups, setExpandedGroups] = useState({}); // { [milestone]: true }

  useEffect(() => {
    let cancelled = false;
    async function load() {
      if (!employeeId) { setLoading(false); return; }
      setLoading(true);
      setError(null);
      try {
        let q = supabase
          .from('evidence_ledger')
          .select('id, source_title, excerpt, event_date, metadata, source_url')
          .eq('employee_id', employeeId)
          .eq('source_type', 'leadership_action')
          .order('event_date', { ascending: false });
        if (cycle?.period_start) q = q.gte('event_date', cycle.period_start);
        if (cycle?.period_end) {
          // Include the whole final day.
          const end = new Date(cycle.period_end);
          end.setUTCHours(23, 59, 59, 999);
          q = q.lte('event_date', end.toISOString());
        }
        const { data, error } = await q;
        if (cancelled) return;
        if (error) throw error;
        // Filter client-side on metadata.status = 'Done' in case some rows
        // slipped through with a different status.
        const doneRows = (data ?? []).filter(r => {
          const s = (r?.metadata?.status || '').toLowerCase();
          return s === 'done' || s === '';
        });
        setItems(doneRows);
        // Default-expand every group so user sees everything at first glance.
        const groups = {};
        for (const row of doneRows) {
          const ms = row?.metadata?.milestone || 'Без майлстоуна';
          groups[ms] = true;
        }
        setExpandedGroups(groups);
      } catch (e) {
        if (!cancelled) setError(e.message || String(e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [employeeId, cycle?.period_start, cycle?.period_end]);

  // Group by milestone.
  const grouped = useMemo(() => {
    const g = new Map();
    for (const r of items) {
      const ms = r?.metadata?.milestone || 'Без майлстоуна';
      if (!g.has(ms)) g.set(ms, []);
      g.get(ms).push(r);
    }
    return Array.from(g.entries());
  }, [items]);

  const selectedCount = Object.values(selected).filter(Boolean).length;

  const toggleOne = (id) => setSelected(s => ({ ...s, [id]: !s[id] }));
  const toggleGroup = (rows, allSelected) => {
    setSelected(s => {
      const next = { ...s };
      for (const r of rows) next[r.id] = !allSelected;
      return next;
    });
  };

  const handleInsert = () => {
    const picks = items.filter(r => selected[r.id]);
    if (picks.length === 0) return;
    // Group selected picks by milestone for readable output.
    const byMs = new Map();
    for (const r of picks) {
      const ms = r?.metadata?.milestone || 'Без майлстоуна';
      if (!byMs.has(ms)) byMs.set(ms, []);
      byMs.get(ms).push(r);
    }
    const lines = [];
    for (const [ms, rows] of byMs.entries()) {
      lines.push(`• ${ms}`);
      for (const r of rows) {
        const sprint = r?.metadata?.sprint ? ` (${r.metadata.sprint})` : '';
        lines.push(`   – ${r.source_title || r.excerpt}${sprint}`);
      }
    }
    const appendBlock = lines.join('\n');
    const base = (achievementsText || '').trimEnd();
    const sep = base ? '\n\n' : '';
    onInsert(base + sep + appendBlock);
    // Clear selection after insert so the user sees progress.
    setSelected({});
  };

  if (!employeeId) return null;

  return (
    <div className="mx-5 mt-4 mb-1 rounded-xl border border-brand-200 bg-brand-50/30">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between px-4 py-3 text-left"
      >
        <div className="flex items-center gap-2">
          <Icon name="download" className="w-4 h-4 text-brand-700" />
          <span className="font-semibold text-brand-700">
            Импорт из Leadership Actions
          </span>
          <span className="text-xs text-ink-500">
            {loading ? 'загрузка…' : error ? 'ошибка' : `${items.length} Done за цикл`}
          </span>
        </div>
        <Icon name={open ? 'chevron-up' : 'chevron-down'} className="w-4 h-4 text-ink-500" />
      </button>

      {open && (
        <div className="px-4 pb-4 space-y-3">
          {error && (
            <div className="text-xs text-red-600">
              Не удалось загрузить: {error}
            </div>
          )}
          {!loading && !error && items.length === 0 && (
            <div className="text-xs text-ink-500">
              Нет закрытых действий за этот цикл. Если они есть в Notion, запусти
              notion-sync (HR Admin · Settings · Notion sync) и обнови страницу.
            </div>
          )}

          {grouped.map(([milestone, rows]) => {
            const allSelected = rows.every(r => selected[r.id]);
            const expanded = expandedGroups[milestone] !== false;
            return (
              <div key={milestone} className="rounded-lg bg-white border border-ink-100">
                <div className="flex items-center justify-between px-3 py-2">
                  <button
                    type="button"
                    className="flex items-center gap-2 text-left flex-1"
                    onClick={() => setExpandedGroups(g => ({ ...g, [milestone]: !expanded }))}
                  >
                    <Icon name={expanded ? 'chevron-down' : 'chevron-right'} className="w-3 h-3 text-ink-500" />
                    <span className="font-medium text-ink-800 text-sm">{milestone}</span>
                    <span className="text-xs text-ink-500">({rows.length})</span>
                  </button>
                  <button
                    type="button"
                    className="text-xs text-brand-700 hover:underline"
                    onClick={() => toggleGroup(rows, allSelected)}
                  >
                    {allSelected ? 'Снять всё' : 'Выбрать всё'}
                  </button>
                </div>
                {expanded && (
                  <ul className="divide-y divide-ink-100">
                    {rows.map(r => {
                      const sprint = r?.metadata?.sprint;
                      const prio = r?.metadata?.priority;
                      const checked = !!selected[r.id];
                      return (
                        <li key={r.id} className="px-3 py-2">
                          <label className="flex items-start gap-2 cursor-pointer">
                            <input
                              type="checkbox"
                              className="mt-1"
                              checked={checked}
                              onChange={() => toggleOne(r.id)}
                            />
                            <div className="flex-1 min-w-0">
                              <div className="text-sm text-ink-800">
                                {r.source_title || r.excerpt}
                              </div>
                              <div className="text-xs text-ink-500 mt-0.5 flex gap-3 flex-wrap">
                                {sprint && <span>🗓 {sprint}</span>}
                                {prio && <span>⭐ {prio}</span>}
                                {r.event_date && (
                                  <span>✓ {new Date(r.event_date).toLocaleDateString('ru-RU')}</span>
                                )}
                                {r.source_url && (
                                  <a href={r.source_url} target="_blank" rel="noreferrer"
                                     className="text-brand-600 hover:underline"
                                     onClick={(e) => e.stopPropagation()}>
                                    Notion →
                                  </a>
                                )}
                              </div>
                            </div>
                          </label>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            );
          })}

          {items.length > 0 && (
            <div className="flex items-center justify-between pt-2">
              <span className="text-xs text-ink-500">
                Выбрано: {selectedCount} из {items.length}
              </span>
              <button
                type="button"
                disabled={selectedCount === 0}
                onClick={handleInsert}
                className={
                  "rounded-lg px-3 py-1.5 text-sm font-medium " +
                  (selectedCount === 0
                    ? "bg-ink-100 text-ink-400 cursor-not-allowed"
                    : "bg-brand-600 text-white hover:bg-brand-700")
                }
              >
                Вставить выбранное ({selectedCount}) в Ключевые достижения
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// Default export — корневое приложение, обёрнутое в ScorecardsProvider.
// Mount происходит в src/main.jsx через createRoot — здесь только дерево.
export default function FreedomOS() {
  return (
    <ScorecardsProvider>
      <App />
    </ScorecardsProvider>
  );
}
